var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const distinctErrorSlug = "sdkshop.log.cart.validation.error.distinct";
class DistinctValidator {
  constructor(metadata2) {
    __publicField(this, "metadata");
    __publicField(this, "seen", /* @__PURE__ */ new Map());
    this.metadata = metadata2;
  }
  isValid(mutate = true) {
    let isValid = true;
    this.seen.clear();
    for (const metadata2 of this.metadata()) {
      const [duplicate, previous] = this.hasDuplicate(metadata2);
      if (!duplicate) {
        this.removeDuplicationError(metadata2);
        continue;
      }
      isValid = false;
      if (mutate) {
        this.addDuplicationError(metadata2);
        if (previous) {
          this.addDuplicationError(previous);
        }
      }
    }
    return isValid;
  }
  addDuplicationError(metadata2) {
    if (!metadata2.errors.includes(distinctErrorSlug)) {
      metadata2.errors.push(distinctErrorSlug);
    }
  }
  removeDuplicationError(metadata2) {
    let i = metadata2.errors.findIndex((v) => v === distinctErrorSlug);
    while (i >= 0) {
      metadata2.errors.splice(i, 1);
      i = metadata2.errors.findIndex((v) => v === distinctErrorSlug);
    }
  }
  hasDuplicate(metadata2) {
    if (!isMetadataWithDistinctRule(metadata2) || !isComparable(metadata2.value)) {
      return [false, null];
    }
    const valueSet = this.getOrAddValueSet(metadata2.item.guid, metadata2.value);
    if (valueSet.size === 1 && !valueSet.has(metadata2)) {
      const previous = [...valueSet.values()][0];
      valueSet.add(metadata2);
      return [true, previous];
    }
    valueSet.add(metadata2);
    return [valueSet.size > 1, null];
  }
  getOrAddValueSet(id, value) {
    const seen = this.getOrCreateSeenMap(id);
    const comparableKey = this.getComparableKey(value);
    let valueSet = seen.get(comparableKey);
    if (!valueSet) {
      valueSet = /* @__PURE__ */ new Set();
      seen.set(comparableKey, valueSet);
    }
    return valueSet;
  }
  getComparableKey(value) {
    let lookupValue;
    if (typeof value === "object") {
      lookupValue = value.getTime();
    } else if (typeof value === "string") {
      lookupValue = value.toLowerCase().trim();
    } else {
      lookupValue = value;
    }
    return lookupValue;
  }
  getOrCreateSeenMap(id) {
    let seen = this.seen.get(id);
    if (!seen) {
      seen = /* @__PURE__ */ new Map();
      this.seen.set(id, seen);
    }
    return seen;
  }
}
function isMetadataWithDistinctRule(metadata2) {
  if (!metadata2.item.extra || !Array.isArray(metadata2.item.extra)) {
    return false;
  }
  return metadata2.item.extra.some((rule) => rule === "distinct" || rule.startsWith("distinct:"));
}
function isComparable(value) {
  switch (typeof value) {
    case "bigint":
    case "boolean":
    case "number":
      return true;
    case "object":
      if (value instanceof Date) {
        return !Number.isNaN(value.getTime());
      }
      return false;
    case "string":
      return !!value;
    default:
      return false;
  }
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function leapYear$1(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function checkFalsePositiveDates$1(dateString = "") {
  if (dateString.length === 10) {
    let normalizedDate = dateString.replace(".", "-").replace("/", "-");
    let parts = normalizedDate.split("-");
    if (parts.length === 3) {
      if (parts[0].length === 4) {
        let y = parseInt(parts[0]);
        let m = parseInt(parts[1]);
        let d = parseInt(parts[2]);
        if (m === 2) {
          if (leapYear$1(y)) {
            if (d > 29) {
              return false;
            }
          } else {
            if (d > 28) {
              return false;
            }
          }
        }
        if (m === 4 || m === 6 || m === 9 || m === 11) {
          if (d > 30) {
            return false;
          }
        }
      }
    }
    return true;
  }
  return true;
}
function isValidDate$1(dateString) {
  let testDate;
  if (typeof dateString === "number") {
    testDate = new Date(dateString);
    if (typeof testDate === "object") {
      return true;
    }
  }
  testDate = new Date(dateString);
  if (typeof testDate === "object") {
    if (testDate.toString() === "Invalid Date") {
      return false;
    }
    if (!checkFalsePositiveDates$1(dateString)) {
      return false;
    }
    return true;
  }
  var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;
  if (!regex_date.test(dateString)) {
    return false;
  }
  var parts = dateString.split("-");
  var day = parseInt(parts[2], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[0], 10);
  if (year < 1e3 || year > 3e3 || month == 0 || month > 12) {
    return false;
  }
  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) {
    monthLength[1] = 29;
  }
  return day > 0 && day <= monthLength[month - 1];
}
var rules = {
  required: function(val) {
    var str;
    if (val === void 0 || val === null) {
      return false;
    }
    str = String(val).replace(/\s/g, "");
    return str.length > 0 ? true : false;
  },
  required_if: function(val, req, attribute) {
    req = this.getParameters();
    if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
      return this.validator.getRule("required").validate(val);
    }
    return true;
  },
  required_unless: function(val, req, attribute) {
    req = this.getParameters();
    if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
      return this.validator.getRule("required").validate(val);
    }
    return true;
  },
  required_with: function(val, req, attribute) {
    if (this.validator._objectPath(this.validator.input, req)) {
      return this.validator.getRule("required").validate(val);
    }
    return true;
  },
  required_with_all: function(val, req, attribute) {
    req = this.getParameters();
    for (var i = 0; i < req.length; i++) {
      if (!this.validator._objectPath(this.validator.input, req[i])) {
        return true;
      }
    }
    return this.validator.getRule("required").validate(val);
  },
  required_without: function(val, req, attribute) {
    if (this.validator._objectPath(this.validator.input, req)) {
      return true;
    }
    return this.validator.getRule("required").validate(val);
  },
  required_without_all: function(val, req, attribute) {
    req = this.getParameters();
    for (var i = 0; i < req.length; i++) {
      if (this.validator._objectPath(this.validator.input, req[i])) {
        return true;
      }
    }
    return this.validator.getRule("required").validate(val);
  },
  boolean: function(val) {
    return val === true || val === false || val === 0 || val === 1 || val === "0" || val === "1" || val === "true" || val === "false";
  },
  // compares the size of strings
  // with numbers, compares the value
  size: function(val, req, attribute) {
    if (val) {
      req = parseFloat(req);
      var size = this.getSize();
      return size === req;
    }
    return true;
  },
  string: function(val, req, attribute) {
    return typeof val === "string";
  },
  sometimes: function(val) {
    return true;
  },
  /**
   * Compares the size of strings or the value of numbers if there is a truthy value
   */
  min: function(val, req, attribute) {
    var size = this.getSize();
    return size >= req;
  },
  /**
   * Compares the size of strings or the value of numbers if there is a truthy value
   */
  max: function(val, req, attribute) {
    var size = this.getSize();
    return size <= req;
  },
  between: function(val, req, attribute) {
    req = this.getParameters();
    var size = this.getSize();
    var min = parseFloat(req[0], 10);
    var max = parseFloat(req[1], 10);
    return size >= min && size <= max;
  },
  email: function(val) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(val)) {
      re = /^((?:[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]|[^\u0000-\u007F])+@(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?(?:\.(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?)+)*$/;
    }
    return re.test(val);
  },
  numeric: function(val) {
    var num;
    num = Number(val);
    if (typeof num === "number" && !isNaN(num) && typeof val !== "boolean") {
      return true;
    } else {
      return false;
    }
  },
  array: function(val) {
    return val instanceof Array;
  },
  url: function(url) {
    return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&/=]*)/i.test(url);
  },
  alpha: function(val) {
    return /^[a-zA-Z]+$/.test(val);
  },
  alpha_dash: function(val) {
    return /^[a-zA-Z0-9_\-]+$/.test(val);
  },
  alpha_num: function(val) {
    return /^[a-zA-Z0-9]+$/.test(val);
  },
  same: function(val, req) {
    var val1 = this.validator._flattenObject(this.validator.input)[req];
    var val2 = val;
    if (val1 === val2) {
      return true;
    }
    return false;
  },
  different: function(val, req) {
    var val1 = this.validator._flattenObject(this.validator.input)[req];
    var val2 = val;
    if (val1 !== val2) {
      return true;
    }
    return false;
  },
  in: function(val, req) {
    var list, i;
    if (val) {
      list = this.getParameters();
    }
    if (val && !(val instanceof Array)) {
      var localValue = val;
      for (i = 0; i < list.length; i++) {
        if (typeof list[i] === "string") {
          localValue = String(val);
        }
        if (localValue === list[i]) {
          return true;
        }
      }
      return false;
    }
    if (val && val instanceof Array) {
      for (i = 0; i < val.length; i++) {
        if (list.indexOf(val[i]) < 0) {
          return false;
        }
      }
    }
    return true;
  },
  not_in: function(val, req) {
    var list = this.getParameters();
    var len = list.length;
    var returnVal = true;
    for (var i = 0; i < len; i++) {
      var localValue = val;
      if (typeof list[i] === "string") {
        localValue = String(val);
      }
      if (localValue === list[i]) {
        returnVal = false;
        break;
      }
    }
    return returnVal;
  },
  accepted: function(val) {
    if (val === "on" || val === "yes" || val === 1 || val === "1" || val === true) {
      return true;
    }
    return false;
  },
  confirmed: function(val, req, key) {
    var confirmedKey = key + "_confirmation";
    if (this.validator.input[confirmedKey] === val) {
      return true;
    }
    return false;
  },
  integer: function(val) {
    return String(parseInt(val, 10)) === String(val);
  },
  digits: function(val, req) {
    var numericRule = this.validator.getRule("numeric");
    if (numericRule.validate(val) && String(val.trim()).length === parseInt(req)) {
      return true;
    }
    return false;
  },
  digits_between: function(val) {
    var numericRule = this.validator.getRule("numeric");
    var req = this.getParameters();
    var valueDigitsCount = String(val).length;
    var min = parseFloat(req[0], 10);
    var max = parseFloat(req[1], 10);
    if (numericRule.validate(val) && valueDigitsCount >= min && valueDigitsCount <= max) {
      return true;
    }
    return false;
  },
  regex: function(val, req) {
    var mod = /[g|i|m]{1,3}$/;
    var flag2 = req.match(mod);
    flag2 = flag2 ? flag2[0] : "";
    req = req.replace(mod, "").slice(1, -1);
    req = new RegExp(req, flag2);
    return !!req.test(val);
  },
  date: function(val, format) {
    return isValidDate$1(val);
  },
  present: function(val) {
    return typeof val !== "undefined";
  },
  after: function(val, req) {
    var val1 = this.validator.input[req];
    var val2 = val;
    if (!isValidDate$1(val1)) {
      return false;
    }
    if (!isValidDate$1(val2)) {
      return false;
    }
    if (new Date(val1).getTime() < new Date(val2).getTime()) {
      return true;
    }
    return false;
  },
  after_or_equal: function(val, req) {
    var val1 = this.validator.input[req];
    var val2 = val;
    if (!isValidDate$1(val1)) {
      return false;
    }
    if (!isValidDate$1(val2)) {
      return false;
    }
    if (new Date(val1).getTime() <= new Date(val2).getTime()) {
      return true;
    }
    return false;
  },
  before: function(val, req) {
    var val1 = this.validator.input[req];
    var val2 = val;
    if (!isValidDate$1(val1)) {
      return false;
    }
    if (!isValidDate$1(val2)) {
      return false;
    }
    if (new Date(val1).getTime() > new Date(val2).getTime()) {
      return true;
    }
    return false;
  },
  before_or_equal: function(val, req) {
    var val1 = this.validator.input[req];
    var val2 = val;
    if (!isValidDate$1(val1)) {
      return false;
    }
    if (!isValidDate$1(val2)) {
      return false;
    }
    if (new Date(val1).getTime() >= new Date(val2).getTime()) {
      return true;
    }
    return false;
  },
  hex: function(val) {
    return /^[0-9a-f]+$/i.test(val);
  },
  ipv4: function(val, req, attribute) {
    if (typeof val != "string")
      return false;
    var er = /^[0-9]+$/;
    octets = val.split(".");
    if (octets.length != 4)
      return false;
    for (let i = 0; i < octets.length; i++) {
      const element = octets[i];
      if (!er.test(element))
        return false;
      var octetValue = parseInt(element);
      if (octetValue >= 256)
        return false;
    }
    return true;
  },
  ipv6: function(val, req, attribute) {
    if (typeof val != "string")
      return false;
    var er = /^[0-9a-f]+$/;
    hextets = val.split(":");
    colons = val.match(/::/);
    if (colons != null && val.match(/::/g).length > 1)
      return false;
    if (val[0] == ":" && (colons == null || colons != null && colons.index != 0))
      return false;
    if (val[val.length - 1] == ":" && (colons == null || colons != null && colons.index != val.length - 2))
      return false;
    if (3 > hextets.length)
      return false;
    var isEdgeCase = hextets.length == 9 && colons != null && (colons.index == 0 || colons.index == val.length - 2);
    if (hextets.length > 8 && !isEdgeCase)
      return false;
    if (hextets.length != 8 && colons == null)
      return false;
    for (let i = 0; i < hextets.length; i++) {
      const element = hextets[i];
      if (element.length == 0)
        continue;
      if (!er.test(element))
        return false;
      if (element.length > 4)
        return false;
    }
    return true;
  },
  ip: function(val, req, attribute) {
    return rules["ipv4"](val, req, attribute) || rules["ipv6"](val, req, attribute);
  }
};
var missedRuleValidator = function() {
  throw new Error("Validator `" + this.name + "` is not defined!");
};
var missedRuleMessage;
function Rule(name, fn, async2) {
  this.name = name;
  this.fn = fn;
  this.passes = null;
  this._customMessage = void 0;
  this.async = async2;
}
Rule.prototype = {
  /**
   * Validate rule
   *
   * @param  {mixed} inputValue
   * @param  {mixed} ruleValue
   * @param  {string} attribute
   * @param  {function} callback
   * @return {boolean|undefined}
   */
  validate: function(inputValue, ruleValue, attribute, callback) {
    var _this = this;
    this._setValidatingData(attribute, inputValue, ruleValue);
    if (typeof callback === "function") {
      this.callback = callback;
      var handleResponse = function(passes, message) {
        _this.response(passes, message);
      };
      if (this.async) {
        return this._apply(inputValue, ruleValue, attribute, handleResponse);
      } else {
        return handleResponse(this._apply(inputValue, ruleValue, attribute));
      }
    }
    return this._apply(inputValue, ruleValue, attribute);
  },
  /**
   * Apply validation function
   *
   * @param  {mixed} inputValue
   * @param  {mixed} ruleValue
   * @param  {string} attribute
   * @param  {function} callback
   * @return {boolean|undefined}
   */
  _apply: function(inputValue, ruleValue, attribute, callback) {
    var fn = this.isMissed() ? missedRuleValidator : this.fn;
    return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
  },
  /**
   * Set validating data
   *
   * @param {string} attribute
   * @param {mixed} inputValue
   * @param {mixed} ruleValue
   * @return {void}
   */
  _setValidatingData: function(attribute, inputValue, ruleValue) {
    this.attribute = attribute;
    this.inputValue = inputValue;
    this.ruleValue = ruleValue;
  },
  /**
   * Get parameters
   *
   * @return {array}
   */
  getParameters: function() {
    var value = [];
    if (typeof this.ruleValue === "string") {
      value = this.ruleValue.split(",");
    }
    if (typeof this.ruleValue === "number") {
      value.push(this.ruleValue);
    }
    if (this.ruleValue instanceof Array) {
      value = this.ruleValue;
    }
    return value;
  },
  /**
   * Get true size of value
   *
   * @return {integer|float}
   */
  getSize: function() {
    var value = this.inputValue;
    if (value instanceof Array) {
      return value.length;
    }
    if (typeof value === "number") {
      return value;
    }
    if (this.validator._hasNumericRule(this.attribute)) {
      return parseFloat(value, 10);
    }
    return value.length;
  },
  /**
   * Get the type of value being checked; numeric or string.
   *
   * @return {string}
   */
  _getValueType: function() {
    if (typeof this.inputValue === "number" || this.validator._hasNumericRule(this.attribute)) {
      return "numeric";
    }
    return "string";
  },
  /**
   * Set the async callback response
   *
   * @param  {boolean|undefined} passes  Whether validation passed
   * @param  {string|undefined} message Custom error message
   * @return {void}
   */
  response: function(passes, message) {
    this.passes = passes === void 0 || passes === true;
    this._customMessage = message;
    this.callback(this.passes, message);
  },
  /**
   * Set validator instance
   *
   * @param {Validator} validator
   * @return {void}
   */
  setValidator: function(validator2) {
    this.validator = validator2;
  },
  /**
   * Check if rule is missed
   *
   * @return {boolean}
   */
  isMissed: function() {
    return typeof this.fn !== "function";
  },
  get customMessage() {
    return this.isMissed() ? missedRuleMessage : this._customMessage;
  }
};
var manager = {
  /**
   * List of async rule names
   *
   * @type {Array}
   */
  asyncRules: [],
  /**
   * Implicit rules (rules to always validate)
   *
   * @type {Array}
   */
  implicitRules: [
    "required",
    "required_if",
    "required_unless",
    "required_with",
    "required_with_all",
    "required_without",
    "required_without_all",
    "accepted",
    "present"
  ],
  /**
   * Get rule by name
   *
   * @param  {string} name
   * @param {Validator}
   * @return {Rule}
   */
  make: function(name, validator2) {
    var async2 = this.isAsync(name);
    var rule = new Rule(name, rules[name], async2);
    rule.setValidator(validator2);
    return rule;
  },
  /**
   * Determine if given rule is async
   *
   * @param  {string}  name
   * @return {boolean}
   */
  isAsync: function(name) {
    for (var i = 0, len = this.asyncRules.length; i < len; i++) {
      if (this.asyncRules[i] === name) {
        return true;
      }
    }
    return false;
  },
  /**
   * Determine if rule is implicit (should always validate)
   *
   * @param {string} name
   * @return {boolean}
   */
  isImplicit: function(name) {
    return this.implicitRules.indexOf(name) > -1;
  },
  /**
   * Register new rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  register: function(name, fn) {
    rules[name] = fn;
  },
  /**
   * Register new implicit rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerImplicit: function(name, fn) {
    this.register(name, fn);
    this.implicitRules.push(name);
  },
  /**
   * Register async rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerAsync: function(name, fn) {
    this.register(name, fn);
    this.asyncRules.push(name);
  },
  /**
   * Register implicit async rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerAsyncImplicit: function(name, fn) {
    this.registerImplicit(name, fn);
    this.asyncRules.push(name);
  },
  registerMissedRuleValidator: function(fn, message) {
    missedRuleValidator = fn;
    missedRuleMessage = message;
  }
};
var rules_1 = manager;
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var replacements = {
  /**
   * Between replacement (replaces :min and :max)
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  between: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      min: parameters[0],
      max: parameters[1]
    });
  },
  /**
   * Digits-Between replacement (replaces :min and :max)
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  digits_between: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      min: parameters[0],
      max: parameters[1]
    });
  },
  /**
   * Required_if replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_if: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      other: this._getAttributeName(parameters[0]),
      value: parameters[1]
    });
  },
  /**
   * Required_unless replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_unless: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      other: this._getAttributeName(parameters[0]),
      value: parameters[1]
    });
  },
  /**
   * Required_with replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_with: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      field: this._getAttributeName(parameters[0])
    });
  },
  /**
   * Required_with_all replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_with_all: function(template, rule) {
    var parameters = rule.getParameters();
    var getAttributeName = this._getAttributeName.bind(this);
    return this._replacePlaceholders(rule, template, {
      fields: parameters.map(getAttributeName).join(", ")
    });
  },
  /**
   * Required_without replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_without: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      field: this._getAttributeName(parameters[0])
    });
  },
  /**
   * Required_without_all replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_without_all: function(template, rule) {
    var parameters = rule.getParameters();
    var getAttributeName = this._getAttributeName.bind(this);
    return this._replacePlaceholders(rule, template, {
      fields: parameters.map(getAttributeName).join(", ")
    });
  },
  /**
   * After replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  after: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      after: this._getAttributeName(parameters[0])
    });
  },
  /**
   * Before replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  before: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      before: this._getAttributeName(parameters[0])
    });
  },
  /**
   * After_or_equal replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  after_or_equal: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      after_or_equal: this._getAttributeName(parameters[0])
    });
  },
  /**
   * Before_or_equal replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  before_or_equal: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      before_or_equal: this._getAttributeName(parameters[0])
    });
  },
  /**
   * Same replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  same: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      same: this._getAttributeName(parameters[0])
    });
  }
};
function formatter(attribute) {
  return attribute.replace(/[_\[]/g, " ").replace(/]/g, "");
}
var attributes = {
  replacements,
  formatter
};
var Attributes$1 = attributes;
var Messages$1 = function(lang2, messages2) {
  this.lang = lang2;
  this.messages = messages2;
  this.customMessages = {};
  this.attributeNames = {};
};
Messages$1.prototype = {
  constructor: Messages$1,
  /**
   * Set custom messages
   *
   * @param {object} customMessages
   * @return {void}
   */
  _setCustom: function(customMessages) {
    this.customMessages = customMessages || {};
  },
  /**
   * Set custom attribute names.
   *
   * @param {object} attributes
   */
  _setAttributeNames: function(attributes2) {
    this.attributeNames = attributes2;
  },
  /**
   * Set the attribute formatter.
   *
   * @param {fuction} func
   * @return {void}
   */
  _setAttributeFormatter: function(func) {
    this.attributeFormatter = func;
  },
  /**
   * Get attribute name to display.
   *
   * @param  {string} attribute
   * @return {string}
   */
  _getAttributeName: function(attribute) {
    var name = attribute;
    if (this.attributeNames.hasOwnProperty(attribute)) {
      return this.attributeNames[attribute];
    } else if (this.messages.attributes.hasOwnProperty(attribute)) {
      name = this.messages.attributes[attribute];
    }
    if (this.attributeFormatter) {
      name = this.attributeFormatter(name);
    }
    return name;
  },
  /**
   * Get all messages
   *
   * @return {object}
   */
  all: function() {
    return this.messages;
  },
  /**
   * Render message
   *
   * @param  {Rule} rule
   * @return {string}
   */
  render: function(rule) {
    if (rule.customMessage) {
      return rule.customMessage;
    }
    var template = this._getTemplate(rule);
    var message;
    if (Attributes$1.replacements[rule.name]) {
      message = Attributes$1.replacements[rule.name].apply(this, [template, rule]);
    } else {
      message = this._replacePlaceholders(rule, template, {});
    }
    return message;
  },
  /**
   * Get the template to use for given rule
   *
   * @param  {Rule} rule
   * @return {string}
   */
  _getTemplate: function(rule) {
    var messages2 = this.messages;
    var template = messages2.def;
    var customMessages = this.customMessages;
    var formats = [rule.name + "." + rule.attribute, rule.name];
    for (var i = 0, format; i < formats.length; i++) {
      format = formats[i];
      if (customMessages.hasOwnProperty(format)) {
        template = customMessages[format];
        break;
      } else if (messages2.hasOwnProperty(format)) {
        template = messages2[format];
        break;
      }
    }
    if (typeof template === "object") {
      template = template[rule._getValueType()];
    }
    return template;
  },
  /**
   * Replace placeholders in the template using the data object
   *
   * @param  {Rule} rule
   * @param  {string} template
   * @param  {object} data
   * @return {string}
   */
  _replacePlaceholders: function(rule, template, data) {
    var message, attribute;
    data.attribute = this._getAttributeName(rule.attribute);
    data[rule.name] = data[rule.name] || rule.getParameters().join(",");
    if (typeof template === "string" && typeof data === "object") {
      message = template;
      for (attribute in data) {
        message = message.replace(new RegExp(":" + attribute, "g"), data[attribute]);
      }
    }
    return message;
  }
};
var messages$1 = Messages$1;
var en = {
  accepted: "The :attribute must be accepted.",
  after: "The :attribute must be after :after.",
  after_or_equal: "The :attribute must be equal or after :after_or_equal.",
  alpha: "The :attribute field must contain only alphabetic characters.",
  alpha_dash: "The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.",
  alpha_num: "The :attribute field must be alphanumeric.",
  before: "The :attribute must be before :before.",
  before_or_equal: "The :attribute must be equal or before :before_or_equal.",
  between: {
    numeric: "The :attribute field must be between :min and :max.",
    string: "The :attribute field must be between :min and :max characters."
  },
  confirmed: "The :attribute confirmation does not match.",
  email: "The :attribute format is invalid.",
  date: "The :attribute is not a valid date format.",
  def: "The :attribute attribute has errors.",
  digits: "The :attribute must be :digits digits.",
  digits_between: "The :attribute field must be between :min and :max digits.",
  different: "The :attribute and :different must be different.",
  in: "The selected :attribute is invalid.",
  integer: "The :attribute must be an integer.",
  hex: "The :attribute field should have hexadecimal format",
  min: {
    numeric: "The :attribute must be at least :min.",
    string: "The :attribute must be at least :min characters."
  },
  max: {
    numeric: "The :attribute may not be greater than :max.",
    string: "The :attribute may not be greater than :max characters."
  },
  not_in: "The selected :attribute is invalid.",
  numeric: "The :attribute must be a number.",
  present: "The :attribute field must be present (but can be empty).",
  required: "The :attribute field is required.",
  required_if: "The :attribute field is required when :other is :value.",
  required_unless: "The :attribute field is required when :other is not :value.",
  required_with: "The :attribute field is required when :field is not empty.",
  required_with_all: "The :attribute field is required when :fields are not empty.",
  required_without: "The :attribute field is required when :field is empty.",
  required_without_all: "The :attribute field is required when :fields are empty.",
  same: "The :attribute and :same fields must match.",
  size: {
    numeric: "The :attribute must be :size.",
    string: "The :attribute must be :size characters."
  },
  string: "The :attribute must be a string.",
  url: "The :attribute format is invalid.",
  regex: "The :attribute format is invalid.",
  attributes: {}
};
const en$1 = /* @__PURE__ */ getDefaultExportFromCjs(en);
var Messages = messages$1;
var require_method = commonjsRequire;
var container = {
  messages: {},
  /**
   * Set messages for language
   *
   * @param {string} lang
   * @param {object} rawMessages
   * @return {void}
   */
  _set: function(lang2, rawMessages) {
    this.messages[lang2] = rawMessages;
  },
  /**
   * Set message for given language's rule.
   *
   * @param {string} lang
   * @param {string} attribute
   * @param {string|object} message
   * @return {void}
   */
  _setRuleMessage: function(lang2, attribute, message) {
    this._load(lang2);
    if (message === void 0) {
      message = this.messages[lang2].def;
    }
    this.messages[lang2][attribute] = message;
  },
  /**
   * Load messages (if not already loaded)
   *
   * @param  {string} lang
   * @return {void}
   */
  _load: function(lang2) {
    if (!this.messages[lang2]) {
      try {
        var rawMessages = require_method("./lang/" + lang2);
        this._set(lang2, rawMessages);
      } catch (e) {
      }
    }
  },
  /**
   * Get raw messages for language
   *
   * @param  {string} lang
   * @return {object}
   */
  _get: function(lang2) {
    this._load(lang2);
    return this.messages[lang2];
  },
  /**
   * Make messages for given language
   *
   * @param  {string} lang
   * @return {Messages}
   */
  _make: function(lang2) {
    this._load(lang2);
    return new Messages(lang2, this.messages[lang2]);
  }
};
var lang = container;
var Errors$1 = function() {
  this.errors = {};
};
Errors$1.prototype = {
  constructor: Errors$1,
  /**
   * Add new error message for given attribute
   *
   * @param  {string} attribute
   * @param  {string} message
   * @return {void}
   */
  add: function(attribute, message) {
    if (!this.has(attribute)) {
      this.errors[attribute] = [];
    }
    if (this.errors[attribute].indexOf(message) === -1) {
      this.errors[attribute].push(message);
    }
  },
  /**
   * Returns an array of error messages for an attribute, or an empty array
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {array} An array of error messages
   */
  get: function(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute];
    }
    return [];
  },
  /**
   * Returns the first error message for an attribute, false otherwise
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {string|false} First error message or false
   */
  first: function(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute][0];
    }
    return false;
  },
  /**
   * Get all error messages from all failing attributes
   *
   * @return {Object} Failed attribute names for keys and an array of messages for values
   */
  all: function() {
    return this.errors;
  },
  /**
   * Determine if there are any error messages for an attribute
   *
   * @param  {string}  attribute A key in the data object being validated
   * @return {boolean}
   */
  has: function(attribute) {
    if (this.errors.hasOwnProperty(attribute)) {
      return true;
    }
    return false;
  }
};
var errors = Errors$1;
function AsyncResolvers$1(onFailedOne, onResolvedAll) {
  this.onResolvedAll = onResolvedAll;
  this.onFailedOne = onFailedOne;
  this.resolvers = {};
  this.resolversCount = 0;
  this.passed = [];
  this.failed = [];
  this.firing = false;
}
AsyncResolvers$1.prototype = {
  /**
   * Add resolver
   *
   * @param {Rule} rule
   * @return {integer}
   */
  add: function(rule) {
    var index = this.resolversCount;
    this.resolvers[index] = rule;
    this.resolversCount++;
    return index;
  },
  /**
   * Resolve given index
   *
   * @param  {integer} index
   * @return {void}
   */
  resolve: function(index) {
    var rule = this.resolvers[index];
    if (rule.passes === true) {
      this.passed.push(rule);
    } else if (rule.passes === false) {
      this.failed.push(rule);
      this.onFailedOne(rule);
    }
    this.fire();
  },
  /**
   * Determine if all have been resolved
   *
   * @return {boolean}
   */
  isAllResolved: function() {
    return this.passed.length + this.failed.length === this.resolversCount;
  },
  /**
   * Attempt to fire final all resolved callback if completed
   *
   * @return {void}
   */
  fire: function() {
    if (!this.firing) {
      return;
    }
    if (this.isAllResolved()) {
      this.onResolvedAll(this.failed.length === 0);
    }
  },
  /**
   * Enable firing
   *
   * @return {void}
   */
  enableFiring: function() {
    this.firing = true;
  }
};
var async = AsyncResolvers$1;
var Rules = rules_1;
var Lang = lang;
var Errors = errors;
var Attributes = attributes;
var AsyncResolvers = async;
var Validator = function(input, rules2, customMessages) {
  var lang2 = Validator.getDefaultLang();
  this.input = input || {};
  this.messages = Lang._make(lang2);
  this.messages._setCustom(customMessages);
  this.setAttributeFormatter(Validator.prototype.attributeFormatter);
  this.errors = new Errors();
  this.errorCount = 0;
  this.hasAsync = false;
  this.rules = this._parseRules(rules2);
};
Validator.prototype = {
  constructor: Validator,
  /**
   * Default language
   *
   * @type {string}
   */
  lang: "en",
  /**
   * Numeric based rules
   *
   * @type {array}
   */
  numericRules: ["integer", "numeric"],
  /**
   * Attribute formatter.
   *
   * @type {function}
   */
  attributeFormatter: Attributes.formatter,
  /**
   * Run validator
   *
   * @return {boolean} Whether it passes; true = passes, false = fails
   */
  check: function() {
    for (var attribute in this.rules) {
      var attributeRules = this.rules[attribute];
      var inputValue = this._objectPath(this.input, attribute);
      if (this._hasRule(attribute, ["sometimes"]) && !this._suppliedWithData(attribute)) {
        continue;
      }
      for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
        ruleOptions = attributeRules[i];
        rule = this.getRule(ruleOptions.name);
        if (!this._isValidatable(rule, inputValue)) {
          continue;
        }
        rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);
        if (!rulePassed) {
          this._addFailure(rule);
        }
        if (this._shouldStopValidating(attribute, rulePassed)) {
          break;
        }
      }
    }
    return this.errorCount === 0;
  },
  /**
   * Run async validator
   *
   * @param {function} passes
   * @param {function} fails
   * @return {void}
   */
  checkAsync: function(passes, fails) {
    var _this = this;
    passes = passes || function() {
    };
    fails = fails || function() {
    };
    var failsOne = function(rule2, message) {
      _this._addFailure(rule2, message);
    };
    var resolvedAll = function(allPassed) {
      if (allPassed) {
        passes();
      } else {
        fails();
      }
    };
    var asyncResolvers = new AsyncResolvers(failsOne, resolvedAll);
    var validateRule = function(inputValue2, ruleOptions2, attribute2, rule2) {
      return function() {
        var resolverIndex = asyncResolvers.add(rule2);
        rule2.validate(inputValue2, ruleOptions2.value, attribute2, function() {
          asyncResolvers.resolve(resolverIndex);
        });
      };
    };
    for (var attribute in this.rules) {
      var attributeRules = this.rules[attribute];
      var inputValue = this._objectPath(this.input, attribute);
      if (this._hasRule(attribute, ["sometimes"]) && !this._suppliedWithData(attribute)) {
        continue;
      }
      for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
        ruleOptions = attributeRules[i];
        rule = this.getRule(ruleOptions.name);
        if (!this._isValidatable(rule, inputValue)) {
          continue;
        }
        validateRule(inputValue, ruleOptions, attribute, rule)();
      }
    }
    asyncResolvers.enableFiring();
    asyncResolvers.fire();
  },
  /**
   * Add failure and error message for given rule
   *
   * @param {Rule} rule
   */
  _addFailure: function(rule) {
    var msg = this.messages.render(rule);
    this.errors.add(rule.attribute, msg);
    this.errorCount++;
  },
  /**
   * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
   *
   * @param  {object} nested object
   * @return {object} flattened object
   */
  _flattenObject: function(obj) {
    var flattened = {};
    function recurse(current, property) {
      if (!property && Object.getOwnPropertyNames(current).length === 0) {
        return;
      }
      if (Object(current) !== current || Array.isArray(current)) {
        flattened[property] = current;
      } else {
        var isEmpty = true;
        for (var p in current) {
          isEmpty = false;
          recurse(current[p], property ? property + "." + p : p);
        }
        if (isEmpty) {
          flattened[property] = {};
        }
      }
    }
    if (obj) {
      recurse(obj);
    }
    return flattened;
  },
  /**
   * Extract value from nested object using string path with dot notation
   *
   * @param  {object} object to search in
   * @param  {string} path inside object
   * @return {any|void} value under the path
   */
  _objectPath: function(obj, path) {
    if (Object.prototype.hasOwnProperty.call(obj, path)) {
      return obj[path];
    }
    var keys = path.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, "").split(".");
    var copy = {};
    for (var attr in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, attr)) {
        copy[attr] = obj[attr];
      }
    }
    for (var i = 0, l = keys.length; i < l; i++) {
      if (typeof copy === "object" && copy !== null && Object.hasOwnProperty.call(copy, keys[i])) {
        copy = copy[keys[i]];
      } else {
        return;
      }
    }
    return copy;
  },
  /**
   * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
   *
   * @param  {object} rules
   * @return {object}
   */
  _parseRules: function(rules2) {
    var parsedRules = {};
    rules2 = this._flattenObject(rules2);
    for (var attribute in rules2) {
      var rulesArray = rules2[attribute];
      this._parseRulesCheck(attribute, rulesArray, parsedRules);
    }
    return parsedRules;
  },
  _parseRulesCheck: function(attribute, rulesArray, parsedRules, wildCardValues) {
    if (attribute.indexOf("*") > -1) {
      this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
    } else {
      this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
    }
  },
  _parsedRulesRecurse: function(attribute, rulesArray, parsedRules, wildCardValues) {
    var parentPath = attribute.substr(0, attribute.indexOf("*") - 1);
    var propertyValue = this._objectPath(this.input, parentPath);
    if (propertyValue) {
      for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
        var workingValues = wildCardValues ? wildCardValues.slice() : [];
        workingValues.push(propertyNumber);
        this._parseRulesCheck(attribute.replace("*", propertyNumber), rulesArray, parsedRules, workingValues);
      }
    }
  },
  _parseRulesDefault: function(attribute, rulesArray, parsedRules, wildCardValues) {
    var attributeRules = [];
    if (rulesArray instanceof Array) {
      rulesArray = this._prepareRulesArray(rulesArray);
    }
    if (typeof rulesArray === "string") {
      rulesArray = rulesArray.split("|");
    }
    for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
      rule = typeof rulesArray[i] === "string" ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];
      if (rule.value) {
        rule.value = this._replaceWildCards(rule.value, wildCardValues);
        this._replaceWildCardsMessages(wildCardValues);
      }
      if (Rules.isAsync(rule.name)) {
        this.hasAsync = true;
      }
      attributeRules.push(rule);
    }
    parsedRules[attribute] = attributeRules;
  },
  _replaceWildCards: function(path, nums) {
    if (!nums) {
      return path;
    }
    var path2 = path;
    nums.forEach(function(value) {
      if (Array.isArray(path2)) {
        path2 = path2[0];
      }
      const pos = path2.indexOf("*");
      if (pos === -1) {
        return path2;
      }
      path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
    });
    if (Array.isArray(path)) {
      path[0] = path2;
      path2 = path;
    }
    return path2;
  },
  _replaceWildCardsMessages: function(nums) {
    var customMessages = this.messages.customMessages;
    var self2 = this;
    Object.keys(customMessages).forEach(function(key) {
      if (nums) {
        var newKey = self2._replaceWildCards(key, nums);
        customMessages[newKey] = customMessages[key];
      }
    });
    this.messages._setCustom(customMessages);
  },
  /**
   * Prepare rules if it comes in Array. Check for objects. Need for type validation.
   *
   * @param  {array} rulesArray
   * @return {array}
   */
  _prepareRulesArray: function(rulesArray) {
    var rules2 = [];
    for (var i = 0, len = rulesArray.length; i < len; i++) {
      if (typeof rulesArray[i] === "object") {
        for (var rule in rulesArray[i]) {
          rules2.push({
            name: rule,
            value: rulesArray[i][rule]
          });
        }
      } else {
        rules2.push(rulesArray[i]);
      }
    }
    return rules2;
  },
  /**
   * Determines if the attribute is supplied with the original data object.
   *
   * @param  {array} attribute
   * @return {boolean}
   */
  _suppliedWithData: function(attribute) {
    return this.input.hasOwnProperty(attribute);
  },
  /**
   * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
   *
   * @param  {string} ruleString min:3
   * @return {object} object containing the name of the rule and value
   */
  _extractRuleAndRuleValue: function(ruleString) {
    var rule = {}, ruleArray;
    rule.name = ruleString;
    if (ruleString.indexOf(":") >= 0) {
      ruleArray = ruleString.split(":");
      rule.name = ruleArray[0];
      rule.value = ruleArray.slice(1).join(":");
    }
    return rule;
  },
  /**
   * Determine if attribute has any of the given rules
   *
   * @param  {string}  attribute
   * @param  {array}   findRules
   * @return {boolean}
   */
  _hasRule: function(attribute, findRules) {
    var rules2 = this.rules[attribute] || [];
    for (var i = 0, len = rules2.length; i < len; i++) {
      if (findRules.indexOf(rules2[i].name) > -1) {
        return true;
      }
    }
    return false;
  },
  /**
   * Determine if attribute has any numeric-based rules.
   *
   * @param  {string}  attribute
   * @return {Boolean}
   */
  _hasNumericRule: function(attribute) {
    return this._hasRule(attribute, this.numericRules);
  },
  /**
   * Determine if rule is validatable
   *
   * @param  {Rule}   rule
   * @param  {mixed}  value
   * @return {boolean}
   */
  _isValidatable: function(rule, value) {
    if (Array.isArray(value)) {
      return true;
    }
    if (Rules.isImplicit(rule.name)) {
      return true;
    }
    return this.getRule("required").validate(value);
  },
  /**
   * Determine if we should stop validating.
   *
   * @param  {string} attribute
   * @param  {boolean} rulePassed
   * @return {boolean}
   */
  _shouldStopValidating: function(attribute, rulePassed) {
    var stopOnAttributes = this.stopOnAttributes;
    if (typeof stopOnAttributes === "undefined" || stopOnAttributes === false || rulePassed === true) {
      return false;
    }
    if (stopOnAttributes instanceof Array) {
      return stopOnAttributes.indexOf(attribute) > -1;
    }
    return true;
  },
  /**
   * Set custom attribute names.
   *
   * @param {object} attributes
   * @return {void}
   */
  setAttributeNames: function(attributes2) {
    this.messages._setAttributeNames(attributes2);
  },
  /**
   * Set the attribute formatter.
   *
   * @param {fuction} func
   * @return {void}
   */
  setAttributeFormatter: function(func) {
    this.messages._setAttributeFormatter(func);
  },
  /**
   * Get validation rule
   *
   * @param  {string} name
   * @return {Rule}
   */
  getRule: function(name) {
    return Rules.make(name, this);
  },
  /**
   * Stop on first error.
   *
   * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
   * @return {void}
   */
  stopOnError: function(attributes2) {
    this.stopOnAttributes = attributes2;
  },
  /**
   * Determine if validation passes
   *
   * @param {function} passes
   * @return {boolean|undefined}
   */
  passes: function(passes) {
    var async2 = this._checkAsync("passes", passes);
    if (async2) {
      return this.checkAsync(passes);
    }
    return this.check();
  },
  /**
   * Determine if validation fails
   *
   * @param {function} fails
   * @return {boolean|undefined}
   */
  fails: function(fails) {
    var async2 = this._checkAsync("fails", fails);
    if (async2) {
      return this.checkAsync(function() {
      }, fails);
    }
    return !this.check();
  },
  /**
   * Check if validation should be called asynchronously
   *
   * @param  {string}   funcName Name of the caller
   * @param  {function} callback
   * @return {boolean}
   */
  _checkAsync: function(funcName, callback) {
    var hasCallback = typeof callback === "function";
    if (this.hasAsync && !hasCallback) {
      throw funcName + " expects a callback when async rules are being tested.";
    }
    return this.hasAsync || hasCallback;
  }
};
Validator.setMessages = function(lang2, messages2) {
  Lang._set(lang2, messages2);
  return this;
};
Validator.getMessages = function(lang2) {
  return Lang._get(lang2);
};
Validator.useLang = function(lang2) {
  this.prototype.lang = lang2;
};
Validator.getDefaultLang = function() {
  return this.prototype.lang;
};
Validator.setAttributeFormatter = function(func) {
  this.prototype.attributeFormatter = func;
};
Validator.stopOnError = function(attributes2) {
  this.prototype.stopOnAttributes = attributes2;
};
Validator.register = function(name, fn, message, fnReplacement) {
  var lang2 = Validator.getDefaultLang();
  Rules.register(name, fn);
  Lang._setRuleMessage(lang2, name, message);
};
Validator.registerImplicit = function(name, fn, message, fnReplacement) {
  var lang2 = Validator.getDefaultLang();
  Rules.registerImplicit(name, fn);
  Lang._setRuleMessage(lang2, name, message);
};
Validator.registerAsync = function(name, fn, message, fnReplacement) {
  var lang2 = Validator.getDefaultLang();
  Rules.registerAsync(name, fn);
  Lang._setRuleMessage(lang2, name, message);
};
Validator.registerAsyncImplicit = function(name, fn, message) {
  var lang2 = Validator.getDefaultLang();
  Rules.registerAsyncImplicit(name, fn);
  Lang._setRuleMessage(lang2, name, message);
};
Validator.registerMissedRuleValidator = function(fn, message) {
  Rules.registerMissedRuleValidator(fn, message);
};
var validator$1 = Validator;
const Validator$1 = /* @__PURE__ */ getDefaultExportFromCjs(validator$1);
var ca = {
  accepted: "El camp :attribute pot ser aceptat.",
  after: "El camp :attribute pot ser una data posterior a :after.",
  alpha: "El camp :attribute només pot contenir lletras.",
  alpha_dash: "El camp :attribute només pot contenir lletras, nombres y guions.",
  alpha_num: "El camp :attribute només pot contenir lletras y nombres.",
  attributes: {},
  between: "El camp :attribute té que estar entre :min - :max.",
  confirmed: "La confirmació de :attribute no coincideix.",
  different: "El camp :attribute y :other poden ser diferents.",
  digits: "El camp :attribute pot tindre :digits dígitos.",
  digits_between: "El camp  :attribute ha de tenir entre :min i :max dígits.",
  email: "El camp :attribute no es un correu válido.",
  "in": "El camp :attribute es invàlid.",
  integer: "El camp :attribute pot ser un nombre enter.",
  hex: "El camp :attribute hauria de tenir format hexadecimal",
  max: {
    numeric: "El camp :attribute no pot ser mayor a :max.",
    string: "El camp :attribute no pot ser mayor que :max caràcters."
  },
  min: {
    numeric: "La mida del camp :attribute pot ser de al menys :min.",
    string: "El camp :attribute pot contenir al menys :min caràcters."
  },
  not_in: "El camp :attribute es invàlid.",
  numeric: "El camp :attribute pot ser numéric.",
  present: "El camp de :attribute pot estar present (però pot estar buit).",
  regex: "El format del camp :attribute es invàlid.",
  required: "El camp :attribute es obligatori.",
  required_if: "El camp :attribute es obligatori quan :other es :value.",
  same: "El camp :attribute y :other poden coincidir.",
  size: {
    numeric: "La mida del camp :attribute pot ser :size.",
    string: "El camp :attribute pot contenir :size caràcters."
  },
  url: "El format de :attribute es invàlid."
};
const ca$1 = /* @__PURE__ */ getDefaultExportFromCjs(ca);
var cs = {
  accepted: ":attribute musí být přijat.",
  active_url: ":attribute není platnou URL adresou.",
  after: ":attribute musí být datum po :date.",
  after_or_equal: "The :attribute must be a date after or equal to :date.",
  alpha: ":attribute může obsahovat pouze písmena.",
  alpha_dash: ":attribute může obsahovat pouze písmena, číslice, pomlčky a podtržítka. České znaky (á, é, í, ó, ú, ů, ž, š, č, ř, ď, ť, ň) nejsou podporovány.",
  alpha_num: ":attribute může obsahovat pouze písmena a číslice.",
  attributes: {},
  array: ":attribute musí být pole.",
  before: ":attribute musí být datum před :date.",
  before_or_equal: "The :attribute must be a date before or equal to :date.",
  between: {
    numeric: ":attribute musí být hodnota mezi :min a :max.",
    file: ":attribute musí být větší než :min a menší než :max Kilobytů.",
    string: ":attribute musí být delší než :min a kratší než :max znaků.",
    array: ":attribute musí obsahovat nejméně :min a nesmí obsahovat více než :max prvků."
  },
  boolean: ":attribute musí být true nebo false",
  confirmed: ":attribute nebylo odsouhlaseno.",
  date: ":attribute musí být platné datum.",
  date_format: ":attribute není platný formát data podle :format.",
  different: ":attribute a :other se musí lišit.",
  digits: ":attribute musí být :digits pozic dlouhé.",
  digits_between: ":attribute musí být dlouhé nejméně :min a nejvíce :max pozic.",
  dimensions: ":attribute má neplatné rozměry.",
  distinct: ":attribute má duplicitní hodnotu.",
  email: ":attribute není platný formát.",
  exists: "Zvolená hodnota pro :attribute není platná.",
  file: ":attribute musí být soubor.",
  filled: ":attribute musí být vyplněno.",
  gt: {
    numeric: "The :attribute must be greater than :value.",
    file: "The :attribute must be greater than :value kilobytes.",
    string: "The :attribute must be greater than :value characters.",
    array: "The :attribute must have more than :value items."
  },
  gte: {
    numeric: "The :attribute must be greater than or equal :value.",
    file: "The :attribute must be greater than or equal :value kilobytes.",
    string: "The :attribute must be greater than or equal :value characters.",
    array: "The :attribute must have :value items or more."
  },
  hex: "The :attribute field should have hexadecimal format",
  image: ":attribute musí být obrázek.",
  in: "Zvolená hodnota pro :attribute je neplatná.",
  in_array: ":attribute není obsažen v :other.",
  integer: ":attribute musí být celé číslo.",
  ip: ":attribute musí být platnou IP adresou.",
  ipv4: "The :attribute must be a valid IPv4 address.",
  ipv6: "The :attribute must be a valid IPv6 address.",
  json: ":attribute musí být platný JSON řetězec.",
  lt: {
    numeric: "The :attribute must be less than :value.",
    file: "The :attribute must be less than :value kilobytes.",
    string: "The :attribute must be less than :value characters.",
    array: "The :attribute must have less than :value items."
  },
  lte: {
    numeric: "The :attribute must be less than or equal :value.",
    file: "The :attribute must be less than or equal :value kilobytes.",
    string: "The :attribute must be less than or equal :value characters.",
    array: "The :attribute must not have more than :value items."
  },
  max: {
    numeric: ":attribute musí být nižší než :max.",
    file: ":attribute musí být menší než :max Kilobytů.",
    string: ":attribute musí být kratší než :max znaků.",
    array: ":attribute nesmí obsahovat více než :max prvků."
  },
  mimes: ":attribute musí být jeden z následujících datových typů :values.",
  mimetypes: ":attribute musí být jeden z následujících datových typů :values.",
  min: {
    numeric: ":attribute musí být větší než :min.",
    file: ":attribute musí být větší než :min Kilobytů.",
    string: ":attribute musí být delší než :min znaků.",
    array: ":attribute musí obsahovat více než :min prvků."
  },
  not_in: "Zvolená hodnota pro :attribute je neplatná.",
  not_regex: "The :attribute format is invalid.",
  numeric: ":attribute musí být číslo.",
  present: ":attribute musí být vyplněno.",
  regex: ":attribute nemá správný formát.",
  required: ":attribute musí být vyplněno.",
  required_if: ":attribute musí být vyplněno pokud :other je :value.",
  required_unless: ":attribute musí být vyplněno dokud :other je v :value.",
  required_with: ":attribute musí být vyplněno pokud :field je vyplněno.",
  required_with_all: ":attribute musí být vyplněno pokud :fields je zvoleno.",
  required_without: ":attribute musí být vyplněno pokud :field není vyplněno.",
  required_without_all: ":attribute musí být vyplněno pokud není žádné z :fields zvoleno.",
  same: ":attribute a :other se musí shodovat.",
  size: {
    numeric: ":attribute musí být přesně :size.",
    file: ":attribute musí mít přesně :size Kilobytů.",
    string: ":attribute musí být přesně :size znaků dlouhý.",
    array: ":attribute musí obsahovat právě :size prvků."
  },
  string: ":attribute musí být řetězec znaků.",
  timezone: ":attribute musí být platná časová zóna.",
  unique: ":attribute musí být unikátní.",
  uploaded: "Nahrávání :attribute se nezdařilo.",
  url: "Formát :attribute je neplatný."
};
const cs$1 = /* @__PURE__ */ getDefaultExportFromCjs(cs);
var da = {
  accepted: ":attribute skal accepteres.",
  after: ":attribute skal være en dato efter :after.",
  after_or_equal: ":attribute skal være en dato efter eller lig med :after_or_equal.",
  alpha: ":attribute må kun bestå af bogstaver.",
  alpha_dash: ":attribute må kun bestå af bogstaver, tal og bindestreger.",
  alpha_num: ":attribute må kun bestå af bogstaver og tal.",
  before: ":attribute skal være en dato før :before.",
  before_or_equal: ":attribute skal være en dato før eller lig med :before_or_equal.",
  between: ":attribute skal være mellem :min og :max.",
  confirmed: ":attribute er ikke det samme som bekræftelsesfeltet.",
  email: ":attribute skal være en gyldig email.",
  date: ":attribute er ikke en gyldig dato.",
  def: ":attribute attributen har fejl.",
  digits: ":attribute skal have :digits cifre.",
  digits_between: ":attribute skal have mellem :min og :max cifre.",
  different: ":attribute og :different skal være forskellige.",
  in: "Det valgte :attribute er ugyldigt.",
  integer: ":attribute skal være et heltal.",
  hex: ":attribute skal have hexadecimalt format",
  min: {
    numeric: ":attribute skal være mindst :min.",
    string: ":attribute skal være mindst :min tegn."
  },
  max: {
    numeric: ":attribute skal være højest :max.",
    string: ":attribute skal være højest :max tegn."
  },
  not_in: "Den valgte :attribute er ugyldig",
  numeric: ":attribute skal være et tal.",
  present: ":attribute skal være tilstede.",
  required: ":attribute skal udfyldes.",
  required_if: ":attribute skal udfyldes når :other er :value.",
  required_unless: ":attribute er påkrævet medmindre :other findes i :values.",
  required_with: ":attribute skal udfyldes når :field er udfyldt.",
  required_with_all: ":attribute skal udfyldes når :fields er udfyldt.",
  required_without: ":attribute skal udfyldes når :field ikke er udfyldt.",
  required_without_all: ":attribute skal udfyldes når ingen af :fields er udfyldt.",
  same: ":attribute og :same skal være ens.",
  size: {
    numeric: ":attribute skal være :size.",
    string: ":attribute skal være :size tegn lang."
  },
  string: ":attribute skal være en streng.",
  url: ":attribute formatet er ugyldigt.",
  regex: ":attribute formatet er ugyldigt.",
  attributes: {}
};
const da$1 = /* @__PURE__ */ getDefaultExportFromCjs(da);
var de = {
  accepted: "Das :attribute Feld muss akzeptiert werden.",
  after: "Das :attribute muss ein Datum nach dem :after sein.",
  after_or_equal: "Das :attribute Datum muss kleiner oder gleich dem :after_or_equal sein.",
  alpha: "Das :attribute Feld darf nur aus Buchstaben bestehen.",
  alpha_dash: "Das :attribute Feld darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.",
  alpha_num: "Das :attribute Feld darf nur aus Buchstaben und Zahlen bestehen.",
  before: "Das :attribute muss ein Datum vor dem :before sein.",
  before_or_equal: "Das :attribute Datum muss größer oder gleich dem :before_or_equal sein.",
  between: "Das :attribute Feld muss zwischen :min und :max liegen.",
  confirmed: "Das :attribute Feld stimmt nicht mit der Bestätigung überein.",
  email: "Das :attribute Format ist ungültig.",
  date: "Das :attribute Feld muss ein gültiges Datum sein.",
  def: "Das :attribute Feld hat Fehler.",
  digits: "Das :attribute Feld muss :digits Stellen haben.",
  digits_between: "Das :attribute Feld muss zwischen :min und :max Stellen haben.",
  different: "Die Felder :attribute und :different müssen sich unterscheiden.",
  in: "Der gewählte Wert für :attribute ist ungültig.",
  integer: "Das :attribute Feld muss eine ganze Zahl sein.",
  hex: "Das :attribute Feld sollte hexadezimal sein",
  min: {
    numeric: "Das :attribute Feld muss mindestens :min sein.",
    string: "Das :attribute Feld muss mindestens :min Zeichen lang sein."
  },
  max: {
    numeric: "Das :attribute Feld darf maximal :max sein.",
    string: "Das :attribute Feld darf maximal :max Zeichen haben."
  },
  not_in: "Der gewählte Wert für :attribute ist ungültig.",
  numeric: "Das :attribute Feld muss eine Zahl sein.",
  present: "Das Feld :attribute muss vorhanden sein (kann aber leer sein).",
  required: "Das :attribute Feld muss ausgefüllt sein.",
  required_if: "Das :attribute Feld muss ausgefüllt sein, wenn :other :value ist.",
  same: "Die Felder :attribute und :same müssen übereinstimmen.",
  size: {
    numeric: "Das :attribute Feld muss gleich :size sein.",
    string: "Das :attribute Feld muss :size Zeichen lang sein."
  },
  string: "Das :attribute Feld muss ein Satz sein.",
  url: "Das Format von :attribute ist ungültig.",
  regex: "Das :attribute Format ist ungültig.",
  attributes: {}
};
const de$1 = /* @__PURE__ */ getDefaultExportFromCjs(de);
var el = {
  accepted: "Το πεδίο :attribute πρέπει να γίνει αποδεκτό.",
  after: "Το πεδίο :attribute πρέπει να είναι μία ημερομηνία μετά από :after.",
  alpha: "Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα.",
  alpha_dash: "Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα, αριθμούς, και παύλες.",
  alpha_num: "Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα και αριθμούς.",
  between: "Το πεδίο :attribute πρέπει να είναι μεταξύ :min και :max.",
  confirmed: "Η επιβεβαίωση του :attribute δεν ταιριάζει.",
  email: "Το πεδίο :attribute πρέπει να είναι μία έγκυρη διεύθυνση email.",
  date: "Το πεδίο :attribute δεν είναι έγκυρη ημερομηνία.",
  def: "Το πεδίο :attribute περιέχει σφάλματα.",
  digits: "Το πεδίο :attribute πρέπει να είναι :digits ψηφία.",
  digits_between: "Το πεδίο :attribute πρέπει να είναι μεταξύ :min και :max ψηφία.",
  different: "Το πεδίο :attribute  και :different πρέπει να είναι διαφορετικά.",
  in: "Το επιλεγμένο :attribute δεν είναι έγκυρο.",
  integer: "Το πεδίο :attribute πρέπει να είναι ακέραιος.",
  hex: "Το πεδίο :attribute πρέπει να είναι σε δεκαεξαδική μορφή.",
  min: {
    numeric: "Το πεδίο :attribute πρέπει να είναι τουλάχιστον :min.",
    string: "Το πεδίο :attribute πρέπει να έχει τουλάχιστον :min χαρακτήρες."
  },
  max: {
    numeric: "Το πεδίο :attribute δεν μπορεί να είναι μεγαλύτερο από :max.",
    string: "Το πεδίο :attribute δεν μπορεί να έχει περισσότερους από :max χαρακτήρες."
  },
  not_in: "Το επιλεγμένο :attribute δεν είναι αποδεκτό.",
  numeric: "Το πεδίο :attribute πρέπει να είναι αριθμός.",
  present: "The :attribute field must be present (but can be empty).",
  required: "Το πεδίο :attribute είναι απαραίτητο.",
  required_if: "Το πεδίο :attribute είναι απαραίτητο όταν το πεδίο :other είναι :value.",
  same: "Τα πεδία :attribute και :same πρέπει να είναι ίδια.",
  size: {
    numeric: "Το πεδίο :attribute πρέπει να είναι :size.",
    string: "Το πεδίο :attribute πρέπει να είναι :size χαρακτήρες."
  },
  string: "Το πεδίο :attribute πρέπει να είναι αλφαριθμητικό.",
  url: "Το πεδίο :attribute δεν είναι έγκυρη διεύθυνση URL.",
  regex: "Η μορφή του :attribute δεν είναι αποδεκτή.",
  attributes: {}
};
const el$1 = /* @__PURE__ */ getDefaultExportFromCjs(el);
var es = {
  accepted: "El campo :attribute debe ser aceptado.",
  after: "El campo :attribute debe ser una fecha posterior a :after.",
  alpha: "El campo :attribute solo debe contener letras.",
  alpha_dash: "El campo :attribute solo debe contener letras, números y guiones.",
  alpha_num: "El campo :attribute solo debe contener letras y números.",
  attributes: {},
  between: "El campo :attribute tiene que estar entre :min - :max.",
  confirmed: "La confirmación de :attribute no coincide.",
  different: "El campo :attribute y :other deben ser diferentes.",
  digits: "El campo :attribute debe tener :digits dígitos.",
  digits_between: "El campo :attribute debe tener entre :min y :max dígitos.",
  email: "El campo :attribute no es un correo válido.",
  in: "El campo :attribute es inválido.",
  integer: "El campo :attribute debe ser un número entero.",
  hex: "El campo :attribute debe tener formato hexadecimal.",
  max: {
    numeric: "El campo :attribute no debe ser mayor a :max.",
    string: "El campo :attribute no debe ser mayor que :max caracteres."
  },
  min: {
    numeric: "El tamaño del campo :attribute debe ser de al menos :min.",
    string: "El campo :attribute debe contener al menos :min caracteres."
  },
  not_in: "El campo :attribute es inválido.",
  numeric: "El campo :attribute debe ser numérico.",
  present: "El campo de :attribute debe estar presente (pero puede estar vacío).",
  regex: "El formato del campo :attribute es inválido.",
  required: "El campo :attribute es obligatorio.",
  required_if: "El campo :attribute es obligatorio cuando :other es :value.",
  same: "El campo :attribute y :other deben coincidir.",
  size: {
    numeric: "El tamaño del campo :attribute debe ser :size.",
    string: "El campo :attribute debe contener :size caracteres."
  },
  url: "El formato de :attribute es inválido."
};
const es$1 = /* @__PURE__ */ getDefaultExportFromCjs(es);
var fr = {
  accepted: "Le champ :attribute doit être accepté.",
  alpha: "Le champ :attribute ne peut contenir que des caractères alphabétiques.",
  alpha_dash: "Le champ :attribute ne peut contenir que des caractères alphanumériques, des tirets et des underscores.",
  alpha_num: "Le champ :attribute ne peut contenir que des caractères alphanumériques.",
  between: "La longueur du champ :attribute doit être comprise entre :min and :max.",
  confirmed: "Le champ :attribute n'est pas confirmé.",
  email: "Le champ :attribute contient un format invalide.",
  def: "Le champ :attribute contient un attribut erroné.",
  digits: "Le champ :attribute doit être composé de :digits chiffres.",
  digits_between: "Le champ :attribute doit contenir entre :min et :max chiffres.",
  different: "Les champs :attribute et :different doivent être différents.",
  in: "Le champ :attribute est invalide.",
  integer: "Le champ :attribute doit être un entier.",
  hex: "Le champ :attribute doit être au format hexadécimal.",
  min: {
    numeric: "Le champ :attribute doit être supérieur à :min.",
    string: "Le champ :attribute doit contenir plus de :min caractères."
  },
  max: {
    numeric: "Le champ :attribute doit être inférieur à :max.",
    string: "Le champ :attribute doit contenir moins de :max caractères."
  },
  not_in: "Le champ :attribute est invalide.",
  numeric: "Le champ :attribute doit être un chiffre.",
  present: "Le champ :attribute doit être présent (mais peut être vide).",
  required: "Le champ :attribute est requis.",
  required_if: "Le champ :attribute est requis quand :other est :value.",
  same: "Les champs :attribute et :same doivent correspondre.",
  size: {
    numeric: "Le champ :attribute doit être égal à :size.",
    string: "Le champ :attribute doit contenir :size caractères."
  },
  url: "Le format du champ :attribute est invalide.",
  regex: "Le format du champ :attribute est invalide.",
  attributes: {}
};
const fr$1 = /* @__PURE__ */ getDefaultExportFromCjs(fr);
var it = {
  accepted: "Il campo :attribute deve essere accettato.",
  alpha: "Il campo :attribute deve contenere sono caratteri alfabetici.",
  alpha_dash: "Il campo :attribute può contenere solo caratteri alfanumerici oltre a trattini e trattini bassi.",
  alpha_num: "Il campo :attribute deve essere alfanumerico.",
  between: "Il campo :attribute deve essere compreso tra :min e :max.",
  confirmed: "Il campo conferma :attribute non è uguale.",
  email: "Il formato dell'attributo :attribute non è valido.",
  def: "Gli attributi del campo :attribute contengono degli errori.",
  digits: "Il campo :attribute deve essere di :digits cifre.",
  digits_between: "Il campo :attribute deve essere tra :min e :max cifre.",
  different: "Il campo :attribute e :different devo essere diversi.",
  in: "Il valore del campo :attribute non è valido.",
  integer: "Il campo :attribute deve essere un valore intero.",
  hex: "Il campo :attribute deve essere in formato esadecimale",
  min: {
    numeric: "Il campo :attribute deve essere maggiore o uguale di :min.",
    string: "Il campo :attribute deve essere composto da almeno :min caratteri."
  },
  max: {
    numeric: "Il campo :attribute deve essere minore o uguale di :max.",
    string: "Il campo :attribute deve essere composto da massimo :max caratteri."
  },
  not_in: "Il campo :attribute non è valido.",
  numeric: "Il campo :attribute deve essere un numero.",
  present: "Il campo :attribute deve essere presente (ma può essere vuoto).",
  required: "Il campo :attribute è richiesto.",
  required_if: "Il campo :attribute è richiesto quando il campo :other è uguale a :value.",
  same: "I campi :attribute e :same devono essere uguali.",
  size: {
    numeric: "La dimensione del campo :attribute deve essere uguale a :size.",
    string: "Il campo :attribute deve essere di :size caratteri."
  },
  string: "Il campo :attribute deve essere una stringa.",
  url: "Il formato del campo :attribute non è valido.",
  regex: "Il formato del campo :attribute non è valido.",
  attributes: {}
};
const it$1 = /* @__PURE__ */ getDefaultExportFromCjs(it);
var nl = {
  accepted: "Het :attribute veld moet geaccepteerd worden.",
  after: ":attribute moet een datum na :after zijn.",
  after_or_equal: "De :attribute datum moet op of na :after_or_equal zijn.",
  alpha: "Het :attribute veld mag alleen maar letters bevatten.",
  alpha_dash: "Het :attribute veld mag alleen maar letters, cijfers en (liggende) streepjes bevatten.",
  alpha_num: "Het :attribute veld mag alleen maar letters en cijfers bevatten.",
  before: ":attribute moet vòòr :before zijn.",
  before_or_equal: ":attribute moet vòòr of op :before_or_equal zijn.",
  between: "Het :attribute veld moet tussen :min en :max liggen.",
  confirmed: "Het :attribute veld komt niet met de bevestiging overeen.",
  email: "Het :attribute formaat is ongeldig.",
  date: "Het :attribute veld moet een geldige datum zijn.",
  def: "Het :attribute veld bevat fouten.",
  digits: "Het :attribute veld moet :digits cijfers hebben.",
  digits_between: ":attribute moet bestaan uit minimaal :min en maximaal :max cijfers.",
  different: "Het :attribute en :different veld moeten verschillend zijn.",
  in: "De gekozen waarde voor :attribute is ongeldig.",
  integer: "Het :attribute veld moet een geheel getal zijn.",
  hex: "Het :attribute veld moet hexadecimaal zijn",
  min: {
    numeric: "Het :attribute veld moet minstens :min zijn.",
    string: "Het :attribute veld moet minstens :min karakters bevatten."
  },
  max: {
    numeric: "Het :attribute veld mag maximaal :max zijn.",
    string: "Het :attribute veld mag niet meer dan :max karakters bevatten."
  },
  not_in: "De gekozen waarde voor :attribute is ongeldig.",
  numeric: "Het :attribute veld moet een getal zijn.",
  present: "Het :attribute veld moet aanwezig zijn (maar mag leeg zijn).",
  required: "Het :attribute veld moet ingevuld zijn.",
  required_if: "Het :attribute veld moet ingevuld zijn, wanneer :other :value is.",
  required_unless: "Het :attribute veld moet ingevuld zijn, wanneer :other niet :value is.",
  required_with: "Het :attribute veld moet ingevuld zijn, wanneer :field niet leeg is.",
  required_with_all: "Het :attribute veld moet ingevuld zijn, wanneer :fields niet leeg zijn.",
  required_without: "Het :attribute veld moet ingevuld zijn, wanneer :field leeg is.",
  required_without_all: "Het :attribute veld moet ingevuld zijn, wanneer :fields leeg zijn.",
  same: "De :attribute en :same velden moeten overeenkomen.",
  size: {
    numeric: "Het :attribute veld moet :size zijn.",
    string: "Het :attribute veld moet :size karakters bevatten."
  },
  string: "Het :attribute veld moet een woord of zin zijn.",
  url: "Het :attribute veld heeft een ongeldig formaat.",
  regex: "Het :attribute veld heeft een ongeldig formaat.",
  attributes: {}
};
const nl$1 = /* @__PURE__ */ getDefaultExportFromCjs(nl);
var pt = {
  accepted: "O campo :attribute deverá ser aceite.",
  active_url: "O campo :attribute não contém um URL válido.",
  after: "O campo :attribute deverá conter uma data posterior a :date.",
  after_or_equal: "O campo :attribute deverá conter uma data posterior ou igual a :date.",
  alpha: "O campo :attribute deverá conter apenas letras.",
  alpha_dash: "O campo :attribute deverá conter apenas letras, números e traços.",
  alpha_num: "O campo :attribute deverá conter apenas letras e números .",
  attributes: {},
  array: "O campo :attribute deverá conter uma coleção de elementos.",
  before: "O campo :attribute deverá conter uma data anterior a :date.",
  before_or_equal: "O Campo :attribute deverá conter uma data anterior ou igual a :date.",
  between: {
    numeric: "O campo :attribute deverá ter um valor entre :min - :max.",
    file: "O campo :attribute deverá ter um tamanho entre :min - :max kilobytes.",
    string: "O campo :attribute deverá conter entre :min - :max caracteres.",
    array: "O campo :attribute deverá conter entre :min - :max elementos."
  },
  boolean: "O campo :attribute deverá conter o valor verdadeiro ou falso.",
  confirmed: "A confirmação para o campo :attribute não coincide.",
  date: "O campo :attribute não contém uma data válida.",
  date_format: "A data indicada para o campo :attribute não respeita o formato :format.",
  different: "Os campos :attribute e :other deverão conter valores diferentes.",
  digits: "O campo :attribute deverá conter :digits caracteres.",
  digits_between: "O campo :attribute deverá conter entre :min a :max caracteres.",
  dimensions: "O campo :attribute deverá conter uma dimensão de imagem válida.",
  distinct: "O campo :attribute contém um valor duplicado.",
  email: "O campo :attribute não contém um endereço de correio eletrónico válido.",
  exists: "O valor selecionado para o campo :attribute é inválido.",
  file: "O campo :attribute deverá conter um ficheiro.",
  filled: "É obrigatória a indicação de um valor para o campo :attribute.",
  gt: {
    numeric: "The :attribute must be greater than :value.",
    file: "The :attribute must be greater than :value kilobytes.",
    string: "The :attribute must be greater than :value characters.",
    array: "The :attribute must have more than :value items."
  },
  gte: {
    numeric: "The :attribute must be greater than or equal :value.",
    file: "The :attribute must be greater than or equal :value kilobytes.",
    string: "The :attribute must be greater than or equal :value characters.",
    array: "The :attribute must have :value items or more."
  },
  hex: "The :attribute field should have hexadecimal format",
  image: "O campo :attribute deverá conter uma imagem.",
  in: "O campo :attribute não contém um valor válido.",
  in_array: "O campo :attribute não existe em :other.",
  integer: "O campo :attribute deverá conter um número inteiro.",
  ip: "O campo :attribute deverá conter um IP válido.",
  ipv4: "O campo :attribute deverá conter um IPv4 válido.",
  ipv6: "O campo :attribute deverá conter um IPv6 válido.",
  json: "O campo :attribute deverá conter um texto JSON válido.",
  lt: {
    numeric: "The :attribute must be less than :value.",
    file: "The :attribute must be less than :value kilobytes.",
    string: "The :attribute must be less than :value characters.",
    array: "The :attribute must have less than :value items."
  },
  lte: {
    numeric: "The :attribute must be less than or equal :value.",
    file: "The :attribute must be less than or equal :value kilobytes.",
    string: "The :attribute must be less than or equal :value characters.",
    array: "The :attribute must not have more than :value items."
  },
  max: {
    numeric: "O campo :attribute não deverá conter um valor superior a :max.",
    file: "O campo :attribute não deverá ter um tamanho superior a :max kilobytes.",
    string: "O campo :attribute não deverá conter mais de :max caracteres.",
    array: "O campo :attribute não deverá conter mais de :max elementos."
  },
  mimes: "O campo :attribute deverá conter um ficheiro do tipo: :values.",
  mimetypes: "O campo :attribute deverá conter um ficheiro do tipo: :values.",
  min: {
    numeric: "O campo :attribute deverá ter um valor superior ou igual a :min.",
    file: "O campo :attribute deverá ter no mínimo :min kilobytes.",
    string: "O campo :attribute deverá conter no mínimo :min caracteres.",
    array: "O campo :attribute deverá conter no mínimo :min elementos."
  },
  not_in: "O campo :attribute contém um valor inválido.",
  not_regex: "The :attribute format is invalid.",
  numeric: "O campo :attribute deverá conter um valor numérico.",
  present: "O campo :attribute deverá estar presente.",
  regex: "O formato do valor para o campo :attribute é inválido.",
  required: "É obrigatória a indicação de um valor para o campo :attribute.",
  required_if: "É obrigatória a indicação de um valor para o campo :attribute quando o valor do campo :other é igual a :value.",
  required_unless: "É obrigatória a indicação de um valor para o campo :attribute a menos que :other esteja presente em :values.",
  required_with: "É obrigatória a indicação de um valor para o campo :attribute quando :values está presente.",
  required_with_all: "É obrigatória a indicação de um valor para o campo :attribute quando um dos :values está presente.",
  required_without: "É obrigatória a indicação de um valor para o campo :attribute quando :values não está presente.",
  required_without_all: "É obrigatória a indicação de um valor para o campo :attribute quando nenhum dos :values está presente.",
  same: "Os campos :attribute e :other deverão conter valores iguais.",
  size: {
    numeric: "O campo :attribute deverá conter o valor :size.",
    file: "O campo :attribute deverá ter o tamanho de :size kilobytes.",
    string: "O campo :attribute deverá conter :size caracteres.",
    array: "O campo :attribute deverá conter :size elementos."
  },
  string: "O campo :attribute deverá conter texto.",
  timezone: "O campo :attribute deverá ter um fuso horário válido.",
  unique: "O valor indicado para o campo :attribute já se encontra registado.",
  uploaded: "O upload do ficheiro :attribute falhou.",
  url: "O formato do URL indicado para o campo :attribute é inválido."
};
const pt$1 = /* @__PURE__ */ getDefaultExportFromCjs(pt);
var tr = {
  accepted: ":attribute kabul edilmeli.",
  after: ":attribute alanı :after alanından sonra olmalıdır.",
  after_or_equal: ":attribute alanı :after_or_equal alanına eşit veya sonra olmalıdır.",
  alpha: ":attribute alanı sadece harflerden oluşabilir.",
  alpha_dash: ":attribute alanı sadece alfa-nümerik, tire ve alt çizgi karakterlerden oluşabilir.",
  alpha_num: ":attribute alanı alfa-nümerik olmalıdır.",
  before: ":attribute alanı :before alanından önce olmalıdır.",
  before_or_equal: ":attribute alanı :before_or_equal alanına eşit veya önce olmalıdır.",
  between: ":attribute alanı :min ile :max arasında olabilir.",
  confirmed: ":attribute uyuşmuyor.",
  email: ":attribute formatı geçersiz.",
  date: ":attribute geöerli bir tarih alanı değil.",
  def: ":attribute hatalar içeriyor.",
  digits: ":attribute sadece rakamlardan oluşabilir.",
  digits_between: ":attribute :min ile :max arasında rakam olmalıdır.",
  different: ":attribute ve :different farklı olmalı.",
  in: "Seçilen :attribute geçerli değil.",
  integer: ":attribute tam sayı olmalı.",
  hex: ":attribute onaltılık formatta olmalı.",
  min: {
    numeric: ":attribute en az :min olmalı.",
    string: ":attribute en az :min karakter uzunluğunda olmalı."
  },
  max: {
    numeric: ":attribute en çok :max olabilir.",
    string: ":attribute uzunluğu en çok :max karakter uzunluğunda olabilir."
  },
  not_in: "Seçilen :attribute geçerli değil.",
  numeric: ":attribute sayı olmalı.",
  present: ":attribute alanı bulunmalıdır (ancak boş olabilir).",
  required: ":attribute alanı gerekli.",
  required_if: ":attribute alanı :other alanı :value olduğunda gerekli.",
  required_unless: ":attribute alanı :other alanı :value değilse gereklidir.",
  required_with: ":attribute alanı :field boş değilse gereklidir.",
  required_with_all: ":attribute alanı :fields alanları boş değilse gereklidir.",
  required_without: ":attribute alanı :field alanı boşsa gereklidir.",
  required_without_all: ":attribute alanı :fields alanları boşsa gereklidir.",
  same: ":attribute ve :same aynı olmalı.",
  size: {
    numeric: ":attribute :size olmalı.",
    string: ":attribute :size karakter uzunluğunda olmalı."
  },
  string: ":attribute alfa-numerik olmalı.",
  url: ":attribute formatı geçersiz.",
  regex: ":attribute formatı geçersiz.",
  attributes: {}
};
const tr$1 = /* @__PURE__ */ getDefaultExportFromCjs(tr);
const metadata = { "version": 4, "country_calling_codes": { "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], "7": ["RU", "KZ"], "20": ["EG"], "27": ["ZA"], "30": ["GR"], "31": ["NL"], "32": ["BE"], "33": ["FR"], "34": ["ES"], "36": ["HU"], "39": ["IT", "VA"], "40": ["RO"], "41": ["CH"], "43": ["AT"], "44": ["GB", "GG", "IM", "JE"], "45": ["DK"], "46": ["SE"], "47": ["NO", "SJ"], "48": ["PL"], "49": ["DE"], "51": ["PE"], "52": ["MX"], "53": ["CU"], "54": ["AR"], "55": ["BR"], "56": ["CL"], "57": ["CO"], "58": ["VE"], "60": ["MY"], "61": ["AU", "CC", "CX"], "62": ["ID"], "63": ["PH"], "64": ["NZ"], "65": ["SG"], "66": ["TH"], "81": ["JP"], "82": ["KR"], "84": ["VN"], "86": ["CN"], "90": ["TR"], "91": ["IN"], "92": ["PK"], "93": ["AF"], "94": ["LK"], "95": ["MM"], "98": ["IR"], "211": ["SS"], "212": ["MA", "EH"], "213": ["DZ"], "216": ["TN"], "218": ["LY"], "220": ["GM"], "221": ["SN"], "222": ["MR"], "223": ["ML"], "224": ["GN"], "225": ["CI"], "226": ["BF"], "227": ["NE"], "228": ["TG"], "229": ["BJ"], "230": ["MU"], "231": ["LR"], "232": ["SL"], "233": ["GH"], "234": ["NG"], "235": ["TD"], "236": ["CF"], "237": ["CM"], "238": ["CV"], "239": ["ST"], "240": ["GQ"], "241": ["GA"], "242": ["CG"], "243": ["CD"], "244": ["AO"], "245": ["GW"], "246": ["IO"], "247": ["AC"], "248": ["SC"], "249": ["SD"], "250": ["RW"], "251": ["ET"], "252": ["SO"], "253": ["DJ"], "254": ["KE"], "255": ["TZ"], "256": ["UG"], "257": ["BI"], "258": ["MZ"], "260": ["ZM"], "261": ["MG"], "262": ["RE", "YT"], "263": ["ZW"], "264": ["NA"], "265": ["MW"], "266": ["LS"], "267": ["BW"], "268": ["SZ"], "269": ["KM"], "290": ["SH", "TA"], "291": ["ER"], "297": ["AW"], "298": ["FO"], "299": ["GL"], "350": ["GI"], "351": ["PT"], "352": ["LU"], "353": ["IE"], "354": ["IS"], "355": ["AL"], "356": ["MT"], "357": ["CY"], "358": ["FI", "AX"], "359": ["BG"], "370": ["LT"], "371": ["LV"], "372": ["EE"], "373": ["MD"], "374": ["AM"], "375": ["BY"], "376": ["AD"], "377": ["MC"], "378": ["SM"], "380": ["UA"], "381": ["RS"], "382": ["ME"], "383": ["XK"], "385": ["HR"], "386": ["SI"], "387": ["BA"], "389": ["MK"], "420": ["CZ"], "421": ["SK"], "423": ["LI"], "500": ["FK"], "501": ["BZ"], "502": ["GT"], "503": ["SV"], "504": ["HN"], "505": ["NI"], "506": ["CR"], "507": ["PA"], "508": ["PM"], "509": ["HT"], "590": ["GP", "BL", "MF"], "591": ["BO"], "592": ["GY"], "593": ["EC"], "594": ["GF"], "595": ["PY"], "596": ["MQ"], "597": ["SR"], "598": ["UY"], "599": ["CW", "BQ"], "670": ["TL"], "672": ["NF"], "673": ["BN"], "674": ["NR"], "675": ["PG"], "676": ["TO"], "677": ["SB"], "678": ["VU"], "679": ["FJ"], "680": ["PW"], "681": ["WF"], "682": ["CK"], "683": ["NU"], "685": ["WS"], "686": ["KI"], "687": ["NC"], "688": ["TV"], "689": ["PF"], "690": ["TK"], "691": ["FM"], "692": ["MH"], "850": ["KP"], "852": ["HK"], "853": ["MO"], "855": ["KH"], "856": ["LA"], "880": ["BD"], "886": ["TW"], "960": ["MV"], "961": ["LB"], "962": ["JO"], "963": ["SY"], "964": ["IQ"], "965": ["KW"], "966": ["SA"], "967": ["YE"], "968": ["OM"], "970": ["PS"], "971": ["AE"], "972": ["IL"], "973": ["BH"], "974": ["QA"], "975": ["BT"], "976": ["MN"], "977": ["NP"], "992": ["TJ"], "993": ["TM"], "994": ["AZ"], "995": ["GE"], "996": ["KG"], "998": ["UZ"] }, "countries": { "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([457]\\d{6})$", "268$1", 0, "268"], "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2457]\\d{6})$", "264$1", 0, "264"], "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "1|([267]\\d{6})$", "684$1", 0, "684"], "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "0|(183[12])", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "246$1", 0, "246"], "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], "BF": ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], "BG": ["359", "00", "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]]], "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], "BJ": ["229", "00", "(?:[25689]\\d|40)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], "BL": ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "441$1", 0, "441"], "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], "BO": ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([3-8]\\d{6})$", "242$1", 0, "242"], "BT": ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], "CA": ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-7]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CD": ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "0|(1(?:[12]\\d|79)\\d\\d)", 0, 0, 0, 0, "00"], "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["[39]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0(4(?:[14]4|56)|[579])?"], "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], "CU": ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|[23]1|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "767$1", 0, "767"], "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0"], "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "FK": ["500", "00", "[2-7]\\d{4}", [5]], "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[01359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[0-79]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-26-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "473$1", 0, "473"], "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], "GF": ["594", "00", "(?:[56]94|80\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "0|([25-9]\\d{5})$", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], "GI": ["350", "00", "(?:[25]\\d\\d|606)\\d{5}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], "GP": ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-289]|7[08]|8[0-689]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], "GT": ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "1|([3-9]\\d{6})$", "671$1", 0, "671"], "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], "GY": ["592", "001", "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]]], "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], "HR": ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], "HT": ["509", "00", "[2-489]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]]], "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], "ID": ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([25-8]\\d{5})$", "1624$1", 0, "74576|(?:16|7[56])24"], "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "IT": ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([0-24-8]\\d{5})$", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "JP": ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0"], "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "KG": ["996", "00", "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "869$1", 0, "869"], "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "345$1", 0, "345"], "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "758$1", 0, "758"], "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "0|(1001)"], "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], "LR": ["231", "00", "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"]], "0"], "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], "LV": ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[89]|389)", "5(?:29[89]|389)0"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:29(?:[189][05]|2[29]|3[01])|389[05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[08]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], "MF": ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "0|([24-9]\\d{6})$", "20$1"], "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "670$1", 0, "670"], "MQ": ["596", "00", "(?:69|80)\\d{7}|(?:59|97)6\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "1|([34]\\d{6})$", "664$1", 0, "664"], "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["5"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MW": ["265", "00", "(?:[129]\\d|31|77|88)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], "MX": ["52", "0[09]", "1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]]], "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], "NG": ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|59"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], "NR": ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], "NU": ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], "NZ": ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], "PL": ["48", "00", "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], "PM": ["508", "00", "(?:[45]|80\\d\\d)\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], "QA": ["974", "00", "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}", [7, 8, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]]]], "RE": ["262", "00", "976\\d{6}|(?:26|[68]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, "26[23]|69|[89]"], "RO": ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0"], "SA": ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], "SB": ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], "SC": ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-5]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]], "0"], "SR": ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], "SV": ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|(5\\d{6})$", "721$1", 0, "721"], "SY": ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "1|([2-479]\\d{6})$", "649$1", 0, "649"], "TD": ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "TJ": ["992", "810", "(?:00|[1-57-9]\\d)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], "TM": ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-46-8]\\d{6})$", "868$1", 0, "868"], "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], "TZ": ["255", "00[056]", "(?:[26-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|22|33)|4(?:00|4[24]|65|82)|5(?:00|29|58|83)|6(?:00|66|82)|7(?:58|77)|8(?:00|42|5[25]|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}"]]], "UY": ["598", "0(?:0|1[3-9]\\d)", "4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], "UZ": ["998", "810", "(?:33|55|[679]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "784$1", 0, "784"], "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-578]\\d{6})$", "284$1", 0, "284"], "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "340$1", 0, "340"], "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], "WF": ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "XK": ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], "YT": ["262", "00", "80\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, "269|63"], "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "ZM": ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, "nonGeographic": { "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], "870": ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], "881": ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]], "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["4"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[19]"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-3]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]], "883": ["883", 0, "(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?", [9, 10, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["2"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[35]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"]]], "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata);
  return func.apply(this, args);
}
function _typeof$3(obj) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$3(obj);
}
function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result2);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var ParseError = /* @__PURE__ */ function(_Error) {
  _inherits(ParseError2, _Error);
  var _super = _createSuper(ParseError2);
  function ParseError2(code) {
    var _this;
    _classCallCheck$2(this, ParseError2);
    _this = _super.call(this, code);
    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError2.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass$2(ParseError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9０-９٠-٩۰-۹";
var DASHES = "-‐-―−ー－";
var SLASHES = "／/";
var DOTS = "．.";
var WHITESPACE = "  ­​⁠　";
var BRACKETS = "()（）［］\\[\\]";
var TILDES = "~⁓∼～";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+＋";
function compare(a, b) {
  a = a.split("-");
  b = b.split("-");
  var pa = a[0].split(".");
  var pb = b[0].split(".");
  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb)
      return 1;
    if (nb > na)
      return -1;
    if (!isNaN(na) && isNaN(nb))
      return 1;
    if (isNaN(na) && !isNaN(nb))
      return -1;
  }
  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }
  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata2) {
    _classCallCheck$1(this, Metadata2);
    validateMetadata$1(metadata2);
    this.metadata = metadata2;
    setVersion.call(this, metadata2);
  }
  _createClass$1(Metadata2, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function(_) {
        return _ !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3)
        return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
    // Deprecated.
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = void 0;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata2 = this.nonGeographic()[callingCode];
        if (metadata2) {
          return metadata2;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return this.metadata.countries["001"];
        }
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1)
        return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== void 0;
    }
  }]);
  return Metadata2;
}();
var NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata2, globalMetadataObject) {
    _classCallCheck$1(this, NumberingPlan2);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata2;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  _createClass$1(NumberingPlan2, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2)
        return this.metadata[1];
      return this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1)
        return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata2) {
      return metadata2[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata2) {
      return metadata2[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2)
        return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
  return NumberingPlan2;
}();
var Format = /* @__PURE__ */ function() {
  function Format2(format, metadata2) {
    _classCallCheck$1(this, Format2);
    this._format = format;
    this.metadata = metadata2;
  }
  _createClass$1(Format2, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
  return Format2;
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /* @__PURE__ */ function() {
  function Type2(type, metadata2) {
    _classCallCheck$1(this, Type2);
    this.type = type;
    this.metadata = metadata2;
  }
  _createClass$1(Type2, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1)
        return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1)
        return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
  return Type2;
}();
function getType(types, type) {
  switch (type) {
    case "FIXED_LINE":
      return types[0];
    case "MOBILE":
      return types[1];
    case "TOLL_FREE":
      return types[2];
    case "PREMIUM_RATE":
      return types[3];
    case "PERSONAL_NUMBER":
      return types[4];
    case "VOICEMAIL":
      return types[5];
    case "UAN":
      return types[6];
    case "PAGER":
      return types[7];
    case "VOIP":
      return types[8];
    case "SHARED_COST":
      return types[9];
  }
}
function validateMetadata$1(metadata2) {
  if (!metadata2) {
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  }
  if (!is_object$3(metadata2) || !is_object$3(metadata2.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object$3(metadata2) ? "an object of shape: { " + Object.keys(metadata2).join(", ") + " }" : "a " + type_of(metadata2) + ": " + metadata2, "."));
  }
}
var is_object$3 = function is_object(_) {
  return _typeof$2(_) === "object";
};
var type_of = function type_of2(_) {
  return _typeof$2(_);
};
function getCountryCallingCode(country, metadata2) {
  metadata2 = new Metadata(metadata2);
  if (metadata2.hasCountry(country)) {
    return metadata2.country(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata2) {
  return metadata2.countries[country] !== void 0;
}
function setVersion(metadata2) {
  var version = metadata2.version;
  if (typeof version === "number") {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}
var RFC3966_EXTN_PREFIX = ";ext=";
var getExtensionDigitsPattern = function getExtensionDigitsPattern2(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20";
  var extLimitAfterLikelyLabel = "15";
  var extLimitAfterAmbiguousChar = "9";
  var extLimitWhenNotSure = "6";
  var possibleSeparatorsBetweenNumberAndExtLabel = "[  \\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.．]?[  \\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)";
  var ambiguousExtLabels = "(?:[xｘ#＃~～]|int|ｉｎｔ)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[  \\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
"(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
  // Either a short two-digit-only phone number
  "^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$",
  "i"
);
function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}
function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;
  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }
    i++;
  }
}
var DIGITS = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function parseDigit(character) {
  return DIGITS[character];
}
function _createForOfIteratorHelperLoose$5(o, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it2)
    return (it2 = it2.call(o)).next.bind(it2);
  if (Array.isArray(o) || (it2 = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it2)
      o = it2;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$6(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$6(o, minLen);
}
function _arrayLikeToArray$6(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function parseIncompletePhoneNumber(string) {
  var result2 = "";
  for (var _iterator = _createForOfIteratorHelperLoose$5(string.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  if (character === "+") {
    if (prevParsedCharacters) {
      return;
    }
    return "+";
  }
  return parseDigit(character);
}
function _createForOfIteratorHelperLoose$4(o, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it2)
    return (it2 = it2.call(o)).next.bind(it2);
  if (Array.isArray(o) || (it2 = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it2)
      o = it2;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$5(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$5(o, minLen);
}
function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function mergeArrays(a, b) {
  var merged = a.slice();
  for (var _iterator = _createForOfIteratorHelperLoose$4(b), _step; !(_step = _iterator()).done; ) {
    var element = _step.value;
    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }
  return merged.sort(function(a2, b2) {
    return a2 - b2;
  });
}
function checkNumberLength(nationalNumber, metadata2) {
  return checkNumberLengthForType(nationalNumber, void 0, metadata2);
}
function checkNumberLengthForType(nationalNumber, type, metadata2) {
  var type_info = metadata2.type(type);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata2.possibleLengths();
  if (!possible_lengths) {
    return "IS_POSSIBLE";
  }
  if (type === "FIXED_LINE_OR_MOBILE") {
    if (!metadata2.type("FIXED_LINE")) {
      return checkNumberLengthForType(nationalNumber, "MOBILE", metadata2);
    }
    var mobile_type = metadata2.type("MOBILE");
    if (mobile_type) {
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
    }
  } else if (type && !type_info) {
    return "INVALID_LENGTH";
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return "IS_POSSIBLE";
  }
  if (minimum_length > actual_length) {
    return "TOO_SHORT";
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return "TOO_LONG";
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function isPossiblePhoneNumber$2(input, options, metadata2) {
  if (options === void 0) {
    options = {};
  }
  metadata2 = new Metadata(metadata2);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error("Invalid phone number object passed");
    }
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata2.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata2.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error("Invalid phone number object passed");
      }
      metadata2.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata2.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata2);
  } else {
    if (input.countryCallingCode && metadata2.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "IS_POSSIBLE":
      return true;
    default:
      return false;
  }
}
function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _createForOfIteratorHelperLoose$3(o, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it2)
    return (it2 = it2.call(o)).next.bind(it2);
  if (Array.isArray(o) || (it2 = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it2)
      o = it2;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$4(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$4(o, minLen);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function parseRFC3966(text) {
  var number;
  var ext;
  text = text.replace(/^tel:/, "tel=");
  for (var _iterator = _createForOfIteratorHelperLoose$3(text.split(";")), _step; !(_step = _iterator()).done; ) {
    var part = _step.value;
    var _part$split = part.split("="), _part$split2 = _slicedToArray$1(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
    switch (name) {
      case "tel":
        number = value;
        break;
      case "ext":
        ext = value;
        break;
      case "phone-context":
        if (value[0] === "+") {
          number = value + number;
        }
        break;
    }
  }
  if (!isViablePhoneNumber(number)) {
    return {};
  }
  var result2 = {
    number
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function formatRFC3966(_ref) {
  var number = _ref.number, ext = _ref.ext;
  if (!number) {
    return "";
  }
  if (number[0] !== "+") {
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  }
  return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}
function matchesEntirely(text, regular_expression) {
  text = text || "";
  return new RegExp("^(?:" + regular_expression + ")$").test(text);
}
function _createForOfIteratorHelperLoose$2(o, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it2)
    return (it2 = it2.call(o)).next.bind(it2);
  if (Array.isArray(o) || (it2 = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it2)
      o = it2;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$3(o, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata2) {
  options = options || {};
  if (!input.country) {
    return;
  }
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata2)) {
    if (metadata2.type("MOBILE") && metadata2.type("MOBILE").pattern() === "") {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (!metadata2.type("MOBILE")) {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata2)) {
      return "FIXED_LINE_OR_MOBILE";
    }
    return "FIXED_LINE";
  }
  for (var _iterator = _createForOfIteratorHelperLoose$2(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done; ) {
    var type = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type, metadata2)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata2) {
  type = metadata2.type(type);
  if (!type || !type.pattern()) {
    return false;
  }
  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type.pattern());
}
function isValidNumber(input, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  if (!input.country) {
    return false;
  }
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata2.hasTypes()) {
    return getNumberType(input, options, metadata2.metadata) !== void 0;
  }
  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(national_number, metadata2.nationalNumberPattern());
}
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix;
  _ref.carrierCode;
  _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format()
  ));
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata2) {
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
function _createForOfIteratorHelperLoose$1(o, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it2)
    return (it2 = it2.call(o)).next.bind(it2);
  if (Array.isArray(o) || (it2 = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it2)
      o = it2;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$2(o, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$6(Object(source), true).forEach(function(key) {
      _defineProperty$6(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata2) {
    return "".concat(formattedNumber).concat(metadata2.ext()).concat(extension);
  }
};
function formatNumber(input, format, options, metadata2) {
  if (options) {
    options = _objectSpread$6(_objectSpread$6({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata2 = new Metadata(metadata2);
  if (input.country && input.country !== "001") {
    if (!metadata2.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata2.country(input.country);
  } else if (input.countryCallingCode) {
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else
    return input.phone || "";
  var countryCallingCode = metadata2.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number;
  switch (format) {
    case "NATIONAL":
      if (!nationalNumber) {
        return "";
      }
      number = formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata2, options);
      return addExtension(number, input.ext, metadata2, options.formatExtension);
    case "INTERNATIONAL":
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number = formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata2, options.formatExtension);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    case "IDD":
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata2);
      return addExtension(formattedNumber, input.ext, metadata2, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
  }
}
function formatNationalNumber(number, carrierCode, formatAs, metadata2, options) {
  var format = chooseFormatForNumber(metadata2.formats(), number);
  if (!format) {
    return number;
  }
  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode,
    metadata: metadata2
  });
}
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$1(availableFormats), _step; !(_step = _iterator()).done; ) {
    var format = _step.value;
    if (format.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    }
    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}
function addExtension(formattedNumber, ext, metadata2, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata2) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata2) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata2.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata2);
    if (countryCallingCode === "1") {
      return countryCallingCode + " " + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata2.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2));
  }
}
function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$5(Object(source), true).forEach(function(key) {
      _defineProperty$5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryCallingCode, nationalNumber, metadata2) {
    _classCallCheck(this, PhoneNumber2);
    if (!countryCallingCode) {
      throw new TypeError("`country` or `countryCallingCode` not passed");
    }
    if (!nationalNumber) {
      throw new TypeError("`nationalNumber` not passed");
    }
    if (!metadata2) {
      throw new TypeError("`metadata` not passed");
    }
    var _metadata = new Metadata(metadata2);
    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;
      _metadata.country(countryCallingCode);
      countryCallingCode = _metadata.countryCallingCode();
    }
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = "+" + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata2;
  }
  _createClass(PhoneNumber2, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber$2(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata2 = new Metadata(this.metadata);
      return metadata2.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
    // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }
  }, {
    key: "getType",
    value: function getType2() {
      return getNumberType(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$5(_objectSpread$5({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format("NATIONAL", options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format("INTERNATIONAL", options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format("RFC3966", options);
    }
  }]);
  return PhoneNumber2;
}();
var isCountryCode = function isCountryCode2(value) {
  return /^[A-Z]{2}$/.test(value);
};
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number, country, callingCode, metadata2) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number = number.slice(number.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === "0") {
      return;
    }
  }
  return number;
}
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata2) {
  if (number && metadata2.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata2.numberingPlan.nationalPrefixForParsing() + ")");
    var prefixMatch = prefixPattern.exec(number);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata2.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata2.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata2.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata2.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number
  };
}
function extractNationalNumber(number, metadata2) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata2), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata2)) {
      return {
        nationalNumber: number
      };
    }
    if (metadata2.possibleLengths()) {
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata2)) {
        return {
          nationalNumber: number
        };
      }
    }
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata2) {
  if (matchesEntirely(nationalNumberBefore, metadata2.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata2.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return false;
    default:
      return true;
  }
}
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata2) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata2) : callingCode;
  if (number.indexOf(countryCallingCode) === 0) {
    metadata2 = new Metadata(metadata2);
    metadata2.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata2), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number, metadata2), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata2.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata2) === "TOO_LONG") {
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number
  };
}
function extractCountryCallingCode(number, country, callingCode, metadata2) {
  if (!number) {
    return {};
  }
  if (number[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata2);
    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = "+" + numberWithoutIDD;
    } else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata2), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        number
      };
    }
  }
  if (number[1] === "0") {
    return {};
  }
  metadata2 = new Metadata(metadata2);
  var i = 2;
  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);
    if (metadata2.hasCallingCode(_countryCallingCode)) {
      metadata2.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }
    i++;
  }
  return {};
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it2)
    return (it2 = it2.call(o)).next.bind(it2);
  if (Array.isArray(o) || (it2 = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it2)
      o = it2;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata2) {
  var possibleCountries = metadata2.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata2.metadata);
}
function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata2) {
  metadata2 = new Metadata(metadata2);
  for (var _iterator = _createForOfIteratorHelperLoose(possibleCountries), _step; !(_step = _iterator()).done; ) {
    var country = _step.value;
    metadata2.country(country);
    if (metadata2.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata2.leadingDigits()) === 0) {
        return country;
      }
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata2.metadata)) {
      return country;
    }
  }
}
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse(text, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  if (options.defaultCountry && !metadata2.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === "TOO_SHORT") {
        throw new ParseError("TOO_SHORT");
      }
      throw new ParseError("NOT_A_NUMBER");
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber$1(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata2), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata2.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_SHORT");
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_LONG");
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata2.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    return phoneNumber;
  }
  var valid = (options.extended ? metadata2.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? true : options.extended === true && metadata2.possibleLengths() && isPossibleNumber(nationalNumber, metadata2) ? true : false,
    phone: nationalNumber,
    ext
  };
}
function extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError("TOO_LONG");
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
function parseInput(text, v2, extract) {
  if (text && text.indexOf("tel:") === 0) {
    return parseRFC3966(text);
  }
  var number = extractFormattedPhoneNumber(text, extract, v2);
  if (!number) {
    return {};
  }
  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: "TOO_SHORT"
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function parsePhoneNumber$1(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata2) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata2.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata2.selectNumberingPlan(countryCallingCode);
  } else if (number && (defaultCountry || defaultCallingCode)) {
    metadata2.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata2.metadata);
  } else
    return {};
  if (!number) {
    return {
      countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata2), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, nationalNumber, metadata2);
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === "001")
      ;
    else {
      metadata2.country(country);
    }
  }
  return {
    country,
    countryCallingCode,
    nationalNumber,
    carrierCode
  };
}
function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$4(Object(source), true).forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumber(text, options, metadata2) {
  return parse(text, _objectSpread$4(_objectSpread$4({}, options), {}, {
    v2: true
  }), metadata2);
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(source), true).forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata2;
  if (typeof arg_1 === "string") {
    text = arg_1;
  } else
    throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 === "string") {
    if (arg_4) {
      options = arg_3;
      metadata2 = arg_4;
    } else {
      options = void 0;
      metadata2 = arg_3;
    }
    if (arg_2) {
      options = _objectSpread$3({
        defaultCountry: arg_2
      }, options);
    }
  } else if (isObject$2(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata2 = arg_3;
    } else {
      metadata2 = arg_2;
    }
  } else
    throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text,
    options,
    metadata: metadata2
  };
}
var isObject$2 = function isObject(_) {
  return _typeof$1(_) === "object";
};
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumberFromString(text, options, metadata2) {
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata2)) {
    options = _objectSpread$2(_objectSpread$2({}, options), {}, {
      defaultCountry: void 0
    });
  }
  try {
    return parsePhoneNumber(text, options, metadata2);
  } catch (error) {
    if (error instanceof ParseError)
      ;
    else {
      throw error;
    }
  }
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function isValidPhoneNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata2 = _normalizeArguments.metadata;
  options = _objectSpread$1(_objectSpread$1({}, options), {}, {
    extract: false
  });
  var phoneNumber = parsePhoneNumberFromString(text, options, metadata2);
  return phoneNumber && phoneNumber.isValid() || false;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function isPossiblePhoneNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata2 = _normalizeArguments.metadata;
  options = _objectSpread(_objectSpread({}, options), {}, {
    extract: false
  });
  var phoneNumber = parsePhoneNumberFromString(text, options, metadata2);
  return phoneNumber && phoneNumber.isPossible() || false;
}
function isValidPhoneNumber() {
  return withMetadataArgument(isValidPhoneNumber$1, arguments);
}
function isPossiblePhoneNumber() {
  return withMetadataArgument(isPossiblePhoneNumber$1, arguments);
}
Validator$1.setMessages("ca", { def: "L'atribut :attribute té errors.", attributes: {}, ...ca$1 || {} });
Validator$1.setMessages("cs", { def: "Atribut :attribute obsahuje chyby.", attributes: {}, ...cs$1 || {} });
Validator$1.setMessages("da", { def: ":attribute attributen har fejl.", attributes: {}, ...da$1 || {} });
Validator$1.setMessages("de", { def: "Das :attribute Feld hat Fehler.", attributes: {}, ...de$1 || {} });
Validator$1.setMessages("el", { def: "Το πεδίο :attribute περιέχει σφάλματα.", attributes: {}, ...el$1 || {} });
Validator$1.setMessages("en", { def: "The :attribute attribute has errors.", attributes: {}, ...en$1 || {} });
Validator$1.setMessages("es", { def: "El atributo :attribute tiene errores.", attributes: {}, ...es$1 || {} });
Validator$1.setMessages("fr", { def: "Le champ :attribute contient un attribut erroné.", attributes: {}, ...fr$1 || {} });
Validator$1.setMessages("it", { def: "L'attributo :attribute contiene errori.", attributes: {}, ...it$1 || {} });
Validator$1.setMessages("nl", { def: "Het :attribute veld bevat fouten.", attributes: {}, ...nl$1 || {} });
Validator$1.setMessages("pt", { def: "O atributo :attribute contém erros.", attributes: {}, ...pt$1 || {} });
Validator$1.setMessages("tr", { def: ":attribute hatalar içeriyor.", attributes: {}, ...tr$1 || {} });
function leapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function checkFalsePositiveDates(dateString = "") {
  if (dateString.length === 10) {
    const normalizedDate = dateString.replace(".", "-").replace("/", "-");
    const parts = normalizedDate.split("-");
    if (parts.length === 3) {
      if (parts[0].length === 4) {
        const y = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10);
        const d = parseInt(parts[2], 10);
        if (m === 2) {
          if (leapYear(y)) {
            if (d > 29) {
              return false;
            }
          } else if (d > 28) {
            return false;
          }
        }
        if (m === 4 || m === 6 || m === 9 || m === 11) {
          if (d > 30) {
            return false;
          }
        }
      }
    }
    return true;
  }
  return true;
}
function isValidDate(dateString) {
  let testDate;
  if (typeof dateString === "number") {
    testDate = new Date(dateString);
    if (typeof testDate === "object") {
      return true;
    }
    dateString = `${dateString}`;
  }
  if (typeof dateString !== "string") {
    return false;
  }
  testDate = new Date(dateString);
  if (typeof testDate === "object") {
    if (testDate.toString() === "Invalid Date") {
      return false;
    }
    if (!checkFalsePositiveDates(dateString)) {
      return false;
    }
    return true;
  }
  const regex_date = /^\d{4}-\d{1,2}-\d{1,2}$/;
  if (!regex_date.test(dateString)) {
    return false;
  }
  const parts = dateString.split("-");
  const day = parseInt(parts[2], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[0], 10);
  if (year < 1e3 || year > 3e3 || month === 0 || month > 12) {
    return false;
  }
  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (year % 400 === 0 || year % 100 !== 0 && year % 4 === 0) {
    monthLength[1] = 29;
  }
  return day > 0 && day <= monthLength[month - 1];
}
function validateAndParseDates(inputValue, ruleValue, rule) {
  if (!isValidDate(inputValue)) {
    return null;
  }
  if (!isValidDate(ruleValue)) {
    if (typeof ruleValue !== "string" && typeof ruleValue !== "number") {
      return null;
    }
    if (typeof ruleValue === "string" && ["yesterday", "today", "tomorrow"].includes(ruleValue)) {
      const relativeReferenceDate = new Date(Date.now());
      const shouldIncrementDateAndSubtractSecond = ["before_or_equal", "after"].includes(rule.name) ? 1 : 0;
      const relativeDayOffset = {
        yesterday: -1 + shouldIncrementDateAndSubtractSecond,
        today: 0 + shouldIncrementDateAndSubtractSecond,
        tomorrow: 1 + shouldIncrementDateAndSubtractSecond
      };
      if (ruleValue in relativeDayOffset) {
        relativeReferenceDate.setDate(relativeReferenceDate.getDate() + relativeDayOffset[ruleValue]);
        relativeReferenceDate.setHours(0, 0, 0, -1 * shouldIncrementDateAndSubtractSecond);
      }
      rule.validator.setAttributeFormatter((attribute) => {
        if (attribute === ruleValue) {
          return [
            relativeReferenceDate.getFullYear(),
            (relativeReferenceDate.getMonth() + 1).toFixed(0).padStart(2, "0"),
            relativeReferenceDate.getDate().toFixed(0).padStart(2, "0")
          ].join("-");
        }
        return attribute;
      });
      return {
        inputValue: new Date(inputValue),
        ruleValue: new Date(relativeReferenceDate)
      };
    }
    const referencedRuleValue = rule.validator.input[ruleValue];
    if (!isValidDate(referencedRuleValue)) {
      return null;
    }
    return {
      inputValue: new Date(inputValue),
      ruleValue: new Date(referencedRuleValue)
    };
  }
  return {
    inputValue: new Date(inputValue),
    ruleValue: new Date(ruleValue)
  };
}
function after(val, req) {
  const parsed = validateAndParseDates(val, req, this);
  if (!parsed) {
    return false;
  }
  return parsed.ruleValue.getTime() < parsed.inputValue.getTime();
}
function after_or_equal(val, req) {
  const parsed = validateAndParseDates(val, req, this);
  if (!parsed) {
    return false;
  }
  return parsed.ruleValue.getTime() <= parsed.inputValue.getTime();
}
function before(val, req) {
  const parsed = validateAndParseDates(val, req, this);
  if (!parsed) {
    return false;
  }
  return parsed.ruleValue.getTime() > parsed.inputValue.getTime();
}
function before_or_equal(val, req) {
  const parsed = validateAndParseDates(val, req, this);
  if (!parsed) {
    return false;
  }
  return parsed.ruleValue.getTime() >= parsed.inputValue.getTime();
}
const originalEmailRule = new Validator$1({}, {}).getRule("email").fn;
function email(val, req, attribute) {
  if (typeof val !== "string") {
    return false;
  }
  if (!originalEmailRule(val, req, attribute)) {
    return false;
  }
  return /^[ -~]*$/.test(val);
}
function phone(val, _req, _attribute) {
  if (typeof val !== "string") {
    return false;
  }
  return isValidPhoneNumber(val);
}
function phone_possible(val, _req, _attribute) {
  if (typeof val !== "string") {
    return false;
  }
  return isPossiblePhoneNumber(val);
}
function distinct(_val, _req, _attribute) {
  return true;
}
const messages = Validator$1.getMessages(Validator$1.getDefaultLang());
Validator$1.register(
  "after",
  after,
  messages && typeof messages.after === "string" ? messages.after : void 0
);
Validator$1.register(
  "after_or_equal",
  after_or_equal,
  messages && typeof messages.after_or_equal === "string" ? messages.after_or_equal : void 0
);
Validator$1.register(
  "before",
  before,
  messages && typeof messages.before === "string" ? messages.before : void 0
);
Validator$1.register(
  "before_or_equal",
  before_or_equal,
  messages && typeof messages.before_or_equal === "string" ? messages.before_or_equal : void 0
);
Validator$1.register(
  "email",
  email,
  messages && typeof messages.email === "string" ? messages.email : void 0
);
Validator$1.register(
  "phone",
  phone,
  messages && typeof messages.phone === "string" ? messages.phone : void 0
);
Validator$1.register(
  "phone_possible",
  phone_possible,
  messages && typeof messages.phone_possible === "string" ? messages.phone_possible : void 0
);
Validator$1.register(
  "distinct",
  distinct,
  messages && typeof messages.distinct === "string" ? messages.distinct : void 0
);
function hasAttribute(object, attribute) {
  return !!object && typeof object === "object" && !Array.isArray(object) && attribute in object;
}
function slugError(message, slug, data) {
  return errorToSlugError(new Error(message), slug, data);
}
function errorToSlugError(error, slug, data) {
  const sluggedError = error;
  sluggedError.slug = `sdkshop.log.${slug.join(".")}`;
  if (data) {
    sluggedError.slugData = data;
  }
  return sluggedError;
}
function isSluggedError(v) {
  return !!v && typeof v === "object" && "slug" in v && typeof v.slug === "string";
}
function errorHasResponseStatus(value) {
  return hasAttribute(value, "response") && hasAttribute(value.response, "status") && typeof value.response.status === "number";
}
class ApiError extends Error {
  /**
   *  @internal Used to construct ApiErrors
   */
  constructor(error) {
    super(error && error.message || "Unknown error");
    /**
     *  The name of the error.
     */
    __publicField(this, "name", "ApiError");
    /**
     *  Containing information about why the error got thrown.
     */
    __publicField(this, "description");
    /**
     *  Containing the returned HTTP status code.
     */
    __publicField(this, "statusCode");
    /**
     *  Containing the original returned response like [AxiosResponse](https://github.com/axios/axios#response-schema).
     */
    __publicField(this, "response");
    if (error) {
      this.response = error.response;
    }
    this.statusCode = errorHasResponseStatus(this) ? this.response.status : 500;
    if (this.response && typeof this.response.data === "string") {
      this.description = this.response.data;
    } else if (this.response && this.response.data && hasAttribute(this.response.data, "error_description") && !!this.response.data.error_description) {
      if (hasAttribute(this.response.data.error_description, "message") && !!this.response.data.error_description.message) {
        this.description = this.response.data.error_description.message;
      } else {
        this.description = this.response.data.error_description;
      }
    } else if (this.response && this.response.statusText) {
      this.description = this.response.statusText;
    }
    if (typeof this.description === "string" || Array.isArray(this.description)) {
      this.description = this.description.length > 0 ? this.description : "Unknown error";
    } else if (typeof this.description === "object" && !Object.getOwnPropertyNames(this.description).length) {
      this.description = "Unknown error";
    }
    if (!this.description) {
      this.description = this.message;
    }
  }
}
class OrderApiError extends ApiError {
  constructor() {
    super(...arguments);
    /**
     *  The name of the error.
     */
    __publicField(this, "name", "OrderApiError");
  }
}
class ShopError extends Error {
  /**
   *  @internal Used to construct ShopErrors
   */
  constructor(message) {
    super(message);
    /**
     *  The name of the error.
     */
    __publicField(this, "name", "ShopError");
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
function forOwn(obj, cb, thisArg) {
  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
      continue;
    }
    if (cb.call(thisArg, obj[key], key, obj) === false) {
      break;
    }
  }
}
function forEach$1(items, cb, thisArg) {
  if (!Array.isArray(items)) {
    throw new TypeError(`ForEach util: provided items is not an Array: ${typeof items}`);
  }
  items.every((item, index) => cb.call(thisArg, item, index, items) !== false);
}
function arraysMatch(a, b) {
  if (a === b) {
    return true;
  }
  if (!Array.isArray(a) || !Array.isArray(b)) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }
  if (!a.length) {
    return true;
  }
  const aSorted = Array.from(a).sort();
  const bSorted = Array.from(b).sort();
  let matches = true;
  forEach$1(aSorted, (valueA) => {
    if (valueA !== bSorted.shift()) {
      matches = false;
    }
    return matches;
  });
  return matches;
}
function flattenObject(data, separator = ".") {
  if (!data) {
    return {};
  }
  return _flattenObject(data, separator, "", {}, [data]);
}
function _isFlattenableObject(value) {
  return typeof value === "object" && value !== null && !(value instanceof String) && !(value instanceof Number) && !(value instanceof Boolean) && !(value instanceof BigInt) && !(value instanceof Symbol);
}
function _flattenObject(data, separator, prefix, flatData, cyclic) {
  const newPrefix = prefix ? prefix + separator : "";
  const objects = {};
  forOwn(data, (value, key) => {
    if (_isFlattenableObject(value)) {
      if (cyclic.indexOf(value) > -1) {
        return;
      }
      cyclic.push(value);
      objects[key] = value;
    } else {
      flatData[`${newPrefix}${key}`] = value;
    }
  });
  forOwn(objects, (value, key) => {
    _flattenObject(value, separator, `${newPrefix}${key}`, flatData, cyclic);
  });
  return flatData;
}
function enumIncludes(enumValues, value) {
  if (enumValues.constructor !== Object) {
    throw new TypeError(`EnumIncludes util: provided enum is not an Object: ${typeof enumValues}`);
  }
  if (!value) {
    throw new Error("EnumIncludes util: value to check not provided");
  }
  let includes = false;
  forOwn(enumValues, (enumValue) => {
    if (enumValue === value) {
      includes = true;
    }
    return !includes;
  });
  return includes;
}
function isIndexSortable(model) {
  return !!model && typeof model.index === "number";
}
function isStartSortable(model) {
  return !!model && model.start instanceof Date;
}
function modelSort(modelA, modelB) {
  if (isIndexSortable(modelA) && isIndexSortable(modelB)) {
    if (modelA.index === modelB.index) {
      return 0;
    }
    return modelA.index < modelB.index ? -1 : 1;
  }
  if (isStartSortable(modelA) && isStartSortable(modelB)) {
    const timeA = modelA.start.getTime();
    const timeB = modelB.start.getTime();
    return timeA === timeB ? 0 : timeA - timeB;
  }
  return 0;
}
const promises = {};
function loadScript$1(src) {
  if (src in promises) {
    return promises[src];
  }
  promises[src] = new Promise((resolve, reject) => {
    try {
      const script = document.createElement("script");
      script.src = src;
      script.addEventListener("load", () => {
        resolve(script);
      });
      script.addEventListener("error", () => {
        reject(new Error(`Failed to load script: ${src}`));
      });
      document.head.appendChild(script);
    } catch (error) {
      reject(error);
    }
  });
  return promises[src];
}
function parseQuery() {
  if (!document || !document.location || !document.location.search) {
    return {};
  }
  const queryString = document.location.search;
  const queryParts = queryString.substr(queryString.indexOf("?") === 0 ? 1 : 0).split("&");
  const queryPartsZipped = queryParts.map((part) => {
    const eqPos = part.indexOf("=");
    return [
      part.substr(0, eqPos > -1 ? eqPos : void 0),
      eqPos > -1 ? part.substr(eqPos + 1) : ""
    ];
  }).filter(([key]) => !!key);
  const queryMap = {};
  forEach$1(queryPartsZipped, ([key, value]) => {
    queryMap[key] = queryMap[key] || [];
    queryMap[key].push(value);
  });
  const query = {};
  forOwn(queryMap, (values, key) => {
    if (values.length > 1) {
      query[key] = values;
    } else {
      [query[key]] = values;
    }
  });
  return query;
}
function guessTimezone() {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (zone && zone.length > 3) {
      return zone;
    }
  } catch (e) {
  }
  return void 0;
}
let adsBlockedPromise;
async function adsBlocked() {
  if (adsBlockedPromise) {
    return adsBlockedPromise;
  }
  if (!window || !window.fetch) {
    return true;
  }
  adsBlockedPromise = window.fetch("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", {
    method: "HEAD",
    mode: "no-cors",
    credentials: "omit",
    referrerPolicy: "no-referrer",
    cache: "no-store"
  }).then(() => false).catch(() => true);
  return adsBlockedPromise;
}
const TEST_LOCALSTORAGE_KEY$1 = "TEST_LOCALSTORAGE_KEY_OPENTICKET";
function hasLocalStorage$1() {
  try {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(TEST_LOCALSTORAGE_KEY$1, "yes");
      if (localStorage.getItem(TEST_LOCALSTORAGE_KEY$1) === "yes") {
        localStorage.removeItem(TEST_LOCALSTORAGE_KEY$1);
        return true;
      }
    }
    return false;
  } catch (e) {
    return false;
  }
}
function cartRemoveOnId(cart, idToSearchFor) {
  if (typeof cart !== "object" || !Array.isArray(cart) || cart.length === 0) {
    return;
  }
  for (let i = cart.length - 1; i >= 0; i--) {
    if (cart[i] && "id" in cart[i] && cart[i].id === idToSearchFor) {
      cart.splice(i, 1);
    }
  }
}
function round(value) {
  return Math.trunc(value >= 0 ? value + 0.5 : value - 0.5);
}
function sumBy(array, propertyToSum) {
  if (typeof array !== "object" || !Array.isArray(array)) {
    return 0;
  }
  return array.reduce((sum, item) => {
    if (item && typeof item === "object" && item[propertyToSum]) {
      const value = item[propertyToSum];
      if (typeof value === "number") {
        return sum + value;
      }
    }
    return sum;
  }, 0);
}
const realIds = {};
let counter = 0;
const MAX_DELAY = 2 ** 31 - 1;
function setLargeTimeout(handler, timeout, ...args) {
  return _setLargeTimeout(counter++, handler, timeout, ...args);
}
function _setLargeTimeout(index, handler, timeout, ...args) {
  if (!timeout || timeout <= MAX_DELAY) {
    realIds[index] = window.setTimeout(() => {
      delete realIds[index];
      handler.call(void 0, ...args);
    }, timeout, ...args);
    return index;
  }
  timeout -= MAX_DELAY;
  realIds[index] = window.setTimeout(() => {
    _setLargeTimeout(index, handler, timeout, ...args);
  }, MAX_DELAY);
  return index;
}
function clearLargeTimeout(handle) {
  const realTimerId = realIds[handle];
  delete realIds[handle];
  if (!realTimerId) {
    return;
  }
  window.clearTimeout(realTimerId);
}
let random = (bytes) => crypto.getRandomValues(new Uint8Array(bytes));
let customRandom = (alphabet, size, getRandom) => {
  let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
  let step = -~(1.6 * mask * size / alphabet.length);
  return () => {
    let id = "";
    while (true) {
      let bytes = getRandom(step);
      let j = step;
      while (j--) {
        id += alphabet[bytes[j] & mask] || "";
        if (id.length === size)
          return id;
      }
    }
  };
};
let customAlphabet = (alphabet, size) => customRandom(alphabet, size, random);
const easyToSpeakId = customAlphabet("346789ABCDEFGHJKLMNPQRTUVWXY", 12);
var MetadataAppliesTo = /* @__PURE__ */ ((MetadataAppliesTo2) => {
  MetadataAppliesTo2["Person"] = "person";
  MetadataAppliesTo2["Product"] = "product";
  return MetadataAppliesTo2;
})(MetadataAppliesTo || {});
var MetadataType = /* @__PURE__ */ ((MetadataType2) => {
  MetadataType2["Integer"] = "integer";
  MetadataType2["String"] = "string";
  MetadataType2["Date"] = "date";
  MetadataType2["Enum"] = "enum";
  MetadataType2["EnumOther"] = "enumOther";
  MetadataType2["Boolean"] = "boolean";
  MetadataType2["Values"] = "values";
  MetadataType2["SeatSelect"] = "seatSelect";
  MetadataType2["Phone"] = "phone";
  return MetadataType2;
})(MetadataType || {});
var CartAction = /* @__PURE__ */ ((CartAction2) => {
  CartAction2["Start"] = "start";
  CartAction2["End"] = "end";
  return CartAction2;
})(CartAction || {});
var CartItemChildType = /* @__PURE__ */ ((CartItemChildType2) => {
  CartItemChildType2["Tickets"] = "tickets";
  CartItemChildType2["Products"] = "products";
  return CartItemChildType2;
})(CartItemChildType || {});
var CartItemType = /* @__PURE__ */ ((CartItemType2) => {
  CartItemType2["Ticket"] = "ticket";
  CartItemType2["Product"] = "product";
  return CartItemType2;
})(CartItemType || {});
var TermsActions = /* @__PURE__ */ ((TermsActions2) => {
  TermsActions2["Accept"] = "Accept";
  TermsActions2["Reject"] = "Reject";
  return TermsActions2;
})(TermsActions || {});
const availableLocales = [
  "ar",
  "az",
  "be",
  "bg",
  "bs",
  "ca",
  "cs",
  "cy",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "eu",
  "fa",
  "fi",
  "fr",
  "hr",
  "hu",
  "id",
  "it",
  "ja",
  "ka",
  "ko",
  "lt",
  "lv",
  "mk",
  "mn",
  "ms",
  "nl",
  "pl",
  "pt",
  "ro",
  "ru",
  "se",
  "sl",
  "sq",
  "sr",
  "sv",
  "tr",
  "ua",
  "uk",
  "vi",
  "zh"
];
function addMetadataToCollection(metadata2, map, list, indexOffset = 0) {
  let defaultValue = null;
  if (metadata2.item.type === MetadataType.Boolean && !metadata2.item.extra.includes("required")) {
    defaultValue = false;
  }
  const cartMetaData = {
    item: metadata2.item,
    value: defaultValue,
    errors: [],
    index: metadata2.index + Math.max(0, indexOffset)
  };
  map[metadata2.guid] = cartMetaData;
  list.push(cartMetaData);
}
function addMetadataFromProduct(product, map, list, appliesTo, indexOffset = 0) {
  forEach$1(product.metadata, (metadata2) => {
    if (metadata2.item.applies_to !== appliesTo || Object.prototype.hasOwnProperty.call(map, metadata2.guid)) {
      return;
    }
    addMetadataToCollection(metadata2, map, list, indexOffset);
  });
  list.sort(modelSort);
}
function setValidationLang(locale) {
  if (["nb_NO", "pt_BR", "zh_TW"].includes(locale)) {
    Validator$1.useLang(locale);
    return;
  }
  const lang2 = locale.slice(0, 2);
  if (locale.length >= 2 && availableLocales.includes(lang2)) {
    Validator$1.useLang(lang2);
    return;
  }
  Validator$1.useLang("en");
}
function validateMetadata(metadata2, mutateErrors = true) {
  if (!metadata2) {
    throw new ShopError("Failed to validate metadata -> no cart metadata provided");
  }
  if (!metadata2.item || !metadata2.item.name || typeof metadata2.item.name !== "string") {
    throw new ShopError("Failed to validate metadata -> invalid metadata item");
  }
  if (!Object.prototype.hasOwnProperty.call(metadata2.item, "extra") || !(Array.isArray(metadata2.item.extra) || typeof metadata2.item.extra === "string")) {
    throw new ShopError("Failed to validate metadata -> invalid metadata rules");
  }
  if (!Object.prototype.hasOwnProperty.call(metadata2, "value")) {
    throw new ShopError("Failed to validate metadata -> value property not present on cart metadata");
  }
  const ruleStrOrRules = metadata2.item.extra;
  let rules2 = typeof ruleStrOrRules === "string" ? ruleStrOrRules.split("|") : ruleStrOrRules;
  if (metadata2.item.type === MetadataType.EnumOther) {
    rules2 = rules2.filter((rule) => !rule.startsWith("in:") && rule !== "distinct" && !rule.startsWith("distinct:"));
  }
  const name = metadata2.item.translateName || metadata2.item.name;
  const validator2 = new Validator$1(metadata2, { value: rules2 });
  validator2.setAttributeNames({ value: name.toString().toLowerCase() });
  validator2.check();
  const errors2 = validator2.errors.get("value");
  if (mutateErrors) {
    metadata2.errors.splice(0, metadata2.errors.length);
    metadata2.errors.push(...errors2);
  }
  return errors2;
}
function* metadataGen(cart, metadataId) {
  for (const key in cart.flatItems[CartItemChildType.Tickets]) {
    yield* metadataGenForTicketOrProduct(cart.flatItems[CartItemChildType.Tickets][key], metadataId);
  }
  for (const key in cart.flatItems[CartItemChildType.Products]) {
    yield* metadataGenForTicketOrProduct(cart.flatItems[CartItemChildType.Products][key], metadataId);
  }
}
function* metadataGenForTicketOrProduct(ticket2, metadataId) {
  for (const metadata2 of ticket2.metadataList) {
    if (!metadataId || metadata2.item.guid === metadataId) {
      yield metadata2;
    }
  }
}
class BaseValidator {
  /**
   *  Validate a specific cart metadata.
   *
   *  ```ts
   *  const cartMetadata = {
   *      item: shop.data.metadata[id],
   *      value: null,
   *      errors: [],
   *  };
   *
   *  const validationOk: string[] | undefined = cart.validateMetadata(cartMetadata);
   *  const validationOk: string[] | undefined = cart.validateMetadata(cartMetadata, false);
   *  ```
   *
   *  When the mutateErrors boolean is not set,
   *  the errors are returned, but not set on the cart metadata instance.
   *
   *  | Error                                    | Reason                              |
   *  | :--------------------------------------- | :---------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
   *
   *  Note: Failed validation will NOT throw an error
   */
  metadata(metadata2, mutateErrors = true) {
    const validationErrors = validateMetadata(metadata2, mutateErrors);
    return {
      valid: !validationErrors.length,
      message: validationErrors[0] || "",
      errors: validationErrors
    };
  }
}
function isHttpClient(client) {
  return !!client && !["delete", "get", "head", "options", "post", "put", "patch"].filter((method) => {
    if (!Object.prototype.hasOwnProperty.call(client, method)) {
      return true;
    }
    const pd = Object.getOwnPropertyDescriptor(client, method);
    return !pd || typeof pd.value !== "function";
  }).length;
}
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["None"] = "none";
  LogLevel2["Fatal"] = "fatal";
  LogLevel2["Error"] = "error";
  LogLevel2["Warning"] = "warning";
  LogLevel2["Info"] = "info";
  LogLevel2["Debug"] = "debug";
  return LogLevel2;
})(LogLevel || {});
var LogLevelNumber = /* @__PURE__ */ ((LogLevelNumber2) => {
  LogLevelNumber2[LogLevelNumber2["None"] = 1] = "None";
  LogLevelNumber2[LogLevelNumber2["Fatal"] = 2] = "Fatal";
  LogLevelNumber2[LogLevelNumber2["Error"] = 3] = "Error";
  LogLevelNumber2[LogLevelNumber2["Warning"] = 4] = "Warning";
  LogLevelNumber2[LogLevelNumber2["Info"] = 5] = "Info";
  LogLevelNumber2[LogLevelNumber2["Debug"] = 6] = "Debug";
  return LogLevelNumber2;
})(LogLevelNumber || {});
const logLevelNumberToString = {
  [
    1
    /* None */
  ]: "none",
  [
    2
    /* Fatal */
  ]: "fatal",
  [
    3
    /* Error */
  ]: "error",
  [
    4
    /* Warning */
  ]: "warning",
  [
    5
    /* Info */
  ]: "info",
  [
    6
    /* Debug */
  ]: "debug"
  /* Debug */
};
const logLevelStringToNumber = {
  [
    "none"
    /* None */
  ]: 1,
  [
    "fatal"
    /* Fatal */
  ]: 2,
  [
    "error"
    /* Error */
  ]: 3,
  [
    "warning"
    /* Warning */
  ]: 4,
  [
    "info"
    /* Info */
  ]: 5,
  [
    "debug"
    /* Debug */
  ]: 6
  /* Debug */
};
const SIZEOF_SHORT = 2;
const SIZEOF_INT = 4;
const FILE_IDENTIFIER_LENGTH = 4;
const SIZE_PREFIX_LENGTH = 4;
const int32 = new Int32Array(2);
const float32 = new Float32Array(int32.buffer);
const float64 = new Float64Array(int32.buffer);
const isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;
var Encoding;
(function(Encoding2) {
  Encoding2[Encoding2["UTF8_BYTES"] = 1] = "UTF8_BYTES";
  Encoding2[Encoding2["UTF16_STRING"] = 2] = "UTF16_STRING";
})(Encoding || (Encoding = {}));
class ByteBuffer {
  /**
   * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
   */
  constructor(bytes_) {
    this.bytes_ = bytes_;
    this.position_ = 0;
    this.text_decoder_ = new TextDecoder();
  }
  /**
   * Create and allocate a new ByteBuffer with a given size.
   */
  static allocate(byte_size) {
    return new ByteBuffer(new Uint8Array(byte_size));
  }
  clear() {
    this.position_ = 0;
  }
  /**
   * Get the underlying `Uint8Array`.
   */
  bytes() {
    return this.bytes_;
  }
  /**
   * Get the buffer's position.
   */
  position() {
    return this.position_;
  }
  /**
   * Set the buffer's position.
   */
  setPosition(position) {
    this.position_ = position;
  }
  /**
   * Get the buffer's capacity.
   */
  capacity() {
    return this.bytes_.length;
  }
  readInt8(offset) {
    return this.readUint8(offset) << 24 >> 24;
  }
  readUint8(offset) {
    return this.bytes_[offset];
  }
  readInt16(offset) {
    return this.readUint16(offset) << 16 >> 16;
  }
  readUint16(offset) {
    return this.bytes_[offset] | this.bytes_[offset + 1] << 8;
  }
  readInt32(offset) {
    return this.bytes_[offset] | this.bytes_[offset + 1] << 8 | this.bytes_[offset + 2] << 16 | this.bytes_[offset + 3] << 24;
  }
  readUint32(offset) {
    return this.readInt32(offset) >>> 0;
  }
  readInt64(offset) {
    return BigInt.asIntN(64, BigInt(this.readUint32(offset)) + (BigInt(this.readUint32(offset + 4)) << BigInt(32)));
  }
  readUint64(offset) {
    return BigInt.asUintN(64, BigInt(this.readUint32(offset)) + (BigInt(this.readUint32(offset + 4)) << BigInt(32)));
  }
  readFloat32(offset) {
    int32[0] = this.readInt32(offset);
    return float32[0];
  }
  readFloat64(offset) {
    int32[isLittleEndian ? 0 : 1] = this.readInt32(offset);
    int32[isLittleEndian ? 1 : 0] = this.readInt32(offset + 4);
    return float64[0];
  }
  writeInt8(offset, value) {
    this.bytes_[offset] = value;
  }
  writeUint8(offset, value) {
    this.bytes_[offset] = value;
  }
  writeInt16(offset, value) {
    this.bytes_[offset] = value;
    this.bytes_[offset + 1] = value >> 8;
  }
  writeUint16(offset, value) {
    this.bytes_[offset] = value;
    this.bytes_[offset + 1] = value >> 8;
  }
  writeInt32(offset, value) {
    this.bytes_[offset] = value;
    this.bytes_[offset + 1] = value >> 8;
    this.bytes_[offset + 2] = value >> 16;
    this.bytes_[offset + 3] = value >> 24;
  }
  writeUint32(offset, value) {
    this.bytes_[offset] = value;
    this.bytes_[offset + 1] = value >> 8;
    this.bytes_[offset + 2] = value >> 16;
    this.bytes_[offset + 3] = value >> 24;
  }
  writeInt64(offset, value) {
    this.writeInt32(offset, Number(BigInt.asIntN(32, value)));
    this.writeInt32(offset + 4, Number(BigInt.asIntN(32, value >> BigInt(32))));
  }
  writeUint64(offset, value) {
    this.writeUint32(offset, Number(BigInt.asUintN(32, value)));
    this.writeUint32(offset + 4, Number(BigInt.asUintN(32, value >> BigInt(32))));
  }
  writeFloat32(offset, value) {
    float32[0] = value;
    this.writeInt32(offset, int32[0]);
  }
  writeFloat64(offset, value) {
    float64[0] = value;
    this.writeInt32(offset, int32[isLittleEndian ? 0 : 1]);
    this.writeInt32(offset + 4, int32[isLittleEndian ? 1 : 0]);
  }
  /**
   * Return the file identifier.   Behavior is undefined for FlatBuffers whose
   * schema does not include a file_identifier (likely points at padding or the
   * start of a the root vtable).
   */
  getBufferIdentifier() {
    if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH) {
      throw new Error("FlatBuffers: ByteBuffer is too short to contain an identifier.");
    }
    let result2 = "";
    for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
      result2 += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + i));
    }
    return result2;
  }
  /**
   * Look up a field in the vtable, return an offset into the object, or 0 if the
   * field is not present.
   */
  __offset(bb_pos, vtable_offset) {
    const vtable = bb_pos - this.readInt32(bb_pos);
    return vtable_offset < this.readInt16(vtable) ? this.readInt16(vtable + vtable_offset) : 0;
  }
  /**
   * Initialize any Table-derived type to point to the union at the given offset.
   */
  __union(t, offset) {
    t.bb_pos = offset + this.readInt32(offset);
    t.bb = this;
    return t;
  }
  /**
   * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
   * This allocates a new string and converts to wide chars upon each access.
   *
   * To avoid the conversion to string, pass Encoding.UTF8_BYTES as the
   * "optionalEncoding" argument. This is useful for avoiding conversion when
   * the data will just be packaged back up in another FlatBuffer later on.
   *
   * @param offset
   * @param opt_encoding Defaults to UTF16_STRING
   */
  __string(offset, opt_encoding) {
    offset += this.readInt32(offset);
    const length = this.readInt32(offset);
    offset += SIZEOF_INT;
    const utf8bytes = this.bytes_.subarray(offset, offset + length);
    if (opt_encoding === Encoding.UTF8_BYTES)
      return utf8bytes;
    else
      return this.text_decoder_.decode(utf8bytes);
  }
  /**
   * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
   * if a string then return a new one
   *
   * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
   * makes the behaviour of __union_with_string different compared to __union
   */
  __union_with_string(o, offset) {
    if (typeof o === "string") {
      return this.__string(offset);
    }
    return this.__union(o, offset);
  }
  /**
   * Retrieve the relative offset stored at "offset"
   */
  __indirect(offset) {
    return offset + this.readInt32(offset);
  }
  /**
   * Get the start of data of a vector whose offset is stored at "offset" in this object.
   */
  __vector(offset) {
    return offset + this.readInt32(offset) + SIZEOF_INT;
  }
  /**
   * Get the length of a vector whose offset is stored at "offset" in this object.
   */
  __vector_len(offset) {
    return this.readInt32(offset + this.readInt32(offset));
  }
  __has_identifier(ident) {
    if (ident.length != FILE_IDENTIFIER_LENGTH) {
      throw new Error("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
    }
    for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
      if (ident.charCodeAt(i) != this.readInt8(this.position() + SIZEOF_INT + i)) {
        return false;
      }
    }
    return true;
  }
  /**
   * A helper function for generating list for obj api
   */
  createScalarList(listAccessor, listLength) {
    const ret = [];
    for (let i = 0; i < listLength; ++i) {
      const val = listAccessor(i);
      if (val !== null) {
        ret.push(val);
      }
    }
    return ret;
  }
  /**
   * A helper function for generating list for obj api
   * @param listAccessor function that accepts an index and return data at that index
   * @param listLength listLength
   * @param res result list
   */
  createObjList(listAccessor, listLength) {
    const ret = [];
    for (let i = 0; i < listLength; ++i) {
      const val = listAccessor(i);
      if (val !== null) {
        ret.push(val.unpack());
      }
    }
    return ret;
  }
}
class Builder {
  /**
   * Create a FlatBufferBuilder.
   */
  constructor(opt_initial_size) {
    this.minalign = 1;
    this.vtable = null;
    this.vtable_in_use = 0;
    this.isNested = false;
    this.object_start = 0;
    this.vtables = [];
    this.vector_num_elems = 0;
    this.force_defaults = false;
    this.string_maps = null;
    this.text_encoder = new TextEncoder();
    let initial_size;
    if (!opt_initial_size) {
      initial_size = 1024;
    } else {
      initial_size = opt_initial_size;
    }
    this.bb = ByteBuffer.allocate(initial_size);
    this.space = initial_size;
  }
  clear() {
    this.bb.clear();
    this.space = this.bb.capacity();
    this.minalign = 1;
    this.vtable = null;
    this.vtable_in_use = 0;
    this.isNested = false;
    this.object_start = 0;
    this.vtables = [];
    this.vector_num_elems = 0;
    this.force_defaults = false;
    this.string_maps = null;
  }
  /**
   * In order to save space, fields that are set to their default value
   * don't get serialized into the buffer. Forcing defaults provides a
   * way to manually disable this optimization.
   *
   * @param forceDefaults true always serializes default values
   */
  forceDefaults(forceDefaults) {
    this.force_defaults = forceDefaults;
  }
  /**
   * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
   * called finish(). The actual data starts at the ByteBuffer's current position,
   * not necessarily at 0.
   */
  dataBuffer() {
    return this.bb;
  }
  /**
   * Get the bytes representing the FlatBuffer. Only call this after you've
   * called finish().
   */
  asUint8Array() {
    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
  }
  /**
   * Prepare to write an element of `size` after `additional_bytes` have been
   * written, e.g. if you write a string, you need to align such the int length
   * field is aligned to 4 bytes, and the string data follows it directly. If all
   * you need to do is alignment, `additional_bytes` will be 0.
   *
   * @param size This is the of the new element to write
   * @param additional_bytes The padding size
   */
  prep(size, additional_bytes) {
    if (size > this.minalign) {
      this.minalign = size;
    }
    const align_size = ~(this.bb.capacity() - this.space + additional_bytes) + 1 & size - 1;
    while (this.space < align_size + size + additional_bytes) {
      const old_buf_size = this.bb.capacity();
      this.bb = Builder.growByteBuffer(this.bb);
      this.space += this.bb.capacity() - old_buf_size;
    }
    this.pad(align_size);
  }
  pad(byte_size) {
    for (let i = 0; i < byte_size; i++) {
      this.bb.writeInt8(--this.space, 0);
    }
  }
  writeInt8(value) {
    this.bb.writeInt8(this.space -= 1, value);
  }
  writeInt16(value) {
    this.bb.writeInt16(this.space -= 2, value);
  }
  writeInt32(value) {
    this.bb.writeInt32(this.space -= 4, value);
  }
  writeInt64(value) {
    this.bb.writeInt64(this.space -= 8, value);
  }
  writeFloat32(value) {
    this.bb.writeFloat32(this.space -= 4, value);
  }
  writeFloat64(value) {
    this.bb.writeFloat64(this.space -= 8, value);
  }
  /**
   * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int8` to add the buffer.
   */
  addInt8(value) {
    this.prep(1, 0);
    this.writeInt8(value);
  }
  /**
   * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int16` to add the buffer.
   */
  addInt16(value) {
    this.prep(2, 0);
    this.writeInt16(value);
  }
  /**
   * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int32` to add the buffer.
   */
  addInt32(value) {
    this.prep(4, 0);
    this.writeInt32(value);
  }
  /**
   * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int64` to add the buffer.
   */
  addInt64(value) {
    this.prep(8, 0);
    this.writeInt64(value);
  }
  /**
   * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float32` to add the buffer.
   */
  addFloat32(value) {
    this.prep(4, 0);
    this.writeFloat32(value);
  }
  /**
   * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float64` to add the buffer.
   */
  addFloat64(value) {
    this.prep(8, 0);
    this.writeFloat64(value);
  }
  addFieldInt8(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addInt8(value);
      this.slot(voffset);
    }
  }
  addFieldInt16(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addInt16(value);
      this.slot(voffset);
    }
  }
  addFieldInt32(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addInt32(value);
      this.slot(voffset);
    }
  }
  addFieldInt64(voffset, value, defaultValue) {
    if (this.force_defaults || value !== defaultValue) {
      this.addInt64(value);
      this.slot(voffset);
    }
  }
  addFieldFloat32(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addFloat32(value);
      this.slot(voffset);
    }
  }
  addFieldFloat64(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addFloat64(value);
      this.slot(voffset);
    }
  }
  addFieldOffset(voffset, value, defaultValue) {
    if (this.force_defaults || value != defaultValue) {
      this.addOffset(value);
      this.slot(voffset);
    }
  }
  /**
   * Structs are stored inline, so nothing additional is being added. `d` is always 0.
   */
  addFieldStruct(voffset, value, defaultValue) {
    if (value != defaultValue) {
      this.nested(value);
      this.slot(voffset);
    }
  }
  /**
   * Structures are always stored inline, they need to be created right
   * where they're used.  You'll get this assertion failure if you
   * created it elsewhere.
   */
  nested(obj) {
    if (obj != this.offset()) {
      throw new TypeError("FlatBuffers: struct must be serialized inline.");
    }
  }
  /**
   * Should not be creating any other object, string or vector
   * while an object is being constructed
   */
  notNested() {
    if (this.isNested) {
      throw new TypeError("FlatBuffers: object serialization must not be nested.");
    }
  }
  /**
   * Set the current vtable at `voffset` to the current location in the buffer.
   */
  slot(voffset) {
    if (this.vtable !== null)
      this.vtable[voffset] = this.offset();
  }
  /**
   * @returns Offset relative to the end of the buffer.
   */
  offset() {
    return this.bb.capacity() - this.space;
  }
  /**
   * Doubles the size of the backing ByteBuffer and copies the old data towards
   * the end of the new buffer (since we build the buffer backwards).
   *
   * @param bb The current buffer with the existing data
   * @returns A new byte buffer with the old data copied
   * to it. The data is located at the end of the buffer.
   *
   * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
   * it a uint8Array we need to suppress the type check:
   * @suppress {checkTypes}
   */
  static growByteBuffer(bb) {
    const old_buf_size = bb.capacity();
    if (old_buf_size & 3221225472) {
      throw new Error("FlatBuffers: cannot grow buffer beyond 2 gigabytes.");
    }
    const new_buf_size = old_buf_size << 1;
    const nbb = ByteBuffer.allocate(new_buf_size);
    nbb.setPosition(new_buf_size - old_buf_size);
    nbb.bytes().set(bb.bytes(), new_buf_size - old_buf_size);
    return nbb;
  }
  /**
   * Adds on offset, relative to where it will be written.
   *
   * @param offset The offset to add.
   */
  addOffset(offset) {
    this.prep(SIZEOF_INT, 0);
    this.writeInt32(this.offset() - offset + SIZEOF_INT);
  }
  /**
   * Start encoding a new object in the buffer.  Users will not usually need to
   * call this directly. The FlatBuffers compiler will generate helper methods
   * that call this method internally.
   */
  startObject(numfields) {
    this.notNested();
    if (this.vtable == null) {
      this.vtable = [];
    }
    this.vtable_in_use = numfields;
    for (let i = 0; i < numfields; i++) {
      this.vtable[i] = 0;
    }
    this.isNested = true;
    this.object_start = this.offset();
  }
  /**
   * Finish off writing the object that is under construction.
   *
   * @returns The offset to the object inside `dataBuffer`
   */
  endObject() {
    if (this.vtable == null || !this.isNested) {
      throw new Error("FlatBuffers: endObject called without startObject");
    }
    this.addInt32(0);
    const vtableloc = this.offset();
    let i = this.vtable_in_use - 1;
    for (; i >= 0 && this.vtable[i] == 0; i--) {
    }
    const trimmed_size = i + 1;
    for (; i >= 0; i--) {
      this.addInt16(this.vtable[i] != 0 ? vtableloc - this.vtable[i] : 0);
    }
    const standard_fields = 2;
    this.addInt16(vtableloc - this.object_start);
    const len = (trimmed_size + standard_fields) * SIZEOF_SHORT;
    this.addInt16(len);
    let existing_vtable = 0;
    const vt1 = this.space;
    outer_loop:
      for (i = 0; i < this.vtables.length; i++) {
        const vt2 = this.bb.capacity() - this.vtables[i];
        if (len == this.bb.readInt16(vt2)) {
          for (let j = SIZEOF_SHORT; j < len; j += SIZEOF_SHORT) {
            if (this.bb.readInt16(vt1 + j) != this.bb.readInt16(vt2 + j)) {
              continue outer_loop;
            }
          }
          existing_vtable = this.vtables[i];
          break;
        }
      }
    if (existing_vtable) {
      this.space = this.bb.capacity() - vtableloc;
      this.bb.writeInt32(this.space, existing_vtable - vtableloc);
    } else {
      this.vtables.push(this.offset());
      this.bb.writeInt32(this.bb.capacity() - vtableloc, this.offset() - vtableloc);
    }
    this.isNested = false;
    return vtableloc;
  }
  /**
   * Finalize a buffer, poiting to the given `root_table`.
   */
  finish(root_table, opt_file_identifier, opt_size_prefix) {
    const size_prefix = opt_size_prefix ? SIZE_PREFIX_LENGTH : 0;
    if (opt_file_identifier) {
      const file_identifier = opt_file_identifier;
      this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + size_prefix);
      if (file_identifier.length != FILE_IDENTIFIER_LENGTH) {
        throw new TypeError("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
      }
      for (let i = FILE_IDENTIFIER_LENGTH - 1; i >= 0; i--) {
        this.writeInt8(file_identifier.charCodeAt(i));
      }
    }
    this.prep(this.minalign, SIZEOF_INT + size_prefix);
    this.addOffset(root_table);
    if (size_prefix) {
      this.addInt32(this.bb.capacity() - this.space);
    }
    this.bb.setPosition(this.space);
  }
  /**
   * Finalize a size prefixed buffer, pointing to the given `root_table`.
   */
  finishSizePrefixed(root_table, opt_file_identifier) {
    this.finish(root_table, opt_file_identifier, true);
  }
  /**
   * This checks a required field has been set in a given table that has
   * just been constructed.
   */
  requiredField(table, field) {
    const table_start = this.bb.capacity() - table;
    const vtable_start = table_start - this.bb.readInt32(table_start);
    const ok = field < this.bb.readInt16(vtable_start) && this.bb.readInt16(vtable_start + field) != 0;
    if (!ok) {
      throw new TypeError("FlatBuffers: field " + field + " must be set");
    }
  }
  /**
   * Start a new array/vector of objects.  Users usually will not call
   * this directly. The FlatBuffers compiler will create a start/end
   * method for vector types in generated code.
   *
   * @param elem_size The size of each element in the array
   * @param num_elems The number of elements in the array
   * @param alignment The alignment of the array
   */
  startVector(elem_size, num_elems, alignment) {
    this.notNested();
    this.vector_num_elems = num_elems;
    this.prep(SIZEOF_INT, elem_size * num_elems);
    this.prep(alignment, elem_size * num_elems);
  }
  /**
   * Finish off the creation of an array and all its elements. The array must be
   * created with `startVector`.
   *
   * @returns The offset at which the newly created array
   * starts.
   */
  endVector() {
    this.writeInt32(this.vector_num_elems);
    return this.offset();
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If the string passed has
   * already been seen, we return the offset of the already written string
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createSharedString(s) {
    if (!s) {
      return 0;
    }
    if (!this.string_maps) {
      this.string_maps = /* @__PURE__ */ new Map();
    }
    if (this.string_maps.has(s)) {
      return this.string_maps.get(s);
    }
    const offset = this.createString(s);
    this.string_maps.set(s, offset);
    return offset;
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
   * instead of a string, it is assumed to contain valid UTF-8 encoded data.
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createString(s) {
    if (s === null || s === void 0) {
      return 0;
    }
    let utf8;
    if (s instanceof Uint8Array) {
      utf8 = s;
    } else {
      utf8 = this.text_encoder.encode(s);
    }
    this.addInt8(0);
    this.startVector(1, utf8.length, 1);
    this.bb.setPosition(this.space -= utf8.length);
    this.bb.bytes().set(utf8, this.space);
    return this.endVector();
  }
  /**
   * Create a byte vector.
   *
   * @param v The bytes to add
   * @returns The offset in the buffer where the byte vector starts
   */
  createByteVector(v) {
    if (v === null || v === void 0) {
      return 0;
    }
    this.startVector(1, v.length, 1);
    this.bb.setPosition(this.space -= v.length);
    this.bb.bytes().set(v, this.space);
    return this.endVector();
  }
  /**
   * A helper function to pack an object
   *
   * @returns offset of obj
   */
  createObjectOffset(obj) {
    if (obj === null) {
      return 0;
    }
    if (typeof obj === "string") {
      return this.createString(obj);
    } else {
      return obj.pack(this);
    }
  }
  /**
   * A helper function to pack a list of object
   *
   * @returns list of offsets of each non null object
   */
  createObjectOffsetList(list) {
    const ret = [];
    for (let i = 0; i < list.length; ++i) {
      const val = list[i];
      if (val !== null) {
        ret.push(this.createObjectOffset(val));
      } else {
        throw new TypeError("FlatBuffers: Argument for createObjectOffsetList cannot contain null.");
      }
    }
    return ret;
  }
  createStructOffsetList(list, startFunc) {
    startFunc(this, list.length);
    this.createObjectOffsetList(list.slice().reverse());
    return this.endVector();
  }
}
function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const { iterator, toStringTag } = Symbol;
const kindOf = /* @__PURE__ */ ((cache) => (thing) => {
  const str = toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null));
const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type;
};
const typeOfTest = (type) => (thing) => typeof thing === type;
const { isArray } = Array;
const isUndefined = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result2;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result2 = ArrayBuffer.isView(val);
  } else {
    result2 = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result2;
}
const isString = typeOfTest("string");
const isFunction = typeOfTest("function");
const isNumber = typeOfTest("number");
const isObject$1 = (thing) => thing !== null && typeof thing === "object";
const isBoolean = (thing) => thing === true || thing === false;
const isPlainObject = (val) => {
  if (kindOf(val) !== "object") {
    return false;
  }
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(toStringTag in val) && !(iterator in val);
};
const isDate = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject$1(val) && isFunction(val.pipe);
const isFormData = (thing) => {
  let kind;
  return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
  kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest);
const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(obj, fn, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i;
  let l;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined")
    return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context) => !isUndefined(context) && context !== _global;
function merge() {
  const { caseless } = isContextDefined(this) && this || {};
  const result2 = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result2, key) || key;
    if (isPlainObject(result2[targetKey]) && isPlainObject(val)) {
      result2[targetKey] = merge(result2[targetKey], val);
    } else if (isPlainObject(val)) {
      result2[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result2[targetKey] = val.slice();
    } else {
      result2[targetKey] = val;
    }
  };
  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result2;
}
const extend = (a, b, thisArg, { allOwnKeys } = {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, { allOwnKeys });
  return a;
};
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};
const toFlatObject = (sourceObj, destObj, filter2, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null)
    return destObj;
  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter2 !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter2 || filter2(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray = (thing) => {
  if (!thing)
    return null;
  if (isArray(thing))
    return thing;
  let i = thing.length;
  if (!isNumber(i))
    return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};
const isTypedArray = /* @__PURE__ */ ((TypedArray) => {
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[iterator];
  const _iterator = generator.call(obj);
  let result2;
  while ((result2 = _iterator.next()) && !result2.done) {
    const pair = result2.value;
    fn.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];
  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};
const hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors2, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    if (isFunction(obj) && ["arguments", "caller", "callee"].indexOf(name) !== -1) {
      return false;
    }
    const value = obj[name];
    if (!isFunction(value))
      return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };
  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
  return obj;
};
const noop = () => {
};
const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[toStringTag] === "FormData" && thing[iterator]);
}
const toJSONObject = (obj) => {
  const stack = new Array(10);
  const visit = (source, i) => {
    if (isObject$1(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }
      if (!("toJSON" in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });
        stack[i] = void 0;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing) => thing && (isObject$1(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }
  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({ source, data }) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);
    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    };
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === "function",
  isFunction(_global.postMessage)
);
const asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind(_global) : typeof process !== "undefined" && process.nextTick || _setImmediate;
const isIterable = (thing) => thing != null && isFunction(thing[iterator]);
const utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: isObject$1,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap,
  isIterable
};
function AxiosError$1(message, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}
utils$1.inherits(AxiosError$1, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const prototype$1 = AxiosError$1.prototype;
const descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError$1, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: true });
AxiosError$1.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  utils$1.toFlatObject(error, axiosError, function filter2(obj) {
    return obj !== Error.prototype;
  }, (prop) => {
    return prop !== "isAxiosError";
  });
  AxiosError$1.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
const httpAdapter = null;
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}
function removeBrackets(key) {
  return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
function renderKey(path, key, dots) {
  if (!path)
    return key;
  return path.concat(key).map(function each(token, i) {
    token = removeBrackets(token);
    return !dots && i ? "[" + token + "]" : token;
  }).join(dots ? "." : "");
}
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});
function toFormData$1(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError("target must be an object");
  }
  formData = formData || new FormData();
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    return !utils$1.isUndefined(source[option]);
  });
  const metaTokens = options.metaTokens;
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
  if (!utils$1.isFunction(visitor)) {
    throw new TypeError("visitor must be a function");
  }
  function convertValue(value) {
    if (value === null)
      return "";
    if (utils$1.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError$1("Blob is not supported. Use a Buffer instead.");
    }
    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === "object") {
      if (utils$1.endsWith(key, "{}")) {
        key = metaTokens ? key : key.slice(0, -2);
        value = JSON.stringify(value);
      } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value))) {
        key = removeBrackets(key);
        arr.forEach(function each(el2, index) {
          !(utils$1.isUndefined(el2) || el2 === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + "[]",
            convertValue(el2)
          );
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (utils$1.isUndefined(value))
      return;
    if (stack.indexOf(value) !== -1) {
      throw Error("Circular reference detected in " + path.join("."));
    }
    stack.push(value);
    utils$1.forEach(value, function each(el2, key) {
      const result2 = !(utils$1.isUndefined(el2) || el2 === null) && visitor.call(
        formData,
        el2,
        utils$1.isString(key) ? key.trim() : key,
        path,
        exposedHelpers
      );
      if (result2 === true) {
        build(el2, path ? path.concat(key) : [key]);
      }
    });
    stack.pop();
  }
  if (!utils$1.isObject(obj)) {
    throw new TypeError("data must be an object");
  }
  build(obj);
  return formData;
}
function encode$1(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && toFormData$1(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};
prototype.toString = function toString2(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;
  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + "=" + _encode(pair[1]);
  }, "").join("&");
};
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
  if (!params) {
    return url;
  }
  const _encode = options && options.encode || encode;
  if (utils$1.isFunction(options)) {
    options = {
      serialize: options
    };
  }
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
const FormData$1 = typeof FormData !== "undefined" ? FormData : null;
const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
const platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
const _navigator = typeof navigator === "object" && navigator || void 0;
const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0);
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const origin = hasBrowserEnv && window.location.href || "http://localhost";
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin
}, Symbol.toStringTag, { value: "Module" }));
const platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(data, options) {
  return toFormData$1(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString("base64"));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
function parsePropPath(name) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map((match) => {
    return match[0] === "[]" ? "" : match[1] || match[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    if (name === "__proto__")
      return true;
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;
    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }
      return !isNumericKey;
    }
    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }
    const result2 = buildPath(path, value, target[name], index);
    if (result2 && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }
    return !isNumericKey;
  }
  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};
    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });
    return obj;
  }
  return null;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || "";
    const hasJSONContentType = contentType.indexOf("application/json") > -1;
    const isObjectPayload = utils$1.isObject(data);
    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData2 = utils$1.isFormData(data);
    if (isFormData2) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }
    if (utils$1.isArrayBuffer(data) || utils$1.isBuffer(data) || utils$1.isStream(data) || utils$1.isFile(data) || utils$1.isBlob(data) || utils$1.isReadableStream(data)) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
      return data.toString();
    }
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList2 = utils$1.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData$1(
          isFileList2 ? { "files[]": data } : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType("application/json", false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional2 = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    const JSONRequested = this.responseType === "json";
    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }
    if (data && utils$1.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw AxiosError$1.from(e, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
  defaults.headers[method] = {};
});
const defaults$1 = defaults;
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
const parseHeaders = (rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
    i = line.indexOf(":");
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === "set-cookie") {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    }
  });
  return parsed;
};
const $internals = Symbol("internals");
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens = /* @__PURE__ */ Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;
  while (match = tokensRE.exec(str)) {
    tokens[match[1]] = match[2];
  }
  return tokens;
}
const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter2, isHeaderNameFilter) {
  if (utils$1.isFunction(filter2)) {
    return filter2.call(this, value, header);
  }
  if (isHeaderNameFilter) {
    value = header;
  }
  if (!utils$1.isString(value))
    return;
  if (utils$1.isString(filter2)) {
    return value.indexOf(filter2) !== -1;
  }
  if (utils$1.isRegExp(filter2)) {
    return filter2.test(value);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(" " + header);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
let AxiosHeaders$1 = class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error("header name must be a non-empty string");
      }
      const key = utils$1.findKey(self2, lHeader);
      if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
        self2[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers, _rewrite) => utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isObject(header) && utils$1.isIterable(header)) {
      let obj = {}, dest, key;
      for (const entry of header) {
        if (!utils$1.isArray(entry)) {
          throw TypeError("Object iterator must return a key-value pair");
        }
        obj[key = entry[0]] = (dest = obj[key]) ? utils$1.isArray(dest) ? [...dest, entry[1]] : [dest, entry[1]] : entry[1];
      }
      setHeaders(obj, valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  }
  get(header, parser) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(header, matcher) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  }
  delete(header, matcher) {
    const self2 = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils$1.findKey(self2, _header);
        if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
          delete self2[key];
          deleted = true;
        }
      }
    }
    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  }
  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;
    while (i--) {
      const key = keys[i];
      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format) {
    const self2 = this;
    const headers = {};
    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);
      if (key) {
        self2[key] = normalizeValue(value);
        delete self2[header];
        return;
      }
      const normalized = format ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self2[header];
      }
      self2[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = /* @__PURE__ */ Object.create(null);
    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed = new this(first);
    targets.forEach((target) => computed.set(target));
    return computed;
  }
  static accessor(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype2, _header);
        accessors[lHeader] = true;
      }
    }
    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
};
AxiosHeaders$1.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders$1.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders$1);
const AxiosHeaders$2 = AxiosHeaders$1;
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders$2.from(context.headers);
  let data = context.data;
  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : void 0);
  });
  headers.normalize();
  return data;
}
function isCancel$1(value) {
  return !!(value && value.__CANCEL__);
}
function CanceledError$1(message, config, request) {
  AxiosError$1.call(this, message == null ? "canceled" : message, AxiosError$1.ERR_CANCELED, config, request);
  this.name = "CanceledError";
}
utils$1.inherits(CanceledError$1, AxiosError$1, {
  __CANCEL__: true
});
function settle(resolve, reject, response) {
  const validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError$1(
      "Request failed with status code " + response.status,
      [AxiosError$1.ERR_BAD_REQUEST, AxiosError$1.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}
function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || "";
}
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min = min !== void 0 ? min : 1e3;
  return function push(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i = tail;
    let bytesCount = 0;
    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now - firstSampleTS < min) {
      return;
    }
    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  };
}
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1e3 / freq;
  let lastArgs;
  let timer;
  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  };
  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if (passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };
  const flush = () => lastArgs && invoke(lastArgs);
  return [throttled, flush];
}
const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return throttle((e) => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : void 0;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate ? rate : void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? "download" : "upload"]: true
    };
    listener(data);
  }, freq);
};
const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;
  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};
const asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));
const isURLSameOrigin = platform.hasStandardBrowserEnv ? /* @__PURE__ */ ((origin2, isMSIE) => (url) => {
  url = new URL(url, platform.origin);
  return origin2.protocol === url.protocol && origin2.host === url.host && (isMSIE || origin2.port === url.port);
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true;
const cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + "=" + encodeURIComponent(value)];
      utils$1.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
      utils$1.isString(path) && cookie.push("path=" + path);
      utils$1.isString(domain) && cookie.push("domain=" + domain);
      secure === true && cookie.push("secure");
      document.cookie = cookie.join("; ");
    },
    read(name) {
      const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  let isRelativeUrl = !isAbsoluteURL(requestedURL);
  if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
const headersToObject = (thing) => thing instanceof AxiosHeaders$2 ? { ...thing } : thing;
function mergeConfig$1(config1, config2) {
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source, prop, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({ caseless }, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a, b, prop, caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, prop, caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(void 0, a, prop, caseless);
    }
  }
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(void 0, b);
    }
  }
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(void 0, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(void 0, a);
    }
  }
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(void 0, a);
    }
  }
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b, prop) => mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
  };
  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge2 = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge2(config1[prop], config2[prop], prop);
    utils$1.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
}
const resolveConfig = (config) => {
  const newConfig = mergeConfig$1({}, config);
  let { data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
  newConfig.headers = headers = AxiosHeaders$2.from(headers);
  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
  if (auth) {
    headers.set(
      "Authorization",
      "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : ""))
    );
  }
  let contentType;
  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(void 0);
    } else if ((contentType = headers.getContentType()) !== false) {
      const [type, ...tokens] = contentType ? contentType.split(";").map((token) => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || "multipart/form-data", ...tokens].join("; "));
    }
  }
  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
    if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(newConfig.url)) {
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }
  return newConfig;
};
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
const xhrAdapter = isXHRAdapterSupported && function(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders$2.from(_config.headers).normalize();
    let { responseType, onUploadProgress, onDownloadProgress } = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;
    function done() {
      flushUpload && flushUpload();
      flushDownload && flushDownload();
      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
      _config.signal && _config.signal.removeEventListener("abort", onCanceled);
    }
    let request = new XMLHttpRequest();
    request.open(_config.method.toUpperCase(), _config.url, true);
    request.timeout = _config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders$2.from(
        "getAllResponseHeaders" in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request = null;
    }
    if ("onloadend" in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, config, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, config, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError$1(
        timeoutErrorMessage,
        transitional2.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
        config,
        request
      ));
      request = null;
    };
    requestData === void 0 && requestHeaders.setContentType(null);
    if ("setRequestHeader" in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request.responseType = _config.responseType;
    }
    if (onDownloadProgress) {
      [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
      request.addEventListener("progress", downloadThrottled);
    }
    if (onUploadProgress && request.upload) {
      [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
      request.upload.addEventListener("progress", uploadThrottled);
      request.upload.addEventListener("loadend", flushUpload);
    }
    if (_config.cancelToken || _config.signal) {
      onCanceled = (cancel) => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError$1(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
      }
    }
    const protocol = parseProtocol(_config.url);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError$1("Unsupported protocol " + protocol + ":", AxiosError$1.ERR_BAD_REQUEST, config));
      return;
    }
    request.send(requestData || null);
  });
};
const composeSignals = (signals, timeout) => {
  const { length } = signals = signals ? signals.filter(Boolean) : [];
  if (timeout || length) {
    let controller = new AbortController();
    let aborted;
    const onabort = function(reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError$1 ? err : new CanceledError$1(err instanceof Error ? err.message : err));
      }
    };
    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError$1(`timeout ${timeout} of ms exceeded`, AxiosError$1.ETIMEDOUT));
    }, timeout);
    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal2) => {
          signal2.unsubscribe ? signal2.unsubscribe(onabort) : signal2.removeEventListener("abort", onabort);
        });
        signals = null;
      }
    };
    signals.forEach((signal2) => signal2.addEventListener("abort", onabort));
    const { signal } = controller;
    signal.unsubscribe = () => utils$1.asap(unsubscribe);
    return signal;
  }
};
const composeSignals$1 = composeSignals;
const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;
  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }
  let pos = 0;
  let end;
  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};
const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};
const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }
  const reader = stream.getReader();
  try {
    for (; ; ) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};
const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator2 = readBytes(stream, chunkSize);
  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };
  return new ReadableStream({
    async pull(controller) {
      try {
        const { done: done2, value } = await iterator2.next();
        if (done2) {
          _onFinish();
          controller.close();
          return;
        }
        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator2.return();
    }
  }, {
    highWaterMark: 2
  });
};
const isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === "function";
const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? /* @__PURE__ */ ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) : async (str) => new Uint8Array(await new Response(str).arrayBuffer()));
const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false;
  }
};
const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;
  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      duplexAccessed = true;
      return "half";
    }
  }).headers.has("Content-Type");
  return duplexAccessed && !hasContentType;
});
const DEFAULT_CHUNK_SIZE = 64 * 1024;
const supportsResponseStream = isReadableStreamSupported && test(() => utils$1.isReadableStream(new Response("").body));
const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};
isFetchSupported && ((res) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((type) => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res2) => res2[type]() : (_, config) => {
      throw new AxiosError$1(`Response type '${type}' is not supported`, AxiosError$1.ERR_NOT_SUPPORT, config);
    });
  });
})(new Response());
const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }
  if (utils$1.isBlob(body)) {
    return body.size;
  }
  if (utils$1.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: "POST",
      body
    });
    return (await _request.arrayBuffer()).byteLength;
  }
  if (utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }
  if (utils$1.isURLSearchParams(body)) {
    body = body + "";
  }
  if (utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};
const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());
  return length == null ? getBodyLength(body) : length;
};
const fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = "same-origin",
    fetchOptions
  } = resolveConfig(config);
  responseType = responseType ? (responseType + "").toLowerCase() : "text";
  let composedSignal = composeSignals$1([signal, cancelToken && cancelToken.toAbortSignal()], timeout);
  let request;
  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
    composedSignal.unsubscribe();
  });
  let requestContentLength;
  try {
    if (onUploadProgress && supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
      let _request = new Request(url, {
        method: "POST",
        body: data,
        duplex: "half"
      });
      let contentTypeHeader;
      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) {
        headers.setContentType(contentTypeHeader);
      }
      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );
        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }
    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? "include" : "omit";
    }
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : void 0
    });
    let response = await fetch(request);
    const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
    if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
      const options = {};
      ["status", "statusText", "headers"].forEach((prop) => {
        options[prop] = response[prop];
      });
      const responseContentLength = utils$1.toFiniteNumber(response.headers.get("content-length"));
      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];
      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }
    responseType = responseType || "text";
    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || "text"](response, config);
    !isStreamResponse && unsubscribe && unsubscribe();
    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders$2.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    });
  } catch (err) {
    unsubscribe && unsubscribe();
    if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      );
    }
    throw AxiosError$1.from(err, err && err.code, config, request);
  }
});
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};
utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, "name", { value });
    } catch (e) {
    }
    Object.defineProperty(fn, "adapterName", { value });
  }
});
const renderReason = (reason) => `- ${reason}`;
const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;
const adapters = {
  getAdapter: (adapters2) => {
    adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
    const { length } = adapters2;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters2[i];
      let id;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === void 0) {
          throw new AxiosError$1(`Unknown adapter '${id}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id || "#" + i] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id, state]) => `adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build")
      );
      let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError$1(
        `There is no suitable adapter to dispatch the request ` + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return adapter;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError$1(null, config);
  }
}
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = AxiosHeaders$2.from(config.headers);
  config.data = transformData.call(
    config,
    config.transformRequest
  );
  if (["post", "put", "patch"].indexOf(config.method) !== -1) {
    config.headers.setContentType("application/x-www-form-urlencoded", false);
  }
  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );
    response.headers = AxiosHeaders$2.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel$1(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$2.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
const VERSION$1 = "1.9.0";
const validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i) => {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return (value, opt, opts) => {
    if (validator2 === false) {
      throw new AxiosError$1(
        formatMessage(opt, " has been removed" + (version ? " in " + version : "")),
        AxiosError$1.ERR_DEPRECATED
      );
    }
    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
validators$1.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator2 = schema[opt];
    if (validator2) {
      const value = options[opt];
      const result2 = value === void 0 || validator2(value, opt, options);
      if (result2 !== true) {
        throw new AxiosError$1("option " + opt + " must be " + result2, AxiosError$1.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError$1("Unknown option " + opt, AxiosError$1.ERR_BAD_OPTION);
    }
  }
}
const validator = {
  assertOptions,
  validators: validators$1
};
const validators = validator.validators;
let Axios$1 = class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig || {};
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};
        Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
        try {
          if (!err.stack) {
            err.stack = stack;
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) {
            err.stack += "\n" + stack;
          }
        } catch (e) {
        }
      }
      throw err;
    }
  }
  _request(configOrUrl, config) {
    if (typeof configOrUrl === "string") {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig$1(this.defaults, config);
    const { transitional: transitional2, paramsSerializer, headers } = config;
    if (transitional2 !== void 0) {
      validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }
    if (config.allowAbsoluteUrls !== void 0)
      ;
    else if (this.defaults.allowAbsoluteUrls !== void 0) {
      config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
    } else {
      config.allowAbsoluteUrls = true;
    }
    validator.assertOptions(config, {
      baseUrl: validators.spelling("baseURL"),
      withXsrfToken: validators.spelling("withXSRFToken")
    }, true);
    config.method = (config.method || this.defaults.method || "get").toLowerCase();
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );
    headers && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (method) => {
        delete headers[method];
      }
    );
    config.headers = AxiosHeaders$2.concat(contextHeaders, headers);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), void 0];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);
      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i = 0;
    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i = 0;
    len = responseInterceptorChain.length;
    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig$1(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
};
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig$1(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data
      }));
    };
  }
  Axios$1.prototype[method] = generateHTTPMethod();
  Axios$1.prototype[method + "Form"] = generateHTTPMethod(true);
});
const Axios$2 = Axios$1;
let CancelToken$1 = class CancelToken {
  constructor(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token = this;
    this.promise.then((cancel) => {
      if (!token._listeners)
        return;
      let i = token._listeners.length;
      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve) => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message, config, request) {
      if (token.reason) {
        return;
      }
      token.reason = new CanceledError$1(message, config, request);
      resolvePromise(token.reason);
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }
  toAbortSignal() {
    const controller = new AbortController();
    const abort = (err) => {
      controller.abort(err);
    };
    this.subscribe(abort);
    controller.signal.unsubscribe = () => this.unsubscribe(abort);
    return controller.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
};
const CancelToken$2 = CancelToken$1;
function spread$1(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
function isAxiosError$1(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
}
const HttpStatusCode$1 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode$1).forEach(([key, value]) => {
  HttpStatusCode$1[value] = key;
});
const HttpStatusCode$2 = HttpStatusCode$1;
function createInstance(defaultConfig) {
  const context = new Axios$2(defaultConfig);
  const instance = bind(Axios$2.prototype.request, context);
  utils$1.extend(instance, Axios$2.prototype, context, { allOwnKeys: true });
  utils$1.extend(instance, context, null, { allOwnKeys: true });
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig$1(defaultConfig, instanceConfig));
  };
  return instance;
}
const axios = createInstance(defaults$1);
axios.Axios = Axios$2;
axios.CanceledError = CanceledError$1;
axios.CancelToken = CancelToken$2;
axios.isCancel = isCancel$1;
axios.VERSION = VERSION$1;
axios.toFormData = toFormData$1;
axios.AxiosError = AxiosError$1;
axios.Cancel = axios.CanceledError;
axios.all = function all(promises2) {
  return Promise.all(promises2);
};
axios.spread = spread$1;
axios.isAxiosError = isAxiosError$1;
axios.mergeConfig = mergeConfig$1;
axios.AxiosHeaders = AxiosHeaders$2;
axios.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$2;
axios.default = axios;
const {
  Axios: Axios2,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken: CancelToken2,
  VERSION,
  all: all2,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders: AxiosHeaders2,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = axios;
var Level = /* @__PURE__ */ ((Level2) => {
  Level2[Level2["Trace"] = 0] = "Trace";
  Level2[Level2["Debug"] = 1] = "Debug";
  Level2[Level2["Info"] = 2] = "Info";
  Level2[Level2["Warn"] = 3] = "Warn";
  Level2[Level2["Error"] = 4] = "Error";
  Level2[Level2["Fatal"] = 5] = "Fatal";
  Level2[Level2["Panic"] = 6] = "Panic";
  return Level2;
})(Level || {});
class ExternalLoggerService {
  constructor(settings) {
    __publicField(this, "_settings");
    __publicField(this, "_url");
    this._settings = createSettings(settings);
    this._url = `${this._settings.proto}://${this._settings.host}`;
  }
  /**
   *  Log a message to the external service.
   */
  log(level, slug, data) {
    const url = this._url;
    setTimeout(async () => {
      try {
        await fetch(url, {
          body: buildFlatBuffer(level, slug, data),
          cache: "no-cache",
          // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "omit",
          // omit, *same-origin, include
          method: "POST",
          // *GET, POST, PUT, DELETE, etc.
          mode: "cors"
          // no-cors, *cors, same-origin
        });
      } catch (e) {
        console.error("Failed to send log to external service", e);
      }
    }, 0);
  }
}
function buildFlatBuffer(level, slug, data) {
  const builder = new Builder(128);
  const messageOffset = builder.createString(slug);
  const fieldsArr = [];
  for (const [key, value] of Object.entries(data)) {
    const keyOffset = builder.createString(key);
    const valueOffset = builder.createString(value);
    builder.startObject(2);
    builder.addFieldOffset(0, keyOffset, 0);
    builder.addFieldOffset(1, valueOffset, 0);
    fieldsArr.unshift(builder.endObject());
  }
  builder.startVector(4, fieldsArr.length, 4);
  for (const offset of fieldsArr) {
    builder.addOffset(offset);
  }
  const fieldsOffset = builder.endVector();
  builder.startObject(3);
  builder.addFieldOffset(0, messageOffset, 0);
  builder.addFieldInt8(
    1,
    level,
    0
    /* Trace */
  );
  builder.addFieldOffset(2, fieldsOffset, 0);
  builder.finish(builder.endObject());
  return builder.asUint8Array();
}
function createSettings(settings) {
  if (!settings.entityId) {
    throw new Error("Missing entityId in settings");
  }
  if (!settings.host) {
    throw new Error("Missing host in settings");
  }
  if (settings.httpClient && !isHttpClient(settings.httpClient)) {
    throw new Error("No valid HTTP client provided");
  }
  return {
    proto: "https",
    ...settings,
    httpClient: settings.httpClient || axios.create()
  };
}
const sessionIdGenerator = customAlphabet("346789ABCDEFGHJKLMNPQRTUVWXY", 12);
let idIncrement = 0;
class Logger {
  constructor(eventBus, config) {
    __publicField(this, "_id");
    __publicField(this, "_eventBus");
    /**
     *  Severity log levels for individual processors
     */
    __publicField(this, "_logLevelsConfig", {
      console: LogLevelNumber.Warning,
      service: LogLevelNumber.None
    });
    /**
     *  External logging service
     *
     *  When undefined, no messages will be logged to the external service
     */
    __publicField(this, "_externalService");
    /**
     *  Holds all values that will be injected in all log messages
     */
    __publicField(this, "_staticValues", {});
    /**
     *  Holds the INTENDED entity id (e.g. shop guid, order guid, etc.).
     */
    __publicField(this, "entityId", "");
    this._id = config && config.sessionId ? config.sessionId : Logger.generateSessionId();
    this._eventBus = eventBus;
    this._eventBus.on(["log"], (path, payload) => {
      let msg;
      if (payload && hasAttribute(payload, "_isOpenTicketLogMessage")) {
        msg = payload;
      } else {
        msg = this._buildFromError(payload, path);
      }
      this._send(msg);
    });
  }
  static generateSessionId() {
    return sessionIdGenerator();
  }
  get id() {
    return this._id;
  }
  /**
   *  Set the severity log levels
   *
   *  Any log message with a level smaller or equal should be processed.
   *
   *  @param logLevels Individual log level settings per processor.
   */
  setLoggingLevels(logLevels) {
    if (logLevels && logLevels.console && logLevelStringToNumber[logLevels.console]) {
      this._logLevelsConfig.console = logLevelStringToNumber[logLevels.console];
      console.info("Console log level changed", logLevels.console);
    }
    if (logLevels && logLevels.service && logLevelStringToNumber[logLevels.service]) {
      this._logLevelsConfig.service = logLevelStringToNumber[logLevels.service];
      console.info("Service log level changed", logLevels.service);
    }
  }
  /**
   *  Set the logging url for the external logging service
   *
   *  @param loggingUrl
   */
  setLoggingUrl(loggingUrl) {
    const proto = loggingUrl.startsWith("http://") ? "http" : "https";
    const host = loggingUrl.replace(/^(?:[a-z]+:)?\/\//, "").replace(/\/*$/, "");
    const settings = {
      entityId: this.entityId || "",
      proto,
      host
    };
    if (this._externalService) {
      console.info("Restart external log service", proto, host);
    } else {
      console.info("Start external log service", proto, host);
    }
    this._externalService = new ExternalLoggerService(settings);
  }
  /**
   *  Set the entity ID to be used with the logging service.
   *
   *  Note, this should be the INTENDED entity id (e.g. shop id, order id, etc.).
   *  As the validity is not yet known until after the logger is initialized!
   *
   *  @param entityId The intended entity id.
   */
  setEntityId(entityId) {
    this.entityId = entityId;
    this.addStaticValue("entity_id", entityId);
  }
  /**
   *  Add a static value to all log messages
   *
   *  @param key
   *  @param value
   */
  addStaticValue(key, value) {
    this._staticValues[key] = value;
  }
  /**
   *  Create and emit a log message
   *
   *  @param logLevel The log level of the log message
   *  @param path The event path of the log message. Also used to create the slug.
   *  @param message Add optional human readable message.
   *  @param data The extra data for the log message. Also used for translation placeholders.
   *  @param parent When the log messages is a wrapper for another log message.
   */
  create(logLevel, path, data = {}, message = null, parent = null) {
    if (!path || !path.length) {
      path = ["unknown"];
    }
    path = ["external", ...path];
    return this._buildAndEmit(logLevel, path, data, message, parent);
  }
  /**
   *  Create and emit a log message
   *
   *  @param logLevel The log level of the log message
   *  @param path The event path of the log message. Also used to create the slug.
   *  @param message Add optional human readable message.
   *  @param data The extra data for the log message. Also used for translation placeholders.
   *  @param parent When the log messages is a wrapper for another log message.
   *  @param shouldEmit If the message should be processed.
   */
  _create(logLevel, path, data = {}, message = null, parent = null, shouldEmit = true) {
    return this._buildAndEmit(logLevel, path, data, message, parent, shouldEmit);
  }
  /**
   *  Pass-through the parent log message, if it is a log message.
   *  Create and emit a log message, if not.
   *
   *  @param logLevel The log level of the log message
   *  @param path The event path of the log message. Also used to create the slug.
   *  @param message Add optional human readable message.
   *  @param data The extra data for the log message. Also used for translation placeholders.
   *  @param parent When the log messages is a wrapper for another log message.
   *  @param shouldEmit If the message should be processed.
   */
  _passThroughOrCreate(parent, logLevel, path, data = {}, message = null, shouldEmit = true) {
    if (parent && hasAttribute(parent, "_isOpenTicketLogMessage")) {
      return parent;
    }
    return this._buildAndEmit(logLevel, path, data, message, parent, shouldEmit);
  }
  /**
   *  Send the log message to all processors.
   *
   *  If the log level is enough.
   *
   *  @param msg
   */
  _send(msg) {
    const at = new Date(msg.at);
    this._getConsoleForLoggingLevel(msg)(`[${msg.session} | ${msg.id} | ${at.getHours()}:${at.getMinutes()}] ${msg.slug}${msg.parent ? ` (^ ${msg.parent.id})` : ""}`, msg.message, msg.data);
    this._sendMessageToExternalService(msg);
  }
  /**
   *  Helper to create a new log message object and emit it
   *
   *  @param logLevel The log level of the log message
   *  @param path The event path of the log message. Also used to create the slug for the translatable message
   *  @param message Add optional human readable message
   *  @param data The extra data for the error. Also used for translation placeholders
   *  @param parent When the error is a wrapper for another error
   *  @param shouldEmit If the message should be processed.
   */
  _buildAndEmit(logLevel, path, data = {}, message = null, parent = null, shouldEmit = true) {
    if (!path || !path.length) {
      path = ["unknown"];
    }
    path = ["log", ...path];
    const err = this._build(logLevel, path, message, data, parent);
    if (shouldEmit) {
      try {
        this._eventBus.emit(path, err);
      } catch (e) {
      }
    }
    return err;
  }
  /**
   *  Helper to create a new log message from an error object
   *
   *  @param err The Error to transform to a log message object
   *  @param path Optionally, the error can have been emitted and thus will have a path/slug
   */
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  _buildFromError(err, path) {
    let message = null;
    let data = {};
    if (err) {
      data = this._retrieveDataFromError(err);
      if (hasAttribute(err, "description") && typeof err.description === "string") {
        message = err.description;
      } else if (hasAttribute(err, "message") && typeof err.message === "string") {
        message = err.message;
      } else if (hasAttribute(err, "name") && typeof err.name === "string") {
        message = err.name;
      }
    }
    if (!path) {
      path = ["log", "unknown"];
    }
    return this._build(LogLevel.Error, path, message, data);
  }
  /**
   *  Helper to create a new log message object
   *
   *  @param logLevel The severity level of the log message
   *  @param path The event path of the log message. Also used to create the slug for the translatable message
   *  @param message Add optional human readable message
   *  @param data The extra data for the log message. Also used for translation placeholders
   *  @param parent When the log message is a wrapper for another log message
   */
  _build(logLevel, path, message = null, data = {}, parent = null) {
    const logLevelNumber = logLevelStringToNumber[logLevel] || LogLevel.None;
    const logMessage = {
      _isOpenTicketLogMessage: true,
      at: Date.now(),
      data: {},
      displayLogLevel: logLevel,
      exception: null,
      id: ++idIncrement,
      logLevel: logLevelNumber,
      message,
      parent: null,
      session: this._id,
      slug: `sdkshop.${path.join(".")}`
    };
    data = { ...data, ...this._staticValues };
    try {
      if (parent && hasAttribute(parent, "_isOpenTicketLogMessage")) {
        logMessage.parent = parent;
      } else if (parent && parent instanceof Error) {
        logMessage.exception = parent;
        data = { ...data, exception: this._retrieveDataFromError(parent) };
      } else if (parent) {
        data = { ...parent, ...data };
      }
    } catch (_) {
    }
    logMessage.data = data;
    return logMessage;
  }
  // noinspection JSMethodCanBeStatic
  /**
   *  Retrieve the data from the given error exception.
   *
   *  @param error The error exception
   */
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  _retrieveDataFromError(error) {
    if (!error) {
      return {
        name: "Error",
        message: "Unknown error"
      };
    }
    const getErrorProp = (propName, fallback) => {
      if (!hasAttribute(error, propName)) {
        return fallback;
      }
      if (error[propName] === void 0 || error[propName] === null) {
        return fallback;
      }
      switch (typeof error[propName]) {
        case "string":
          if (typeof error[propName] !== "string") {
            return fallback;
          }
          break;
        case "number":
          if (typeof error[propName] !== "number") {
            return fallback;
          }
          break;
        default:
          return fallback;
      }
      return error[propName];
    };
    const flatError = {
      name: getErrorProp("name", "Error"),
      message: getErrorProp("message", "Unknown error"),
      description: getErrorProp("description"),
      number: getErrorProp("number"),
      fileName: getErrorProp("fileName"),
      lineNumber: getErrorProp("lineNumber"),
      columnNumber: getErrorProp("columnNumber")
    };
    if (error && typeof error === "object" && "isAxiosError" in error && error.isAxiosError) {
      const toLog = {};
      if (hasAttribute(error, "response")) {
        if (hasAttribute(error.response, "status") && typeof error.response.status === "number") {
          toLog.status = error.response.status.toString();
        }
        if (hasAttribute(error.response, "statusText") && typeof error.response.statusText === "string") {
          toLog.statusText = error.response.statusText;
        }
      }
      if (hasAttribute(error, "config")) {
        if (hasAttribute(error.config, "method") && typeof error.config.method === "string") {
          toLog.method = error.config.method;
        }
        if (hasAttribute(error.config, "url") && typeof error.config.url === "string") {
          toLog.url = error.config.url;
        }
      }
      if (hasAttribute(error, "request")) {
        if (hasAttribute(error.request, "readyState") && typeof error.request.readyState === "number") {
          toLog.readyState = error.request.readyState.toString();
        }
        if (hasAttribute(error.request, "status") && typeof error.request.status === "string") {
          toLog.requestStatus = error.request.status;
        }
      }
      if (flatError.description) {
        toLog.description = flatError.description;
      }
      flatError.description = Object.entries(toLog).map(([k, v]) => `${k}: ${v}`).join(", ");
    }
    if (hasAttribute(error, "response")) {
      if (hasAttribute(error.response, "status") && hasAttribute(error.response, "statusText")) {
        flatError.status = error.response.status;
        flatError.statusText = error.response.statusText;
      }
      if (hasAttribute(error.response, "data")) {
        if (hasAttribute(error.response.data, "status_code")) {
          flatError.status_code = error.response.data.status_code;
        }
        if (hasAttribute(error.response.data, "error_description")) {
          flatError.error_description = error.response.data.error_description;
        }
      }
    }
    if (hasAttribute(error, "stack")) {
      flatError.stack = String(error.stack);
      let stack = [];
      if (typeof error.stack === "string") {
        stack = error.stack.split("\n");
      }
      if (Array.isArray(error.stack)) {
        stack = error.stack;
      }
      flatError.stackList = stack.map((part) => typeof part === "string" ? part.trim() : "").filter((part) => part && part.length);
    }
    if (hasAttribute(error, "slug")) {
      flatError.slug = String(error.slug);
      if (hasAttribute(error, "slugData")) {
        return {
          ...error.slugData,
          ...flatError
        };
      }
    }
    return flatError;
  }
  /**
   *  Retrieve the correct console processor.
   *
   *  Depends on the console logging level.
   *
   *  @param msg
   */
  _getConsoleForLoggingLevel(msg) {
    if (msg.logLevel > this._logLevelsConfig.console) {
      return () => {
      };
    }
    switch (msg.logLevel) {
      case LogLevelNumber.Debug:
        return console.debug;
      case LogLevelNumber.Info:
        return console.info;
      case LogLevelNumber.Warning:
        return console.warn;
      case LogLevelNumber.Error:
      case LogLevelNumber.Fatal:
      default:
        return console.error;
    }
  }
  /**
   *  Send the message to the external logging service.
   *
   *  Depends on the service logging level.
   *
   *  @param msg
   */
  _sendMessageToExternalService(msg) {
    if (!this._externalService || msg.logLevel > this._logLevelsConfig.service) {
      return;
    }
    let logLevel;
    switch (msg.logLevel) {
      case LogLevelNumber.Fatal:
        logLevel = Level.Fatal;
        break;
      case LogLevelNumber.Error:
        logLevel = Level.Error;
        break;
      case LogLevelNumber.Warning:
        logLevel = Level.Warn;
        break;
      case LogLevelNumber.Debug:
        logLevel = Level.Debug;
        break;
      case LogLevelNumber.Info:
      default:
        logLevel = Level.Info;
        break;
    }
    const rawData = JSON.stringify(msg.data);
    const flatData = flattenObject({ data: JSON.parse(rawData) });
    this._externalService.log(logLevel, msg.slug, {
      ...flatData,
      raw_data: rawData,
      entity_id: this.entityId || "",
      session: msg.session,
      id: JSON.stringify(msg.id),
      at: JSON.stringify(msg.at),
      parent: msg.parent ? JSON.stringify(msg.parent.id) : "",
      slug: msg.slug,
      message: msg.message || ""
    });
  }
}
var lib$1 = {};
var is_scrolled$1 = {};
Object.defineProperty(is_scrolled$1, "__esModule", { value: true });
function addIsScrolledListener() {
  var el2 = document.getElementsByTagName("body")[0];
  window.onscroll = function() {
    if (window.scrollY >= 5) {
      if (!el2.classList.contains("is-scrolled")) {
        el2.classList.add("is-scrolled");
      }
    } else if (window.scrollY < 5) {
      if (el2.classList.contains("is-scrolled")) {
        el2.classList.remove("is-scrolled");
      }
    }
  };
}
is_scrolled$1.default = addIsScrolledListener;
var copy_to_clipboard$1 = {};
Object.defineProperty(copy_to_clipboard$1, "__esModule", { value: true });
function copyToClipboard(text) {
  var dummy = document.createElement("textarea");
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
}
copy_to_clipboard$1.default = copyToClipboard;
var flag$1 = {};
Object.defineProperty(flag$1, "__esModule", { value: true });
var REGIONAL_INDICATOR_CHAR_CODE_OFFSET = 127397;
function charToRegionalIndicator(char) {
  return String.fromCodePoint(char.charCodeAt(0) + REGIONAL_INDICATOR_CHAR_CODE_OFFSET);
}
function countryCodeToFlag(code) {
  if (!code || code.length !== 2) {
    return "🏳";
  }
  return code.substr(0, 2).toUpperCase().replace(/./g, charToRegionalIndicator);
}
flag$1.default = countryCodeToFlag;
var browser_language$1 = {};
Object.defineProperty(browser_language$1, "__esModule", { value: true });
function getBrowserLanguage() {
  var nav = window.navigator;
  var languages = nav.languages || [];
  for (var _i = 0, languages_1 = languages; _i < languages_1.length; _i++) {
    var language = languages_1[_i];
    if (language.length) {
      return language.split("_").join("-");
    }
  }
  var browserLanguagePropertyKeys = [
    "language",
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore -- These are not technically according to spec, but... IE...
    "browserLanguage",
    "systemLanguage",
    "userLanguage"
  ];
  for (var _a = 0, browserLanguagePropertyKeys_1 = browserLanguagePropertyKeys; _a < browserLanguagePropertyKeys_1.length; _a++) {
    var browserLanguagePropertyKey = browserLanguagePropertyKeys_1[_a];
    var language = nav[browserLanguagePropertyKey];
    if (language && typeof language === "string" && language.length) {
      return language.split("_").join("-");
    }
  }
  return null;
}
browser_language$1.default = getBrowserLanguage;
var has_local_storage$1 = {};
Object.defineProperty(has_local_storage$1, "__esModule", { value: true });
var TEST_LOCALSTORAGE_KEY = "TEST_LOCALSTORAGE_KEY_OPENTICKET";
function hasLocalStorage() {
  try {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(TEST_LOCALSTORAGE_KEY, "yes");
      if (localStorage.getItem(TEST_LOCALSTORAGE_KEY) === "yes") {
        localStorage.removeItem(TEST_LOCALSTORAGE_KEY);
        return true;
      }
    }
    return false;
  } catch (e) {
    return false;
  }
}
has_local_storage$1.default = hasLocalStorage;
var int_to_duration$1 = {};
Object.defineProperty(int_to_duration$1, "__esModule", { value: true });
function intToDuration(seconds, highestOnly) {
  if (highestOnly === void 0) {
    highestOnly = false;
  }
  var duration = [];
  var add = function(unit, value) {
    if (value && (!highestOnly || highestOnly && !duration.length)) {
      if (highestOnly && unit !== "seconds") {
        duration.push(value + 1 + " " + unit);
      } else {
        duration.push(value + " " + unit);
      }
    }
  };
  add("years", Math.floor(seconds / 31536e3));
  add("days", Math.floor(seconds % 31536e3 / 86400));
  add("hours", Math.floor(seconds % 31536e3 % 86400 / 3600));
  add("minutes", Math.floor(seconds % 31536e3 % 86400 % 3600 / 60));
  add("seconds", seconds % 31536e3 % 86400 % 3600 % 60);
  var last = duration.pop();
  if (!last) {
    return "";
  }
  if (duration.length) {
    return duration.slice(0, -1).join(", ") + " and " + last;
  }
  return last;
}
function intToDurationObject$1(seconds) {
  return {
    days: Math.floor(seconds % 31536e3 / 86400),
    hours: Math.floor(seconds % 31536e3 % 86400 / 3600),
    minutes: Math.floor(seconds % 31536e3 % 86400 % 3600 / 60),
    seconds: Math.floor(seconds % 31536e3 % 86400 % 3600 % 60),
    years: Math.floor(seconds / 31536e3)
  };
}
int_to_duration$1.default = intToDuration;
int_to_duration$1.intToDurationObject = intToDurationObject$1;
var is_object$2 = {};
Object.defineProperty(is_object$2, "__esModule", { value: true });
function isObject2(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
}
is_object$2.default = isObject2;
var scroll_to$1 = {};
Object.defineProperty(scroll_to$1, "__esModule", { value: true });
function scrollToTop() {
  window.scrollTo(0, 0);
}
function scrollTo(config) {
  var elem;
  if (config.element) {
    elem = config.element;
  } else {
    elem = document.getElementById(config.id);
  }
  if (!elem) {
    return;
  }
  setTimeout(function() {
    elem.scrollIntoView({
      behavior: "smooth",
      block: config.position
    });
  }, config.delay || 0);
}
scroll_to$1.default = scrollTo;
scroll_to$1.scrollToTop = scrollToTop;
var style$1 = {};
Object.defineProperty(style$1, "__esModule", { value: true });
var is_object$1 = is_object$2;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || from);
}
function writeToDom(key, val) {
  document.body.style.setProperty("--" + key, val);
}
function setStyle(style2, path) {
  if (path === void 0) {
    path = [];
  }
  for (var styleProp in style2) {
    if (!Object.prototype.hasOwnProperty.call(style2, styleProp)) {
      continue;
    }
    var val = style2[styleProp];
    var newPath = __spreadArray(__spreadArray([], path), [styleProp]);
    if (is_object$1["default"](val)) {
      setStyle(val, newPath);
      return;
    }
    if (val && typeof val === "string") {
      writeToDom(newPath.join("-"), val);
    }
  }
}
var Style = (
  /** @class */
  function() {
    function Style2() {
    }
    Style2.applyStyle = function(style2) {
      setStyle(style2);
    };
    Style2.getCustomProperty = function(key) {
      var styles = window.getComputedStyle(document.body);
      return styles.getPropertyValue("--" + key);
    };
    Style2.setFavicon = function() {
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "icon");
        document.head.appendChild(link);
      }
      var img = document.createElement("img");
      var faviconUrl = link.href || window.location.origin + "/favicon.ico";
      var onImageLoaded = function() {
        var canvas = document.createElement("canvas");
        canvas.width = 32;
        canvas.height = 32;
        var context = canvas.getContext("2d");
        context.drawImage(img, 0, 0);
        context.globalCompositeOperation = "xor";
        context.fillStyle = Style2.getCustomProperty("color-secondary");
        context.fillRect(0, 0, 32, 32);
        context.fill();
        link.type = "image/x-icon";
        link.href = canvas.toDataURL();
      };
      img.addEventListener("load", onImageLoaded);
      img.src = faviconUrl;
    };
    return Style2;
  }()
);
style$1.default = Style;
var dates$1 = {};
Object.defineProperty(dates$1, "__esModule", { value: true });
var dateformat = { exports: {} };
(function(module, exports) {
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function _typeof3(obj2) {
        return typeof obj2;
      };
    } else {
      _typeof2 = function _typeof3(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      };
    }
    return _typeof2(obj);
  }
  (function(global2) {
    var _arguments = arguments;
    var dateFormat2 = /* @__PURE__ */ function() {
      var token = /d{1,4}|D{3,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|W{1,2}|[LlopSZN]|"[^"]*"|'[^']*'/g;
      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
      var timezoneClip = /[^-+\dA-Z]/g;
      return function(date, mask, utc, gmt) {
        if (_arguments.length === 1 && kindOf2(date) === "string" && !/\d/.test(date)) {
          mask = date;
          date = void 0;
        }
        date = date || date === 0 ? date : /* @__PURE__ */ new Date();
        if (!(date instanceof Date)) {
          date = new Date(date);
        }
        if (isNaN(date)) {
          throw TypeError("Invalid date");
        }
        mask = String(dateFormat2.masks[mask] || mask || dateFormat2.masks["default"]);
        var maskSlice = mask.slice(0, 4);
        if (maskSlice === "UTC:" || maskSlice === "GMT:") {
          mask = mask.slice(4);
          utc = true;
          if (maskSlice === "GMT:") {
            gmt = true;
          }
        }
        var _ = function _2() {
          return utc ? "getUTC" : "get";
        };
        var _d = function d() {
          return date[_() + "Date"]();
        };
        var D = function D2() {
          return date[_() + "Day"]();
        };
        var _m = function m() {
          return date[_() + "Month"]();
        };
        var y = function y2() {
          return date[_() + "FullYear"]();
        };
        var _H = function H() {
          return date[_() + "Hours"]();
        };
        var _M = function M() {
          return date[_() + "Minutes"]();
        };
        var _s = function s() {
          return date[_() + "Seconds"]();
        };
        var _L = function L() {
          return date[_() + "Milliseconds"]();
        };
        var _o = function o() {
          return utc ? 0 : date.getTimezoneOffset();
        };
        var _W = function W() {
          return getWeek(date);
        };
        var _N = function N() {
          return getDayOfWeek(date);
        };
        var flags = { d: function d() {
          return _d();
        }, dd: function dd() {
          return pad(_d());
        }, ddd: function ddd() {
          return dateFormat2.i18n.dayNames[D()];
        }, DDD: function DDD() {
          return getDayName({ y: y(), m: _m(), d: _d(), _: _(), dayName: dateFormat2.i18n.dayNames[D()], short: true });
        }, dddd: function dddd() {
          return dateFormat2.i18n.dayNames[D() + 7];
        }, DDDD: function DDDD() {
          return getDayName({ y: y(), m: _m(), d: _d(), _: _(), dayName: dateFormat2.i18n.dayNames[D() + 7] });
        }, m: function m() {
          return _m() + 1;
        }, mm: function mm() {
          return pad(_m() + 1);
        }, mmm: function mmm() {
          return dateFormat2.i18n.monthNames[_m()];
        }, mmmm: function mmmm() {
          return dateFormat2.i18n.monthNames[_m() + 12];
        }, yy: function yy() {
          return String(y()).slice(2);
        }, yyyy: function yyyy() {
          return pad(y(), 4);
        }, h: function h() {
          return _H() % 12 || 12;
        }, hh: function hh() {
          return pad(_H() % 12 || 12);
        }, H: function H() {
          return _H();
        }, HH: function HH() {
          return pad(_H());
        }, M: function M() {
          return _M();
        }, MM: function MM() {
          return pad(_M());
        }, s: function s() {
          return _s();
        }, ss: function ss() {
          return pad(_s());
        }, l: function l() {
          return pad(_L(), 3);
        }, L: function L() {
          return pad(Math.floor(_L() / 10));
        }, t: function t() {
          return _H() < 12 ? dateFormat2.i18n.timeNames[0] : dateFormat2.i18n.timeNames[1];
        }, tt: function tt() {
          return _H() < 12 ? dateFormat2.i18n.timeNames[2] : dateFormat2.i18n.timeNames[3];
        }, T: function T() {
          return _H() < 12 ? dateFormat2.i18n.timeNames[4] : dateFormat2.i18n.timeNames[5];
        }, TT: function TT() {
          return _H() < 12 ? dateFormat2.i18n.timeNames[6] : dateFormat2.i18n.timeNames[7];
        }, Z: function Z() {
          return gmt ? "GMT" : utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, "").replace(/GMT\+0000/g, "UTC");
        }, o: function o() {
          return (_o() > 0 ? "-" : "+") + pad(Math.floor(Math.abs(_o()) / 60) * 100 + Math.abs(_o()) % 60, 4);
        }, p: function p() {
          return (_o() > 0 ? "-" : "+") + pad(Math.floor(Math.abs(_o()) / 60), 2) + ":" + pad(Math.floor(Math.abs(_o()) % 60), 2);
        }, S: function S() {
          return ["th", "st", "nd", "rd"][_d() % 10 > 3 ? 0 : (_d() % 100 - _d() % 10 != 10) * _d() % 10];
        }, W: function W() {
          return _W();
        }, WW: function WW() {
          return pad(_W());
        }, N: function N() {
          return _N();
        } };
        return mask.replace(token, function(match) {
          if (match in flags) {
            return flags[match]();
          }
          return match.slice(1, match.length - 1);
        });
      };
    }();
    dateFormat2.masks = { default: "ddd mmm dd yyyy HH:MM:ss", shortDate: "m/d/yy", paddedShortDate: "mm/dd/yyyy", mediumDate: "mmm d, yyyy", longDate: "mmmm d, yyyy", fullDate: "dddd, mmmm d, yyyy", shortTime: "h:MM TT", mediumTime: "h:MM:ss TT", longTime: "h:MM:ss TT Z", isoDate: "yyyy-mm-dd", isoTime: "HH:MM:ss", isoDateTime: "yyyy-mm-dd'T'HH:MM:sso", isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'", expiresHeaderFormat: "ddd, dd mmm yyyy HH:MM:ss Z" };
    dateFormat2.i18n = { dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], timeNames: ["a", "p", "am", "pm", "A", "P", "AM", "PM"] };
    var pad = function pad2(val, len) {
      val = String(val);
      len = len || 2;
      while (val.length < len) {
        val = "0" + val;
      }
      return val;
    };
    var getDayName = function getDayName2(_ref) {
      var y = _ref.y, m = _ref.m, d = _ref.d, _ = _ref._, dayName = _ref.dayName, _ref$short = _ref["short"], _short = _ref$short === void 0 ? false : _ref$short;
      var today = /* @__PURE__ */ new Date();
      var yesterday = /* @__PURE__ */ new Date();
      yesterday.setDate(yesterday[_ + "Date"]() - 1);
      var tomorrow = /* @__PURE__ */ new Date();
      tomorrow.setDate(tomorrow[_ + "Date"]() + 1);
      var today_d = function today_d2() {
        return today[_ + "Date"]();
      };
      var today_m = function today_m2() {
        return today[_ + "Month"]();
      };
      var today_y = function today_y2() {
        return today[_ + "FullYear"]();
      };
      var yesterday_d = function yesterday_d2() {
        return yesterday[_ + "Date"]();
      };
      var yesterday_m = function yesterday_m2() {
        return yesterday[_ + "Month"]();
      };
      var yesterday_y = function yesterday_y2() {
        return yesterday[_ + "FullYear"]();
      };
      var tomorrow_d = function tomorrow_d2() {
        return tomorrow[_ + "Date"]();
      };
      var tomorrow_m = function tomorrow_m2() {
        return tomorrow[_ + "Month"]();
      };
      var tomorrow_y = function tomorrow_y2() {
        return tomorrow[_ + "FullYear"]();
      };
      if (today_y() === y && today_m() === m && today_d() === d) {
        return _short ? "Tdy" : "Today";
      } else if (yesterday_y() === y && yesterday_m() === m && yesterday_d() === d) {
        return _short ? "Ysd" : "Yesterday";
      } else if (tomorrow_y() === y && tomorrow_m() === m && tomorrow_d() === d) {
        return _short ? "Tmw" : "Tomorrow";
      }
      return dayName;
    };
    var getWeek = function getWeek2(date) {
      var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      targetThursday.setDate(targetThursday.getDate() - (targetThursday.getDay() + 6) % 7 + 3);
      var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
      firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);
      var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
      targetThursday.setHours(targetThursday.getHours() - ds);
      var weekDiff = (targetThursday - firstThursday) / (864e5 * 7);
      return 1 + Math.floor(weekDiff);
    };
    var getDayOfWeek = function getDayOfWeek2(date) {
      var dow = date.getDay();
      if (dow === 0) {
        dow = 7;
      }
      return dow;
    };
    var kindOf2 = function kindOf3(val) {
      if (val === null) {
        return "null";
      }
      if (val === void 0) {
        return "undefined";
      }
      if (_typeof2(val) !== "object") {
        return _typeof2(val);
      }
      if (Array.isArray(val)) {
        return "array";
      }
      return {}.toString.call(val).slice(8, -1).toLowerCase();
    };
    if (_typeof2(exports) === "object") {
      module.exports = dateFormat2;
    } else {
      global2.dateFormat = dateFormat2;
    }
  })(void 0);
})(dateformat, dateformat.exports);
var dateFormat = dateformat.exports;
var ISO8601_REGEX = /^(\d{4})-(?:(02)-(0[1-9]|[12]\d)|(0[469]|11)-(0[1-9]|[12]\d|30)|(0[13578]|1[02])-(0[1-9]|[12]\d|3[01]))T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\.(\d{1,6}))?(Z|-(?:(?:0[0-9]|1[012]):00|0[39]:30)|\+(?:(?:0\d|1[0-4]):00|(?:0[3-69]|1[0]):30|0[58]:45|12:45))$/;
function containsDate(dateCollection, date) {
  var dateParts = dateFormat(date, "yyyy-mm-dd").split("-");
  if (dateParts.length < 3) {
    return false;
  }
  var year = dateCollection[dateParts[0]];
  if (!year) {
    return false;
  }
  var month = year[dateParts[1]];
  if (!month) {
    return false;
  }
  var day = month[dateParts[2]];
  return day && day.length > 0;
}
function getFirstDateFromNow(dateCollection) {
  var now = /* @__PURE__ */ new Date();
  if (containsDate(dateCollection, now)) {
    now.setHours(0, 0, 0, 0);
    return now;
  }
  var yearKeys = Object.getOwnPropertyNames(dateCollection).sort();
  for (var _i = 0, yearKeys_1 = yearKeys; _i < yearKeys_1.length; _i++) {
    var year = yearKeys_1[_i];
    var months = dateCollection[year];
    var monthKeys = Object.getOwnPropertyNames(months).sort();
    for (var _a = 0, monthKeys_1 = monthKeys; _a < monthKeys_1.length; _a++) {
      var month = monthKeys_1[_a];
      var days = months[month];
      var dayKeys = Object.getOwnPropertyNames(days).sort();
      for (var _b = 0, dayKeys_1 = dayKeys; _b < dayKeys_1.length; _b++) {
        var day = dayKeys_1[_b];
        if (days[day] && days[day].length > 0) {
          try {
            return new Date(parseInt(year, 10), parseInt(month, 10), parseInt(day, 10));
          } catch (e) {
          }
        }
      }
    }
  }
  return null;
}
function isValidISO8601String(value) {
  if (!value || typeof value !== "string") {
    return false;
  }
  if (!ISO8601_REGEX.test(value)) {
    return false;
  }
  var iso8601 = new Date(value);
  return iso8601.toString() !== "Invalid Date";
}
function ensureDateInstance(value) {
  if (!(value instanceof Date)) {
    if (!isValidISO8601String(value)) {
      return null;
    }
    return new Date(value);
  }
  return value;
}
dates$1.containsDate = containsDate;
dates$1.ensureDateInstance = ensureDateInstance;
dates$1.getFirstDateFromNow = getFirstDateFromNow;
dates$1.isValidISO8601String = isValidISO8601String;
Object.defineProperty(lib$1, "__esModule", { value: true });
var is_scrolled = is_scrolled$1;
var copy_to_clipboard = copy_to_clipboard$1;
var flag = flag$1;
var browser_language = browser_language$1;
var has_local_storage = has_local_storage$1;
var int_to_duration = int_to_duration$1;
var is_object2 = is_object$2;
var scroll_to = scroll_to$1;
var style = style$1;
var dates = dates$1;
lib$1.addIsScrolledListener = is_scrolled["default"];
lib$1.copyToClipboard = copy_to_clipboard["default"];
lib$1.countryCodeToFlag = flag["default"];
lib$1.getBrowserLanguage = browser_language["default"];
lib$1.hasLocalStorage = has_local_storage["default"];
lib$1.intToDuration = int_to_duration["default"];
var intToDurationObject = lib$1.intToDurationObject = int_to_duration.intToDurationObject;
lib$1.isObject = is_object2["default"];
lib$1.scrollTo = scroll_to["default"];
lib$1.scrollToTop = scroll_to.scrollToTop;
lib$1.Style = style["default"];
lib$1.containsDate = dates.containsDate;
lib$1.ensureDateInstance = dates.ensureDateInstance;
lib$1.getFirstDateFromNow = dates.getFirstDateFromNow;
lib$1.isValidISO8601String = dates.isValidISO8601String;
class OpenTicketBaseNotifications {
  constructor(base) {
    __publicField(this, "_shop");
    this._shop = base;
    this._shop._eventBus.on(["cart", "coupon"], (path) => {
      switch (path[2]) {
        case "add":
          this._send({ type: "is-success", message: "Coupon applied", slug: "sdkshop.notifications.coupon_applied" });
          break;
        case "remove":
          this._send({ type: "is-warning", message: "Coupon removed", slug: "sdkshop.notifications.coupon_removed" });
          break;
      }
    });
    let countdownStart = null;
    let countdownWarningShown = false;
    let countdownDangerShown = false;
    this._shop.events.on(
      ["timer"],
      (path, data) => {
        const durationObject = intToDurationObject(data.secondsRemaining || 0);
        switch (path[1]) {
          case "start":
            countdownStart = data.secondsRemaining;
            if (durationObject.days >= 1) {
              if (durationObject.hours === 0) {
                this._send({
                  type: "is-info",
                  message: `Reserved for ${durationObject.days} day(s).`,
                  slug: "sdkshop.notifications.reservation_days_zero_hours",
                  slugCount: durationObject.days,
                  slugData: { ...durationObject }
                });
              } else if (durationObject.hours === 1) {
                this._send({
                  type: "is-info",
                  message: `Reserved for ${durationObject.days} day(s) and ${durationObject.hours} hour.`,
                  slug: "sdkshop.notifications.reservation_days_one_hour",
                  slugCount: durationObject.days,
                  slugData: { ...durationObject }
                });
              } else if (durationObject.hours > 1) {
                this._send({
                  type: "is-info",
                  message: `Reserved for ${durationObject.days} day(s) and ${durationObject.hours} hours.`,
                  slug: "sdkshop.notifications.reservation_days_multiple_hours",
                  slugCount: durationObject.days,
                  slugData: { ...durationObject }
                });
              }
            } else if (durationObject.hours >= 1) {
              if (durationObject.minutes === 0) {
                this._send({
                  type: "is-info",
                  message: `Reserved for ${durationObject.hours} hour(s).`,
                  slug: "sdkshop.notifications.reservation_hours_zero_minutes",
                  slugCount: durationObject.hours,
                  slugData: { ...durationObject }
                });
              } else if (durationObject.minutes === 1) {
                this._send({
                  type: "is-info",
                  message: `Reserved for ${durationObject.hours} hour(s) and ${durationObject.minutes} minute.`,
                  slug: "sdkshop.notifications.reservation_hours_one_minute",
                  slugCount: durationObject.hours,
                  slugData: { ...durationObject }
                });
              } else if (durationObject.minutes > 1) {
                this._send({
                  type: "is-info",
                  message: `Reserved for ${durationObject.hours} hour(s) and ${durationObject.minutes} minutes.`,
                  slug: "sdkshop.notifications.reservation_hours_multiple_minutes",
                  slugCount: durationObject.hours,
                  slugData: { ...durationObject }
                });
              }
            } else if (durationObject.minutes >= 1) {
              if (durationObject.seconds === 0) {
                this._send({
                  type: "is-info",
                  message: `Reserved for ${durationObject.minutes} minute(s).`,
                  slug: "sdkshop.notifications.reservation_minutes_zero_seconds",
                  slugCount: durationObject.seconds,
                  slugData: { ...durationObject }
                });
              } else if (durationObject.seconds === 1) {
                this._send({
                  type: "is-info",
                  message: `Reserved for ${durationObject.minutes} minute(s) and ${durationObject.seconds} second.`,
                  slug: "sdkshop.notifications.reservation_minutes_one_second",
                  slugCount: durationObject.seconds,
                  slugData: { ...durationObject }
                });
              } else if (durationObject.seconds > 1) {
                this._send({
                  type: "is-info",
                  message: `Reserved for ${durationObject.minutes} minute(s) and ${durationObject.seconds} seconds.`,
                  slug: "sdkshop.notifications.reservation_minutes_multiple_seconds",
                  slugCount: durationObject.seconds,
                  slugData: { ...durationObject }
                });
              }
            } else {
              this._send({
                type: "is-info",
                message: `Reserved for ${durationObject.seconds} seconds.`,
                slug: "sdkshop.notifications.reservation_started.seconds",
                slugData: { ...durationObject }
              });
            }
            break;
          case "tick":
            if (!countdownWarningShown && countdownStart && data.secondsRemaining && countdownStart < data.secondsRemaining) {
              countdownWarningShown = true;
              this._send({
                type: "is-warning",
                message: `Reserved for ${intToDurationObject(data.secondsRemaining || 0).minutes}`,
                slug: "sdkshop.notifications.reservation_expiration_warning",
                slugData: { ...durationObject }
              });
            }
            break;
          case "clear":
            if (!countdownDangerShown) {
              if (data.timeout) {
                countdownDangerShown = true;
                this._send({
                  type: "is-danger",
                  message: "Reservation expired",
                  slug: "sdkshop.notifications.reservation_expired"
                });
              } else {
                this._send({
                  type: "is-info",
                  message: "Cart cleared",
                  slug: "sdkshop.notifications.cart_cleared"
                });
              }
            }
            break;
        }
      }
    );
  }
  /**
   * Send a notification over the notification channel
   * @param data - Notification configuration
   */
  send(data) {
    this._send(data);
  }
  _send(data) {
    this._shop.events.emit(["notification"], data);
  }
}
var ReservationRequestAction = /* @__PURE__ */ ((ReservationRequestAction2) => {
  ReservationRequestAction2["Reserve"] = "reserve";
  ReservationRequestAction2["Release"] = "release";
  return ReservationRequestAction2;
})(ReservationRequestAction || {});
var ReservationType = /* @__PURE__ */ ((ReservationType2) => {
  ReservationType2["Ticket"] = "Ticket";
  ReservationType2["Product"] = "Product";
  return ReservationType2;
})(ReservationType || {});
class ReservationRequest {
  constructor(type, guid, numberOfReservations) {
    __publicField(this, "action");
    __publicField(this, "type");
    __publicField(this, "guid");
    __publicField(this, "numberOfReservations");
    __publicField(this, "childType");
    __publicField(this, "childGuid");
    __publicField(this, "_promise");
    __publicField(this, "_resolve", () => {
    });
    __publicField(this, "_reject", () => {
    });
    if (!type || !enumIncludes(ReservationType, type)) {
      throw slugError("Invalid reservation request -> invalid type", ["reservator", "request", "constructor", "error", "type"]);
    }
    if (!guid || typeof guid !== "string" || !guid.length) {
      throw slugError("Invalid reservation request -> invalid guid", ["reservator", "request", "constructor", "error", "guid"]);
    }
    if (!numberOfReservations || !Number.isSafeInteger(numberOfReservations) || numberOfReservations < 1) {
      throw slugError("Invalid reservation request -> invalid number of reservations", ["reservator", "request", "constructor", "error", "numberofreservations"]);
    }
    this.action = ReservationRequestAction.Reserve;
    this.type = type;
    this.guid = guid;
    this.numberOfReservations = numberOfReservations;
    this.childType = void 0;
    this.childGuid = void 0;
    this._promise = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }
  /**
   *  For child changes a reservation request to request a child reservation for the already present reservation
   *  This method can only be called once and can not be called if the reservation request is a release request
   */
  forChild(type, guid) {
    if (!(this instanceof ReservationRequest)) {
      throw slugError("Invalid reservation request -> for child called on invalid reservation request", ["reservator", "request", "forChild", "error", "reservationrequest"]);
    }
    if (this.childType || this.childGuid) {
      throw slugError("Invalid reservation request -> can not combine child reservation and release", ["reservator", "request", "forChild", "error", "exclusive"]);
    }
    if (!type || !enumIncludes(ReservationType, type)) {
      throw slugError("Invalid reservation request -> invalid child type", ["reservator", "request", "forChild", "error", "type"]);
    }
    if (!guid || typeof guid !== "string" || !guid.length) {
      throw slugError("Invalid reservation request -> invalid child guid", ["reservator", "request", "forChild", "error", "guid"]);
    }
    this.childType = type;
    this.childGuid = guid;
    return this;
  }
  /**
   *  Release changes a reservation request to release the already present reservation
   *  This method can only be called once and can not be called if the reservation request is a child reservation request
   */
  release(reservation) {
    if (!(this instanceof ReservationRequest)) {
      throw slugError("Invalid reservation request -> release called on invalid reservation request", ["reservator", "request", "release", "error", "reservationrequest"]);
    }
    if (this.childType || this.childGuid) {
      throw slugError("Invalid reservation request -> can not combine release and child reservation", ["reservator", "request", "release", "error", "exclusive"]);
    }
    if (!reservation || typeof reservation !== "string" || !reservation.length) {
      throw slugError("Invalid reservation request -> invalid reservation key", ["reservator", "request", "release", "error", "reservation"]);
    }
    this.action = ReservationRequestAction.Release;
    this.childType = void 0;
    this.childGuid = reservation;
    return this;
  }
  /**
   *  Handler to resolve the underlying promise
   */
  resolve(value) {
    this._resolve(value);
  }
  /**
   *  Handler to reject the underlying promise
   */
  reject(reason) {
    this._reject(reason);
  }
}
class ShopConfig {
  constructor(config) {
    /**
     *  If it is a config instance.
     */
    __publicField(this, "_isConfigInstance", true);
    /**
     *  Reservator settings to limit the amount of pending / in-air requests
     */
    __publicField(this, "reservator");
    /**
     *  Default reservation time in minutes
     */
    __publicField(this, "defaultReservationTime");
    __publicField(this, "guid");
    __publicField(this, "baseUrl");
    __publicField(this, "gtmCode");
    __publicField(this, "trackingInfo");
    __publicField(this, "cseUrls");
    __publicField(this, "httpClient");
    /**
     *  Logging level(s)
     */
    __publicField(this, "logLevels");
    /**
     *  External logging service url.
     *
     *  When undefined, no messages will be logged to the external log service
     */
    __publicField(this, "loggerUrl");
    __publicField(this, "_urlUid", 0);
    if (!config) {
      throw slugError("No config provided", ["base", "config", "error", "missing"]);
    }
    this._setReservator(config.reservator);
    this._setDefaultReservationTime(config.defaultReservationTime);
    this._setBaseUrl(config.baseUrl);
    this._setGuid(config.guid);
    this._setHttpClient(config.httpClient, this._getConfigHeaders(config));
    this._setLogLevels(config.logLevels);
    this._setLoggerUrl(config.loggerUrl);
    this.cseUrls = config.cseUrls;
    this.gtmCode = config.gtmCode;
    this.trackingInfo = config.trackingInfo;
  }
  static isInitializedShopConfig(config) {
    return !!config && typeof config === "object" && "_isConfigInstance" in config && !!config._isConfigInstance;
  }
  /**
   *  Set thee reservator settings. Checks if the input is valid and
   *  chooses sensible defaults if no input is given.
   */
  _setReservator(reservator) {
    if (!reservator) {
      reservator = {};
    }
    if (reservator.maxPendingReservations && typeof reservator.maxPendingReservations !== "number") {
      throw slugError("reservator.maxPendingReservations is not a number", ["shop", "config", "error", "maxPendingReservations"]);
    }
    if (reservator.maxConcurrentReservations && typeof reservator.maxConcurrentReservations !== "number") {
      throw slugError("reservator.maxConcurrentReservations is not a number", ["shop", "config", "error", "maxConcurrentReservations"]);
    }
    if (reservator.minRequestTime && typeof reservator.minRequestTime !== "number") {
      throw slugError("reservator.minRequestTime is not a number", ["shop", "config", "error", "minRequestTime"]);
    }
    if (!reservator.maxPendingReservations) {
      reservator.maxPendingReservations = 20;
    }
    if (!reservator.maxConcurrentReservations) {
      reservator.maxConcurrentReservations = 1;
    }
    if (!reservator.minRequestTime) {
      reservator.minRequestTime = 334;
    }
    this.reservator = reservator;
  }
  /**
   *  Set the default reservation time, Checks if the input is valid and
   *  chooses a sensible default if no input is given.
   */
  _setDefaultReservationTime(defaultReservationTime) {
    if (defaultReservationTime && typeof defaultReservationTime !== "number") {
      throw slugError("defaultReservationTime is not a number", ["shop", "config", "error", "defaultReservationTime"]);
    }
    if (!defaultReservationTime) {
      defaultReservationTime = 8;
    }
    this.defaultReservationTime = defaultReservationTime;
  }
  /**
   *  @internal Function to validate and set the base url.
   */
  _setBaseUrl(url) {
    if (!url) {
      throw slugError("No base url provided", ["base", "config", "baseurl", "error", "missing"]);
    }
    if (typeof url !== "string") {
      throw slugError(`The provided base url must be a string: ${typeof url} received`, ["base", "config", "baseurl", "error", "type"]);
    }
    url = cleanUrl(url);
    const includesProtocol = /^[a-z]+:\/\//i.test(url);
    if (!includesProtocol) {
      url = `https://${url}`;
    } else if (!/^https?:\/\//.test(url)) {
      throw slugError(`The provided url must contain the http(s) protocol: ${url}`, ["base", "config", "baseurl", "error", "https"]);
    }
    this.baseUrl = url;
  }
  /**
   *
   *  Get an absolute path from a relative one
   *
   *  @param path - Relative path
   *  @param filters - The filters to add as GET params
   *
   */
  getUrl(path, filters) {
    let url = this.baseUrl;
    if (path) {
      path = cleanUrl(path);
      if (path.length) {
        url += `/${path}`;
      }
    }
    if (filters) {
      const filterKeys = Object.keys(filters);
      url += /\?[\w]/i.test(url) ? "&" : "?";
      forEach$1(filterKeys, (prop, index) => {
        url += `${prop}=${filters[prop]}`;
        if (index < filterKeys.length - 1) {
          url += "&";
        }
      });
    }
    return encodeURI(url);
  }
  /**
   *  Get an absolute path from a relative one.
   *
   *  A 'nocache' query parameter is added to the data,
   *  to bust any browser micro-cache.
   *
   *  @param path - Relative path
   *  @param filters - The filters to add as GET params
   *
   */
  getNoCacheUrl(path, filters) {
    const queryParams = { ...filters || {} };
    queryParams.nocache = `${(/* @__PURE__ */ new Date()).getTime()}-${(++this._urlUid).toString()}-${Math.floor(Math.random() * 1e9)}`;
    return this.getUrl(path, queryParams);
  }
  /**
   * Set additional tracking information to be sent with the order call (in cart)
   */
  setTrackingInfo(trackingInfo) {
    this.trackingInfo = trackingInfo;
  }
  /**
   *  @internal Function to validate and set the guid of the shop.
   */
  _setGuid(guid) {
    if (!guid) {
      throw new Error("No guid provided");
    }
    if (typeof guid !== "string") {
      throw new Error(`The provided guid must be a string: ${typeof guid} received`);
    }
    this.guid = guid;
  }
  /**
   *  @internal Internal function to validate and set the http client
   */
  _setHttpClient(httpClient, internalHeaders = {}) {
    if (httpClient && !isHttpClient(httpClient)) {
      throw new Error("No valid HTTP client provided");
    }
    this.httpClient = httpClient || axios.create();
    this.httpClient.interceptors.request.use((config) => {
      if (internalHeaders && config.url && config.url.startsWith(this.baseUrl)) {
        config.headers = new AxiosHeaders2(config.headers);
        config.headers.set(internalHeaders);
      }
      return config;
    });
  }
  /**
   *  @internal Set the config log levels
   */
  _setLogLevels(logLevels) {
    this.logLevels = logLevels;
  }
  /**
   *  @internal Set the config logger url.
   *
   *  When undefined, no messages will be logged to the external log service
   */
  _setLoggerUrl(loggerUrl) {
    this.loggerUrl = loggerUrl;
  }
  /**
   * @internal Find possible headers in the configs and return them
   */
  _getConfigHeaders(config) {
    const headers = {};
    const { jti } = config;
    if (typeof jti === "string" && jti.length > 0) {
      headers["x-jti"] = jti;
    }
    return headers;
  }
}
function cleanUrl(urlOrPath) {
  while (urlOrPath[0] === "/") {
    urlOrPath = urlOrPath.substr(1, urlOrPath.length);
  }
  while (urlOrPath.substr(urlOrPath.length - 1, 1) === "/") {
    urlOrPath = urlOrPath.substr(0, urlOrPath.length - 1);
  }
  return urlOrPath;
}
async function reservationDelayer(cb, minTime) {
  const timePromise = new Promise(
    (resolve) => {
      setTimeout(resolve, minTime);
    }
  );
  const response = cb();
  await timePromise;
  return response;
}
class Reservator {
  /**
   *  The constructor initializes a new reservator instance and checks if all (relevant) values in the settings object are valid
   *
   *  @internal
   */
  constructor(config) {
    __publicField(this, "_config");
    __publicField(this, "_queue", []);
    __publicField(this, "_requestSlots", 0);
    __publicField(this, "_typePendingCount", {});
    if (!config) {
      throw slugError("No valid settings provided for the reservator", ["reservator", "constructor", "error", "config"]);
    }
    if (ShopConfig.isInitializedShopConfig(config)) {
      this._config = config;
    } else {
      this._config = new ShopConfig(config);
    }
  }
  /**
   *  The reserve method will queue a reservation request and ensure it will be send within the limitations set in the settings.
   *
   *  These limitations will ensure the server as well as the client are not swamped with requests.
   *
   *  Limitations are placed on:
   *  - Total pending requests ('in the air' + waiting)
   *  - Total pending requests 'in the air'
   *
   *  It is possible to request multiple reservations in bulk by providing the numberOfReservations amount.
   *  @todo Right now reservation requests are handled individually, another efficiency step here would be to implement bulk reservations.
   *    These bulk requests would allow higher volumes to be requested by the the user, while keeping request congestion to a minimum.
   *
   *  @internal
   */
  async reserve(type, guid, numberOfReservations = 1) {
    if (this._queue.length + this._requestSlots >= this._config.reservator.maxPendingReservations) {
      throw slugError("Max pending reservations reached", ["reservator", "reserve", "error", "maxpending"]);
    }
    const reservationRequest = new ReservationRequest(type, guid, numberOfReservations);
    this._queue.push(reservationRequest);
    void this._send();
    let reservations;
    try {
      reservations = await reservationRequest._promise;
    } catch (error) {
      if (errorHasResponseStatus(error) && error.response.status === 406) {
        throw errorToSlugError(error, ["reservator", "reserve", "error", "notacceptable"]);
      }
      throw errorToSlugError(error, ["reservator", "reserve", "error", "failed"]);
    }
    if (!reservations || !Array.isArray(reservations) || !reservations.length) {
      throw slugError("Reserve failed -> Reservations missing in response", ["reservator", "reserve", "error", "reservation"]);
    }
    const filteredReservations = reservations.filter((reservation) => !!reservation);
    if (filteredReservations.length !== numberOfReservations) {
      throw slugError("Reserve failed -> (Some) reservation(s) missing in response", ["reservator", "reserve", "error", "reservations"]);
    }
    return filteredReservations;
  }
  /**
   *  The reserve method will queue a child reservation request and ensure it will be send within the limitations set in the settings.
   *
   *  These limitations will ensure the server as well as the client are not swamped with requests.
   *
   *  Limitations are placed on:
   *  - Total pending requests ('in the air' + waiting)
   *  - Total pending requests 'in the air'
   *
   *  It is possible to request multiple reservations in bulk by providing the numberOfReservations amount.
   *  @todo Right now reservation requests are handled individually, another efficiency step here would be to implement bulk reservations.
   *    These bulk requests would allow higher volumes to be requested by the the user, while keeping request congestion to a minimum.
   *
   *  @internal
   */
  async reserveChild(type, guid, childType, childGuid, numberOfReservations = 1) {
    if (this._queue.length + this._requestSlots >= this._config.reservator.maxPendingReservations) {
      throw slugError("Max pending reservations reached", ["reservator", "reserveChild", "error", "maxpending"]);
    }
    const reservationRequest = new ReservationRequest(type, guid, numberOfReservations).forChild(childType, childGuid);
    this._queue.push(reservationRequest);
    void this._send();
    let reservations;
    try {
      reservations = await reservationRequest._promise;
    } catch (error) {
      if (errorHasResponseStatus(error) && error.response.status === 406) {
        throw errorToSlugError(error, ["reservator", "reserveChild", "error", "notacceptable"]);
      }
      throw errorToSlugError(error, ["reservator", "reserveChild", "error", "failed"]);
    }
    if (!reservations || !reservations.length) {
      throw slugError("Reserve child failed -> Reservations missing in response", ["reservator", "reserveChild", "error", "reservation"]);
    }
    const filteredReservations = reservations.filter((reservation) => !!reservation);
    if (filteredReservations.length !== numberOfReservations) {
      throw slugError("Reserve child failed -> (Some) reservation(s) missing in response", ["reservator", "reserveChild", "error", "reservations"]);
    }
    return filteredReservations;
  }
  /**
   *  The release method will queue a release request and ensure it will be send within the limitations set in the settings.
   *
   *  @internal
   */
  async release(type, guid, reservation) {
    const reservationRequest = new ReservationRequest(type, guid, 1).release(reservation);
    this._queue.push(reservationRequest);
    void this._send();
    await reservationRequest._promise;
  }
  /**
   *  The send method will take queued reservation requests as long as there are requests in the queue.
   *  This will allow any call over the concurrent limit to this method to silently return and
   *  trust the request it was supposed to handle will still be handled.
   *
   *  There is a configurable, limited amount of calls to this method allowed to be running at the same time.
   *  This protects the client and server from too many consecutive alive requests.
   *
   *  If the API returned a reservation response, this will be marshalled into a reservation object and
   *  used as the promise resolution value.
   *
   *  @internal
   */
  async _send() {
    if (++this._requestSlots > this._config.reservator.maxConcurrentReservations) {
      this._requestSlots--;
      return Promise.resolve();
    }
    let job;
    while (job = this._queue.shift()) {
      try {
        if (job.action === ReservationRequestAction.Reserve) {
          const guid = job.childGuid || job.guid;
          const { numberOfReservations } = job;
          const typeCounts = this._typePendingCount[job.childType || job.type] = this._typePendingCount[job.childType || job.type] || {};
          typeCounts[guid] = typeCounts[guid] || 0;
          typeCounts[guid] += numberOfReservations;
          const result2 = [];
          try {
            for (let i = 0; i < numberOfReservations; i++) {
              const url = this.compileUrl(job.type, job.guid, job.childType, job.childGuid);
              const reservationResponse = await reservationDelayer(
                () => this._config.httpClient.get(url),
                this._config.reservator.minRequestTime
              );
              result2.push(marshalReservationResponse(reservationResponse.data));
            }
          } finally {
            typeCounts[guid] -= numberOfReservations;
          }
          job.resolve(result2);
        } else {
          const url = this.compileUrl(job.type, job.guid, job.childType, job.childGuid);
          await this._config.httpClient.delete(url);
          job.resolve([]);
        }
      } catch (error) {
        job.reject(error);
      }
    }
    this._requestSlots--;
    return Promise.resolve();
  }
  /**
   *  Create the URL for any reservation calls
   *
   *  @internal
   */
  compileUrl(type, guid, childType, childGuid) {
    let path = `${this._config.guid}/reserve/${type.toLowerCase()}/${guid}`;
    if (childType) {
      path += `/${childType.toLowerCase()}`;
    }
    if (childGuid) {
      path += `/${childGuid}`;
    }
    return this._config.getNoCacheUrl(path);
  }
  /**
   *  Alternative release method to facilitate releasing reservation on window unload.
   *
   *  Note: This is not a perfect solution, as it is not supported in IE at all.
   *
   *  @internal
   */
  releaseOnUnload(type, guid, reservation) {
    const reservationRequest = new ReservationRequest(type, guid, 1).release(reservation);
    return window.fetch(this.compileUrl(reservationRequest.type, reservationRequest.guid, reservationRequest.childType, reservationRequest.childGuid), {
      method: "DELETE",
      // *GET, POST, PUT, DELETE, etc.
      mode: "cors",
      // no-cors, *cors, same-origin
      cache: "no-cache",
      // *default, no-cache, reload, force-cache, only-if-cached
      keepalive: true
      // Fetch with the keepalive flag is a replacement for the Navigator.sendBeacon() API.
    });
  }
  /**
   *  This will return the aggregated pending count for a type and guid.
   *
   *  E.g.: The reserve count minus release count
   *
   *  @internal
   */
  inFlightCount(type, guid) {
    if (type && guid) {
      const typed = this._typePendingCount[type] || {};
      if (guid) {
        return typed[guid] || 0;
      }
      return Object.values(typed).reduce((carry, count = 0) => carry + count, 0);
    }
    return Object.values(this._typePendingCount).reduce((carry, typed) => carry + Object.values(typed).reduce((subCarry, count = 0) => subCarry + count, 0), 0);
  }
}
function marshalReservationResponse(reservationResponse) {
  if (!reservationResponse || !reservationResponse.reservation) {
    return void 0;
  }
  const reservation = {
    received_at: new Date(Date.now()),
    // Ambiguous to enable easier testing. Mocking Date.now() is easier.
    reservation: reservationResponse.reservation
  };
  if (!reservationResponse.childReservations) {
    return reservation;
  }
  forOwn(ReservationType, (childReservationType) => {
    if (!Object.prototype.hasOwnProperty.call(reservationResponse.childReservations, childReservationType) || !reservationResponse.childReservations[childReservationType]) {
      return;
    }
    reservation.childReservations = reservation.childReservations || {};
    forOwn(reservationResponse.childReservations[childReservationType], (childReservationIds, childId) => {
      reservation.childReservations[childReservationType] = reservation.childReservations[childReservationType] || {};
      reservation.childReservations[childReservationType][childId] = reservation.childReservations[childReservationType][childId] || [];
      reservation.childReservations[childReservationType][childId].push(...(childReservationIds || []).map((childReservationId) => ({
        received_at: new Date(Date.now()),
        // Ambiguous to enable easier testing
        reservation: childReservationId
      })));
    });
  });
  return reservation;
}
function cloneObject(objectToClone) {
  if (typeof structuredClone === "function") {
    return structuredClone(objectToClone);
  }
  return JSON.parse(JSON.stringify(objectToClone));
}
class CartItem {
  /**
   *  Constructing a new cart item creates the basic cart item instance,
   *  this should (and can) only be used by calling `super()` in an inherited constructor
   *
   *  #### Possible errors
   *  One type of error could be thrown while initializing a cart item.
   *
   *  | Error                                    | Reason                                                                          |
   *  | :--------------------------------------- | :------------------------------------------------------------------------------ |
   *  | [ShopError](shoperror.html)              | A (child) reservation is not recognized [Reservation](../interfaces/cart.html)  |
   */
  constructor(data, item, reservation, childOf, seatInfo) {
    /**
     *  The identified for the cart item. A unique value, that functions as the (temporary) id for the cart item
     *  It is a combination of the original object's guid and the reservation key.
     *
     *  This value has no power with the API
     */
    __publicField(this, "id");
    /**
     *  Reference to the original reservable model.
     *
     *  @category Cart
     */
    __publicField(this, "item");
    /**
     *  The reservation returned from the API
     *
     *  @category Cart
     */
    __publicField(this, "reservation");
    /**
     *  Optional parent id
     *
     *  @category Cart
     */
    __publicField(this, "childOf");
    /**
     *  Optional parent item id
     *
     *  @category Cart
     */
    __publicField(this, "childOfItemId");
    /**
     *  The children of the cart item.
     *  E.g.: (Optional) products in a ticket
     *
     *  @category Cart
     */
    __publicField(this, "children", {});
    /**
     *  The metadata (answers) for the current level of cart item(s)
     *
     *  @category Cart
     */
    __publicField(this, "metadata", {});
    __publicField(this, "metadataList", []);
    /**
     *  The seat info if the item is seated.
     *
     *  @category Cart
     */
    __publicField(this, "seatsInfo");
    // The below properties are set once and should/will never be replaced!
    // Note: content can change though.
    // E.g.: Children can be added/removed, item availability could change, etc.
    __publicField(this, "data");
    this.data = data;
    this.item = item;
    this.reservation = reservation;
    if (childOf) {
      this.childOf = childOf.id;
      this.childOfItemId = childOf.item.guid;
    }
    if (seatInfo) {
      this.seatsInfo = seatInfo;
    }
    this.id = this._setId();
    if (CartTicket.isCartTicket(this)) {
      this.children[CartItemChildType.Products] = {
        map: {},
        collection: []
      };
    }
    this._processChildReservations(reservation.childReservations);
  }
  /**
   *  Recompute the unique (temporary) identifier for the cart item
   */
  _setId() {
    return this.id = `${this.item.guid}-${this.reservation.reservation}`;
  }
  /**
   *  Determine if the given object is a cart item.
   *  Optionally a (specific) type can be specified
   */
  static isCartItem(cartItem, type) {
    if (!cartItem || typeof cartItem.getType !== "function") {
      return false;
    }
    if (type) {
      return cartItem.getType() === type;
    }
    return enumIncludes(CartItemType, cartItem.getType());
  }
  /**
   *  Process any child reservations
   *
   *  Child reservations are nested reservation in a reservation response.
   *  E.g.: When reserving a ticket, the API might decide that required products should also be returned.
   *  These products then don't have to be reserved separately (which they would have to be, as they are required).
   *  This also holds for (soft required) product groups.
   *  When a product group has a minimum, returning a 'best guess' child reservation
   *  will (on average) limit the reservation calls.
   *
   *  #### Possible errors
   *  One type of error could be thrown while processing product child reservations.
   *
   *  | Error                                    | Reason                                                                         |
   *  | :--------------------------------------- | :----------------------------------------------------------------------------- |
   *  | [ShopError](shoperror.html)              | A (child) reservation is not recognized [Reservation](../interfaces/cart.html) |
   */
  _processChildReservations(childReservations) {
    if (!childReservations) {
      return {};
    }
    const productChildReservations = childReservations[ReservationType.Product] || {};
    forOwn(productChildReservations, (reservations, childId) => {
      this._processProductChildReservation(childId, ...reservations);
    });
    forEach$1(Object.keys(childReservations), (reservationType) => {
      if (
        // Disabling eslint since we want to error about everything that is ignored,
        // instead of forcing the type into an enum
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
        reservationType !== ReservationType.Product && Object.prototype.hasOwnProperty.call(childReservations, reservationType)
      ) {
        console.error(`Child reservation of type ${reservationType} ignored`);
      }
    });
    return this.children;
  }
  /**
   *  Add the product cart items for the given id and (child) reservations
   *
   *  #### Possible errors
   *  One type of error could be thrown while processing product child reservations.
   *
   *  | Error                                    | Reason                                                                         |
   *  | :--------------------------------------- | :----------------------------------------------------------------------------- |
   *  | [ShopError](shoperror.html)              | A (child) reservation is not recognized [Reservation](../interfaces/cart.html) |
   */
  _processProductChildReservation(childId, ...reservations) {
    if (!Object.prototype.hasOwnProperty.call(this.data.products_map, childId)) {
      throw new ShopError(`Unrecognized child reservation, invalid guid ${childId}`);
    }
    const product = this.data.products_map[childId];
    const childCollection = this.children[CartItemChildType.Products] = this.children[CartItemChildType.Products] || {
      map: {},
      collection: []
    };
    const addedChildren = [];
    childCollection.map[childId] = childCollection.map[childId] || {};
    forEach$1(reservations, (reservation) => {
      const cartItem = new CartProduct(this.data, product, reservation, this);
      childCollection.map[childId][cartItem.id] = cartItem;
      childCollection.collection.push(cartItem);
      addedChildren.push(cartItem);
    });
    return addedChildren;
  }
}
class CartTicket extends CartItem {
  /**
   *  Constructing a new ticket cart item creates the cart item instance.
   *
   *  When product child reservations are included, these products can contain
   *  metadata that should be applied on the ticket.
   *  Those (cart) metadata are added to the ticket iff they are not present yet.
   *  If the metadata is already present (e.g.: because multiple products add the same metadata),
   *  it will be ignored. The alternative would be overwriting existing metadata,
   *  which could result in losing already filled in values.
   *
   *  #### Possible errors
   *  One type of error could be thrown while initializing a ticket cart item.
   *
   *  | Error                                    | Reason                                                                          |
   *  | :--------------------------------------- | :------------------------------------------------------------------------------ |
   *  | [ShopError](shoperror.html)              | A (child) reservation is not recognized [Reservation](../interfaces/cart.html)  |
   */
  constructor(data, ticket2, reservation, childOf, seatInfo) {
    super(data, ticket2, reservation, childOf, seatInfo);
    // Overload the pricing type to let it hold ticket pricing
    __publicField(this, "pricing");
    // Products is a readonly reference to the product children of the underlying cartItem
    __publicField(this, "products");
    // Holding the original min price of the ticket to make sure it's taken into account while computing the pricing
    __publicField(this, "min_price");
    this.pricing = cloneObject({ ...ticket2.pricing, coupons: {}, coupons_count: {} });
    this.products = this.children[CartItemChildType.Products];
    this.min_price = this.item.min_price;
    forOwn(this.products.map, (products) => {
      forOwn(products, (product) => {
        if (!ticket2.late_personalization || product.skip_late_personalization) {
          addMetadataFromProduct(product.item, this.metadata, this.metadataList, MetadataAppliesTo.Person);
        }
      });
    });
  }
  /**
   *  Retrieve the cart item type
   */
  getType() {
    return CartItemType.Ticket;
  }
  /**
   *  Determine if the given object is a cart ticket
   */
  static isCartTicket(cartItem) {
    return CartItem.isCartItem(cartItem, CartItemType.Ticket);
  }
  /**
   *  Remove any metadata no longer used by the global products in the cart.
   */
  _checkRemovedProductMetadata(metadataCollection) {
    const metadataRemove = {};
    forEach$1(metadataCollection, (metadata2) => {
      if (metadata2.item.applies_to !== MetadataAppliesTo.Person) {
        return;
      }
      metadataRemove[metadata2.guid] = metadata2;
    });
    forOwn(this.products.map, (cartProducts) => {
      forOwn(cartProducts, (cartProduct) => {
        forEach$1(cartProduct.item.metadata, (metadata2) => {
          if (metadata2.item.applies_to !== MetadataAppliesTo.Person) {
            return;
          }
          if (this.item.late_personalization && !cartProduct.skip_late_personalization) {
            return;
          }
          delete metadataRemove[metadata2.guid];
        });
      });
    });
    forOwn(metadataRemove, (metadata2, metadataId) => {
      delete this.metadata[metadataId];
      const listIndex = this.metadataList.findIndex((cartMetadata) => cartMetadata.item.guid === metadata2.guid);
      if (listIndex > -1) {
        this.metadataList.splice(listIndex, 1);
      }
    });
  }
}
class CartProduct extends CartItem {
  /**
   *  Constructing a new product cart item creates the cart item instance,
   *
   *  A product can have metadata that is applied to the product itself
   *  or on the parent (e.g.: ticket).
   *  Here only the metadata applied to the product is processed.
   *  Any metadata applied to the parent will be handled by the parent
   *  when adding this cart product to the parent.
   *
   *  #### Possible errors
   *  One type of error could be thrown while initializing a product cart item.
   *
   *  | Error                                    | Reason                                                                          |
   *  | :--------------------------------------- | :------------------------------------------------------------------------------ |
   *  | [ShopError](shoperror.html)              | A (child) reservation is not recognized [Reservation](../interfaces/cart.html)  |
   */
  constructor(data, product, reservation, childOf) {
    super(data, product, reservation, childOf);
    // Overload the pricing type to let it hold product pricing
    __publicField(this, "pricing");
    // If the product is optional for the ticket to which it's added,
    // which defaults to true if it doesn't belong to a ticket
    __publicField(this, "is_optional", true);
    // Boolean wheter to force show metadata in shop, even when late_personalization is on
    __publicField(this, "skip_late_personalization", false);
    this.pricing = JSON.parse(JSON.stringify(product.pricing));
    this.skip_late_personalization = product.skip_late_personalization;
    this.setOptional();
    const addMetadata = !childOf || CartTicket.isCartTicket(childOf) && !childOf.item.late_personalization || this.skip_late_personalization;
    if (addMetadata) {
      addMetadataFromProduct(product, this.metadata, this.metadataList, MetadataAppliesTo.Product);
    }
  }
  /**
   *  Used to compute the optional state of a cart product. It is always optional
   *  by default, but becomes required if the product is part of a ticket and it's
   *  located in the tickets' required products collection.
   */
  setOptional() {
    this.is_optional = true;
    if (!this.childOfItemId) {
      return;
    }
    const ticket2 = this.data.tickets_map[this.childOfItemId];
    if (!ticket2) {
      return;
    }
    forEach$1(ticket2.products.required, (ticketProduct) => {
      if (ticketProduct.item.guid === this.item.guid) {
        return this.is_optional = false;
      }
      return void 0;
    });
  }
  /**
   *  Retrieve the cart item type
   */
  getType() {
    return CartItemType.Product;
  }
  /**
   *  Determine if the given object is a cart product
   */
  static isCartProduct(cartItem) {
    return CartItem.isCartItem(cartItem, CartItemType.Product);
  }
}
var CouponType = /* @__PURE__ */ ((CouponType2) => {
  CouponType2["Cheque"] = "cheque";
  CouponType2["Fixed"] = "fixed-discount";
  CouponType2["Percentage"] = "percentage-discount";
  CouponType2["NewPrice"] = "new-price";
  return CouponType2;
})(CouponType || {});
var CouponAction = /* @__PURE__ */ ((CouponAction2) => {
  CouponAction2["Add"] = "add";
  CouponAction2["Remove"] = "remove";
  CouponAction2["Update"] = "update";
  return CouponAction2;
})(CouponAction || {});
const Coupon = {
  /**
   *
   *  Used to get the items to which a specific forwarded coupon applies.
   *  If the coupon does not specify any products (an empty product prop)
   *  it means it should be applied on all the forwarded products.
   *
   *  (i) As the location of the ticket of a product differs per type of
   *  product, a method for retrieving their ticket should be forwarded.
   *
   *  @return a sorted Array of items on which the forwarded coupon
   *  applies, descending from the most expensive
   *
   */
  getApplicableItems(coupon, products, getTicketOfProduct) {
    const appliesTo = [];
    const appliesToProduct = (product, pivot) => {
      appliesTo.push({
        product,
        ticket: getTicketOfProduct(product),
        pivot,
        product_original_pricing: product.item.pricing
      });
    };
    if (!coupon.coupon.products.length) {
      forOwn(products, (product) => {
        appliesToProduct(product);
      });
    } else {
      forEach$1(coupon.coupon.products, (couponProduct) => {
        forOwn(products, (product) => {
          if (product.item.guid === couponProduct.guid) {
            appliesToProduct(product, couponProduct.pivot);
          }
        });
      });
    }
    appliesTo.sort((caA, caB) => {
      const pricingA = caA.product_original_pricing;
      const pricingB = caB.product_original_pricing;
      if (pricingA.base_price === pricingB.base_price) {
        return 0;
      }
      return pricingA.base_price > pricingB.base_price ? -1 : 1;
    });
    return appliesTo;
  },
  /**
   *  Used to get the amount of discount of a coupon, taking the amount_override
   *  for a specific product (based on the pivot) and the already spend amount
   *  into account in case of a cheque.
   */
  getAmount(coupon, couponApplicable) {
    let { amount } = coupon.item.coupon;
    const usedAmount = coupon.item.used_amount || 0;
    if (coupon.item.coupon.type === CouponType.Cheque) {
      amount = Math.max(0, amount - usedAmount - coupon.spend);
    } else if (couponApplicable.pivot && typeof couponApplicable.pivot.amount_override === "number") {
      amount = couponApplicable.pivot.amount_override;
    }
    return amount;
  },
  /**
   *
   *  Method for applying a coupon discount; either adding or removing it.
   *
   *  (!) Applied on the pricing object to the cart item (product) itself, which is a copy of the
   *  original item's item pricing object, so the original product pricing remains unchanged.
   *
   *  @return When it's about adding the amount of used is returned because it might have used just
   *  a part of the total computed delta (if the delta is bigger than the current price), and the
   *  negative delta should be returned if it's about removing because the delta got removed. Doing
   *  it like this allows users of the method to always plus the returned delta.
   *
   *  @todo How to handle an applied new-price coupon? Is it always leading?
   *
   */
  applyDiscount(coupon, action, couponApplicable) {
    const productPricing = couponApplicable.product.pricing;
    let delta = productPricing.coupons[coupon.item.guid];
    const applied = !!delta;
    if (action === CouponAction.Add && applied || action === CouponAction.Update && applied || action === CouponAction.Remove && !applied) {
      return 0;
    }
    if (delta === void 0) {
      const amount = this.getAmount(coupon, couponApplicable);
      switch (coupon.item.coupon.type) {
        case CouponType.Cheque:
        case CouponType.Fixed:
          delta = amount;
          break;
        case CouponType.Percentage:
          delta = amount / 100 * couponApplicable.product_original_pricing.base_price;
          break;
        case CouponType.NewPrice:
          delta = couponApplicable.product_original_pricing.base_price - amount;
          break;
        default:
          throw new ShopError(`Cannot ${action} coupon code -> Unknown coupon type`);
      }
      delta = Math.ceil(delta);
      if (delta === 0) {
        return 0;
      }
    }
    let newBase = 0;
    let used = 0;
    switch (action) {
      case CouponAction.Add:
      case CouponAction.Update:
        newBase = Math.max(0, productPricing.base_price - delta);
        used = productPricing.base_price < delta ? productPricing.base_price : productPricing.base_price - newBase;
        if (CartProduct.isCartProduct(couponApplicable.product)) {
          coupon.appliedCount++;
          const originalBasePrice = couponApplicable.product_original_pricing.base_price;
          coupon.appliedCounts[originalBasePrice] = coupon.appliedCounts[originalBasePrice] || 0;
          coupon.appliedCounts[originalBasePrice]++;
          coupon.spend += used;
        }
        productPricing.coupons[coupon.item.guid] = used;
        break;
      case CouponAction.Remove:
        newBase = productPricing.base_price + delta;
        if (CartProduct.isCartProduct(couponApplicable.product)) {
          coupon.appliedCount--;
          const originalBasePrice = couponApplicable.product_original_pricing.base_price;
          coupon.appliedCounts[originalBasePrice] = coupon.appliedCounts[originalBasePrice] || 0;
          coupon.appliedCounts[originalBasePrice]--;
          coupon.spend -= delta;
        }
        delete productPricing.coupons[coupon.item.guid];
        break;
    }
    productPricing.base_price = newBase;
    return action === CouponAction.Remove ? -delta : used;
  }
};
function castDate(value) {
  if (!value || value instanceof Date) {
    return value;
  }
  if (typeof value !== "string" && typeof value !== "number") {
    return value;
  }
  if (typeof value === "string") {
    const parsed = Date.parse(value);
    return !Number.isNaN(parsed) ? new Date(value) : value;
  }
  return new Date(value);
}
function castDateAsIs(value) {
  if (!value || value instanceof Date) {
    return value;
  }
  if (typeof value !== "string") {
    return value;
  }
  const parsed = Date.parse(value);
  if (!Number.isNaN(parsed)) {
    const date = new Date(value);
    const year = parseInt(value.substring(0, 4), 10);
    const month = parseInt(value.substring(5, 7), 10);
    const day = parseInt(value.substring(8, 10), 10);
    const hours = parseInt(value.substring(11, 13), 10);
    const minutes = parseInt(value.substring(14, 16), 10);
    const seconds = parseInt(value.substring(17, 19), 10);
    date.setFullYear(year, month - 1, day);
    date.setHours(hours, minutes, seconds);
    return date;
  }
  return value;
}
function event(eventToCast) {
  eventToCast.status_until = castDate(eventToCast.status_until);
  eventToCast.start = castDateAsIs(eventToCast.start);
  eventToCast.end = castDateAsIs(eventToCast.end);
}
function eventDate(eventDateToCast) {
  eventDateToCast.start = castDateAsIs(eventDateToCast.start);
  eventDateToCast.end = castDateAsIs(eventDateToCast.end);
}
function ticket(ticketToCast) {
  ticketToCast.available_from = castDate(ticketToCast.available_from);
  ticketToCast.available_until = castDate(ticketToCast.available_until);
}
function castMultiple(models, method) {
  forOwn(models, method);
}
function events(eventsToCast) {
  castMultiple(eventsToCast, event);
}
function eventDates(eventDatesToCast) {
  castMultiple(eventDatesToCast, eventDate);
}
function tickets(ticketsToCast) {
  castMultiple(ticketsToCast, ticket);
}
const GET_BY_VALUE = true;
const GET_BY_REF = false;
const IGNORE_UNDEFINED = true;
function isModelArray(data) {
  if (!!data && Array.isArray(data) && data.length) {
    return data.every((item) => isModel(item));
  }
  return false;
}
function isModelObject(data) {
  if (!!data && typeof data === "object" && Object.keys(data).length !== 0 && !Array.isArray(data)) {
    return Object.values(data).every((item) => isModel(item));
  }
  return false;
}
function isModel(data) {
  return !!data && typeof data === "object" && "guid" in data;
}
const Model = {
  /**
   *
   *  Used to get the reference or value of a model out of the provided data object. If the model could not be found
   *   this method returns undefined.
   *
   *  @param data Object that holds all the data out of which the model should be get
   *  @param key The key of the collection within the data out of which the model should be get
   *  @param guid The guid of the model to get
   *  @param value If the value of the model should be get, instead of a reference
   *
   */
  getOrUndefinedFrom(data, key, guid, value = false) {
    try {
      return Model.getFrom(data, key, guid, value);
    } catch (e) {
      if (isSluggedError(e) && e.slug === "sdkshop.log.model.getFrom.error.notfound") {
        return void 0;
      }
      throw e;
    }
  },
  /**
   *
   *  Used to get the reference or value of a model out of the provided data object. If the model could not be found
   *   this method throws an error.
   *
   *  @param data Object that holds all the data out of which the model should be get
   *  @param key The key of the collection within the data out of which the model should be get
   *  @param guid The guid of the model to get
   *  @param value If the value of the model should be get, instead of a reference
   *
   */
  getFrom(data, key, guid, value = false) {
    if (!hasAttribute(data, key)) {
      throw slugError(`The provided data does not contain the key ${key}`, ["model", "getFrom", "error", "invalid"], { key });
    }
    const keyData = data[key];
    let _models = [];
    let _model;
    if (isModelArray(keyData) && keyData.length) {
      _models = keyData;
    } else if (isModelObject(keyData)) {
      forOwn(keyData, (model) => {
        _models.push(model);
      });
    }
    forEach$1(_models, (model) => {
      if (model.guid === guid) {
        _model = model;
      }
      return !_model;
    });
    if (!_model) {
      throw slugError(`No model in ${key} with guid: ${guid}`, ["model", "getFrom", "error", "notfound"], { key, guid });
    }
    if (value) {
      const parsedModel = cloneObject(_model);
      if (isModel(parsedModel)) {
        return parsedModel;
      }
    }
    return _model;
  },
  /**
   *
   *  Used to add a model reference to a collection (once); because it may happen that a specific
   *  model is returned out of the API more than once.
   *
   *  @param collection An Array of the models or a guid map Object of the models
   *  @param model Any type of model, **must include a guid to check his uniqueness**
   *
   */
  addTo(collection, model) {
    if (!model.guid) {
      throw new ShopError("The model to add to a collection must have a guid");
    }
    if (Array.isArray(collection)) {
      if (!collection.length) {
        collection.push(model);
        return;
      }
      let alreadyAdded = false;
      forEach$1(collection, (collectionModel) => {
        if (collectionModel.guid === model.guid) {
          alreadyAdded = true;
          return false;
        }
        return void 0;
      });
      if (!alreadyAdded) {
        collection.push(model);
      }
      return;
    }
    if (typeof collection === "object") {
      collection[model.guid] = collection[model.guid] ? Object.assign(collection[model.guid], model) : model;
      return;
    }
    throw new ShopError(`The collection to add a model to should be an Array or Object: ${typeof collection} received`);
  },
  /**
   *  Simplied interface for casting the needed data in a
   *  single or collection of a specific model.
   */
  castData: {
    ofEvent: event,
    ofEvents: events,
    ofEventDate: eventDate,
    ofEventDates: eventDates,
    ofTicket: ticket,
    ofTickets: tickets
  }
};
const PIVOTS_KEY_EVENTS_TICKETS = "events-tickets";
const PIVOTS_KEY_PRODUCTS_METADATA = "products-metadata";
const PIVOTS_KEY_PRODUCTS_TICKETS = "products-tickets";
const PIVOTS_KEY_PRODUCTS_EVENT_DATES = "products-eventDates";
const PIVOTS_KEY_SHOPS_COLLAPSES = "shops-collapses";
const PIVOTS_KEY_SHOPS_METADATA = "shops-metadata";
const PIVOTS_KEY_SHOPS_PRODUCTS = "shops-products";
const PIVOTS_KEY_SHOPS_TICKETS = "shops-tickets";
const PIVOTS_KEY_SHOPS_PAYMENT_METHODS = "shops-paymentmethods";
const PIVOTS_KEY_TICKETS_GROUPS = "tickets-groups";
const PIVOTS_KEY_GROUPS_PRODUCTS = "groups-products";
var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2["Incremental"] = "incremental";
  OrderType2["SternBrocot"] = "sternbrocot";
  return OrderType2;
})(OrderType || {});
function setIncrementalIndexes(items) {
  let index = 0;
  const setIndex = (item) => {
    item.index = index++;
  };
  if (Array.isArray(items)) {
    forEach$1(items, setIndex);
  } else {
    forOwn(items, setIndex);
  }
}
function isPivot(objectToGuard) {
  if (!objectToGuard || typeof objectToGuard !== "object" || Array.isArray(objectToGuard)) {
    return false;
  }
  const validEntries = Object.entries(objectToGuard).filter(
    ([key, value]) => (key.endsWith("_guid") || key.endsWith("_id")) && typeof value === "string" && value.length > 0
  );
  return validEntries.length > 1;
}
function filterFromOneSide(originalPivots, newPivots, keyName, onFilteredOut) {
  if (!newPivots || typeof newPivots !== "object") {
    return originalPivots || [];
  }
  const filteredObjects = [];
  const newPivotsArray = Object.values(newPivots).filter((newPivot) => {
    const valid = isPivot(newPivot);
    if (!valid) {
      filteredObjects.push(newPivot);
    }
    return valid;
  });
  if (filteredObjects.length > 0 && onFilteredOut) {
    onFilteredOut(filteredObjects);
  }
  if (!originalPivots) {
    return newPivotsArray;
  }
  const newGroupedPivots = {};
  forEach$1(newPivotsArray, ({ [keyName]: key }) => {
    if (typeof key === "string") {
      newGroupedPivots[key] = true;
    }
  });
  const filteredList = originalPivots.filter(({ [keyName]: key }) => typeof key === "string" && !newGroupedPivots[key]);
  filteredList.push(...newPivotsArray);
  return filteredList;
}
class Pivot {
  constructor(logger) {
    // Holder of a reference to the original shop data pivots
    __publicField(this, "_pivots", {});
    __publicField(this, "_log");
    this._log = logger;
  }
  /**
   *  Used to set a reference to the original shop data's pivots,
   *  so the pivot methods can easily access it.
   */
  setPivots(newPivots) {
    if (!newPivots) {
      throw new ShopError("The provided pivots are undefined");
    }
    const logFilteredOut = (pivotType) => (filteredOutItems) => {
      if (this._log) {
        this._log._create(LogLevel.Error, ["pivot", "setPivots", "error", "set", "invalid"], {
          pivotType,
          count: filteredOutItems.length
        });
      }
    };
    this._pivots[PIVOTS_KEY_EVENTS_TICKETS] = filterFromOneSide(
      this._pivots[PIVOTS_KEY_EVENTS_TICKETS],
      newPivots[PIVOTS_KEY_EVENTS_TICKETS],
      "event_guid",
      logFilteredOut(PIVOTS_KEY_EVENTS_TICKETS)
    );
    this._pivots[PIVOTS_KEY_PRODUCTS_METADATA] = filterFromOneSide(
      this._pivots[PIVOTS_KEY_PRODUCTS_METADATA],
      newPivots[PIVOTS_KEY_PRODUCTS_METADATA],
      "product_guid",
      logFilteredOut(PIVOTS_KEY_PRODUCTS_METADATA)
    );
    this._pivots[PIVOTS_KEY_PRODUCTS_TICKETS] = filterFromOneSide(
      this._pivots[PIVOTS_KEY_PRODUCTS_TICKETS],
      newPivots[PIVOTS_KEY_PRODUCTS_TICKETS],
      "ticket_guid",
      logFilteredOut(PIVOTS_KEY_PRODUCTS_TICKETS)
    );
    this._pivots[PIVOTS_KEY_PRODUCTS_EVENT_DATES] = filterFromOneSide(
      this._pivots[PIVOTS_KEY_PRODUCTS_EVENT_DATES],
      newPivots[PIVOTS_KEY_PRODUCTS_EVENT_DATES],
      "event_date_guid",
      logFilteredOut(PIVOTS_KEY_PRODUCTS_EVENT_DATES)
    );
    this._pivots[PIVOTS_KEY_SHOPS_COLLAPSES] = filterFromOneSide(
      this._pivots[PIVOTS_KEY_SHOPS_COLLAPSES],
      newPivots[PIVOTS_KEY_SHOPS_COLLAPSES],
      "collapse_guid",
      logFilteredOut(PIVOTS_KEY_SHOPS_COLLAPSES)
    );
    this._pivots[PIVOTS_KEY_SHOPS_METADATA] = filterFromOneSide(
      this._pivots[PIVOTS_KEY_SHOPS_METADATA],
      newPivots[PIVOTS_KEY_SHOPS_METADATA],
      "metadata_guid",
      logFilteredOut(PIVOTS_KEY_SHOPS_METADATA)
    );
    this._pivots[PIVOTS_KEY_SHOPS_PRODUCTS] = filterFromOneSide(
      this._pivots[PIVOTS_KEY_SHOPS_PRODUCTS],
      newPivots[PIVOTS_KEY_SHOPS_PRODUCTS],
      "product_guid",
      logFilteredOut(PIVOTS_KEY_SHOPS_PRODUCTS)
    );
    this._pivots[PIVOTS_KEY_SHOPS_TICKETS] = filterFromOneSide(
      this._pivots[PIVOTS_KEY_SHOPS_TICKETS],
      newPivots[PIVOTS_KEY_SHOPS_TICKETS],
      "ticket_guid",
      logFilteredOut(PIVOTS_KEY_SHOPS_TICKETS)
    );
    this._pivots[PIVOTS_KEY_SHOPS_PAYMENT_METHODS] = Object.values(
      newPivots[PIVOTS_KEY_SHOPS_PAYMENT_METHODS] || []
    );
    this._pivots[PIVOTS_KEY_TICKETS_GROUPS] = filterFromOneSide(
      this._pivots[PIVOTS_KEY_TICKETS_GROUPS],
      newPivots[PIVOTS_KEY_TICKETS_GROUPS],
      "ticket_guid",
      logFilteredOut(PIVOTS_KEY_TICKETS_GROUPS)
    );
    this._pivots[PIVOTS_KEY_GROUPS_PRODUCTS] = filterFromOneSide(
      this._pivots[PIVOTS_KEY_GROUPS_PRODUCTS],
      newPivots[PIVOTS_KEY_GROUPS_PRODUCTS],
      "group_id",
      logFilteredOut(PIVOTS_KEY_GROUPS_PRODUCTS)
    );
    forOwn(newPivots, (newPivot, key) => {
      if (!(key in this._pivots)) {
        if (this._log) {
          this._log._create(LogLevel.Error, ["pivot", "setPivots", "error", "key", "unknown"], {
            key
          });
        }
        console.error("Pivot key not recognized", key);
      }
    });
  }
  /**
   *  Used to get a specific pivot(s) out of the forwarded pivots data, with
   *  the ability to only get pivots that contain a specific guid by
   *  forwarding filter settings.
   */
  get(settings) {
    const { key } = settings;
    const pivots = this._pivots[key];
    if (!pivots) {
      throw new ShopError(`No pivots available for: ${settings.key}`);
    }
    if (!settings.item) {
      return pivots;
    }
    return pivots.filter((pivot) => {
      if (!settings.item) {
        return false;
      }
      let found = pivot[settings.item.guid_key] === settings.item.guid;
      if (found && settings.belongs_to) {
        found = pivot[settings.belongs_to.guid_key] === settings.belongs_to.guid;
      }
      return found;
    });
  }
  /**
   *
   *  Used for determining the index of an item.
   *
   *  Either based on a stern-brocot sequence, or a linked list.
   *
   *  In case of stern-brocot, the fraction is returned as is,
   *  in case of a linked list, the index of an item is
   *  recursively computed based on the pivots,
   *  by iterating over all of them and counting
   *  how much steps it takes to reach the item that does not
   *  have a preceding item.
   *
   *  (i) If the preceding sequence is broken - because the preceding
   *  pivot is undefined or multiple pivots refer to each other - it
   *  will give every item an index based on his returned order,
   *  break the iteration and return -1
   *
   */
  computeIndex(items, settings) {
    if (!settings.item) {
      setIncrementalIndexes(items);
      return [-1, OrderType.Incremental];
    }
    const pivot = this.get(settings)[0];
    if (!pivot) {
      setIncrementalIndexes(items);
      return [-1, OrderType.Incremental];
    }
    if (pivot.numerator !== void 0 && Number.isInteger(pivot.numerator) && !!pivot.denominator && Number.isInteger(pivot.denominator)) {
      return [pivot.numerator / pivot.denominator, OrderType.SternBrocot];
    }
    return [-1, OrderType.Incremental];
  }
  /**
   *
   *  Used to sort the forwarded items based on pivot-based indexes,
   *  making use of the pivot's compute index method.
   *
   *  (!) Also makes sure to give every item an index based on their
   *  returned order when all the items got index zero - which happens
   *  when all their preceding_by's are `null`
   *
   */
  computeIndexes(items, settings) {
    const numberOfItems = Array.isArray(items) ? items.length : Object.keys(items).length;
    if (!numberOfItems) {
      return OrderType.Incremental;
    }
    const indexes = [];
    let validSequence = true;
    let lastOrderType = OrderType.Incremental;
    const computeIndex = (item) => {
      const pivotSettings = settings;
      if (!pivotSettings.item) {
        return void 0;
      }
      pivotSettings.item.guid = item.guid || "";
      const [index, orderType] = this.computeIndex(items, pivotSettings);
      lastOrderType = orderType;
      switch (orderType) {
        case OrderType.SternBrocot:
          item.index = index;
          break;
        case OrderType.Incremental:
        default:
          validSequence = false;
          return false;
      }
      return void 0;
    };
    const validIndexSequence = () => {
      let valid = true;
      let index = 0;
      indexes.sort((indexOne, indexTwo) => indexOne === indexTwo ? 0 : indexOne - indexTwo);
      forEach$1(indexes, (itemIndex) => {
        if (itemIndex !== index) {
          valid = false;
        } else {
          index++;
        }
        return valid;
      });
      return valid;
    };
    if (Array.isArray(items)) {
      forEach$1(items, computeIndex);
    } else {
      forOwn(items, computeIndex);
    }
    if (validSequence && !validIndexSequence()) {
      setIncrementalIndexes(items);
      return OrderType.Incremental;
    }
    return lastOrderType;
  }
}
const IGNORE_OPTIONAL = true;
var VATUpdateAction = /* @__PURE__ */ ((VATUpdateAction2) => {
  VATUpdateAction2["Add"] = "add";
  VATUpdateAction2["Subtract"] = "subtract";
  return VATUpdateAction2;
})(VATUpdateAction || {});
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2[EventType2["Once"] = 0] = "Once";
  EventType2[EventType2["Repeating"] = 1] = "Repeating";
  return EventType2;
})(EventType || {});
var EventStatus = /* @__PURE__ */ ((EventStatus2) => {
  EventStatus2["Unavailable"] = "unavailable";
  EventStatus2["Available"] = "available";
  EventStatus2["Sold_out"] = "sold_out";
  EventStatus2["Refunding"] = "refunding";
  EventStatus2["Moving"] = "moving";
  return EventStatus2;
})(EventStatus || {});
var ProductType = /* @__PURE__ */ ((ProductType2) => {
  ProductType2[ProductType2["Normal"] = 0] = "Normal";
  ProductType2[ProductType2["Varying"] = 1] = "Varying";
  return ProductType2;
})(ProductType || {});
var ProductMethod = /* @__PURE__ */ ((ProductMethod2) => {
  ProductMethod2["BookingProtect"] = "bookingProtect";
  return ProductMethod2;
})(ProductMethod || {});
var PricingMethod = /* @__PURE__ */ ((PricingMethod2) => {
  PricingMethod2["Own"] = "own";
  PricingMethod2["Container"] = "container";
  return PricingMethod2;
})(PricingMethod || {});
var ProductGroupType = /* @__PURE__ */ ((ProductGroupType2) => {
  ProductGroupType2["Required"] = "required";
  ProductGroupType2["Optional"] = "optional";
  ProductGroupType2["Select"] = "select";
  ProductGroupType2["Radio"] = "radio";
  ProductGroupType2["Multiselect"] = "multiselect";
  ProductGroupType2["Checkbox"] = "checkbox";
  return ProductGroupType2;
})(ProductGroupType || {});
var EventSelection = /* @__PURE__ */ ((EventSelection2) => {
  EventSelection2["Auto"] = "auto";
  EventSelection2["Enabled"] = "enabled";
  EventSelection2["Disabled"] = "disabled";
  return EventSelection2;
})(EventSelection || {});
var State = /* @__PURE__ */ ((State2) => {
  State2["Start"] = "start";
  State2["Initializing"] = "initializing";
  State2["Waiting"] = "waiting";
  State2["Loading"] = "loading";
  State2["Ready"] = "ready";
  State2["Error"] = "error";
  return State2;
})(State || {});
const SINGLE_VAT = false;
const PRICING_DETAILS_DATA = [
  "base_price",
  "total_fees",
  "subtotal_price",
  "total_price"
];
const Price = {
  /**
   *  Used to create a pricing details object. A (global)
   *  product has one (self), but a ticket is built up by
   *  three: self, children own and children container.
   *
   *  (i) Details can either contain data of a single VAT
   *  (only applicable for the self) or a VAT collection,
   *  holding every applied VAT in it.
   */
  createPricingDetails(basePrice = 0, vatPercentage = 0, VATCollection = true) {
    const details = {
      base_price: basePrice,
      total_fees: 0,
      subtotal_price: basePrice,
      total_price: basePrice
    };
    if (VATCollection) {
      details.including_vats = {
        percentages: {},
        total: 0
      };
    } else {
      details.vat = {
        percentage: vatPercentage,
        amount: 0
      };
    }
    return details;
  },
  /**
   *  Used to create a default pricing object.
   *  (i) Used for (global) products and as base for tickets
   */
  createPricing(basePrice, fees, vatPercentage = 0) {
    const pricing = this.createPricingDetails(basePrice, vatPercentage, SINGLE_VAT);
    return {
      fees,
      ...pricing,
      coupons: {}
    };
  },
  /**
   *  Used to create a ticket's pricing object, which contains more
   *  than a product's pricing because the pricing of a ticket is
   *  computed based on multiple pricing details.
   */
  createTicketPricing(basePrice, fees, vatPercentage = 0) {
    const pricing = this.createPricing(basePrice, fees, vatPercentage);
    pricing.self = this.createPricingDetails(basePrice, vatPercentage, SINGLE_VAT);
    pricing.including_vats = {
      percentages: {},
      total: 0
    };
    pricing.coupons_count = {};
    pricing.children = {
      own: this.createPricingDetails(),
      container: this.createPricingDetails()
    };
    return pricing;
  },
  /**
   *
   *  Used to compute the pricing of a ticket. Based on required and/or
   *  optional products and taking his min price and applied coupons into
   *  account. Also builds the VAT collection based on the products that
   *  are used for the ticket and setting the highest VAT amount of his
   *  most expensive required product (if it has a value) as his own.
   *
   *  (!) The VAT amounts of the (ticket) products of a ticket must be
   *  computed before executing this method, as the fees and VATs of
   *  products are used for computation.
   *
   *  Returns true if the pricing has changed!
   *
   */
  computeTicketPricing(ticketPricing, ticketMinPrice, products, ignoreOptional = false) {
    const hash = () => [
      ticketPricing.base_price,
      ticketPricing.total_fees,
      ticketPricing.subtotal_price,
      ticketPricing.total_price
    ].toString();
    const beforeHash = hash();
    this.resetTicketPricing(ticketPricing);
    const ticketProducts = {
      all: products,
      optional: [],
      required: []
    };
    forEach$1(products, (product) => {
      ticketProducts[product.is_optional ? "optional" : "required"].push(product);
    });
    ticketPricing.self.base_price = ticketMinPrice || 0;
    const containerProducts = [];
    const addProductToPricing = (product) => {
      const productPricing = product.pricing;
      if (product.is_optional) {
        ticketPricing.children.own.base_price += productPricing.base_price;
        ticketPricing.children.own.total_fees += productPricing.total_fees;
        ticketPricing.children.own.subtotal_price += productPricing.subtotal_price;
        ticketPricing.children.own.total_price += productPricing.total_price;
        this.updateVATCollection(
          VATUpdateAction.Add,
          ticketPricing.children.own.including_vats,
          productPricing.vat.percentage,
          productPricing.vat.amount
        );
        return;
      }
      if (productPricing.base_price > 0) {
        ticketPricing.self.base_price += productPricing.base_price;
        ticketPricing.self.vat.percentage = Math.max(
          ticketPricing.self.vat.percentage,
          productPricing.vat.percentage
        );
      }
    };
    if (typeof ticketMinPrice !== "number") {
      ticketPricing.self.vat.percentage = 0;
      forEach$1(ticketProducts.required, (ticketProduct) => {
        if (ticketProduct.item.pricing_method === PricingMethod.Container) {
          containerProducts.push(ticketProduct);
          return;
        }
        addProductToPricing(ticketProduct);
      });
    } else if (ticketPricing.self.base_price > 0) {
      forEach$1(ticketProducts.required, (product) => {
        forOwn(product.pricing.coupons, (couponDelta) => {
          ticketPricing.self.base_price -= couponDelta;
          return ticketPricing.self.base_price > 0;
        });
        return ticketPricing.self.base_price > 0;
      });
      ticketPricing.self.base_price = Math.max(0, ticketPricing.self.base_price);
    }
    if (ticketPricing.self.base_price > 0) {
      ticketPricing.self.total_fees += ticketPricing.fees.fixed;
      ticketPricing.self.total_fees += round(ticketPricing.self.base_price * ticketPricing.fees.percentage / 100);
    } else {
      ticketPricing.self.total_fees = 0;
    }
    ticketPricing.self.total_price = ticketPricing.self.base_price + ticketPricing.self.total_fees;
    ticketPricing.self.vat.amount = Math.ceil(
      ticketPricing.self.vat.percentage * ticketPricing.self.total_price / (100 + ticketPricing.self.vat.percentage)
    );
    ticketPricing.self.subtotal_price = ticketPricing.self.total_price - ticketPricing.self.vat.amount;
    forEach$1(ticketProducts.optional, (product) => {
      if (product.item.pricing_method === PricingMethod.Container) {
        containerProducts.push(product);
        return;
      }
      if (!ignoreOptional) {
        addProductToPricing(product);
      }
    });
    if (containerProducts.length) {
      const originalTicketPrice = ticketPricing.self.total_price + ticketPricing.children.own.total_price;
      forEach$1(containerProducts, (product) => {
        this.computeProductPricing(product.pricing, originalTicketPrice);
        if (ignoreOptional && product.is_optional) {
          return;
        }
        ticketPricing.children.container.total_fees += product.pricing.total_fees;
        ticketPricing.children.container.subtotal_price += product.pricing.subtotal_price;
        ticketPricing.children.container.total_price += product.pricing.total_price;
        this.updateVATCollection(
          VATUpdateAction.Add,
          ticketPricing.children.container.including_vats,
          product.pricing.vat.percentage,
          product.pricing.vat.amount
        );
      });
    }
    this.computeTicketTotal(ticketPricing);
    forEach$1(ticketProducts.optional, (product) => {
      this.computeProductPricing(product.pricing);
    });
    return beforeHash !== hash();
  },
  /**
   *  Used for resetting the pricing of a ticket, happening every time
   *  the pricing of a ticket should be computed to make sure the
   *  values are being computed from zero.
   */
  resetTicketPricing(ticketPricing) {
    forEach$1(PRICING_DETAILS_DATA, (dataProp) => {
      ticketPricing[dataProp] = 0;
    });
    ticketPricing.including_vats = {
      percentages: {},
      total: 0
    };
    ticketPricing.self = this.createPricingDetails(
      ticketPricing.self.base_price,
      ticketPricing.self.vat.percentage,
      SINGLE_VAT
    );
    ticketPricing.children.own = this.createPricingDetails();
    ticketPricing.children.container = this.createPricingDetails();
  },
  /**
   *  Compute a ticket's total pricing by summing every pricing
   *  details (self, own and container children) of the ticket.
   */
  computeTicketTotal(ticketPricing) {
    const details = [
      ticketPricing.children.own,
      ticketPricing.children.container
    ];
    forEach$1(PRICING_DETAILS_DATA, (dataProp) => {
      ticketPricing[dataProp] += ticketPricing.self[dataProp];
    });
    this.updateVATCollection(
      VATUpdateAction.Add,
      ticketPricing.including_vats,
      ticketPricing.self.vat.percentage,
      ticketPricing.self.vat.amount
    );
    forEach$1(details, (detail) => {
      forEach$1(PRICING_DETAILS_DATA, (dataProp) => {
        ticketPricing[dataProp] += detail[dataProp];
      });
      forOwn(detail.including_vats.percentages, (amount, percentage) => {
        this.updateVATCollection(
          VATUpdateAction.Add,
          ticketPricing.including_vats,
          percentage,
          amount
        );
      });
    });
  },
  /**
   *  Used to compute the total prices of a product's pricing object.
   *
   *  Returns true if the pricing was changed.
   */
  computeProductPricing(pricing, containerPrice) {
    const hash = () => [
      pricing.vat.amount,
      pricing.base_price,
      pricing.subtotal_price,
      pricing.total_fees,
      pricing.total_price
    ].toString();
    const beforeHash = hash();
    const price = typeof containerPrice === "number" ? containerPrice : pricing.base_price;
    if (typeof containerPrice === "number") {
      pricing.base_price = 0;
    }
    if (price === 0) {
      pricing.vat.amount = 0;
      pricing.subtotal_price = 0;
      pricing.total_fees = 0;
      pricing.total_price = 0;
      return beforeHash !== hash();
    }
    pricing.total_fees = pricing.fees.fixed;
    pricing.total_fees += round(price * pricing.fees.percentage / 100);
    pricing.total_price = pricing.base_price + pricing.total_fees;
    const amountThatIncludesVAT = pricing[containerPrice ? "total_fees" : "total_price"];
    pricing.vat.amount = Math.ceil(
      pricing.vat.percentage * amountThatIncludesVAT / (100 + pricing.vat.percentage)
    );
    pricing.subtotal_price = pricing.total_price - pricing.vat.amount;
    return beforeHash !== hash();
  },
  /**
   *
   *  Used to compute the pricing of the forwarded products and tickets, as
   *  used for both regular products and tickets from the shop and cart product
   *  and cart tickets from the cart.
   *
   *  (i) As the location of the products of a ticket differs per type
   *  of ticket, a method for retrieving them must be forwarded.
   *
   */
  computeItemsPricing(products, tickets2, getProductsOfTicket, ignoreOptional = false) {
    const cartItemsUpdated = {
      tickets: [],
      products: []
    };
    forOwn(products, (product) => {
      if (this.computeProductPricing(product.pricing)) {
        cartItemsUpdated.products.push(product);
      }
    });
    forOwn(tickets2, (ticket2) => {
      if (this.computeTicketPricing(
        ticket2.pricing,
        ticket2.min_price,
        getProductsOfTicket(ticket2),
        ignoreOptional
      )) {
        cartItemsUpdated.tickets.push(ticket2);
      }
    });
    return cartItemsUpdated;
  },
  /**
   *  Calculate the cumulative pricing object for an array of cart items.
   */
  getCumulativeCartItemPrice(items) {
    const pricing = items.map((item) => item.pricing);
    return {
      base_price: sumBy(pricing, "base_price"),
      total_fees: sumBy(pricing, "total_fees"),
      subtotal_price: sumBy(pricing, "subtotal_price"),
      total_price: sumBy(pricing, "total_price")
    };
  },
  /**
   *  Used to update the amount of a specific VAT percentage in a collection
   *  of VAT amounts. Meaning it simply adds or subtracts the forwarded amount
   *  to/from the right percentage key in the forwarded collection and
   *  adds/subtracts the amount of the total.
   */
  updateVATCollection(action, collection, percentage, amount) {
    const percentageKey = String(percentage);
    collection.percentages[percentageKey] = typeof collection.percentages[percentageKey] === "number" ? collection.percentages[percentageKey] : 0;
    amount = action === VATUpdateAction.Add ? amount : -amount;
    collection.percentages[percentageKey] += amount;
    collection.total += amount;
    if (collection.percentages[percentageKey] === 0) {
      delete collection.percentages[percentageKey];
    }
  }
};
var lib = { exports: {} };
(function(module, exports) {
  (function(global2, factory) {
    factory(exports);
  })(commonjsGlobal, function(exports2) {
    class EventBus2 {
      constructor(config) {
        this.listeners = {};
        this._map = {};
        this._config = config || {};
      }
      // Subscribe to events by path
      on(path, listener) {
        if (path.length < 1) {
          this.listeners.listeners = this.listeners.listeners || [];
          this.listeners.listeners.push(listener);
        } else {
          let root = this.listeners;
          for (let i = 0; i < path.length; i++) {
            const node = root[path[i]];
            if (!node) {
              root[path[i]] = {};
            }
            root = root[path[i]];
            if (i === path.length - 1) {
              root.listeners = root.listeners || [];
              root.listeners.push(listener);
            }
          }
        }
        const id = this._generateId();
        this._map[id] = {
          path,
          listener
        };
        return id;
      }
      /**
       * Remove a listener from the event bus
       * @param id - as provided by the 'on' method
       */
      off(id) {
        var _a, _b;
        if (!this._map[id]) {
          throw Error("Listener does not exist");
        }
        const path = this._map[id].path;
        const listener = this._map[id].listener;
        let root = this.listeners;
        while (path.length > 0) {
          const part = path.shift();
          root = root[part];
          if (path.length < 1) {
            const index = (_a = root.listeners) === null || _a === void 0 ? void 0 : _a.findIndex((value) => value === listener);
            if (index === void 0 || index < 0) {
              throw Error("Listener not found in tree");
            }
            (_b = root.listeners) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
          }
        }
        delete this._map[id];
      }
      // Emit data to it's listeners by path
      emit(path, data) {
        if (this._config.isDebug) {
          console.info("EVENT", path, data);
        }
        let to = [];
        let root = this.listeners;
        for (let i = 0; i <= path.length; i++) {
          if (root.listeners) {
            to = [...to, ...root.listeners];
          }
          if (root[path[i]]) {
            root = root[path[i]];
          } else {
            break;
          }
        }
        for (const listener of to) {
          const pathCopy = [...path];
          if (data && typeof data === "object") {
            data = JSON.parse(JSON.stringify(data));
          }
          setTimeout(() => {
            listener(pathCopy, data);
          }, 0);
        }
      }
      /**
       * Basic id generator
       * src: https://www.w3resource.com/javascript-exercises/javascript-math-exercise-23.php
       */
      _generateId() {
        let dt = (/* @__PURE__ */ new Date()).getTime();
        const id = "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(/[x]/g, function(c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : r & 3 | 8).toString(16);
        });
        return id;
      }
    }
    class EventScope {
      constructor(eventBus) {
        this._eventBus = eventBus;
      }
      /**
       *  Listen to events by providing a path and a callback to the `on` function
       *  @param path - Path to listen to
       *  @param cb - Will be called when an event occurs
       */
      on(path, cb, noScope = false) {
        if (!Array.isArray(path)) {
          if (path === "*") {
            path = [];
          } else {
            path = [path];
          }
        } else {
          path = [...path];
        }
        if (this._eventScope && !noScope) {
          path = [this._eventScope, ...path];
        }
        return this._eventBus.on(path, cb);
      }
      /**
       * Remove a listener from the event bus
       * @param id - listener id as provided by the 'on' method
       */
      off(id) {
        this._eventBus.off(id);
      }
      /**
       *  Emit an event from the eventScope
       *  @param path - The path on which the event occurred
       *  @param payload - The data to be send
       */
      emit(path, payload, noScope = false) {
        if (!Array.isArray(path)) {
          path = [path];
        }
        if (this._eventScope && !noScope) {
          path = [this._eventScope, ...path];
        }
        this._eventBus.emit(path, payload);
      }
    }
    const EventBusSingleton = new EventBus2();
    exports2.EventBusSingleton = EventBusSingleton;
    exports2.EventScope = EventScope;
    exports2.default = EventBus2;
    Object.defineProperty(exports2, "__esModule", { value: true });
  });
})(lib, lib.exports);
var libExports = lib.exports;
const EventBus = /* @__PURE__ */ getDefaultExportFromCjs(libExports);
var pure$1 = {};
Object.defineProperty(pure$1, "__esModule", { value: true });
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
var V3_URL = "https://js.stripe.com/v3";
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var findScript = function findScript2() {
  var scripts = document.querySelectorAll('script[src^="'.concat(V3_URL, '"]'));
  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];
    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }
    return script;
  }
  return null;
};
var injectScript = function injectScript2(params) {
  var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
  var script = document.createElement("script");
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;
  if (!headOrBody) {
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  }
  headOrBody.appendChild(script);
  return script;
};
var registerWrapper = function registerWrapper2(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }
  stripe._registerWrapper({
    name: "stripe-js",
    version: "1.11.0",
    startTime
  });
};
var stripePromise = null;
var loadScript = function loadScript2(params) {
  if (stripePromise !== null) {
    return stripePromise;
  }
  stripePromise = new Promise(function(resolve, reject) {
    if (typeof window === "undefined") {
      resolve(null);
      return;
    }
    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }
    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }
    try {
      var script = findScript();
      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      }
      script.addEventListener("load", function() {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error("Stripe.js not available"));
        }
      });
      script.addEventListener("error", function() {
        reject(new Error("Failed to load Stripe.js"));
      });
    } catch (error) {
      reject(error);
      return;
    }
  });
  return stripePromise;
};
var initStripe = function initStripe2(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }
  var stripe = maybeStripe.apply(void 0, args);
  registerWrapper(stripe, startTime);
  return stripe;
};
var validateLoadParams = function validateLoadParams2(params) {
  var errorMessage = "invalid load parameters; expected object of shape\n\n    {advancedFraudSignals: boolean}\n\nbut received\n\n    ".concat(JSON.stringify(params), "\n");
  if (params === null || _typeof(params) !== "object") {
    throw new Error(errorMessage);
  }
  if (Object.keys(params).length === 1 && typeof params.advancedFraudSignals === "boolean") {
    return params;
  }
  throw new Error(errorMessage);
};
var loadParams;
var loadStripeCalled = false;
var loadStripe = function loadStripe2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  loadStripeCalled = true;
  var startTime = Date.now();
  return loadScript(loadParams).then(function(maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};
loadStripe.setLoadParameters = function(params) {
  if (loadStripeCalled) {
    throw new Error("You cannot change load parameters after calling loadStripe");
  }
  loadParams = validateLoadParams(params);
};
pure$1.loadStripe = loadStripe;
var pure = pure$1;
class CrossWindowBase {
  constructor(_config) {
    /**
     * Indicates if there is a connection initiated with a cross window client
     */
    __publicField(this, "isConnected", false);
    __publicField(this, "connecting");
    __publicField(this, "identifier", "_isOpenticket");
    // Used to resolve or reject the exposed initTweaks promise
    __publicField(this, "_resolveConnecting");
    __publicField(this, "_rejectConnecting");
    __publicField(this, "_initData");
    /**
     * Minimal configuration detauls for a cross window peer
     */
    __publicField(this, "_config");
    if (!_config) {
      throw new Error("No configuration provided");
    }
    if (!_config.scope || !_config.window) {
      throw new Error("The provided configuration is incomplete");
    }
    if (_config.window === window) {
      throw new Error("Cannot use the current window as a target");
    }
    this._config = _config;
    Object.freeze(this._config);
    this.connecting = new Promise((resolve, reject) => {
      this._resolveConnecting = resolve;
      this._rejectConnecting = reject;
    });
    window.addEventListener("message", (ev) => this._onMessage(ev));
    this._sendRawMessage({
      [this.identifier]: true,
      init: "SYN",
      scope: this._config.scope
    });
  }
  /**
   * Internal handler for messages to do basic checks and filter spam
   * @param event - The event that is received
   */
  async _onMessage(event2) {
    if (!hasAttribute(event2, "data") || !hasAttribute(event2.data, this.identifier) || !event2.data[this.identifier]) {
      return;
    }
    if (hasAttribute(event2.data, "scope") && event2.data.scope === "client" && this._config.scope === "client") {
      return;
    }
    if (hasAttribute(event2.data, "scope") && event2.data.scope !== "client" && this._config.scope !== "client") {
      return;
    }
    if (hasAttribute(event2, "source") && event2.source !== this._config.window) {
      return;
    }
    if (hasAttribute(event2.data, "init")) {
      if (event2.data.init === "SYN") {
        this._sendMessage({ init: "SYN-ACK", payload: this._initData });
      } else if (event2.data.init === "SYN-ACK") {
        await this.onConnect(hasAttribute(event2.data, "payload") ? event2.data.payload : void 0);
        this._sendMessage({ init: "ACK", payload: this._initData });
        this.isConnected = true;
        this._resolveConnecting();
      } else if (event2.data.init === "ACK") {
        await this.onConnect(hasAttribute(event2.data, "payload") ? event2.data.payload : void 0);
        this.isConnected = true;
        this._resolveConnecting();
      }
      return;
    }
    await this.onMessage(event2);
  }
  /**
   * This method will be called when the connection is established
   * @param _data - The data that is received
   */
  async onConnect(_data) {
  }
  /**
   * This method should be implemented by classes using this one,
   * it will be called when a message arrives
   * @param _event - The event that is received
   */
  async onMessage(_event) {
  }
  /**
   * Notify the peer of an error that occurred
   * @param error - A string containing the error description
   */
  _sendError(error) {
    this._sendMessage({ error });
  }
  /**
   * Internal send method
   * @param data - Payload of the message
   */
  _sendMessage(data) {
    this._sendRawMessage({
      [this.identifier]: true,
      scope: this._config.scope,
      ...data
    });
  }
  /**
   * Sends a raw message to the specified window
   * @param data - Payload of the message
   */
  _sendRawMessage(data) {
    this._config.window.postMessage(data, "*");
  }
}
function readClickId(url) {
  const { searchParams } = url;
  const knownClickIds = getKnownClickIds();
  const lowerCasedParams = new URLSearchParams();
  for (const [name, value] of searchParams) {
    lowerCasedParams.append(name.toLowerCase(), value);
  }
  const result2 = {};
  if (!searchParams) {
    return result2;
  }
  Object.entries(knownClickIds).forEach(([paramName, source]) => {
    const param = lowerCasedParams.get(paramName);
    if (param) {
      result2.id = param;
      result2.source = source;
    }
  });
  return result2;
}
function getKnownClickIds() {
  return {
    _z1_agid: "zemanta",
    _z1_caid: "zemanta",
    _z1_msid: "zemanta",
    ad_id: "adroll",
    adobe_mc_sdid: "adobe target (a4t)",
    afid: "yahoo native params",
    auctid: "teads",
    awclid: "amazon",
    bsft_clkid: "blueshift",
    bsft_uid: "blueshift",
    cid: "generic & unknown platforms",
    ck_subscriber_id: "convertkit",
    click_id: "generic",
    "click-id": "generic",
    clickid: "generic",
    cvid: "microsoft msn/bing",
    dclid: "doubleclick",
    ef_id: "adobe",
    eid: "generic & unknown platforms",
    fb_action_ids: "meta",
    fbclid: "meta",
    gclid: "google",
    h_sid: "hive email",
    icid: "other",
    igshid: "instagram",
    li_fat_id: "linkedin",
    mc_cid: "mailchimp",
    mc_eid: "mailchimp",
    msclkid: "microsoft",
    oft_id: "dialog insight",
    oft_ids: "dialog insight",
    oly_anon_id: "olytics",
    oly_enc_id: "olytics",
    omnisendcontactid: "omnisend",
    rb_clickid: "other",
    rdt_cid: "reddit",
    s_cid: "adobe",
    s_kwcid: "adobe",
    ss_email_id: "squarespace newsletter",
    subafid: "other",
    ttclid: "tiktok",
    twclid: "twitter",
    unicorn_click_id: "unicorn media",
    vero_id: "vero",
    vmcid: "yahoo dsp",
    wickedid: "wicked reports",
    "wt.mc_id": "webtrends marketing campaign id",
    yclid: "yandex/yahoo",
    ymclid: "yandex",
    ysclid: "yandex"
  };
}
function buildTrackingInfo(suppliedTrackingInfo, gaTrackerToGetClientIdFor, log) {
  try {
    const resultingTrackingInfo = {
      click_id: suppliedTrackingInfo && suppliedTrackingInfo.click_id,
      click_id_source: suppliedTrackingInfo && suppliedTrackingInfo.click_id_source,
      eaid: suppliedTrackingInfo && suppliedTrackingInfo.eaid,
      google_client_id: suppliedTrackingInfo && suppliedTrackingInfo.google_client_id,
      utm_campaign: suppliedTrackingInfo && suppliedTrackingInfo.utm_campaign,
      utm_medium: suppliedTrackingInfo && suppliedTrackingInfo.utm_medium,
      utm_source: suppliedTrackingInfo && suppliedTrackingInfo.utm_source,
      utm_term: suppliedTrackingInfo && suppliedTrackingInfo.utm_term
    };
    if (window && window.location && window.location.href) {
      try {
        const url = new URL(window.location.href);
        const toForwardList = [
          "utm_campaign",
          "utm_medium",
          "utm_source",
          "utm_term"
        ];
        toForwardList.forEach((toForward) => {
          if (!resultingTrackingInfo[toForward] && url.searchParams.has(toForward)) {
            const forwardValue = url.searchParams.get(toForward);
            if (forwardValue) {
              resultingTrackingInfo[toForward] = forwardValue;
            }
          }
        });
      } catch {
        if (log) {
          log._create(LogLevel.Warning, ["tracking", "buildTrackingInfo", "location", "params", "error"], {
            url: window.location.href
          });
        }
      }
      try {
        const url = new URL(window.location.href);
        const { id, source } = readClickId(url);
        if (id && source && !resultingTrackingInfo.click_id) {
          resultingTrackingInfo.click_id = id;
          resultingTrackingInfo.click_id_source = source;
        }
      } catch {
        if (log) {
          log._create(LogLevel.Warning, ["tracking", "buildTrackingInfo", "location", "click_id", "error"], {
            url: window.location.href
          });
        }
      }
    }
    if (!resultingTrackingInfo.eaid) {
      if ("rudderanalytics" in window && typeof window.rudderanalytics === "object") {
        const rudderAnalytics = window.rudderanalytics;
        if (rudderAnalytics && "getAnonymousId" in rudderAnalytics && typeof rudderAnalytics.getAnonymousId === "function") {
          try {
            resultingTrackingInfo.eaid = rudderAnalytics.getAnonymousId() || void 0;
          } catch (e) {
            if (log) {
              log._create(LogLevel.Warning, ["tracking", "buildTrackingInfo", "rudderstack", "error"]);
            }
          }
        }
      }
    }
    if (!resultingTrackingInfo.google_client_id) {
      if ("gaGlobal" in window && typeof window.gaGlobal === "object" && window.gaGlobal && "vid" in window.gaGlobal && typeof window.gaGlobal.vid === "string") {
        resultingTrackingInfo.google_client_id = window.gaGlobal.vid;
      } else if ("ga" in window && typeof window.ga === "object" && window.ga && "getAll" in window.ga && typeof window.ga.getAll === "function") {
        try {
          const trackers = window.ga.getAll();
          if (trackers && Array.isArray(trackers)) {
            trackers.forEach((tracker) => {
              if (tracker && typeof tracker === "object" && "get" in tracker && typeof tracker.get === "function") {
                if (tracker.get("trackingId") === gaTrackerToGetClientIdFor) {
                  resultingTrackingInfo.google_client_id = tracker.get("clientId") || void 0;
                }
              }
            });
          }
        } catch (e) {
          if (log) {
            log._create(LogLevel.Warning, ["tracking", "buildTrackingInfo", "google_analytics", "error"]);
          }
        }
      }
    }
    return resultingTrackingInfo;
  } catch {
    if (log) {
      log._create(LogLevel.Warning, ["tracking", "buildTrackingInfo", "generic", "error"]);
    }
    return {};
  }
}
class CrossWindowClient extends CrossWindowBase {
  constructor(_window, data) {
    super({
      window: _window,
      scope: "client"
    });
    /**
     * Containers for the received data
     */
    __publicField(this, "cart");
    __publicField(this, "data");
    __publicField(this, "localization");
    __publicField(this, "initErrors");
    /**
     * Listeners for the different types of events
     */
    __publicField(this, "_shopInitListeners", []);
    __publicField(this, "_shopListeners", []);
    __publicField(this, "_cartListeners", []);
    __publicField(this, "_errorListeners", []);
    __publicField(this, "_notificationListeners", []);
    __publicField(this, "_routeChangeListeners", []);
    __publicField(this, "_seatsListeners", []);
    __publicField(this, "_localeListeners", []);
    __publicField(this, "_customMessageListeners", []);
    this._initData = data;
  }
  /**
   * Set tracking information from the host page, if not supplied: try to determine it
   * @param data - Tracking information that should take preference over automatically determined values
   * @param gaTrackerToGetClientIdFor - Analytics code to get the Google Client Id for
   * @param logger - Logger
   */
  setTrackingInformation(data, gaTrackerToGetClientIdFor, logger) {
    this.sendMessage({
      type: "tracking_information",
      data: buildTrackingInfo(data, gaTrackerToGetClientIdFor, logger)
    });
  }
  /**
   * Set booker information and metadata in the cart
   * @param data - Booker information and metadata
   */
  setBookerInformation(data) {
    this.sendMessage({
      type: "booker_information",
      data
    });
  }
  /**
   * Set static shop settings
   * @param data - Static shop settings
   */
  setStaticShopSettings(data) {
    this.sendMessage({
      type: "static_settings",
      data
    });
  }
  /**
   * Is called when the connection is setup
   * @param data - TweakConfig
   */
  async onConnect(data) {
    if (hasAttribute(data, "localization")) {
      this.localization = data.localization;
    }
    if (hasAttribute(data, "initErrors")) {
      this.initErrors = data.initErrors;
    }
    return Promise.resolve();
  }
  /**
   * Handles incoming events
   * @param event - Event that is received
   */
  async onMessage(event2) {
    if (hasAttribute(event2, "data")) {
      if (hasAttribute(event2.data, "scope") && event2.data.scope === "client") {
        return Promise.resolve();
      }
      if (hasAttribute(event2.data, "error") && event2.data.error) {
        let serializableError = typeof event2.data.error === "string" ? event2.data.error : "error";
        if (typeof event2.data.error === "object") {
          if (event2.data.error.toString !== Object.prototype.toString) {
            serializableError = event2.data.error.toString();
          } else {
            console.error("Something went wrong: Unserializable error encountered", event2.data.error);
            serializableError = "Something went wrong";
          }
        }
        return this._notify(this._errorListeners, serializableError);
      }
      if (hasAttribute(event2.data, "action")) {
        switch (event2.data.action) {
          case "init":
            if (hasAttribute(event2.data, "scope") && event2.data.scope === "shop") {
              this.initErrors = {
                valid: hasAttribute(event2.data, "data") && hasAttribute(event2.data.data, "valid") && !!event2.data.data.valid,
                errors: hasAttribute(event2.data, "data") && hasAttribute(event2.data.data, "errors") && event2.data.data.errors || []
              };
              return this._notify(this._shopInitListeners, this.initErrors);
            }
            break;
          case "update":
            if (hasAttribute(event2.data, "scope")) {
              switch (event2.data.scope) {
                case "shop":
                  return this._notify(this._shopListeners, hasAttribute(event2.data, "data") ? event2.data.data : void 0);
                case "cart":
                  this.cart = hasAttribute(event2.data, "data") ? event2.data.data : {};
                  return this._notify(this._cartListeners, hasAttribute(event2.data, "data") ? event2.data.data : void 0);
              }
            }
            break;
          case "notification":
            return Promise.resolve();
          case "client-notification":
            return this._notify(this._notificationListeners, hasAttribute(event2.data, "data") ? event2.data.data : void 0);
          case "router":
            return this._notify(this._routeChangeListeners, hasAttribute(event2.data, "data") ? event2.data.data : void 0);
          case "seats":
            return this._notify(this._seatsListeners, hasAttribute(event2.data, "data") ? event2.data.data : void 0);
          case "locale":
            if (hasAttribute(event2.data, "data") && hasAttribute(event2.data.data, "locale")) {
              this.localization.locale = event2.data.data.locale;
            }
            return this._notify(this._localeListeners, hasAttribute(event2.data, "data") ? event2.data.data : void 0);
          case "custom":
            return this._notify(this._customMessageListeners, hasAttribute(event2.data, "data") ? event2.data.data : void 0);
        }
      }
    }
    console.warn("client: uncaught message", event2);
    return Promise.resolve();
  }
  /**
   * Add a listener for shop init changes
   * @param cb - Callback
   */
  onShopInit(cb) {
    this._shopInitListeners.push(cb);
  }
  /**
   * Add a listener for shop data changes
   * @param cb - Callback
   */
  onShopData(cb) {
    this._shopListeners.push(cb);
  }
  /**
   * Add a listener for cart data changes
   * @param cb - Callback
   */
  onCartData(cb) {
    this._cartListeners.push(cb);
  }
  /**
   * Add a listener for mounting and destroying the seats modal
   * @param cb - Callback
   */
  onSeats(cb) {
    this._seatsListeners.push(cb);
  }
  /**
   * Add a listener for locale changes
   * @param cb - Callback
   */
  onLocale(cb) {
    this._localeListeners.push(cb);
  }
  /**
   * Add a listener for custom messages
   * @param cb - Callback
   */
  onCustomMessage(cb) {
    this._customMessageListeners.push(cb);
  }
  /**
   * Add a listener for errors
   * @param cb - Callback
   */
  onError(cb) {
    this._errorListeners.push(cb);
  }
  onNotification(cb) {
    this._notificationListeners.push(cb);
  }
  onRouteChange(cb) {
    this._routeChangeListeners.push(cb);
  }
  /**
   * Send a custom message
   * @param data - Payload of the message
   */
  sendMessage(data) {
    this._sendMessage(data);
  }
  // noinspection JSMethodCanBeStatic
  /**
   * Internal method to notify listeners
   * @param listeners - Array of listeners to be notified
   * @param data - Payload of the message
   */
  _notify(listeners, data) {
    for (const listener of listeners) {
      if (listener && typeof listener === "function") {
        listener(data);
      }
    }
    return Promise.resolve();
  }
}
function hasExpectedProperties(objectToGuard, propertiesToCheck) {
  if (!objectToGuard || typeof objectToGuard !== "object" || Array.isArray(objectToGuard)) {
    return false;
  }
  return Object.entries(propertiesToCheck).every(
    // eslint-disable-next-line valid-typeof
    ([key, value]) => key in objectToGuard && typeof objectToGuard[key] === value
  );
}
function isRecord(objectToCheck) {
  return !!objectToCheck && typeof objectToCheck === "object" && !Array.isArray(objectToCheck) && Object.keys(objectToCheck).length > 0;
}
class CrossWindowShop extends CrossWindowBase {
  constructor(_window, _shop) {
    super({
      window: _window,
      scope: "shop"
    });
    /**
     * Data received from the client on connect
     */
    __publicField(this, "client", null);
    /**
     * Shop instance to interact with
     */
    __publicField(this, "shop");
    /**
     * Pass the tweak config to the client on connect
     */
    __publicField(this, "_initData", null);
    this.shop = _shop;
    this._initData = {
      localization: {
        currency: this.shop.data.currency,
        locale: this.shop.data.company.locale
      },
      initErrors: {
        valid: !this.shop.initErrors.length,
        errors: this.shop.initErrors
      }
    };
    this.shop.onLog(["shop", "init"], (path, payload) => this._initError(path, payload));
    this.shop.onLog(["shop", "overwriteData"], (path, payload) => this._initError(path, payload));
    this.shop.onLog(["shop", "updateData"], (path, payload) => this._initError(path, payload));
    this.shop._eventBus.on(["shop"], () => this._updateShopData());
    this.shop._eventBus.on(["cart"], (path, data) => {
      if (data && data.busy === true) {
        return;
      }
      this._updateCartData();
    });
    this.shop._eventBus.on(["seats"], (path) => {
      this._sendMessage({
        action: "seats",
        scope: "shop",
        data: {
          state: path[1]
        }
      });
    });
    this.shop._eventBus.on(["cart", "locale"], (path, locale) => {
      this._sendMessage({
        action: "locale",
        scope: "shop",
        data: { locale }
      });
    });
    this.shop._eventBus.on(
      ["notification"],
      (path, data) => {
        this._sendMessage({
          action: "notification",
          data
        });
      }
    );
    this.shop._eventBus.on(
      ["client-notification"],
      (path, data) => {
        this._sendMessage({
          action: "client-notification",
          data
        });
      }
    );
    this.shop._eventBus.on(
      ["router"],
      (path, data) => {
        this._sendMessage({
          action: "router",
          data
        });
      }
    );
  }
  sendCustomMessage(action, data) {
    this._sendMessage({
      action: "custom",
      scope: "shop",
      data
    });
  }
  /**
   * Handled messaging for the OpenTicketBase class
   * @param event - data from the event
   */
  async onMessage(event2) {
    if (hasAttribute(event2, "data") && hasAttribute(event2.data, "scope") && event2.data.scope !== "client") {
      return;
    }
    await this.onClientMessage(event2);
  }
  /**
   *  Handle established connection data
   *  @param data - The data that is received
   */
  async onConnect(data) {
    await super.onConnect(data);
    this.client = data;
    if (data && Object.prototype.hasOwnProperty.call(data, "debugMode")) {
      this.shop.setDebugMode(hasAttribute(data, "debugMode") && !!data.debugMode);
    }
  }
  /**
   * Handle incoming messages
   * @param event - Received message
   */
  async onClientMessage(event2) {
    if (hasAttribute(event2, "data")) {
      const message = event2.data;
      try {
        if (hasAttribute(message, "type")) {
          switch (message.type) {
            case "shop":
              if (hasAttribute(message, "action")) {
                switch (message.action) {
                  case "locale":
                    if (hasAttribute(message, "locale") && typeof message.locale === "string") {
                      this.shop._eventBus.emit(["shop", "locale"], message.locale);
                    }
                    break;
                  default:
                    break;
                }
              }
              break;
            case "ticket":
              if (hasAttribute(message, "action")) {
                switch (message.action) {
                  case "add":
                    if (hasAttribute(message, "guid") && typeof message.guid === "string") {
                      await this.shop.cart.addTicket(message.guid);
                    }
                    break;
                  case "remove":
                    if (hasAttribute(message, "guid") && typeof message.guid === "string") {
                      await this.shop.cart.removeTicket(message.guid);
                    }
                    break;
                  default:
                    break;
                }
              }
              break;
            case "product":
              if (hasAttribute(message, "action")) {
                switch (message.action) {
                  case "add":
                    if (hasAttribute(message, "guid") && typeof message.guid === "string") {
                      await this.shop.cart.addProduct(message.guid);
                    }
                    break;
                  case "remove":
                    if (hasAttribute(message, "guid") && typeof message.guid === "string") {
                      await this.shop.cart.removeProduct(message.guid);
                    }
                    break;
                  default:
                    break;
                }
              }
              break;
            case "coupon":
              if (hasAttribute(message, "action")) {
                switch (message.action) {
                  case "add":
                    if (hasAttribute(message, "code") && typeof message.code === "string") {
                      await this.shop.cart.addCoupon(message.code);
                    }
                    break;
                  case "remove":
                    if (hasAttribute(message, "code") && typeof message.code === "string") {
                      await this.shop.cart.removeCoupon(message.code);
                    }
                    break;
                  default:
                    break;
                }
              }
              break;
            case "booker_information":
              if (hasAttribute(message, "data")) {
                const isExternalBookerInformation = (data) => isRecord(data) && hasExpectedProperties(data, { firstname: "string", lastname: "string", email: "string" });
                if (isExternalBookerInformation(message.data)) {
                  this.shop.cart.setBookerInformation(message.data);
                }
              }
              break;
            case "static_settings":
              this.shop.events.emit(
                ["settings", "static"],
                hasAttribute(message, "data") ? message.data : void 0
              );
              break;
            case "tracking_information":
              if (hasAttribute(message, "data")) {
                const isExternalTrackingInfo = (possibleTrackingInfo) => hasAttribute(possibleTrackingInfo, "google_client_id") || hasAttribute(possibleTrackingInfo, "click_id") || hasAttribute(possibleTrackingInfo, "click_id_source") || hasAttribute(possibleTrackingInfo, "utm_source") || hasAttribute(possibleTrackingInfo, "utm_medium") || hasAttribute(possibleTrackingInfo, "utm_campaign") || hasAttribute(possibleTrackingInfo, "utm_term") || hasAttribute(possibleTrackingInfo, "eaid");
                if (isExternalTrackingInfo(message.data)) {
                  this.shop.setOrderTrackingInfo(message.data);
                }
              }
              break;
            default:
              break;
          }
        }
      } catch (e) {
        if (typeof e === "string") {
          this._sendError(`${e}`);
        } else if (e && typeof e === "object" && "message" in e && typeof e.message === "string") {
          this._sendError(`${e.message}`);
        } else {
          this._sendError("Unknown error occurred in onClientMessage");
        }
      }
    }
  }
  /**
   * Send an update for init errors
   */
  _initError(_, payload) {
    this._sendMessage({
      action: "init",
      scope: "shop",
      data: JSON.parse(JSON.stringify({
        valid: !this.shop.initErrors.length,
        errors: this.shop.initErrors,
        session: payload.session,
        id: payload.id,
        slug: payload.slug,
        message: payload.message
      }))
    });
  }
  /**
   * Send an update event containing the shop data
   */
  _updateShopData() {
    this._sendMessage({
      action: "update",
      scope: "shop",
      data: JSON.parse(JSON.stringify(this.shop.data))
    });
  }
  /**
   * Send an update event containing the cart data
   */
  _updateCartData() {
    const tickets2 = {};
    for (const cartTicket of Object.values(this.shop.cart.flatItems.tickets)) {
      const { guid } = cartTicket.item;
      tickets2[guid] = this.shop.cart.getTicketInfo(guid);
    }
    const products = {};
    for (const cartProduct of Object.values(this.shop.cart.flatItems.products)) {
      const { guid } = cartProduct.item;
      products[guid] = this.shop.cart.getProductInfo(guid);
    }
    const coupons = {};
    for (const appliedCoupon of Object.values(this.shop.cart.getAppliedCoupons())) {
      const { guid } = appliedCoupon.item;
      coupons[guid] = this.shop.cart.getCouponInfo(guid);
    }
    const checkout_details = cloneObject(this.shop.cart.checkout_details);
    this._sendMessage({
      action: "update",
      scope: "cart",
      data: {
        tickets: tickets2,
        products,
        coupons,
        checkout_details
      }
    });
  }
}
const supported = /* @__PURE__ */ new Map([
  ["ar", "ar"],
  ["be", "be"],
  ["bg", "bg"],
  ["ca", "ca"],
  ["cs", "cs"],
  ["cy", "cy"],
  ["da", "da"],
  ["de", "de"],
  ["el", "el"],
  ["en", "en"],
  ["es", "es"],
  ["et", "et"],
  ["fa", "fa"],
  ["fi", "fi"],
  ["fr", "fr"],
  ["hr", "hr"],
  ["he", "he"],
  ["hu", "hu"],
  ["it", "it"],
  ["ja", "ja"],
  ["ku", "ku"],
  ["li", "li"],
  ["lv", "lv"],
  ["no", "no"],
  ["nl", "nl"],
  ["pl", "pl"],
  ["pt", "pt"],
  ["ro", "ro"],
  ["ru", "ru"],
  ["sk", "sk"],
  ["sl", "sl"],
  ["sr", "sr"],
  ["sv", "sv"],
  ["tr", "tr"],
  ["uk", "uk"],
  ["zh-Hans", "zh-Hans"],
  ["zh-Hant", "zh-Hant"]
]);
function toSeatsioLanguage(locale) {
  if (!locale || typeof locale !== "string") {
    return "en";
  }
  const [lang2, ...parts] = locale.toLowerCase().split(/[_-]/g);
  if (!lang2) {
    return "en";
  }
  if (lang2 === "zh" && parts.length > 1) {
    if (parts.includes("Hans")) {
      return "zh-Hans";
    }
    if (parts.includes("Hant")) {
      return "zh-Hant";
    }
  }
  return supported.get(lang2) || "en";
}
class SeatsioService {
  /**
   *  Construct the Seats.io service
   *
   *  This will lock the config in place for all future use cases.
   */
  constructor(config) {
    __publicField(this, "config");
    __publicField(this, "chart");
    __publicField(this, "holdToken");
    this.config = this._ensureConfig(config);
  }
  /**
   *  Ensure the Seats.io chart library is loaded.
   */
  async ensureLoaded() {
    if (!window.seatsio) {
      await loadScript$1("https://cdn-eu.seatsio.net/chart.js");
    }
    if (!window.seatsio) {
      throw new Error("Seats.io -> Not loaded");
    }
  }
  /**
   *  Mount the SeatingChart to the DOM.
   */
  async mount(options) {
    await this.ensureLoaded();
    this.destroy();
    const config = this._ensureOptions(options);
    const { onChartRendered } = config;
    const { onChartRenderingFailed } = config;
    const { onHoldTokenExpired } = config;
    const rendered = new Promise((resolve, reject) => {
      config.onChartRendered = (chart) => {
        this._setHoldToken();
        if (onChartRendered) {
          onChartRendered(chart);
        }
        resolve(this);
      };
      config.onChartRenderingFailed = (chart) => {
        if (onChartRenderingFailed) {
          onChartRenderingFailed(chart);
        }
        this.chart = void 0;
        chart.destroy();
        reject();
      };
      config.onHoldTokenExpired = () => {
        this.holdToken = void 0;
        if (onHoldTokenExpired) {
          onHoldTokenExpired();
        }
        if (this.chart) {
          this.chart.startNewSession().then(() => {
            this._setHoldToken();
          }).catch((e) => {
            console.error("Seats.io -> Failed to start new seatsio session", { e });
            throw new Error("Seats.io -> Failed to start new seatsio session");
          });
        } else {
          console.error("Failed to start new seatsio session -> no chart");
        }
      };
    });
    this.chart = new window.seatsio.SeatingChart(config);
    this.chart.render();
    return rendered;
  }
  /**
   *  Destroy the current seating chart
   *
   *  This is a mandatory step. Failing to destroy charts will lead to memory leaks!
   */
  destroy() {
    if (!this.chart) {
      return;
    }
    const { chart } = this;
    this.chart = void 0;
    chart.destroy();
  }
  /**
   *  Validate the config and merge with the current (default) config.
   */
  _ensureConfig(config) {
    const conf = {
      ...this.config,
      ...config
    };
    if (!conf.workspaceKey) {
      throw new Error("Seats.io -> Workspace key missing");
    }
    return this.config = conf;
  }
  /**
   *  Validate the options (config) and ensure default values are set.
   */
  _ensureOptions(options) {
    if (!options.divId || options.divId.length < 2 || !options.divId.startsWith("#")) {
      throw new Error("Seats.io -> Invalid divId, expected DOM id selector (starts with #)");
    }
    if (!options.events || !options.events.length) {
      throw new Error("Seats.io -> Expected at least one event key");
    }
    if (!options.pricing || !options.pricing.length) {
      throw new Error("Seats.io -> Invalid pricing, expected at least one pricing option");
    }
    const selectionValidators = [];
    if (!options.allowOrphanSeats) {
      selectionValidators.push({
        type: "noOrphanSeats",
        mode: "strict"
        // TODO Should we make this lenient ???
      });
    }
    if (options.forceConsecutiveSeats) {
      selectionValidators.push({
        type: "consecutiveSeats"
      });
    }
    return {
      // DOM location
      divId: options.divId.replace(/^#/, ""),
      // Session values
      session: this.holdToken ? "continue" : "start",
      // Note: holdOnSelect is not allowed when passing in session
      // holdOnSelect: true,
      holdOnSelectForGAs: true,
      // Chart, event, category, pricing settings
      events: options.events,
      pricing: options.pricing,
      maxSelectedObjects: options.maxSelectedObjects,
      priceFormatter: options.priceFormatter,
      objectWithoutPricingSelectable: false,
      objectWithoutCategorySelectable: false,
      canGASelectionBeIncreased: void 0,
      // TODO
      objectTooltip: {
        ...options.objectTooltip || {}
      },
      // Explicitly disabled! Could potentially trigger large number of concurrent reservations!
      multiSelectEnabled: false,
      availableCategories: void 0,
      unavailableCategories: void 0,
      selectedObjects: void 0,
      hideSectionsNotForSale: !!options.hideSectionsNotForSale,
      // Validators
      selectionValidators,
      // Styling
      showRowLines: true,
      showLegend: options.showLegend !== false,
      legend: {
        hideNonSelectableCategories: true
      },
      language: toSeatsioLanguage(options.language),
      showMinimap: true,
      loading: options.loading || void 0,
      colorScheme: options.colorScheme || "light",
      colors: {
        // The color used for certain interactive, selected or highlighted user interface elements.
        colorSelected: options.colors && options.colors.colorSelected || void 0,
        // The background color for the whole tooltip.
        cursorTooltipBackgroundColor: options.colors && options.colors.cursorTooltipBackgroundColor || void 0,
        // The color of certain tiles, such as in modal dialogs or the Category Filter.
        colorTitle: options.colors && options.colors.colorTitle || void 0
      },
      stylePreset: options.stylePreset || "balance",
      style: options.style || void 0,
      onHoldSucceeded: options.onHoldSucceeded || void 0,
      onHoldFailed: options.onHoldFailed || void 0,
      onHoldTokenExpired: options.onHoldTokenExpired || void 0,
      onReleaseHoldSucceeded: options.onReleaseHoldSucceeded || void 0,
      onReleaseHoldFailed: options.onReleaseHoldFailed || void 0,
      onSelectionValid: options.onSelectionValid || void 0,
      onSelectionInvalid: options.onSelectionInvalid || void 0,
      // Non-exposed events.
      // For now the below events are not exposed to any implementor.
      // Should be added when needed!
      // onChartRendered
      // onChartRenderingFailed
      // onObjectClicked
      // onObjectSelected
      // onObjectDeselected
      // onObjectMouseOver
      // onObjectMouseOut
      // onSelectedObjectBooked
      // onBestAvailableSelected
      // onBestAvailableSelectionFailed
      // onFullScreenOpened
      // onFullScreenClosed
      // Other
      unifiedObjectPropertiesInCallbacks: true,
      // Some seats.io accounts are legacy accounts, force the same behaviour here!
      extraConfig: void 0,
      // Immutable config (i.e.: Workspace key)
      ...this.config
    };
  }
  /**
   *  Set the hold token, this signals the Seats.io class a session is currently active.
   */
  _setHoldToken() {
    if (!this.chart) {
      console.error("Failed to retrieve hold token -> chart does not exist");
    } else if (this.chart.holdToken) {
      this.holdToken = this.chart.holdToken;
    } else {
      console.error("Failed to retrieve hold token -> Session not started");
    }
  }
}
class CartValidator extends BaseValidator {
  constructor(cart, logger) {
    super();
    __publicField(this, "_cart");
    __publicField(this, "_log");
    this._cart = cart;
    this._log = logger;
  }
  /**
   *  Validate all booker cart metadata.
   *
   *  This will return true iff all metadata is valid.
   *  On failure, the errors are set on the cart metadata object
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.bookerMetadata();
   *  ```
   *
   *  | Error                                    | Reason                              |
   *  | :--------------------------------------- | :---------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
   *
   *  Note: Failed validation will NOT throw an error
   */
  bookerMetadata(mutateErrors) {
    return mergeValidation({
      booker: mergeValidation({ ...this._cart.booker }, this.metadata.bind(this), mutateErrors),
      metadata: mergeValidation(this._cart.metadata, this.metadata.bind(this), mutateErrors)
    }, (item) => item);
  }
  /**
   *  Validate a given ticket's cart metadata.
   *
   *  This will return true iff all metadata is valid.
   *  On failure, the errors are set on the cart metadata object
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.ticketMetadata(cartTicket);
   *  ```
   *
   *  | Error                                    | Reason                              |
   *  | :--------------------------------------- | :---------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
   *
   *  Note: Failed validation will NOT throw an error
   */
  ticketMetadata(cartTicket, mutateErrors) {
    if (!CartTicket.isCartTicket(cartTicket)) {
      throw slugError("Failed to validate ticket metadata -> invalid cart ticket", ["validation", "ticketMetadata", "error", "ticket"]);
    }
    return this._validateCartItemMetadata(cartTicket, mutateErrors);
  }
  /**
   *  Validate all ticket cart metadata.
   *
   *  This will return true iff all metadata is valid.
   *  On failure, the errors are set on the cart metadata object
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.allTicketMetadata();
   *  ```
   *
   *  | Error                                    | Reason                              |
   *  | :--------------------------------------- | :---------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
   *
   *  Note: Failed validation will NOT throw an error
   */
  allTicketMetadata(mutateErrors) {
    return mergeValidation(this._cart.flatItems[CartItemChildType.Tickets], this.ticketMetadata.bind(this), mutateErrors);
  }
  /**
   *  Validate a given product's cart metadata.
   *
   *  This will return true iff all metadata is valid.
   *  On failure, the errors are set on the cart metadata object
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.productMetadata(cartProduct);
   *  ```
   *
   *  | Error                                    | Reason                              |
   *  | :--------------------------------------- | :---------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
   *
   *  Note: Failed validation will NOT throw an error
   */
  productMetadata(cartProduct, mutateErrors) {
    if (!CartProduct.isCartProduct(cartProduct)) {
      throw slugError("Failed to validate product metadata -> invalid cart product", ["validation", "productMetadata", "error", "product"]);
    }
    return this._validateCartItemMetadata(cartProduct, mutateErrors);
  }
  /**
   *  Validate all (global) product cart metadata.
   *
   *  This will return true iff all metadata is valid.
   *  On failure, the errors are set on the cart metadata object
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.allProductMetadata();
   *  ```
   *
   *  | Error                                    | Reason                              |
   *  | :--------------------------------------- | :---------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
   *
   *  Note: Failed validation will NOT throw an error
   */
  allProductMetadata(mutateErrors) {
    return mergeValidation(this._cart.flatItems[CartItemChildType.Products], (cartProduct) => {
      if (cartProduct.childOf) {
        return validationResponseFromValidationErrors([]);
      }
      return this.productMetadata(cartProduct, mutateErrors);
    });
  }
  /**
   *  Validate all metadata (booker, ticket & product).
   *
   *  This will return true iff all metadata is valid.
   *  On failure, the errors are set on the cart metadata object
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.allMetadata();
   *  ```
   *
   *  | Error                                    | Reason                              |
   *  | :--------------------------------------- | :---------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
   *
   *  Note: Failed validation will NOT throw an error
   */
  allMetadata(mutateErrors) {
    return mergeValidation({
      booker: this.bookerMetadata(mutateErrors),
      ticket: this.allTicketMetadata(mutateErrors),
      product: this.allProductMetadata(mutateErrors)
    }, (item) => item);
  }
  /**
   *  Validate ticket constraints for a ticket
   *
   *  E.g.: min/max orderable amount of tickets
   *
   *  If the ticket is not ordered, it is NOT invalid,
   *  even if the min orderable amount is larger than zero.
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.ticket(ticket);
   *  ```
   *
   *  Note: mutateErrors argument is currently unused and should be implemented
   */
  ticket(ticket2, _mutateErrors = true) {
    if (!Object.prototype.hasOwnProperty.call(this._cart.items, ticket2.event_id) || !Object.prototype.hasOwnProperty.call(this._cart.items[ticket2.event_id][CartItemChildType.Tickets].map, ticket2.guid)) {
      return validationResponseFromValidationErrors([]);
    }
    const min = ticket2.min_orderable_amount_per_order || 1;
    const max = ticket2.max_orderable_amount_per_order || 20;
    const increment = ticket2.increment || 1;
    const cartTicketCount = Object.keys(this._cart.items[ticket2.event_id][CartItemChildType.Tickets].map[ticket2.guid]).length;
    const ticketErrors = [];
    if (cartTicketCount > 0) {
      if (cartTicketCount < min) {
        ticketErrors.push(`invalid minimum orderable amount per order: should contain at least ${ticket2.min_orderable_amount_per_order} tickets`);
      }
      if (cartTicketCount > max) {
        ticketErrors.push(`invalid maximum orderable amount per order: should contain at most ${ticket2.max_orderable_amount_per_order} tickets`);
      }
      if (cartTicketCount % increment !== 0) {
        ticketErrors.push(`invalid increment: should contain a strict multiple of ${ticket2.increment} tickets`);
      }
    }
    return validationResponseFromValidationErrors(ticketErrors, ticketErrors[0]);
  }
  /**
   *  Validate ticket constraints for all tickets
   *
   *  E.g.: min/max orderable amount of tickets
   *
   *  We can safely check the cart tickets here,
   *  as we define cart tickets to be valid,
   *  even when they have not been reserved
   *  AND the min orderable amount is larger than zero.
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.allTickets();
   *  ```
   */
  allTickets(mutateErrors) {
    return mergeValidation(this._cart.items, (eventItems) => mergeValidation(eventItems[CartItemChildType.Tickets].map, (cartTickets) => {
      const firstCartTicket = Object.values(cartTickets)[0];
      if (!firstCartTicket) {
        return validationResponseFromValidationErrors([]);
      }
      return this.ticket(firstCartTicket.item, mutateErrors);
    }));
  }
  /**
   *  Validate (optional) product constraints for a product group of a cart ticket.
   *
   *  A product group is considered valid if the count of the ticket's products is within the bounds.
   *  And the uniqueness is not surpassed for each individual product type.
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.ticketProductGroup(cartTicket, productGroup);
   *  ```
   *
   *  Note: mutateErrors argument is currently unused and should be implemented
   */
  ticketProductGroup(cartTicket, productGroup, _mutateErrors = true) {
    const productGroupErrors = [];
    const productErrors = {};
    let productMessage = "";
    let totalCartProductCount = 0;
    forOwn(cartTicket.products.map, (cartProducts, productGuid) => {
      const groupProduct = productGroup.products.find((product) => product.guid === productGuid);
      if (!groupProduct) {
        return;
      }
      const cartProductCount = Object.keys(cartProducts).length;
      totalCartProductCount += cartProductCount;
      const uniqueness = groupProduct.uniqueness || productGroup.uniqueness;
      if (!!uniqueness && cartProductCount > uniqueness) {
        productErrors[productGuid] = ["product uniqueness invalid"];
        productMessage = "product uniqueness invalid";
      }
    });
    if (totalCartProductCount < productGroup.min_bound) {
      productGroupErrors.push(`invalid min bound: should contain at least ${productGroup.min_bound} products`);
    } else if (!!productGroup.max_bound && totalCartProductCount > productGroup.max_bound) {
      productGroupErrors.push(`invalid max bound: should contain at most ${productGroup.max_bound} products`);
    }
    return mergeValidation({
      count: validationResponseFromValidationErrors(productGroupErrors, productGroupErrors[0]),
      products: validationResponseFromValidationErrors(productErrors, productMessage)
    }, (item) => item);
  }
  /**
   *  Validate (optional) product constraints for a cart ticket.
   *
   *  This is done using the constraints of product groups.
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.ticketProducts(cartTicket);
   *  ```
   */
  ticketProducts(cartTicket, mutateErrors = true) {
    const productGroups = cartTicket.item.groups.reduce((carry, item) => {
      carry[item.guid] = item;
      return carry;
    }, {});
    const groupErrors = mergeValidation(productGroups, (productGroup) => this.ticketProductGroup(cartTicket, productGroup, mutateErrors));
    const productErrors = {};
    let productMessage = "";
    forEach$1(cartTicket.item.products.required, (product) => {
      if (!Object.prototype.hasOwnProperty.call(cartTicket.products.map, product.guid)) {
        productErrors[product.guid] = ["product is required"];
        productMessage = "product is required";
      }
    });
    return mergeValidation({
      groups: groupErrors,
      requiredProducts: validationResponseFromValidationErrors(productErrors, productMessage)
    }, (item) => item);
  }
  /**
   *  Validate (optional) product constraints for all cart tickets.
   *
   *  This is done using the constraints of product groups.
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.allTicketProducts();
   *  ```
   */
  allTicketProducts(mutateErrors) {
    return mergeValidation(this._cart.flatItems[CartItemChildType.Tickets], this.ticketProducts.bind(this), mutateErrors);
  }
  /**
   *  Validate if the cart has items.
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.hasItems();
   *  ```
   */
  hasItems() {
    const messages2 = [];
    if (!this._cart.hasItems()) {
      messages2.push("invalid items: should contain at least 1 item");
    }
    return validationResponseFromValidationErrors(messages2, messages2[0]);
  }
  /**
   *  Validate all validators for the cart.
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.all();
   *  ```
   */
  all() {
    const result2 = mergeValidation({
      // An order should have at least one item
      items: this.hasItems(),
      // Ticket constraints should be valid
      tickets: this.allTickets(),
      // Product group constraints should be valid
      ticket_products: this.allTicketProducts(),
      // All metadata validation should succeed
      metadata: this.allMetadata(),
      // All terms should be accepted
      terms: this.allTerms(),
      // The chosen payment method should be valid
      // Note: Most payment methods can ONLY be valid
      payment_methods: this.paymentMethod(true)
      // It is assumed a coupon is ALWAYS in a valid state.
    }, (item) => item);
    if (!result2.valid) {
      this._log._create(LogLevel.Debug, ["cart", "validation", "all", "invalid"], result2);
    }
    return result2;
  }
  /**
   *  Validate if all terms are accepted.
   *
   *  This will return true iff all terms are accepted.
   *
   *  ```ts
   *  const validationResponse: ValidationResponse = cart.validator.allTerms();
   *  ```
   *
   *  Note: mutateErrors argument is currently unused and should be implemented
   */
  allTerms(_mutateErrors = true) {
    const termsErrors = {};
    let message = "";
    forOwn(this._cart.terms, (term, key) => {
      if (!term) {
        termsErrors[key] = ["term should be accepted"];
        message = "term should be accepted";
      }
    });
    return validationResponseFromValidationErrors(termsErrors, message);
  }
  /**
   *  Validate the custom properties for the chosen payment method.
   *
   *  Note: For the default payment method(s), this is currently irrelevant.
   *  The default payment methods are always valid.
   */
  paymentMethod(checkStripeToken = false, mutateErrors = true) {
    const result2 = this._paymentMethod(checkStripeToken, mutateErrors);
    if (!result2.valid) {
      this._log._create(LogLevel.Debug, ["cart", "validation", "paymentMethod", "invalid"], result2);
    }
    return result2;
  }
  _paymentMethod(checkStripeToken = false, _mutateErrors = true) {
    const cartPaymentMethod = this._cart.paymentMethod;
    if (!cartPaymentMethod) {
      return validationResponseFromValidationErrors(["Payment method missing"], "Payment method missing");
    }
    if (cartPaymentMethod.is_stripe && this._cart.checkout_details.total_price > 0) {
      if (!cartPaymentMethod.item.stripe || !cartPaymentMethod.item.stripe.complete) {
        return validationResponseFromValidationErrors(["Stripe should be completed"], "Stripe should be completed");
      }
      if (cartPaymentMethod.item.stripe.errors.length) {
        const errors2 = cartPaymentMethod.item.stripe.errors.map((error) => error.message);
        return validationResponseFromValidationErrors(errors2, errors2[0]);
      }
      if (checkStripeToken && !cartPaymentMethod.stripe_token) {
        return validationResponseFromValidationErrors(["Stripe token missing"], "Stripe token missing");
      }
    }
    if (cartPaymentMethod.item.cse && !cartPaymentMethod.item.canPlaceCseOrder && this._cart.checkout_details.total_price > 0) {
      return validationResponseFromValidationErrors(["Please, fill in valid card details"], "Please, fill in valid card details");
    }
    return validationResponseFromValidationErrors([]);
  }
  /**
   *  Validate the cart metadata collection of a given cart item.
   *
   *  This will return true iff all metadata is valid.
   *  On failure, the errors are set on the cart metadata object
   *
   *  ```ts
   *  const validationOk: boolean = cart._validateCartItemMetadata(cartItem);
   *  ```
   *
   *  Note: this method expects its first argument to be of type CartItem.
   *  A CartItem type is a generic fixed to a Reservable type. By using `Reservable`
   *  here, the exact type CartItem implementation can be extended in one (or at least less)
   *  place(s).
   *
   *  | Error                                    | Reason                              |
   *  | :--------------------------------------- | :---------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
   *
   *  Note: Failed validation will NOT throw an error
   *
   *  @internal
   */
  _validateCartItemMetadata(cartItem, mutateErrors = true) {
    const metadataErrors = mergeValidation(cartItem.metadata, this.metadata.bind(this), mutateErrors);
    const childErrors = mergeValidation(CartItemChildType, (childType) => {
      if (!Object.prototype.hasOwnProperty.call(cartItem.children, childType) || !cartItem.children[childType]) {
        return validationResponseFromValidationErrors({});
      }
      return mergeValidation(cartItem.children[childType].map, (childItems) => mergeValidation(childItems, this._validateCartItemMetadata.bind(this), mutateErrors));
    });
    return mergeValidation({
      metadata: metadataErrors,
      children: childErrors
    }, (item) => item);
  }
}
function mergeValidation(items, cb, mutateErrors) {
  const errors2 = {};
  let message = "";
  forOwn(items, (item, key) => {
    const validationResponse = cb(item, mutateErrors);
    if (!validationResponse.valid) {
      errors2[key] = validationResponse.errors;
      message = message || validationResponse.message;
    }
  });
  return validationResponseFromValidationErrors(errors2, message);
}
function validationResponseFromValidationErrors(errors2, message) {
  return {
    valid: !Object.keys(errors2).length,
    message: message || "",
    errors: errors2
  };
}
var uaParser = { exports: {} };
/*!
 * UAParser.js v0.7.23
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */
(function(module, exports) {
  (function(window2, undefined$1) {
    var LIBVERSION = "0.7.23", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION2 = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded";
    var util = {
      extend: function(regexes2, extensions) {
        var mergedRegexes = {};
        for (var i in regexes2) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes2[i]);
          } else {
            mergedRegexes[i] = regexes2[i];
          }
        }
        return mergedRegexes;
      },
      has: function(str1, str2) {
        if (typeof str1 === "string") {
          return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
        } else {
          return false;
        }
      },
      lowerize: function(str) {
        return str.toLowerCase();
      },
      major: function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, "").split(".")[0] : undefined$1;
      },
      trim: function(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      }
    };
    var mapper = {
      rgx: function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while (i < arrays.length && !matches) {
          var regex = arrays[i], props = arrays[i + 1];
          j = k = 0;
          while (j < regex.length && !matches) {
            matches = regex[j++].exec(ua);
            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p];
                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length == 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      this[q[0]] = q[1];
                    }
                  } else if (q.length == 3) {
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                    } else {
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                    }
                  } else if (q.length == 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                  }
                } else {
                  this[q] = match ? match : undefined$1;
                }
              }
            }
          }
          i += 2;
        }
      },
      str: function(str, map) {
        for (var i in map) {
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (util.has(map[i][j], str)) {
                return i === UNKNOWN ? undefined$1 : i;
              }
            }
          } else if (util.has(map[i], str)) {
            return i === UNKNOWN ? undefined$1 : i;
          }
        }
        return str;
      }
    };
    var maps = {
      browser: {
        oldsafari: {
          version: {
            "1.0": "/8",
            "1.2": "/1",
            "1.3": "/3",
            "2.0": "/412",
            "2.0.2": "/416",
            "2.0.3": "/417",
            "2.0.4": "/419",
            "?": "/"
          }
        }
      },
      device: {
        amazon: {
          model: {
            "Fire Phone": ["SD", "KF"]
          }
        },
        sprint: {
          model: {
            "Evo Shift 4G": "7373KT"
          },
          vendor: {
            "HTC": "APA",
            "Sprint": "Sprint"
          }
        }
      },
      os: {
        windows: {
          version: {
            "ME": "4.90",
            "NT 3.11": "NT3.51",
            "NT 4.0": "NT4.0",
            "2000": "NT 5.0",
            "XP": ["NT 5.1", "NT 5.2"],
            "Vista": "NT 6.0",
            "7": "NT 6.1",
            "8": "NT 6.2",
            "8.1": "NT 6.3",
            "10": ["NT 6.4", "NT 10.0"],
            "RT": "ARM"
          }
        }
      }
    };
    var regexes = {
      browser: [
        [
          // Presto based
          /(opera\smini)\/([\w\.-]+)/i,
          // Opera Mini
          /(opera\s[mobiletab]{3,6}).+version\/([\w\.-]+)/i,
          // Opera Mobi/Tablet
          /(opera).+version\/([\w\.]+)/i,
          // Opera > 9.80
          /(opera)[\/\s]+([\w\.]+)/i
          // Opera < 9.80
        ],
        [NAME, VERSION2],
        [
          /(opios)[\/\s]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [[NAME, "Opera Mini"], VERSION2],
        [
          /\s(opr)\/([\w\.]+)/i
          // Opera Webkit
        ],
        [[NAME, "Opera"], VERSION2],
        [
          // Mixed
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,
          // Baidu Browser
          /(?:ms|\()(ie)\s([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based
          /(rekonq)\/([\w\.]*)/i,
          // Rekonq
          /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
          // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
        ],
        [NAME, VERSION2],
        [
          /(konqueror)\/([\w\.]+)/i
          // Konqueror
        ],
        [[NAME, "Konqueror"], VERSION2],
        [
          /(trident).+rv[:\s]([\w\.]{1,9}).+like\sgecko/i
          // IE11
        ],
        [[NAME, "IE"], VERSION2],
        [
          /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i
          // Microsoft Edge
        ],
        [[NAME, "Edge"], VERSION2],
        [
          /(yabrowser)\/([\w\.]+)/i
          // Yandex
        ],
        [[NAME, "Yandex"], VERSION2],
        [
          /(Avast)\/([\w\.]+)/i
          // Avast Secure Browser
        ],
        [[NAME, "Avast Secure Browser"], VERSION2],
        [
          /(AVG)\/([\w\.]+)/i
          // AVG Secure Browser
        ],
        [[NAME, "AVG Secure Browser"], VERSION2],
        [
          /(puffin)\/([\w\.]+)/i
          // Puffin
        ],
        [[NAME, "Puffin"], VERSION2],
        [
          /(focus)\/([\w\.]+)/i
          // Firefox Focus
        ],
        [[NAME, "Firefox Focus"], VERSION2],
        [
          /(opt)\/([\w\.]+)/i
          // Opera Touch
        ],
        [[NAME, "Opera Touch"], VERSION2],
        [
          /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
          // UCBrowser
        ],
        [[NAME, "UCBrowser"], VERSION2],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[NAME, /_/g, " "], VERSION2],
        [
          /(windowswechat qbcore)\/([\w\.]+)/i
          // WeChat Desktop for Windows Built-in Browser
        ],
        [[NAME, "WeChat(Win) Desktop"], VERSION2],
        [
          /(micromessenger)\/([\w\.]+)/i
          // WeChat
        ],
        [[NAME, "WeChat"], VERSION2],
        [
          /(brave)\/([\w\.]+)/i
          // Brave browser
        ],
        [[NAME, "Brave"], VERSION2],
        [
          /(whale)\/([\w\.]+)/i
          // Whale browser
        ],
        [[NAME, "Whale"], VERSION2],
        [
          /(qqbrowserlite)\/([\w\.]+)/i
          // QQBrowserLite
        ],
        [NAME, VERSION2],
        [
          /(QQ)\/([\d\.]+)/i
          // QQ, aka ShouQ
        ],
        [NAME, VERSION2],
        [
          /m?(qqbrowser)[\/\s]?([\w\.]+)/i
          // QQBrowser
        ],
        [NAME, VERSION2],
        [
          /(baiduboxapp)[\/\s]?([\w\.]+)/i
          // Baidu App
        ],
        [NAME, VERSION2],
        [
          /(2345Explorer)[\/\s]?([\w\.]+)/i
          // 2345 Browser
        ],
        [NAME, VERSION2],
        [
          /(MetaSr)[\/\s]?([\w\.]+)/i
          // SouGouBrowser
        ],
        [NAME],
        [
          /(LBBROWSER)/i
          // LieBao Browser
        ],
        [NAME],
        [
          /xiaomi\/miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [VERSION2, [NAME, "MIUI Browser"]],
        [
          /;fbav\/([\w\.]+);/i
          // Facebook App for iOS & Android with version
        ],
        [VERSION2, [NAME, "Facebook"]],
        [
          /FBAN\/FBIOS|FB_IAB\/FB4A/i
          // Facebook App for iOS & Android without version
        ],
        [[NAME, "Facebook"]],
        [
          /safari\s(line)\/([\w\.]+)/i,
          // Line App for iOS
          /android.+(line)\/([\w\.]+)\/iab/i
          // Line App for Android
        ],
        [NAME, VERSION2],
        [
          /headlesschrome(?:\/([\w\.]+)|\s)/i
          // Chrome Headless
        ],
        [VERSION2, [NAME, "Chrome Headless"]],
        [
          /\swv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[NAME, /(.+)/, "$1 WebView"], VERSION2],
        [
          /((?:oculus|samsung)browser)\/([\w\.]+)/i
        ],
        [[NAME, /(.+(?:g|us))(.+)/, "$1 $2"], VERSION2],
        [
          // Oculus / Samsung Browser
          /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i
          // Android Browser
        ],
        [VERSION2, [NAME, "Android Browser"]],
        [
          /(sailfishbrowser)\/([\w\.]+)/i
          // Sailfish Browser
        ],
        [[NAME, "Sailfish Browser"], VERSION2],
        [
          /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [NAME, VERSION2],
        [
          /(dolfin)\/([\w\.]+)/i
          // Dolphin
        ],
        [[NAME, "Dolphin"], VERSION2],
        [
          /(qihu|qhbrowser|qihoobrowser|360browser)/i
          // 360
        ],
        [[NAME, "360 Browser"]],
        [
          /((?:android.+)crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [[NAME, "Chrome"], VERSION2],
        [
          /(coast)\/([\w\.]+)/i
          // Opera Coast
        ],
        [[NAME, "Opera Coast"], VERSION2],
        [
          /fxios\/([\w\.-]+)/i
          // Firefox for iOS
        ],
        [VERSION2, [NAME, "Firefox"]],
        [
          /version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i
          // Mobile Safari
        ],
        [VERSION2, [NAME, "Mobile Safari"]],
        [
          /version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [VERSION2, NAME],
        [
          /webkit.+?(gsa)\/([\w\.]+)\s.*(mobile\s?safari|safari)(\/[\w\.]+)/i
          // Google Search Appliance on iOS
        ],
        [[NAME, "GSA"], VERSION2],
        [
          /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [NAME, [VERSION2, mapper.str, maps.browser.oldsafari.version]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [NAME, VERSION2],
        [
          // Gecko based
          /(navigator|netscape)\/([\w\.-]+)/i
          // Netscape
        ],
        [[NAME, "Netscape"], VERSION2],
        [
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
          /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
          /(links)\s\(([\w\.]+)/i,
          // Links
          /(gobrowser)\/?([\w\.]*)/i,
          // GoBrowser
          /(ice\s?browser)\/v?([\w\._]+)/i,
          // ICE Browser
          /(mosaic)[\/\s]([\w\.]+)/i
          // Mosaic
        ],
        [NAME, VERSION2]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i
          // AMD64
        ],
        [[ARCHITECTURE, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[ARCHITECTURE, util.lowerize]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32
        ],
        [[ARCHITECTURE, "ia32"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows\s(ce|mobile);\sppc;/i
        ],
        [[ARCHITECTURE, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i
          // PowerPC
        ],
        [[ARCHITECTURE, /ower/, "", util.lowerize]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[ARCHITECTURE, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[ARCHITECTURE, util.lowerize]]
      ],
      device: [
        [
          /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i
          // iPad/PlayBook
        ],
        [MODEL, VENDOR, [TYPE, TABLET]],
        [
          /applecoremedia\/[\w\.]+ \((ipad)/
          // iPad
        ],
        [MODEL, [VENDOR, "Apple"], [TYPE, TABLET]],
        [
          /(apple\s{0,1}tv)/i
          // Apple TV
        ],
        [[MODEL, "Apple TV"], [VENDOR, "Apple"], [TYPE, SMARTTV]],
        [
          /(archos)\s(gamepad2?)/i,
          // Archos
          /(hp).+(touchpad)/i,
          // HP TouchPad
          /(hp).+(tablet)/i,
          // HP Tablet
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /\s(nook)[\w\s]+build\/(\w+)/i,
          // Nook
          /(dell)\s(strea[kpr\s\d]*[\dko])/i
          // Dell Streak
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /(kf[A-z]+)(\sbuild\/|\)).+silk\//i
          // Kindle Fire HD
        ],
        [MODEL, [VENDOR, "Amazon"], [TYPE, TABLET]],
        [
          /(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i
          // Fire Phone
        ],
        [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, "Amazon"], [TYPE, MOBILE]],
        [
          /android.+aft([bms])\sbuild/i
          // Fire TV
        ],
        [MODEL, [VENDOR, "Amazon"], [TYPE, SMARTTV]],
        [
          /\((ip[honed|\s\w*]+);.+(apple)/i
          // iPod/iPhone
        ],
        [MODEL, VENDOR, [TYPE, MOBILE]],
        [
          /\((ip[honed|\s\w*]+);/i
          // iPod/iPhone
        ],
        [MODEL, [VENDOR, "Apple"], [TYPE, MOBILE]],
        [
          /(blackberry)[\s-]?(\w+)/i,
          // BlackBerry
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
          // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp)\s([\w\s]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i
          // Asus
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /\(bb10;\s(\w+)/i
          // BlackBerry 10
        ],
        [MODEL, [VENDOR, "BlackBerry"], [TYPE, MOBILE]],
        [
          // Asus Tablets
          /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
        ],
        [MODEL, [VENDOR, "Asus"], [TYPE, TABLET]],
        [
          /(sony)\s(tablet\s[ps])\sbuild\//i,
          // Sony
          /(sony)?(?:sgp.+)\sbuild\//i
        ],
        [[VENDOR, "Sony"], [MODEL, "Xperia Tablet"], [TYPE, TABLET]],
        [
          /android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [MODEL, [VENDOR, "Sony"], [TYPE, MOBILE]],
        [
          /\s(ouya)\s/i,
          // Ouya
          /(nintendo)\s([wids3u]+)/i
          // Nintendo
        ],
        [VENDOR, MODEL, [TYPE, CONSOLE]],
        [
          /android.+;\s(shield)\sbuild/i
          // Nvidia
        ],
        [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]],
        [
          /(playstation\s[34portablevi]+)/i
          // Playstation
        ],
        [MODEL, [VENDOR, "Sony"], [TYPE, CONSOLE]],
        [
          /(sprint\s(\w+))/i
          // Sprint Phones
        ],
        [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]],
        [
          /(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i,
          // HTC
          /(zte)-(\w*)/i,
          // ZTE
          /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
        [
          /(nexus\s9)/i
          // HTC Nexus 9
        ],
        [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
        [
          /d\/huawei([\w\s-]+)[;\)]/i,
          // Huawei
          /android.+\s(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?)/i
        ],
        [MODEL, [VENDOR, "Huawei"], [TYPE, MOBILE]],
        [
          /android.+(bah2?-a?[lw]\d{2})/i
          // Huawei MediaPad
        ],
        [MODEL, [VENDOR, "Huawei"], [TYPE, TABLET]],
        [
          /(microsoft);\s(lumia[\s\w]+)/i
          // Microsoft Lumia
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /[\s\(;](xbox(?:\sone)?)[\s\);]/i
          // Microsoft Xbox
        ],
        [MODEL, [VENDOR, "Microsoft"], [TYPE, CONSOLE]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[MODEL, /\./g, " "], [VENDOR, "Microsoft"], [TYPE, MOBILE]],
        [
          // Motorola
          /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
          /mot[\s-]?(\w*)/i,
          /(XT\d{3,4}) build\//i,
          /(nexus\s6)/i
        ],
        [MODEL, [VENDOR, "Motorola"], [TYPE, MOBILE]],
        [
          /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
        ],
        [MODEL, [VENDOR, "Motorola"], [TYPE, TABLET]],
        [
          /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[MODEL, /^/, "SmartTV"], [VENDOR, "Samsung"], [TYPE, SMARTTV]],
        [
          /\(dtv[\);].+(aquos)/i
          // Sharp
        ],
        [MODEL, [VENDOR, "Sharp"], [TYPE, SMARTTV]],
        [
          /android.+((sch-i[89]0\d|shw-m380s|SM-P605|SM-P610|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
          /((SM-T\w+))/i
        ],
        [[VENDOR, "Samsung"], MODEL, [TYPE, TABLET]],
        [
          // Samsung
          /smart-tv.+(samsung)/i
        ],
        [VENDOR, [TYPE, SMARTTV], MODEL],
        [
          /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
          /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
          /sec-((sgh\w+))/i
        ],
        [[VENDOR, "Samsung"], MODEL, [TYPE, MOBILE]],
        [
          /sie-(\w*)/i
          // Siemens
        ],
        [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
        [
          /(maemo|nokia).*(n900|lumia\s\d+)/i,
          // Nokia
          /(nokia)[\s_-]?([\w-]*)/i
        ],
        [[VENDOR, "Nokia"], MODEL, [TYPE, MOBILE]],
        [
          /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i
          // Acer
        ],
        [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
        [
          /android.+([vl]k\-?\d{3})\s+build/i
          // LG Tablet
        ],
        [MODEL, [VENDOR, "LG"], [TYPE, TABLET]],
        [
          /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i
          // LG Tablet
        ],
        [[VENDOR, "LG"], MODEL, [TYPE, TABLET]],
        [
          /linux;\snetcast.+smarttv/i,
          // LG SmartTV
          /lg\snetcast\.tv-201\d/i
        ],
        [[VENDOR, "LG"], MODEL, [TYPE, SMARTTV]],
        [
          /(nexus\s[45])/i,
          // LG
          /lg[e;\s\/-]+(\w*)/i,
          /android.+lg(\-?[\d\w]+)\s+build/i
        ],
        [MODEL, [VENDOR, "LG"], [TYPE, MOBILE]],
        [
          /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i
          // Lenovo tablets
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /android.+(ideatab[a-z0-9\-\s]+)/i
          // Lenovo
        ],
        [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
        [
          /(lenovo)[_\s-]?([\w-]+)/i
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /linux;.+((jolla));/i
          // Jolla
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /((pebble))app\/[\d\.]+\s/i
          // Pebble
        ],
        [VENDOR, MODEL, [TYPE, WEARABLE]],
        [
          /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i
          // OPPO
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[MODEL, "Chromecast"], [VENDOR, "Google"], [TYPE, SMARTTV]],
        [
          /android.+;\s(glass)\s\d/i
          // Google Glass
        ],
        [MODEL, [VENDOR, "Google"], [TYPE, WEARABLE]],
        [
          /android.+;\s(pixel c)[\s)]/i
          // Google Pixel C
        ],
        [MODEL, [VENDOR, "Google"], [TYPE, TABLET]],
        [
          /android.+;\s(pixel( [2-9]a?)?( xl)?)[\s)]/i
          // Google Pixel
        ],
        [MODEL, [VENDOR, "Google"], [TYPE, MOBILE]],
        [
          /android.+;\s(\w+)\s+build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /android.+(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i,
          // Xiaomi Hongmi
          /android.+(redmi[\s\-_]?(?:note|k)?(?:[\s_]?[\w\s]+))(?:\sbuild|\))/i,
          // Xiaomi Redmi
          /android.+(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i
          // Xiaomi Mi
        ],
        [[MODEL, /_/g, " "], [VENDOR, "Xiaomi"], [TYPE, MOBILE]],
        [
          /android.+(mi[\s\-_]?(?:pad)(?:[\s_]?[\w\s]+))(?:\sbuild|\))/i
          // Mi Pad tablets
        ],
        [[MODEL, /_/g, " "], [VENDOR, "Xiaomi"], [TYPE, TABLET]],
        [
          /android.+;\s(m[1-5]\snote)\sbuild/i
          // Meizu
        ],
        [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
        [
          /(mz)-([\w-]{2,})/i
        ],
        [[VENDOR, "Meizu"], MODEL, [TYPE, MOBILE]],
        [
          /android.+a000(1)\s+build/i,
          // OnePlus
          /android.+oneplus\s(a\d{4})[\s)]/i
        ],
        [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
        [
          /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i
          // RCA Tablets
        ],
        [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
        [
          /android.+[;\/\s](Venue[\d\s]{2,7})\s+build/i
          // Dell Venue Tablets
        ],
        [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
        [
          /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i
          // Verizon Tablet
        ],
        [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
        [
          /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i
          // Barnes & Noble Tablet
        ],
        [[VENDOR, "Barnes & Noble"], MODEL, [TYPE, TABLET]],
        [
          /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i
          // Barnes & Noble Tablet
        ],
        [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
        [
          /android.+;\s(k88)\sbuild/i
          // ZTE K Series Tablet
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
        [
          /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i
          // Swiss GEN Mobile
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
        [
          /android.+[;\/]\s*(zur\d{3})\s+build/i
          // Swiss ZUR Tablet
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
        [
          /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i
          // Zeki Tablets
        ],
        [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
        [
          /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
          /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i
          // Dragon Touch Tablet
        ],
        [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
        [
          /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i
          // Insignia Tablets
        ],
        [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
        [
          /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i
          // NextBook Tablets
        ],
        [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
        [
          /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
        ],
        [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
        [
          // Voice Xtreme Phones
          /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i
          // LvTel Phones
        ],
        [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
        [
          /android.+;\s(PH-1)\s/i
        ],
        [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
        [
          // Essential PH-1
          /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i
          // Envizen Tablets
        ],
        [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
        [
          /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i
          // Le Pan Tablets
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /android.+[;\/]\s*(Trio[\s\w\-\.]+)\s+build/i
          // MachSpeed Tablets
        ],
        [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
        [
          /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i
          // Trinity Tablets
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /android.+[;\/]\s*TU_(1491)\s+build/i
          // Rotor Tablets
        ],
        [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
        [
          //android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
          //], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
          /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i
          // Gigaset Tablets
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          // Android Phones from Unidentified Vendors
          /android .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i
        ],
        [MODEL, [TYPE, MOBILE]],
        [
          // Android Tablets from Unidentified Vendors
          /android .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i
        ],
        [MODEL, [TYPE, TABLET]],
        [
          /\s(tablet|tab)[;\/]/i,
          // Unidentifiable Tablet
          /\s(mobile)(?:[;\/]|\ssafari)/i
          // Unidentifiable Mobile
        ],
        [[TYPE, util.lowerize], VENDOR, MODEL],
        [
          /[\s\/\(](smart-?tv)[;\)]/i
          // SmartTV
        ],
        [[TYPE, SMARTTV]],
        [
          /(android[\w\.\s\-]{0,9});.+build/i
          // Generic Android Device
        ],
        [MODEL, [VENDOR, "Generic"]]
      ],
      engine: [
        [
          /windows.+\sedge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [VERSION2, [NAME, "EdgeHTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [VERSION2, [NAME, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/\s]([23]\.[\d\.]+)/i
          // iCab
        ],
        [NAME, VERSION2],
        [
          /rv\:([\w\.]{1,9}).+(gecko)/i
          // Gecko
        ],
        [VERSION2, NAME]
      ],
      os: [
        [
          // Windows based
          /microsoft\s(windows)\s(vista|xp)/i
          // Windows (iTunes)
        ],
        [NAME, VERSION2],
        [
          /(windows)\snt\s6\.2;\s(arm)/i,
          // Windows RT
          /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,
          // Windows Phone
          /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
        ],
        [NAME, [VERSION2, mapper.str, maps.os.windows.version]],
        [
          /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
        ],
        [[NAME, "Windows"], [VERSION2, mapper.str, maps.os.windows.version]],
        [
          // Mobile/Embedded OS
          /\((bb)(10);/i
          // BlackBerry 10
        ],
        [[NAME, "BlackBerry"], VERSION2],
        [
          /(blackberry)\w*\/?([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/\s]([\w\.]+)/i,
          // Tizen/KaiOS
          /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
          // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
        ],
        [NAME, VERSION2],
        [
          /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i
          // Symbian
        ],
        [[NAME, "Symbian"], VERSION2],
        [
          /\((series40);/i
          // Series 40
        ],
        [NAME],
        [
          /mozilla.+\(mobile;.+gecko.+firefox/i
          // Firefox OS
        ],
        [[NAME, "Firefox OS"], VERSION2],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [VERSION2, [NAME, "Chromecast"]],
        [
          // Console
          /(nintendo|playstation)\s([wids34portablevu]+)/i,
          // Nintendo/Playstation
          // GNU/Linux based
          /(mint)[\/\s\(]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[;\s]/i,
          // Mageia/VectorLinux
          /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
          // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
          // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
          /(hurd|linux)\s?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu)\s?([\w\.]*)/i
          // GNU
        ],
        [NAME, VERSION2],
        [
          /(cros)\s[\w]+\s([\w\.]+\w)/i
          // Chromium OS
        ],
        [[NAME, "Chromium OS"], VERSION2],
        [
          // Solaris
          /(sunos)\s?([\w\.\d]*)/i
          // Solaris
        ],
        [[NAME, "Solaris"], VERSION2],
        [
          // BSD based
          /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
        ],
        [NAME, VERSION2],
        [
          /(haiku)\s(\w+)/i
          // Haiku
        ],
        [NAME, VERSION2],
        [
          /cfnetwork\/.+darwin/i,
          /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i
          // iOS
        ],
        [[VERSION2, /_/g, "."], [NAME, "iOS"]],
        [
          /(mac\sos\sx)\s?([\w\s\.]*)/i,
          /(macintosh|mac(?=_powerpc)\s)/i
          // Mac OS
        ],
        [[NAME, "Mac OS"], [VERSION2, /_/g, "."]],
        [
          // Other
          /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,
          // Solaris
          /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,
          // AIX
          /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
          // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
          /(unix)\s?([\w\.]*)/i
          // UNIX
        ],
        [NAME, VERSION2]
      ]
    };
    var UAParser = function(uastring, extensions) {
      if (typeof uastring === "object") {
        extensions = uastring;
        uastring = undefined$1;
      }
      if (!(this instanceof UAParser)) {
        return new UAParser(uastring, extensions).getResult();
      }
      var ua = uastring || (window2 && window2.navigator && window2.navigator.userAgent ? window2.navigator.userAgent : EMPTY);
      var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
      this.getBrowser = function() {
        var browser = { name: undefined$1, version: undefined$1 };
        mapper.rgx.call(browser, ua, rgxmap.browser);
        browser.major = util.major(browser.version);
        return browser;
      };
      this.getCPU = function() {
        var cpu = { architecture: undefined$1 };
        mapper.rgx.call(cpu, ua, rgxmap.cpu);
        return cpu;
      };
      this.getDevice = function() {
        var device = { vendor: undefined$1, model: undefined$1, type: undefined$1 };
        mapper.rgx.call(device, ua, rgxmap.device);
        return device;
      };
      this.getEngine = function() {
        var engine = { name: undefined$1, version: undefined$1 };
        mapper.rgx.call(engine, ua, rgxmap.engine);
        return engine;
      };
      this.getOS = function() {
        var os = { name: undefined$1, version: undefined$1 };
        mapper.rgx.call(os, ua, rgxmap.os);
        return os;
      };
      this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function() {
        return ua;
      };
      this.setUA = function(uastring2) {
        ua = uastring2;
        return this;
      };
      return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
      NAME,
      MAJOR,
      // deprecated
      VERSION: VERSION2
    };
    UAParser.CPU = {
      ARCHITECTURE
    };
    UAParser.DEVICE = {
      MODEL,
      VENDOR,
      TYPE,
      CONSOLE,
      MOBILE,
      SMARTTV,
      TABLET,
      WEARABLE,
      EMBEDDED
    };
    UAParser.ENGINE = {
      NAME,
      VERSION: VERSION2
    };
    UAParser.OS = {
      NAME,
      VERSION: VERSION2
    };
    {
      if (module.exports) {
        exports = module.exports = UAParser;
      }
      exports.UAParser = UAParser;
    }
    var $ = window2 && (window2.jQuery || window2.Zepto);
    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();
      $.ua.get = function() {
        return parser.getUA();
      };
      $.ua.set = function(uastring) {
        parser.setUA(uastring);
        var result2 = parser.getResult();
        for (var prop in result2) {
          $.ua[prop] = result2[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var uaParserExports = uaParser.exports;
class Orderbuilder {
  /**
   *  Constructing a new orderbuilder,
   *  The order builder can be used to consolidate order info and send the order request.
   *
   *  This can be used for placing orders, but also requesting refunds.
   *
   *  ```ts
   *  const orderbuilder: Orderbuilder = new Orderbuilder(settings);
   *  ```
   *
   *  #### Possible errors
   *  One type of error could be thrown while initializing an orderbuilder.
   *
   *  | Error                                    | Reason                                                                    |
   *  | :--------------------------------------- | :------------------------------------------------------------------------ |
   *  | [ShopError](shoperror.html)              | No or invalid settings [ShopData](../interfaces/shopconfig.html) provided |
   */
  constructor(config) {
    /**
     *  The shop config used for it's sensible defaults and http client
     */
    __publicField(this, "_config");
    if (!config) {
      throw slugError("No config provided for the orderbuilder", ["orderbuilder", "constructor", "error", "config"]);
    }
    if (ShopConfig.isInitializedShopConfig(config)) {
      this._config = config;
    } else {
      this._config = new ShopConfig(config);
    }
  }
  /**
   *  Handle the order data given in the orderbuilder options
   *  This will compile the order and send it to the API.
   *
   *  ```ts
   *  const response: PlaceOrderResponse = orderbuilder.handle(orderbuilderOptions);
   *  ```
   *
   *  #### Possible errors
   *  One type of error could be thrown while handling an order builder.
   *
   *  | Error                                    | Reason                                                                     |
   *  | :--------------------------------------- | :------------------------------------------------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid options [ShopData](../interfaces/orderbuilder.html) provided |
   */
  async handle(options, logger) {
    if (!options) {
      throw slugError("Failed to handle orderbuilder -> No options provided", ["orderbuilder", "handle", "error", "options"]);
    }
    if (!options.booker || !options.booker.bookerInfo || !options.booker.bookerInfo.email || !options.booker.bookerInfo.firstname || !options.booker.bookerInfo.lastname || !options.booker.locale) {
      throw slugError("Failed to handle orderbuilder -> No valid booker info provided", ["orderbuilder", "handle", "error", "bookerinfo"]);
    }
    if (!(options.tickets && options.tickets.length) && !(options.products && options.products.length) && !(options.return && options.return.items && options.return.items.length)) {
      throw slugError("Failed to handle orderbuilder -> No valid items provided, need either tickets, products or return items", ["orderbuilder", "handle", "error", "items"]);
    }
    if (options.return && (!(options.return.items && options.return.items.length) || !options.return.order_id || options.return.includes_fees === void 0 || options.return.to_voucher === void 0)) {
      throw slugError("Failed to handle orderbuilder -> No valid return options provided", ["orderbuilder", "handle", "error", "return"]);
    }
    if (!options.paymentMethod) {
      throw slugError("Failed to handle orderbuilder -> No valid payment method provided", ["orderbuilder", "handle", "error", "paymentmethods"]);
    }
    if (options.coupons && options.coupons.length > 1) {
      throw slugError("Failed to handle orderbuilder -> Multiple coupon not implemented yet", ["orderbuilder", "handle", "error", "coupons"]);
    }
    const orderData = {
      cardToken: options.paymentMethod.item.cardToken,
      coupon: options.coupons && options.coupons.length ? options.coupons[0].item.code : void 0,
      currency: options.paymentMethod.currency,
      extraMetaData: {
        ...await Orderbuilder._getTechData(options.cartInitAt, options.seats),
        ...options.extraTechData
      },
      metaData: Orderbuilder._processMetadata(options.metaData),
      paymentProvider: options.paymentMethod.item.guid,
      paymentProviderIssuer: options.paymentMethod.issuer ? options.paymentMethod.issuer.id : void 0,
      products: Orderbuilder._processProducts(options.products),
      receiver: {
        email: options.booker.bookerInfo.email.value || "",
        firstname: options.booker.bookerInfo.firstname.value || "",
        lastname: options.booker.bookerInfo.lastname.value || "",
        locale: options.booker.locale
      },
      return: Orderbuilder._processReturns(options.return),
      seatsReservationToken: options.seats ? options.seats.holdToken : void 0,
      stripeToken: Orderbuilder._getStripeOrderData(options.paymentMethod.stripe_token),
      tickets: Orderbuilder._processTickets(options.tickets, !!options.seats),
      tracking_info: buildTrackingInfo(
        options.trackingInfo,
        options.trackingInfo && options.trackingInfo.google_tag,
        logger
      )
    };
    const response = await this._send(orderData);
    return response.data;
  }
  /**
   *  Send the order data to the API
   *
   *  ```ts
   *  const response: Response<PlaceOrderResponse> = this._send(orderData);
   *  ```
   *
   *  #### Possible errors
   *  Two types of errors could be thrown while sending an order to the API.
   *
   *  | Error                                    | Reason                                           |
   *  | :--------------------------------------- | :----------------------------------------------- |
   *  | [OrderApiError](orderapierror.html)      | Any of the values provided are not valid for the |
   *  |                                          | current state of the API                         |
   *  | [ApiError](apierror.html)                | Something unexpected went wrong                  |
   */
  async _send(orderData) {
    const url = this._config.getNoCacheUrl(`${this._config.guid}/order`);
    try {
      return await this._config.httpClient.post(url, orderData);
    } catch (error) {
      if (errorHasResponseStatus(error) && error.response.status >= 400 && error.response.status < 500) {
        throw errorToSlugError(error, ["orderbuilder", "send", "error", "failed"], { orderData });
      } else {
        throw errorToSlugError(error, ["orderbuilder", "send", "error", "fatal"], { orderData });
      }
    }
  }
  /**
   *  Transform cart tickets into ticket order data
   *
   *  Explicitly static as it should never use any state on the order builder
   */
  static _processTickets(cartTickets, addSeatInfo = false) {
    if (!cartTickets || !cartTickets.length) {
      return [];
    }
    return cartTickets.map((cartTicket) => {
      const cartProducts = [];
      forOwn(cartTicket.products.map, (products) => {
        forOwn(products, (cartProduct) => {
          cartProducts.push(cartProduct);
        });
      });
      let seatInfo;
      if (addSeatInfo && cartTicket.seatsInfo) {
        seatInfo = {
          uuid: cartTicket.seatsInfo.objectLabel,
          eventKeys: cartTicket.seatsInfo.eventKeys
        };
      }
      return {
        guid: cartTicket.item.guid,
        reservation: cartTicket.reservation.reservation,
        products: Orderbuilder._processProducts(cartProducts),
        metaData: Orderbuilder._processMetadata(cartTicket.metadataList),
        seatInfo
      };
    });
  }
  /**
   *  Transform cart products into product order data
   *
   *  Explicitly static as it should never use any state on the order builder
   */
  static _processProducts(cartProducts) {
    if (!cartProducts || !cartProducts.length) {
      return void 0;
    }
    return cartProducts.map((cartProduct) => ({
      guid: cartProduct.item.guid,
      reservation: cartProduct.reservation.reservation,
      metaData: Orderbuilder._processMetadata(cartProduct.metadataList)
    }));
  }
  /**
   *  Transform return items into return order data
   *
   *  Explicitly static as it should never use any state on the order builder
   */
  static _processReturns(options) {
    if (!options || !options.items || !options.items.length) {
      return void 0;
    }
    const returnsOrderData = {
      order_id: options.order_id,
      includes_fees: options.includes_fees,
      to_voucher: options.to_voucher,
      reason: options.reason,
      items: options.items
    };
    if (options.donate_percentage && options.donate_percentage > 0) {
      returnsOrderData.arbitrary = {
        percentage: options.donate_percentage,
        // A gift is by default 0 vat.
        // However, this might not be true for all countries!!!
        // We do not have this notion right now though...
        vat: 0
      };
    }
    return returnsOrderData;
  }
  /**
   *  Transform cart metadata into metadata order data
   *
   *  Explicitly static as it should never use any state on the order builder
   */
  static _processMetadata(cartMetadataCollection) {
    if (!cartMetadataCollection || !cartMetadataCollection.length) {
      return void 0;
    }
    return cartMetadataCollection.filter((cartMetadata) => cartMetadata.item.extra.includes("required") || cartMetadata.value !== null).map((cartMetadata) => ({
      guid: cartMetadata.item.guid,
      value: cartMetadata.value
    }));
  }
  /**
   *  Transform cart payment method's stripe token into stripe order data if present
   *
   *  Explicitly static as it should never use any state on the order builder
   */
  static _getStripeOrderData(stripeToken) {
    return stripeToken ? { id: stripeToken.id } : void 0;
  }
  /**
   *  Transform arbitrary data into a techdata object.
   *
   *  This data is mainly for understanding order flow and debugging purposes.
   *
   *  @param initAt - The exact moment the cart was constructed
   *  @param seatsio - The seatsio info to be saved with the order for debugging purposes.
   */
  static async _getTechData(initAt, seatsio) {
    const dppx = +(window ? window.devicePixelRatio : 0);
    const dpi = dppx * 96;
    const uaParser2 = new uaParserExports.UAParser();
    const adBlocker = await adsBlocked();
    return {
      adblock: adBlocker,
      cookieEnabled: navigator.cookieEnabled,
      doNotTrack: !!navigator.doNotTrack,
      queryParams: parseQuery(),
      referrer: document.referrer,
      screen: {
        width: window.screen.width,
        height: window.screen.height,
        orientation: {
          angle: window.screen && window.screen.orientation && window.screen.orientation.angle || null,
          type: window.screen && window.screen.orientation && window.screen.orientation.type || null
        },
        dpi,
        dpcm: dpi / 2.54,
        dppx
      },
      seatsioHoldToken: (seatsio ? seatsio.holdToken : null) || null,
      timeToBank: Math.ceil(((/* @__PURE__ */ new Date()).getTime() - initAt.getTime()) / 1e3),
      timezone: guessTimezone() || null,
      userAgent: uaParser2.getResult()
    };
  }
}
class CrossWindowCse extends CrossWindowBase {
  constructor(iframe, cse) {
    if (!iframe.contentWindow) {
      throw new Error("Iframe does not have a content window");
    }
    super({
      window: iframe.contentWindow,
      scope: "shop"
    });
    __publicField(this, "identifier", "_isOpenticketCse");
    __publicField(this, "interval");
    __publicField(this, "intervalAction");
    __publicField(this, "cse");
    __publicField(this, "iframe");
    this.iframe = iframe;
    this.cse = cse;
  }
  sendMessage(data) {
    this._sendMessage(data);
  }
  sendMessageUntilResponse(action, data) {
    this.sendMessage({ action, ...data });
    clearInterval(this.interval);
    this.interval = setInterval(() => this.sendMessage({ action, ...data }), 1e3);
    this.intervalAction = action;
  }
  /**
   * Handled messaging for the OpenTicketBase class.
   * @param event - data from the event
   */
  async onMessage(event2) {
    const message = event2.data;
    if (this.intervalAction && typeof message.messageReceived === "string" && message.messageReceived === this.intervalAction) {
      clearInterval(this.interval);
      this.interval = void 0;
      this.intervalAction = void 0;
      return;
    }
    if (message.action && typeof message.action === "string") {
      this.sendMessage({ messageReceived: message.action });
    }
    if (message.cardDetails && typeof message.cardDetails === "object") {
      await this.cse.handleCardDetailsMessage(message.cardDetails);
      return;
    }
    if (message.scrollHeight && typeof message.scrollHeight === "number") {
      this.iframe.style.height = `${message.scrollHeight}px`;
    }
  }
  /**
   *  On connection, the CSE needs the shop guid to get a request token from the correct shop.
   */
  onConnect() {
    this.cse.onConnectMessage();
    return Promise.resolve();
  }
}
class Cse extends libExports.EventScope {
  constructor(cart, logger, externalCardFieldsUrl, targetOrigin, requestTokenUrl, surchargeUrl, companyCountry, eventBus) {
    super(eventBus || new EventBus());
    __publicField(this, "_eventScope", "cse");
    /**
     *  Reference to the shop's logger
     */
    __publicField(this, "log");
    /**
     *  Reference to the cart
     */
    __publicField(this, "_cart");
    __publicField(this, "externalCardFieldsUrl");
    __publicField(this, "targetOrigin");
    __publicField(this, "requestTokenUrl");
    __publicField(this, "surchargeUrl");
    __publicField(this, "companyCountry");
    __publicField(this, "iframePrefix", "cse-iframe");
    __publicField(this, "iframeCounter", 0);
    /**
     * For managing connections between frames
     */
    __publicField(this, "messaging");
    if (!logger) {
      throw slugError("Failed to create cart, missing logger", ["cse", "constructor", "missing", "logger"]);
    }
    this.log = logger;
    if (!cart) {
      throw this.log._create(LogLevel.Fatal, ["cse", "constructor", "error", "missing", "cart"]);
    }
    this._cart = cart;
    this.externalCardFieldsUrl = externalCardFieldsUrl;
    this.targetOrigin = targetOrigin;
    this.requestTokenUrl = requestTokenUrl;
    this.surchargeUrl = surchargeUrl;
    this.companyCountry = companyCountry;
  }
  mountCSEPaymentMethod(selector, serviceId, tokenUrl) {
    const element = typeof selector === "string" ? document.querySelector(selector) : selector;
    if (!element) {
      this._cart.paymentMethod.item.canPlaceCseOrder = true;
      this.log._create(LogLevel.Warning, ["cse", "mount", "wrapper", "missing"]);
      return;
    }
    if (element.getElementsByClassName(this.iframePrefix).length > 0) {
      this.log._create(LogLevel.Warning, ["cse", "mount", "iframe", "exists"]);
      this.messaging.sendMessageUntilResponse("remounted", {});
      return;
    }
    const cseIframe = document.createElement("iframe");
    const queryParams = new URLSearchParams({
      targetOrigin: this.targetOrigin,
      requestTokenUrl: this.requestTokenUrl,
      serviceId,
      tokenUrl
    }).toString();
    cseIframe.src = new URL(`?${queryParams}`, this.externalCardFieldsUrl).href;
    cseIframe.className = this.iframePrefix;
    cseIframe.setAttribute("sandbox", "allow-scripts allow-forms");
    cseIframe.id = `${this.iframePrefix}-${this.iframeCounter++}`;
    element.innerHTML = "";
    element.appendChild(cseIframe);
    try {
      this.messaging = new CrossWindowCse(cseIframe, this);
    } catch (e) {
      this._cart.paymentMethod.item.canPlaceCseOrder = true;
      throw this.log._create(LogLevel.Error, ["cse", "mount", "contentWindow", "missing"]);
    }
    setTimeout(() => {
      if (!this.messaging.isConnected) {
        this._cart.paymentMethod.item.canPlaceCseOrder = true;
      }
    }, 3e3);
  }
  isCardDetails(cardDetails) {
    return !!("cardToken" in cardDetails && typeof cardDetails.cardToken === "object" && cardDetails.cardToken && "token" in cardDetails.cardToken && typeof cardDetails.cardToken.token === "string" && (!("request" in cardDetails) || typeof cardDetails.request === "object" && cardDetails.request && (!("result" in cardDetails.request) || typeof cardDetails.request.result === "string")));
  }
  onConnectMessage() {
    this.messaging.sendMessageUntilResponse("locale", { locale: this._cart.locale });
    this._cart.on(["locale"], () => {
      this.messaging.sendMessageUntilResponse("locale", { locale: this._cart.locale });
    });
  }
  assertSurcharge(surcharge) {
    if (typeof surcharge === "object" && surcharge && "surcharge" in surcharge && typeof surcharge.surcharge === "boolean" && (!("slug" in surcharge) || typeof surcharge.slug === "string")) {
      return;
    }
    throw this.log._create(LogLevel.Error, ["cse", "surcharge", "error"]);
  }
  async handleCardDetailsMessage(cardDetails) {
    if (this.isCardDetails(cardDetails)) {
      await this.checkIfSurchargeAndSwitchPaymentMethod(cardDetails);
    } else if (!("error" in cardDetails)) {
      this.emit(["cardDetails", "error"], cardDetails);
      throw this.log._create(LogLevel.Error, ["cse", "cardDetails", "error"], cardDetails);
    } else if ("error" in cardDetails && cardDetails.error !== "missing") {
      this.emit(["cardDetails", "user_error"], cardDetails);
    }
    this._cart.paymentMethod.item.canPlaceCseOrder = !("error" in cardDetails);
  }
  async checkIfSurchargeAndSwitchPaymentMethod(cardDetails) {
    try {
      if (!this.surchargeUrl) {
        throw this.log._create(LogLevel.Warning, ["cse", "surcharge", "url", "missing"]);
      }
      const surchargeData = {
        cardInfo: cardDetails,
        companyInfo: { country: this.companyCountry },
        booker: {
          firstname: this._cart.booker.firstname.value,
          lastname: this._cart.booker.lastname.value,
          email: this._cart.booker.email.value
        }
      };
      const response = await fetch(this.surchargeUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(surchargeData)
      }).then((data) => data.json());
      this.assertSurcharge(response);
      this.emit(["surcharge", "response"], {
        surcharge: response.surcharge,
        slug: response.slug
      });
      const paymentMethodGuid = response.surcharge ? this._cart.paymentMethod.item.surchargePaymentMethodGuid : this._cart.paymentMethod.item.replacementPaymentMethodGuid;
      if (!paymentMethodGuid) {
        return;
      }
      await this._cart.setPaymentMethod(paymentMethodGuid);
      this._cart.paymentMethod.item.surchargeReason = response.slug || null;
    } catch (e) {
      const logMessage = this.log._create(LogLevel.Error, ["cse", "surcharge", "error"]);
      this.emit(["surcharge", "error"], {
        error: (logMessage.exception ? logMessage.exception.message : logMessage.slug) || "unknown error"
      });
    } finally {
      this._cart.paymentMethod.item.cardToken = cardDetails.cardToken.token;
    }
  }
}
class Cart extends libExports.EventScope {
  /**
   *  Constructing a new cart creates an *(empty)* shopping cart instance,
   *  the cart is immediately ready for use.
   *
   *  ```ts
   *  const cart: Cart = new Cart(shopData, settings);
   *  ```
   *
   *  #### Possible errors
   *  One type of error could be thrown while initializing a shopping cart.
   *
   *  | Error                                    | Reason                                                                    |
   *  | :--------------------------------------- | :------------------------------------------------------------------------ |
   *  | [ShopError](shoperror.html)              | No or invalid shop data [ShopData](../interfaces/shopdata.html) provided  |
   *  |                                          | or no settings provided                                                   |
   */
  constructor(shop, config, logger, eventBus) {
    super(eventBus || new EventBus());
    __publicField(this, "_eventScope", "cart");
    /**
     *  Collection of cart items.
     *  This holds all reserved tickets and products except orphaned global products.
     *  The items are grouped per event and per (ticket/product) abstract instance
     *
     *  @category Cart
     */
    __publicField(this, "items", {});
    /**
     *  Collection of cart products.
     *  This holds all reserved global product not belonging to an event.
     *
     *  @category Cart
     */
    __publicField(this, "orphanedGlobalProducts", {
      map: {},
      collection: []
    });
    /**
     *  Collection of cart items. This holds all reserved tickets and products.
     *
     *  This collection is for retrieving cart items
     *  without the need to iterate over their nested structure
     *
     *  @category Cart
     */
    __publicField(this, "flatItems");
    /**
     *  The default, mandatory booker information
     *  First name, last name, email
     *
     *  @category Cart
     */
    __publicField(this, "booker");
    /**
     *  Holding the checkout details of the cart, being updated every time the items change.
     *
     *  @category Cart
     */
    __publicField(this, "checkout_details", {
      vats: {
        percentages: {},
        total: 0
      },
      payment_method_fee: 0,
      order_fee: {
        fixed: 0,
        percentage: 0,
        total: 0
      },
      booking_fee: {
        fixed: 0,
        percentage: 0,
        total: 0
      },
      transaction_fee: {
        fixed: 0,
        percentage: 0,
        total: 0
      },
      subtotal_price: 0,
      total_price: 0,
      busy: false
    });
    /**
     *  The locale in which the booker is creating his order.
     *
     *  This should be one of the supported languages in the shop.
     *  This value will also be used by the API to determine
     *  in which language to render the tickets, etc..
     */
    __publicField(this, "locale", "en_GB");
    /**
     * Validation methods for the cart data
     */
    __publicField(this, "validator");
    /**
     *  Map of CartMetadata
     *
     *  Metadata wrappers containing values, errors and the original item.
     *
     *  @Category Cart
     */
    __publicField(this, "metadata", {});
    __publicField(this, "metadataList", []);
    /**
     *  Reservations are valid for a specified amount of time.
     *  This will hold the moment this expires in a few easy to use formats.
     *
     *  *Example*
     *  Given:
     *      - The reservation time is 10 minutes
     *      - a ticket is reserved every minute
     *      - the first ticket was reserved 10 minutes ago
     *  All reserved tickets up until that point will be released.
     *  This is done to ensure clean and simple communication to the user.
     *
     *  @Category Cart
     */
    __publicField(this, "reservationExpiration");
    /**
     *  The selected payment method including a potential issuer
     *
     *  @category Cart
     */
    __publicField(this, "paymentMethod");
    /**
     *  Holder for agreement of terms
     *  It is possible multiple terms should be accepted.
     *
     *  @category Cart
     */
    __publicField(this, "terms");
    /**
     *  Holding all the applied coupons, including the data of
     *  the coupon and the number of times it is applied.
     */
    __publicField(this, "_coupons", {});
    /**
     *  The shop config used for it's sensible defaults and preventing request saturation
     */
    __publicField(this, "_config");
    /**
     *  Reference to the shop of the cart
     */
    __publicField(this, "_shop");
    /**
     *  Reference to the shop data object
     */
    __publicField(this, "_data");
    /**
     *  Reference to the shop's logger
     */
    __publicField(this, "log");
    /**
     * CSE instance for handling challenge CSE payments.
     */
    __publicField(this, "cse");
    /**
     *  All reservation logic is handled by a scoped and self-contained tool
     */
    __publicField(this, "_reservator");
    /**
     *  Sending the order is handled by a scoped and self-contained tool.
     *
     *  This is to ensure any refund requests / order mutations
     *  can be handled similar with the same code.
     */
    __publicField(this, "_orderbuilder");
    /**
     *  Reservation time in minutes
     *  If the shop does not provide a reservation time
     *  the default reservation time from the shop config is used.
     */
    __publicField(this, "_reservationTime");
    /**
     *  Reservation ticker handle.
     *  Can be used to clear the ticker.
     *
     *  The ticker updates the seconds till expiration value every second.
     */
    __publicField(this, "_reservationTicker");
    /**
     *  The number of current pending actions. Used to block the
     *  place order call while there are pending actions.
     */
    __publicField(this, "_pendingActions", 0);
    /**
     *  The seatsio instance the cart will mount/render the seating chart from.
     */
    __publicField(this, "seatsioInstance");
    /**
     *  The base price formatter for the current shop
     */
    __publicField(this, "_priceFormatter");
    /**
     *  The exact moment the cart was constructed.
     *
     *  This is used for creating metrics about shopping behaviour.
     *  E.g.: Time to bank is send to the API.
     */
    __publicField(this, "_initAt");
    /**
     *  Extra arbitrary data to add to the place order call
     */
    __publicField(this, "techData", {});
    /**
     *  If set will send TrackingInfo alongside order
     */
    __publicField(this, "_enableOrderTracking", false);
    if (!logger) {
      throw slugError("Failed to create cart, missing logger", ["cart", "constructor", "missing", "logger"]);
    }
    this.log = logger;
    if (!shop) {
      throw this.log._create(LogLevel.Fatal, ["cart", "constructor", "error", "missing", "shop"]);
    }
    if (!shop.data) {
      throw this.log._create(LogLevel.Fatal, ["cart", "constructor", "error", "missing", "data"]);
    }
    if (!config) {
      throw this.log._create(LogLevel.Fatal, ["cart", "constructor", "error", "missing", "config"]);
    }
    this._shop = shop;
    this._data = shop.data;
    this.booker = factoryBookerCartMetadata(shop.data.email_validation_rule);
    if (ShopConfig.isInitializedShopConfig(config)) {
      this._config = config;
    } else {
      this._config = new ShopConfig(config);
    }
    this._reservator = new Reservator(this._config);
    this._orderbuilder = new Orderbuilder(this._config);
    this._reservationTime = shop.data.reservation_time ? shop.data.reservation_time : this._config.defaultReservationTime;
    if (this._config.cseUrls && this._config.cseUrls.externalCardFieldsUrl) {
      const { externalCardFieldsUrl, surchargeUrl } = this._config.cseUrls;
      this.cse = new Cse(
        this,
        this.log,
        externalCardFieldsUrl,
        window.location.origin,
        this._config.getNoCacheUrl(`${this._config.guid}/token`),
        surchargeUrl,
        this._data.company.country,
        this._eventBus
      );
    }
    this.reservationExpiration = {
      date: null,
      secondsRemaining: null
    };
    this.flatItems = {
      products: {},
      tickets: {}
    };
    forEach$1(this._data.booker_metadata, (metadata2) => {
      addMetadataToCollection(metadata2, this.metadata, this.metadataList);
    });
    this.metadataList.sort(modelSort);
    this.validator = new CartValidator(this, this.log);
    const firstPaymentMethod = this._data.payment_methods[0];
    if (!firstPaymentMethod) {
      throw this.log._create(LogLevel.Fatal, ["cart", "constructor", "error", "missing", "paymentmethods"]);
    }
    this.paymentMethod = {
      item: firstPaymentMethod,
      currency: this._data.currency || "EUR",
      // TODO Needing a default here is kinda ugly....
      is_stripe: !!firstPaymentMethod.stripe
    };
    this._computeCheckoutDetails();
    this.terms = {
      default: false
    };
    if (this._data.seats_public_key) {
      this.seatsioInstance = new SeatsioService({
        workspaceKey: this._data.seats_public_key
      });
    }
    this._priceFormatter = this._resetPriceFormatter();
    this._registerOnUnload();
    this._initAt = /* @__PURE__ */ new Date();
  }
  /**
   *  Determines if any items exist in the cart
   */
  hasItems() {
    return Object.keys(this.flatItems.tickets).length > 0 || Object.keys(this.flatItems.products).length > 0;
  }
  /**
   * Get cart ticket info (total count, total price, cart ticket id's)
   */
  getTicketInfo(ticketGuid) {
    const ticket2 = this._data.tickets_map[ticketGuid];
    let cartTickets = [];
    if (this.items[ticket2.event_id]) {
      cartTickets = Object.values(this.items[ticket2.event_id].tickets.map[ticketGuid] || {});
    }
    return this._cartEventItemResponse(
      ticket2,
      cartTickets,
      CartItemChildType.Tickets
    );
  }
  /**
   * Get product ticket info (total count, total price, cart product id's)
   */
  getProductInfo(productGuid) {
    const product = this._data.products_map[productGuid];
    let cartProducts = [];
    if (this.items[product.event_id]) {
      cartProducts = Object.values(this.items[product.event_id].products.map[productGuid] || {});
    }
    return this._cartEventItemResponse(
      product,
      cartProducts,
      CartItemChildType.Products
    );
  }
  /**
   * Get cart ticket product info (total count, total price, cart ticket product id's)
   */
  getTicketProductInfo(cartTicketId, ticketProductGuid) {
    const cartTicket = this.flatItems.tickets[cartTicketId];
    const ticketProduct = this._data.products_map[ticketProductGuid];
    let cartTicketProducts = [];
    if (this.flatItems.tickets[cartTicketId]) {
      cartTicketProducts = Object.values(this.flatItems.tickets[cartTicketId].products.map[ticketProductGuid] || {});
    }
    return this._cartEventItemResponse(
      ticketProduct,
      cartTicketProducts,
      CartItemChildType.Products,
      cartTicket
    );
  }
  /**
   * Get coupon info (counts, spend, applied tickets and products)
   */
  getCouponInfo(couponGuid) {
    const appliedCoupon = this._coupons[couponGuid];
    if (!appliedCoupon) {
      return this._cartEventCouponResponse(null);
    }
    return this._cartEventCouponResponse(appliedCoupon, this._getCouponApplicableItems(appliedCoupon.item));
  }
  /**
   *
   *  Used to sync the data of items that are currently in
   *  the cart with the shop data that got updated.
   *
   *  Updates the cart items' pricing objects according
   *  to their (possibly) updated item and recomputes
   *  their pricing and checkout details.
   *
   *  (i) The Object.assign should be used to remove any saved
   *  data about applied coupons, because the applied coupons
   *  get re-applied.
   *
   *  (i) Only the pricing is relevant to copy from the
   *  item, because other data (such as the name) can be
   *  used directly out of the item's item, where the pricing
   *  is subject to changes because of coupons.
   *
   *  @internal
   *
   */
  _shopDataUpdated() {
    this._action(CartAction.Start);
    forOwn(this.flatItems.products, (cartProduct) => {
      Object.assign(cartProduct.pricing, cartProduct.item.pricing);
      cartProduct.setOptional();
    });
    forOwn(this.flatItems.tickets, (cartTicket) => {
      Object.assign(cartTicket.pricing, cartTicket.item.pricing);
      cartTicket.min_price = cartTicket.item.min_price;
    });
    forOwn(this._coupons, (coupon) => {
      this._resetCoupon(coupon);
      this._couponDiscounts(CouponAction.Add, coupon);
    });
    this._doneUpdatingItems();
    this._action(CartAction.End);
  }
  /**
   *  Add a ticket to the cart. This will only succeed if a reservation can be retrieved.
   *
   *  ```ts
   *  cart.addTicket(ticket.guid);
   *  ```
   *
   *  @param ticketGuid The guid of the ticket to add
   *
   *  | Error                                    | Reason                                                                    |
   *  | :--------------------------------------- | :------------------------------------------------------------------------ |
   *  | [ShopError](shoperror.html)              | No or invalid ticket in shop data [ShopData](../interfaces/shopdata.html) |
   *  | [ApiError](apierror.html)                | The shop API threw an error                                               |
   */
  async addTicket(ticketGuid) {
    this._action(CartAction.Start);
    try {
      const addTicketEvent = await this._addTicket(ticketGuid);
      this._action(CartAction.End);
      this.emit(["ticket", ticketGuid, "add"], addTicketEvent);
      return addTicketEvent;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "addTicket", "error", "failed"], { ticketGuid });
    }
  }
  /**
   *
   *  Internally used for adding a ticket to the cart.
   *
   *  @param ticketGuid The guid of the ticket to add.
   *  @param seatInfo When a ticket is added through the seats integration, it's place's info can be added here.
   *
   */
  async _addTicket(ticketGuid, seatInfo) {
    const ticket2 = this._getShopTicket(ticketGuid);
    this._ensureTicketAvailable(ticket2);
    const eventCollection = this._getOrCreateEventCollection(ticket2.event_id);
    const cartTicketMap = eventCollection.tickets.map[ticketGuid] = eventCollection.tickets.map[ticketGuid] || {};
    const currentTicketCount = Object.keys(cartTicketMap).length + this._reservator.inFlightCount(ReservationType.Ticket, ticket2.guid);
    const numberOfTicketsToReserve = seatInfo ? 1 : calculateTicketDiff(currentTicketCount, ticket2.min_orderable_amount_per_order || 1, ticket2.increment || 1);
    if (currentTicketCount + numberOfTicketsToReserve > ticket2.max_orderable_amount_per_order) {
      throw this.log._create(LogLevel.Warning, ["cart", "addTicket", "error", "max_orderable"], {
        ticketGuid,
        maxOrderable: ticket2.max_orderable_amount_per_order
      });
    }
    try {
      const reservations = await this._reservator.reserve(ReservationType.Ticket, ticket2.guid, numberOfTicketsToReserve);
      const cartTickets = [];
      const freshEventCollection = this._getOrCreateEventCollection(ticket2.event_id);
      const freshCartTicketMap = freshEventCollection.tickets.map[ticketGuid] = freshEventCollection.tickets.map[ticketGuid] || {};
      forEach$1(reservations, (reservation) => {
        const cartTicket = new CartTicket(this._data, ticket2, reservation, void 0, seatInfo);
        freshCartTicketMap[cartTicket.id] = cartTicket;
        freshEventCollection.tickets.collection.push(cartTicket);
        this.flatItems.tickets[cartTicket.id] = cartTicket;
        forOwn(
          cartTicket.products.map,
          (cartProducts) => {
            forOwn(cartProducts, (cartProduct) => {
              this.flatItems.products[cartProduct.id] = cartProduct;
            });
          }
        );
        cartTickets.push(cartTicket);
      });
      this._itemsUpdated();
      return this._cartEventItemResponse(
        ticket2,
        cartTickets,
        CartItemChildType.Tickets
      );
    } catch (error) {
      if (error && hasAttribute(error, "slug") && hasAttribute(error, "response") && hasAttribute(error.response, "data") && hasAttribute(error.response.data, "error_description")) {
        if (error.slug === "sdkshop.log.reservator.reserve.error.notacceptable") {
          if (error.response.data.error_description === "Sold out") {
            ticket2.status = "sold_out";
            throw this.log._passThroughOrCreate(
              error,
              LogLevel.Warning,
              ["cart", "addTicket", "error", "sold_out"],
              { ticketGuid }
            );
          }
          if (error.response.data.error_description === "Everything is reserved") {
            throw this.log._passThroughOrCreate(
              error,
              LogLevel.Warning,
              ["cart", "addTicket", "error", "all_reserved"],
              { ticketGuid }
            );
          }
        }
      }
      throw error;
    }
  }
  /**
   *  Remove a ticket from the cart.
   *
   *  ```ts
   *  cart.removeTicket(ticket.guid);
   *  cart.removeTicket(ticket.guid, cartTicket.id);
   *  ```
   *
   *  @param ticketGuid The guid of the ticket to remove
   *  @param cartTicketId The id of the cart ticket, when not provided the last cart item will be removed
   *
   *  | Error                                    | Reason                                    |
   *  | :--------------------------------------- | :---------------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid ticket in shop data or cart |
   *  |                                          | [ShopData](../interfaces/shopdata.html)   |
   *  | [ApiError](apierror.html)                | The shop API threw an error               |
   */
  async removeTicket(ticketGuid, cartTicketId) {
    this._action(CartAction.Start);
    try {
      const removeTicketEvent = await this._removeTicket(ticketGuid, cartTicketId);
      this._action(CartAction.End);
      this.emit(["ticket", ticketGuid, "remove"], removeTicketEvent);
      return removeTicketEvent;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "removeTicket", "error", "failed"], { ticketGuid, cartTicketId });
    }
  }
  /**
   *
   *  Internally used to remove a ticket from the cart, including the option to not
   *  recompute the checkout details after doing so. Used by the removeAllItems
   *  method to make sure the re-computation of the checkout details only happens
   *  once after every item has been removed.
   *
   *  @param ticketGuid The guid of the ticket to remove
   *  @param cartTicketId The id of the cart ticket, when not provided the last cart item  will be removed
   *  @param singleRemove If it's about the removing of a single product (and not removing all products)
   *
   */
  // eslint-disable-next-line @typescript-eslint/require-await
  async _removeTicket(ticketGuid, cartTicketId, singleRemove = true) {
    const ticket2 = this._getShopTicket(ticketGuid);
    const [cartTicketCollection, cartTicketMap] = this._getTicketItemCollection(
      ticket2.event_id,
      ticket2.guid
    );
    const cartTicketCount = Object.keys(cartTicketMap).length;
    const cartTicketIds = [];
    if (cartTicketId) {
      if (!Object.prototype.hasOwnProperty.call(cartTicketMap, cartTicketId)) {
        throw this.log._create(LogLevel.Error, ["cart", "removeTicket", "error", "notfound"], {
          ticketGuid,
          cartTicketId
        });
      }
      cartTicketIds.push(cartTicketId);
    } else if (cartTicketCount) {
      const numberOfTickets = calculateTicketDiff(
        cartTicketCount,
        ticket2.min_orderable_amount_per_order || 1,
        ticket2.increment || 1,
        -1
      );
      cartTicketIds.push(...Object.getOwnPropertyNames(cartTicketMap).slice(-1 * numberOfTickets));
    } else {
      throw new ShopError(`Ticket is not in cart's item collection: ${ticket2.guid}`);
    }
    const cartTickets = [];
    forEach$1(cartTicketIds, (currentCartTicketId) => {
      const cartTicket = cartTicketMap[currentCartTicketId];
      cartTickets.push(cartTicket);
      this._reservator.release(ReservationType.Ticket, cartTicket.item.guid, cartTicket.reservation.reservation).catch(() => {
      });
      delete cartTicketMap[cartTicket.id];
      cartRemoveOnId(cartTicketCollection, cartTicket.id);
      delete this.flatItems[CartItemChildType.Tickets][cartTicket.id];
      if (cartTicket.item.status === "sold_out") {
        cartTicket.item.status = "available";
      }
      forOwn(
        cartTicket.products.map,
        (cartProducts) => {
          forOwn(cartProducts, (cartProduct) => {
            delete this.flatItems.products[cartProduct.id];
            this._checkRemovedProductCoupons(cartProduct);
          });
        }
      );
    });
    this._cleanUpItemStructure(ticket2.event_id, ticket2.guid);
    if (singleRemove) {
      this._itemsUpdated();
    }
    return this._cartEventItemResponse(
      ticket2,
      cartTickets,
      CartItemChildType.Tickets
    );
  }
  /**
   *  Add a (global) product to the cart. This will only succeed if a reservation can be retrieved.
   *
   *  ```ts
   *  cart.addProduct(product.guid);
   *  ```
   *
   *  @param productGuid The guid of the (global) product to add
   *
   *  | Error                                    | Reason                                                                     |
   *  | :--------------------------------------- | :------------------------------------------------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid product in shop data [ShopData](../interfaces/shopdata.html) |
   *  | [ApiError](apierror.html)                | The shop API threw an error                                                |
   */
  async addProduct(productGuid) {
    this._action(CartAction.Start);
    try {
      const addProductEvent = await this._addProduct(productGuid);
      this._action(CartAction.End);
      this.emit(["product", productGuid, "add"], addProductEvent);
      return addProductEvent;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "addProduct", "error", "failed"], { productGuid });
    }
  }
  /**
   *
   *  Internally used to add a (global) product to the cart.
   *
   *  @param productGuid The guid of the (global) product to add
   *
   */
  async _addProduct(productGuid) {
    const product = this._getShopProduct(productGuid, false);
    const event2 = product.event_id ? this._data.events_map[product.event_id] : void 0;
    const globalProductsCollection = event2 ? event2.global_products : this._data.global_products;
    this._ensureGlobalProduct(globalProductsCollection, product);
    const reservations = await this._reservator.reserve(ReservationType.Product, product.guid);
    let productCollection;
    if (event2) {
      productCollection = this._getOrCreateEventCollection(product.event_id)[CartItemChildType.Products];
    } else {
      productCollection = this.orphanedGlobalProducts;
    }
    const cartProductMap = productCollection.map[product.guid] = productCollection.map[product.guid] || {};
    const cartProducts = [];
    forEach$1(reservations, (reservation) => {
      const cartProduct = new CartProduct(this._data, product, reservation);
      cartProductMap[cartProduct.id] = cartProduct;
      productCollection.collection.push(cartProduct);
      this.flatItems.products[cartProduct.id] = cartProduct;
      cartProducts.push(cartProduct);
    });
    addMetadataFromProduct(product, this.metadata, this.metadataList, MetadataAppliesTo.Person);
    this._itemsUpdated();
    return this._cartEventItemResponse(
      product,
      cartProducts,
      CartItemChildType.Products
    );
  }
  /**
   *  Remove a (global) product from the cart.
   *
   *  ```ts
   *  cart.removeProduct(product.guid);
   *  cart.removeProduct(product.guid, cartProduct.id);
   *  ```
   *
   *  @param productGuid The guid of the (global) product to remove
   *  @param cartProductId The id of the cart product, when not provided the last cart product will be removed
   *
   *  | Error                                    | Reason                                    |
   *  | :--------------------------------------- | :---------------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid ticket in shop data or cart |
   *  |                                          | [ShopData](../interfaces/shopdata.html)   |
   *  | [ApiError](apierror.html)                | The shop API threw an error               |
   */
  async removeProduct(productGuid, cartProductId) {
    this._action(CartAction.Start);
    try {
      const removeProductEvent = await this._removeProduct(productGuid, cartProductId);
      this._action(CartAction.End);
      this.emit(["product", productGuid, "remove"], removeProductEvent);
      return removeProductEvent;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "removeProduct", "error", "failed"], { productGuid, cartProductId });
    }
  }
  /**
   *
   *  Internally used to remove a (global) product from the cart, including the option to
   *  not recompute the checkout details after doing so. Used by the removeAllItems
   *  method to make sure the re-computation of the checkout details only happens
   *  once after every item has been removed.
   *
   *  @param productGuid The guid of the (global) product to remove
   *  @param cartProductId The id of the cart product, when not provided the last (global) cart product will be removed
   *  @param singleRemove If it's about the removing of a single product (and not removing all products)
   *
   */
  // eslint-disable-next-line @typescript-eslint/require-await
  async _removeProduct(productGuid, cartProductId, singleRemove = true) {
    const product = this._getShopProduct(productGuid, false);
    const event2 = product.event_id ? this._data.events_map[product.event_id] : void 0;
    const globalProductsCollection = event2 ? event2.global_products : this._data.global_products;
    this._ensureGlobalProduct(globalProductsCollection, product);
    const [cartProductCollection, cartProductMap] = this._getProductItemCollection(
      event2 ? event2.guid : void 0,
      product.guid
    );
    const cartProductCount = Object.keys(cartProductMap).length;
    const cartProductIds = [];
    if (cartProductId) {
      if (!Object.prototype.hasOwnProperty.call(cartProductMap, cartProductId)) {
        throw new ShopError(`Cart product id not found: ${cartProductId}`);
      }
      cartProductIds.push(cartProductId);
    } else if (cartProductCount) {
      cartProductIds.push(...Object.getOwnPropertyNames(cartProductMap).slice(-1));
    } else {
      throw new ShopError(`Product is not in cart's item collection: ${product.guid}`);
    }
    const cartProducts = [];
    forEach$1(cartProductIds, (currentCartProductId) => {
      const cartProduct = cartProductMap[currentCartProductId];
      cartProducts.push(cartProduct);
      this._reservator.release(ReservationType.Product, cartProduct.item.guid, cartProduct.reservation.reservation).catch(() => {
      });
      delete cartProductMap[cartProduct.id];
      cartRemoveOnId(cartProductCollection, cartProduct.id);
      delete this.flatItems[CartItemChildType.Products][cartProduct.id];
      this._checkRemovedProductCoupons(cartProduct);
    });
    this._cleanUpItemStructure(product.event_id, void 0, product.guid);
    this._checkRemovedProductMetadata(product.metadata);
    if (singleRemove) {
      this._itemsUpdated();
    }
    return this._cartEventItemResponse(
      product,
      cartProducts,
      CartItemChildType.Products
    );
  }
  /**
   *  Add a product to a cart ticket. This will only succeed if a reservation can be retrieved.
   *
   *  ```ts
   *  cart.addProductToTicket(cartTicket.id, product.guid);
   *  ```
   *
   *  @param cartTicketId The id of the cart ticket to add the product to
   *  @param productGuid The guid of the product to add to the ticket
   *
   *  | Error                                    | Reason                                                                     |
   *  | :--------------------------------------- | :------------------------------------------------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid product in shop data [ShopData](../interfaces/shopdata.html) |
   *  | [ApiError](apierror.html)                | The shop API threw an error                                                |
   */
  async addProductToTicket(cartTicketId, productGuid) {
    this._action(CartAction.Start);
    try {
      const addProductToTicketEvent = await this._addProductToTicket(cartTicketId, productGuid);
      this._action(CartAction.End);
      this.emit(["ticket", cartTicketId, "product", productGuid, "add"], addProductToTicketEvent);
      return addProductToTicketEvent;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "addProductToTicket", "error", "failed"], { cartTicketId, productGuid });
    }
  }
  /**
   *
   *  Internally used to add a product to a cart ticket.
   *
   *  @param cartTicketId The id of the cart ticket to add the product to
   *  @param productGuid The guid of the product to add to the ticket
   *
   */
  async _addProductToTicket(cartTicketId, productGuid) {
    const cartTicket = this._getCartTicket(cartTicketId);
    const timesAdded = cartTicket.products.map[productGuid] ? Object.keys(cartTicket.products.map[productGuid]).length : 0;
    forEach$1(cartTicket.item.groups, (productGroup) => {
      let inGroup = false;
      let totalAdded = 0;
      forEach$1(productGroup.products, (groupProduct) => {
        if (productGuid === groupProduct.guid) {
          inGroup = true;
          const uniqueness = groupProduct.uniqueness || productGroup.uniqueness;
          if (!!uniqueness && timesAdded >= uniqueness) {
            throw this.log._create(LogLevel.Warning, ["cart", "addProductToTicket", "error", "uniqueness"], {
              cartTicketId,
              productGroupGuid: productGroup.guid,
              productGuid,
              uniqueness: productGroup.uniqueness
            });
          }
        }
        if (cartTicket.products.map[groupProduct.guid]) {
          totalAdded += Object.keys(cartTicket.products.map[groupProduct.guid]).length;
        }
      });
      if (inGroup && !!productGroup.max_bound && totalAdded >= productGroup.max_bound) {
        throw this.log._create(LogLevel.Warning, ["cart", "addProductToTicket", "error", "max_bound"], {
          cartTicketId,
          productGroupGuid: productGroup.guid,
          productGuid,
          maxBound: productGroup.max_bound
        });
      }
    });
    const ticketProduct = this._getProductFromTicket(cartTicket.item, productGuid);
    try {
      const reservations = await this._reservator.reserveChild(ReservationType.Ticket, cartTicket.item.guid, ReservationType.Product, ticketProduct.item.guid);
      const cartProducts = cartTicket._processProductChildReservation(
        ticketProduct.item.guid,
        ...reservations
      );
      forEach$1(cartProducts, (cartProduct) => {
        this.flatItems.products[cartProduct.id] = cartProduct;
      });
      if (!cartTicket.item.late_personalization || ticketProduct.skip_late_personalization) {
        addMetadataFromProduct(
          ticketProduct.item,
          cartTicket.metadata,
          cartTicket.metadataList,
          MetadataAppliesTo.Person,
          ticketProduct.index * 100
        );
      }
      this._itemsUpdated();
      const originalTicketPrice = cartTicket.pricing.self.total_price + cartTicket.pricing.children.own.total_price;
      forEach$1(cartTicket.item.products.all, (shopProduct) => {
        if (shopProduct.item.pricing_method === PricingMethod.Container) {
          Price.computeProductPricing(shopProduct.pricing, originalTicketPrice);
        }
      });
      return this._cartEventItemResponse(
        ticketProduct.item,
        cartProducts,
        CartItemChildType.Products,
        cartTicket
      );
    } catch (error) {
      if (error && hasAttribute(error, "slug") && hasAttribute(error, "response") && hasAttribute(error.response, "data") && hasAttribute(error.response.data, "error_description")) {
        if (error.slug === "sdkshop.log.reservator.reserveChild.error.notacceptable") {
          if (error.response.data.error_description === "Sold out") {
            ticketProduct.item.status = "sold_out";
            throw this.log._passThroughOrCreate(
              error,
              LogLevel.Warning,
              ["cart", "addProductToTicket", "error", "sold_out"],
              { cartTicketId, productGuid }
            );
          }
          if (error.response.data.error_description === "Everything is reserved") {
            throw this.log._passThroughOrCreate(
              error,
              LogLevel.Warning,
              ["cart", "addProductToTicket", "error", "all_reserved"],
              { cartTicketId, productGuid }
            );
          }
        }
      }
      throw error;
    }
  }
  /**
   *  Remove a product from a cart ticket. This will only succeed if a reservation can be cancelled.
   *
   *  ```ts
   *  cart.removeProductFromTicket(cartTicket.id, product.guid);
   *  cart.removeProductFromTicket(cartTicket.id, product.guid, cartProduct.id);
   *  ```
   *
   *  @param cartTicketId The id of the ticket to remove the product from
   *  @param productGuid The guid of the product to remove
   *  @param cartProductId The id of the cart ticket, when not provided the last cart ticket will be removed
   *
   *  | Error                                    | Reason                                                             |
   *  | :--------------------------------------- | :----------------------------------------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid cart product [ShopData](../interfaces/shopdata.html) |
   *  | [ApiError](apierror.html)                | The shop API threw an error                                        |
   */
  async removeProductFromTicket(cartTicketId, productGuid, cartProductId) {
    this._action(CartAction.Start);
    try {
      const removeTicketProductEvent = await this._removeProductFromTicket(
        cartTicketId,
        productGuid,
        cartProductId
      );
      this._action(CartAction.End);
      this.emit(["ticket", cartTicketId, "product", productGuid, "remove"], removeTicketProductEvent);
      return removeTicketProductEvent;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(
        error,
        LogLevel.Error,
        ["cart", "removeProductFromTicket", "error", "failed"],
        { cartTicketId, productGuid, cartProductId }
      );
    }
  }
  /**
   *
   *  Internally used to remove a product from a cart ticket.
   *
   *  @param cartTicketId The id of the ticket to remove the product from
   *  @param productGuid The guid of the product to remove
   *  @param cartProductId The id of the cart ticket, when not provided the last cart ticket will be removed
   */
  // eslint-disable-next-line @typescript-eslint/require-await
  async _removeProductFromTicket(cartTicketId, productGuid, cartProductId) {
    const cartTicket = this._getCartTicket(cartTicketId);
    const ticketProduct = this._getProductFromTicket(cartTicket.item, productGuid);
    const [cartProductCollection, cartProductMap] = this._getChildProductCollection(
      cartTicket,
      productGuid
    );
    const cartProductCount = Object.keys(cartProductMap).length;
    const cartProductIds = [];
    if (cartProductId) {
      if (!Object.prototype.hasOwnProperty.call(cartProductMap, cartProductId)) {
        throw new ShopError(`Cart product id not found: ${cartProductId}`);
      }
      cartProductIds.push(cartProductId);
    } else if (cartProductCount) {
      cartProductIds.push(...Object.getOwnPropertyNames(cartProductMap).slice(-1));
    } else {
      throw new ShopError(`Product is not in cart ticket's product collection: ${ticketProduct.item.guid}`);
    }
    const cartProducts = [];
    forEach$1(cartProductIds, (currentCartProductId) => {
      const cartProduct = cartProductMap[currentCartProductId];
      cartProducts.push(cartProduct);
      this._reservator.release(ReservationType.Product, cartProduct.item.guid, cartProduct.reservation.reservation).catch(() => {
      });
      delete cartProductMap[cartProduct.id];
      cartRemoveOnId(cartProductCollection, cartProduct.id);
      delete this.flatItems[CartItemChildType.Products][cartProduct.id];
      this._checkRemovedProductCoupons(cartProduct);
    });
    if (!Object.keys(cartTicket.products.map[ticketProduct.item.guid]).length) {
      delete cartTicket.products.map[ticketProduct.item.guid];
    }
    if (!cartTicket.item.late_personalization || ticketProduct.skip_late_personalization) {
      cartTicket._checkRemovedProductMetadata(ticketProduct.item.metadata);
    }
    this._itemsUpdated();
    const originalTicketPrice = cartTicket.pricing.self.total_price + cartTicket.pricing.children.own.total_price;
    forEach$1(cartTicket.item.products.all, (shopProduct) => {
      if (shopProduct.item.pricing_method === PricingMethod.Container) {
        Price.computeProductPricing(shopProduct.pricing, originalTicketPrice);
      }
    });
    return this._cartEventItemResponse(
      ticketProduct.item,
      cartProducts,
      CartItemChildType.Products,
      cartTicket
    );
  }
  /**
   *  Add (a) ticket(s) through the seats selector
   *
   *  Note: The seat selector will be opened for all tickets
   *  with the same set of seats.io eventKeys as the provided ticket.
   *
   *  @param ticketGuid The ticket guid for which to open the seat selector.
   *  @param divId The id of the DOM element to mount seat selector in.
   *  @param inputOptions Extra options to forward to the seat selector.
   */
  async addTicketThroughSeats(ticketGuid, divId, inputOptions) {
    this._action(CartAction.Start);
    try {
      this.emit(["seats", "created"], null, true);
      await this._openSeatsFromTicket(ticketGuid, divId, inputOptions);
      this.emit(["seats", "mounted"], null, true);
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "addTicketThroughSeats", "error", "failed"], { ticketGuid });
    }
  }
  /**
   *  Find a cart ticket by it's seats info object label and remove it from the cart.
   *
   *  @param label The seats.io seating chart object's label
   *  @param ticketGuid The ticket guid from the seats.io pricing ticket type
   */
  async _removeTicketBySeats(label, ticketGuid) {
    const cartTicketMap = ticketGuid ? this._getTicketItemCollection(this._getShopTicket(ticketGuid).event_id, ticketGuid)[1] : this.flatItems[CartItemChildType.Tickets];
    const labeledCartTickets = Object.getOwnPropertyNames(cartTicketMap).map((cartTicketId) => cartTicketMap[cartTicketId]).filter((cartTicket) => cartTicket.seatsInfo && cartTicket.seatsInfo.objectLabel === label).slice(-1);
    if (!labeledCartTickets.length) {
      console.warn("Failed to remove seated ticket -> Could not find ticket: ", label, ticketGuid);
      return void 0;
    }
    return this._removeTicket(labeledCartTickets[0].item.guid, labeledCartTickets[0].id);
  }
  /**
   *  Collect all (nested) event keys from the ticket
   *
   *  Note: If any optional products are connected to an event date with a seats_event_key,
   *  those are ignored (for now...)
   *  Might want to add those to addProductToTicketThroughSeats once the API supports it.
   */
  _getEventKeysFromTicket(ticket2, productType) {
    const eventKeys = {};
    forEach$1(ticket2.products[productType], (product) => {
      forEach$1(product.item.event_dates, (eventDate2) => {
        if (eventDate2.seats_event_key) {
          eventKeys[eventDate2.seats_event_key] = eventDate2.seats_event_key;
        }
      });
    });
    return Object.keys(eventKeys);
  }
  /**
   *  Open the seats selector with the intention of adding tickets to the cart
   *
   *  Note: The seat selector will be opened for all tickets
   *  with the same set of seats.io eventKeys as the provided ticket.
   *
   *  @param ticketGuid The ticket guid for which to open the seat selector.
   *  @param divId The id of the DOM element to mount seat selector in.
   *  @param inputOptions Extra options to forward to the seat selector.
   */
  async _openSeatsFromTicket(ticketGuid, divId, inputOptions) {
    if (!this.seatsioInstance) {
      throw new ShopError("Ticket is not seated -> Seats.io instance not constructed");
    }
    const [tickets2, eventKeys] = this._getSeatedTickets(ticketGuid);
    const pricing = {};
    const useMaxSelectedObjects = tickets2.some((ticket2) => !!ticket2.max_orderable_amount_per_order);
    const maxSelectedObjects = tickets2.map((ticket2) => ({
      quantity: ticket2.max_orderable_amount_per_order,
      ticketType: ticket2.guid,
      category: ticket2.seats_category_key
    }));
    forEach$1(tickets2, (otherTicket) => {
      pricing[otherTicket.seats_category_key] = pricing[otherTicket.seats_category_key] || {
        category: otherTicket.seats_category_key,
        ticketTypes: []
      };
      pricing[otherTicket.seats_category_key].ticketTypes.push({
        ticketType: otherTicket.guid,
        price: otherTicket.pricing.total_price,
        label: otherTicket.name
      });
    });
    const seatsOptions = {
      // Default values from data / cart, can be overwritten by input options!
      language: toSeatsioLanguage(this.locale),
      allowOrphanSeats: this._data.seats_allow_orphan || this._data.company.seats_allow_orphan || false,
      forceConsecutiveSeats: false,
      // TODO: Note the API does not support this (yet)!
      colorScheme: "light",
      priceFormatter: (cents) => this._formatPrice(cents),
      ...useMaxSelectedObjects ? { maxSelectedObjects } : {},
      ...inputOptions || {},
      // Always set by the computed values, can never be set through input options
      divId,
      events: eventKeys,
      // This line shows a confirmation dialog even when only one choice.
      pricing: Object.values(pricing),
      // The below code block could be used to convert single choice categories to the simple pricing config...
      // Note however: the callbacks will need to be rewritten.
      // Without the ticket type info, they can not easily retrieve the associated ticket!!!
      //
      // pricing: Object.values(pricing).map((pricingConfig: seatsio.PricingConfig) => {
      //
      //     if (pricingConfig.ticketTypes && pricingConfig.ticketTypes.length === 1) {
      //
      //         return {
      //             category: pricingConfig.category,
      //             price: pricingConfig.ticketTypes[0].price,
      //         };
      //
      //     }
      //
      //     return pricingConfig;
      //
      // }),
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onHoldSucceeded: async (objects, ticketTypes) => {
        if (!ticketTypes) {
          console.error("Invalid hold -> no ticket types", objects);
          throw new Error("Invalid hold -> no ticket types");
        }
        this._action(CartAction.Start);
        for (const object of objects) {
          const index = objects.indexOf(object);
          const ticketType = ticketTypes[index];
          if (!ticketType.ticketType) {
            console.error("Invalid hold -> no ticket type", object);
            continue;
          }
          const seatInfo = {
            objectLabel: object.label,
            eventKeys
          };
          await this._addTicket(ticketType.ticketType, seatInfo).then((addTicketEvent) => {
            this.emit(["ticket", addTicketEvent.guid, "add"], addTicketEvent);
            return addTicketEvent;
          }).catch((reason) => {
            void object.deselect();
            console.error(`Failed to add ticket for seated object ${object.label}`, reason);
          });
        }
        this._action(CartAction.End);
      },
      onHoldFailed: (objects, ticketTypes) => {
        console.error("onHoldFailed", objects, ticketTypes);
      },
      onHoldTokenExpired: () => {
        console.error("onHoldTokenExpired");
        this.emit(["seats", "error", "hold-expired"], null, true);
      },
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onReleaseHoldSucceeded: async (objects, ticketTypes) => {
        this._action(CartAction.Start);
        forEach$1(objects, (object, index) => {
          const ticketType = ticketTypes ? ticketTypes[index] : void 0;
          this._removeTicketBySeats(object.label, ticketType ? ticketType.ticketType : void 0).then((removeTicketEvent) => {
            if (removeTicketEvent) {
              this.emit(["ticket", removeTicketEvent.guid, "remove"], removeTicketEvent);
            }
            return removeTicketEvent;
          }).catch((reason) => {
            console.error(`Failed to remove ticket for seated object ${object.label}`, reason);
          });
        });
        this._action(CartAction.End);
      },
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onReleaseHoldFailed: async (objects, ticketTypes) => {
        console.error("onReleaseHoldFailed", objects, ticketTypes);
      },
      onSelectionValid: () => {
        this.emit(["seats", "validation", "valid"], {
          valid: true,
          violations: []
        }, true);
      },
      onSelectionInvalid: (violations) => {
        console.error("onSelectionInvalid", violations);
        this.emit(["seats", "validation", "invalid"], {
          valid: false,
          violations
        }, true);
      }
    };
    await this.seatsioInstance.mount(seatsOptions);
  }
  /* eslint-enable sort-keys */
  /**
   *  Close the seats io seating chart
   */
  closeSeats() {
    if (!this.seatsioInstance) {
      throw this.log._create(LogLevel.Warning, ["cart", "closeSeats", "error", "initialized"]);
    }
    this.seatsioInstance.destroy();
    this._action(CartAction.End);
    this.emit(["seats", "destroy"], null, true);
  }
  /**
   *  Retrieve the seats info for the set of (cart) tickets equal to the given ticket guid.
   *
   *  @param ticketGuid The reference ticket's guid
   */
  getSeatedTicketInfo(ticketGuid) {
    const [tickets2, eventKeys] = this._getSeatedTickets(ticketGuid);
    const allCartItems = [];
    forEach$1(tickets2, (ticket2) => {
      try {
        allCartItems.push(...Object.values(this._getTicketItemCollection(ticket2.event_id, ticket2.guid)[1]));
      } catch (e) {
      }
    });
    return {
      items: allCartItems.map((cartTicket) => ({
        ticket_guid: cartTicket.item.guid,
        name: cartTicket.item.name,
        id: cartTicket.id,
        label: cartTicket.seatsInfo ? cartTicket.seatsInfo.objectLabel : "",
        pricing: cartTicket.pricing
      })),
      eventKeys,
      count: allCartItems.length,
      pricing: Price.getCumulativeCartItemPrice(allCartItems)
    };
  }
  /**
   *  Retrieve all seated tickets with the same set of event keys to the given ticket guid.
   *
   *  @param ticketGuid The reference ticket's guid
   */
  _getSeatedTickets(ticketGuid) {
    const ticket2 = this._getShopTicket(ticketGuid);
    if (!ticket2.seats_category_key) {
      throw new ShopError("Ticket is not seated -> Seats.io category key not found");
    }
    if (!ticket2.seated) {
      throw new ShopError("Ticket is not seated");
    }
    const eventKeys = this._getEventKeysFromTicket(ticket2, "required");
    if (!eventKeys.length) {
      throw new ShopError("Ticket is not seated -> Seats.io event key(s) not found");
    }
    const event2 = this._getShopEvent(ticket2.event_id);
    const tickets2 = [];
    forEach$1(event2.tickets, (otherTicket) => {
      if (otherTicket.seats_category_key) {
        if (!this._ensureTicketAvailable(otherTicket, false)) {
          return;
        }
        const ticketEventKeys = this._getEventKeysFromTicket(otherTicket, "required");
        if (ticketEventKeys.length && arraysMatch(eventKeys, ticketEventKeys)) {
          tickets2.push(otherTicket);
        }
      }
    });
    return [tickets2, eventKeys];
  }
  /**
   *  Retrieve a cart ticket from the cart
   *
   *  If it does not exist a shop error is thrown
   */
  _getCartTicket(cartTicketId) {
    if (!cartTicketId || !Object.prototype.hasOwnProperty.call(this.flatItems[CartItemChildType.Tickets], cartTicketId)) {
      throw new ShopError(`No valid cart ticket id provided: ${cartTicketId}`);
    }
    return this.flatItems[CartItemChildType.Tickets][cartTicketId];
  }
  // noinspection JSMethodCanBeStatic
  /**
   *  Retrieve a child cart product collection from the cart ticket
   *
   *  If it does not exist a shop error is thrown
   */
  _getChildProductCollection(cartTicket, productGuid) {
    if (typeof productGuid !== "string" || !Object.prototype.hasOwnProperty.call(cartTicket.products.map, productGuid)) {
      throw new ShopError(`Product ${productGuid} not in cart ticket ${cartTicket.id}`);
    }
    return [cartTicket.products.collection, cartTicket.products.map[productGuid]];
  }
  /**
   *  Retrieve a ticket from the shop data if it exists.
   *
   *  If it does not exist a shop error is thrown
   */
  _getShopTicket(ticketGuid) {
    return this._getShopReservable(this._data.tickets_map, ticketGuid);
  }
  /**
   *  Retrieve a product from the shop data if it exists.
   *
   *  If it does not exist a shop error is thrown
   */
  _getShopProduct(productGuid, ensureEvent) {
    return this._getShopReservable(this._data.products_map, productGuid, ensureEvent);
  }
  /**
   *  Retrieve a reservable from the shop data if it exists.
   *
   *  If it does not exist a shop error is thrown
   */
  _getShopReservable(collection, guid, ensureEvent = true) {
    if (!guid || typeof guid !== "string" || !Object.prototype.hasOwnProperty.call(collection, guid)) {
      throw new ShopError(`No valid item guid provided: ${guid}`);
    }
    const reservable = collection[guid];
    if (!reservable.guid || guid !== reservable.guid) {
      throw new ShopError(`Item does not have valid guid: ${reservable.guid}`);
    }
    if (ensureEvent && (!reservable.event_id || !Object.prototype.hasOwnProperty.call(this._data.events_map, reservable.event_id))) {
      throw new ShopError(`Item does not have valid event guid: ${reservable.event_id}`);
    }
    return reservable;
  }
  /**
   *  Retrieve a product from the ticket if it exists
   *
   *  If it does not exist a shop error is thrown
   */
  _getProductFromTicket(ticket2, productGuid) {
    if (typeof productGuid !== "string" || !Object.prototype.hasOwnProperty.call(this._data.products_map, productGuid)) {
      throw new ShopError(`No valid product guid provided: ${productGuid}`);
    }
    const ticketProduct = ticket2.products.all.find(
      (searchTicketProduct) => searchTicketProduct.item.guid === productGuid
    );
    if (!ticketProduct) {
      throw new ShopError(`Product ${productGuid} not part of ticket ${ticket2.guid}`);
    }
    return ticketProduct;
  }
  /**
   *  Retrieve an event from the shop data if it exists.
   *
   *  If it does not exist a shop error is thrown
   */
  _getShopEvent(eventGuid) {
    if (!eventGuid || typeof eventGuid !== "string" || !Object.prototype.hasOwnProperty.call(this._data.events_map, eventGuid)) {
      throw new ShopError(`Event not found -> No valid event guid provided: ${eventGuid}`);
    }
    return this._data.events_map[eventGuid];
  }
  /**
   *  Ensure the given product is part of a global product collection in the shop data
   *
   *  Throws an error when not the case
   */
  _ensureGlobalProduct(productsCollection, product) {
    let found = false;
    forEach$1(productsCollection, (globalProduct) => {
      if (product.guid === globalProduct.guid) {
        found = true;
      }
      return !found;
    });
    if (found) {
      return product;
    }
    throw new ShopError(`Product not a global product: ${product.guid}`);
  }
  // noinspection JSMethodCanBeStatic
  /**
   *  Ensure the ticket is available.
   *
   *  This checks status and availability range.
   *
   *  @param ticket The ticket to ensure availability for.
   *  @param throwError If set to false, the method returns a boolean instead of throwing an error.
   */
  _ensureTicketAvailable(ticket2, throwError = true) {
    let error;
    if (ticket2.status_overrule === "sold_out") {
      error = `Ticket is not available -> status overruled ${ticket2.status_overrule}`;
    } else if (ticket2.status !== "available") {
      error = `Ticket is not available -> invalid status ${ticket2.status}`;
    } else if (ticket2.available_from && ticket2.available_from > /* @__PURE__ */ new Date()) {
      error = "Ticket is not available -> Not available yet";
    } else if (ticket2.available_until && ticket2.available_until < /* @__PURE__ */ new Date()) {
      error = "Ticket is not available -> Not available any more";
    }
    if (error && throwError) {
      throw new ShopError(error);
    }
    return !error;
  }
  /**
   *  Ensure the event's item collection is defined
   */
  _getOrCreateEventCollection(eventGuid) {
    return this.items[eventGuid] = this.items[eventGuid] || {
      event: this._getShopEvent(eventGuid),
      tickets: {
        map: {},
        collection: []
      },
      products: {
        map: {},
        collection: []
      }
    };
  }
  /**
   *  Retrieve the event's cart ticket collection
   *
   *  This includes the complete ticket collection for the given event
   *  and the ticket map for the specific ticket.
   *
   *  If it does not exist a shop error is thrown
   */
  _getTicketItemCollection(eventGuid, ticketGuid) {
    if (!eventGuid || !Object.prototype.hasOwnProperty.call(this.items, eventGuid)) {
      throw new ShopError(`Event is not in cart: ${eventGuid}`);
    }
    const collection = this.items[eventGuid][CartItemChildType.Tickets];
    if (!ticketGuid || !Object.prototype.hasOwnProperty.call(collection.map, ticketGuid)) {
      throw new ShopError(`Ticket is not in cart: ${ticketGuid}`);
    }
    return [collection.collection, collection.map[ticketGuid]];
  }
  /**
   *  Retrieve the cart product collection from the event or the orphaned global products
   *
   *  If it does not exist a shop error is thrown
   */
  _getProductItemCollection(eventGuid, productGuid) {
    if (eventGuid && !Object.prototype.hasOwnProperty.call(this.items, eventGuid)) {
      throw new ShopError(`Event is not in cart: ${eventGuid}`);
    }
    const collection = eventGuid ? this.items[eventGuid][CartItemChildType.Products] : this.orphanedGlobalProducts;
    if (!productGuid || !Object.prototype.hasOwnProperty.call(collection.map, productGuid)) {
      throw new ShopError(`Product is not in cart: ${productGuid}`);
    }
    return [collection.collection, collection.map[productGuid]];
  }
  /**
   *  Cleanup the cart item's structure
   *
   *  When providing an event guid, ticket guid or product guid,
   *  the method can be focused to those paths.
   */
  _cleanUpItemStructure(eventGuid, ticketGuid, productGuid) {
    if (!eventGuid) {
      const eventGuids = Object.keys(this.items);
      forEach$1(eventGuids, (eventGuidToCleanUp) => {
        this._cleanUpItemStructure(eventGuidToCleanUp);
      });
      return;
    }
    const eventCollection = this.items[eventGuid];
    if (!eventCollection) {
      return;
    }
    const ticketMap = eventCollection[CartItemChildType.Tickets].map;
    const productMap = eventCollection[CartItemChildType.Products].map;
    if (ticketGuid) {
      if (ticketMap[ticketGuid] && !Object.keys(ticketMap[ticketGuid]).length) {
        delete ticketMap[ticketGuid];
      }
    } else if (productGuid) {
      if (productMap[productGuid] && !Object.keys(productMap[productGuid]).length) {
        delete productMap[productGuid];
      }
    } else {
      const ticketGuids = Object.keys(eventCollection[CartItemChildType.Tickets].map);
      forEach$1(ticketGuids, (guid) => {
        if (ticketMap[guid] && !Object.keys(ticketMap[guid]).length) {
          delete ticketMap[guid];
        }
      });
      const productGuids = Object.keys(eventCollection[CartItemChildType.Products].map);
      forEach$1(productGuids, (guid) => {
        if (productMap[guid] && !Object.keys(productMap[guid]).length) {
          delete productMap[guid];
        }
      });
    }
    if (!Object.keys(eventCollection[CartItemChildType.Tickets].map).length && !Object.keys(eventCollection[CartItemChildType.Products].map).length) {
      delete this.items[eventGuid];
    }
  }
  /**
   *  Create the default cart item event object, to always return the same data.
   *
   *  @param item      - Reservable item
   *  @param cartItems - Array of the affected cart items
   *  @param type      - Type of cart item(s)
   *  @param parent    - Optional parent object (CartTicket)
   */
  _cartEventItemResponse(item, cartItems, type, parent) {
    let isTicket = false;
    const event2 = {
      guid: item.guid,
      name: item.name,
      items: cartItems.map((cartItem) => {
        if (cartItem.getType() === CartItemType.Ticket) {
          isTicket = true;
        }
        return {
          id: cartItem.id,
          pricing: cartItem.pricing
        };
      }),
      count: 0,
      counts: {},
      pricing: {
        base_price: 0,
        total_fees: 0,
        subtotal_price: 0,
        total_price: 0
      }
    };
    if (isTicket) {
      event2.max_count = item.max_orderable_amount_per_order;
    }
    let allCartItems;
    if (parent) {
      if (parent.products.collection.length > 0) {
        allCartItems = Object.values(parent.products.map[item.guid] || {});
      }
    } else if (!isTicket && (!item.event_id || !this._data.events_map[item.event_id])) {
      allCartItems = Object.values(this.orphanedGlobalProducts.map[item.guid] || {});
    } else if (this.items[item.event_id] && this.items[item.event_id][type] && this.items[item.event_id][type].map[item.guid]) {
      allCartItems = Object.values(
        this.items[item.event_id][type].map[item.guid] || {}
      );
    }
    if (!allCartItems) {
      return event2;
    }
    forEach$1(allCartItems, (cartItem) => {
      event2.counts[cartItem.pricing.total_price] = (event2.counts[cartItem.pricing.total_price] || 0) + 1;
    });
    event2.count = allCartItems.length;
    event2.pricing = Price.getCumulativeCartItemPrice(allCartItems);
    return event2;
  }
  /**
   *  Used to create the default coupon response, including the products
   *  and tickets that got affected by the coupon action.
   */
  _cartEventCouponResponse(appliedCoupon, affected = []) {
    const event2 = {
      guid: appliedCoupon ? appliedCoupon.guid : null,
      coupon: appliedCoupon ? appliedCoupon.item.coupon : null,
      code: appliedCoupon ? appliedCoupon.item.code : "",
      spend: appliedCoupon ? appliedCoupon.spend : 0,
      products: [],
      tickets: []
    };
    if (affected.length) {
      const affectedTickets = {};
      forEach$1(affected, (couponApplicable) => {
        event2.products.push({
          id: couponApplicable.product.id,
          pricing: couponApplicable.product.pricing
        });
        const cartTicket = couponApplicable.ticket;
        if (cartTicket && !affectedTickets[cartTicket.id]) {
          event2.tickets.push({
            id: cartTicket.id,
            pricing: cartTicket.pricing
          });
          affectedTickets[cartTicket.id] = cartTicket.id;
        }
      });
    }
    return event2;
  }
  /**
   *
   *  Remove all cart items from the cart
   *
   *  Internally release all reservations
   *
   *  Resolves with true on success
   *  Rejects with an array of all errors on failure
   *
   *  It waits for all actions to finish before the promise is settled.
   *  Failures of actions do NOT abort the rest. Every action is waited upon
   *
   *  Coupon stats are updated automatically because it uses the internal
   *  methods for removing tickets and/or products, which make sure to
   *  update coupon stats accordingly
   *
   */
  async removeAllItems() {
    this._action(CartAction.Start);
    try {
      const removePromises = [];
      const removedTickets = {};
      const removedProducts = {};
      forOwn(this.flatItems.tickets, (cartTicket) => {
        if (cartTicket.childOf) {
          return;
        }
        const removeTicketPromise = this._removeTicket(
          cartTicket.item.guid,
          cartTicket.id,
          false
        ).then(() => {
          removedTickets[cartTicket.item.guid] = removedTickets[cartTicket.item.guid] || [];
          removedTickets[cartTicket.item.guid].push(cartTicket);
          return true;
        }, (reason) => Promise.resolve(reason));
        removePromises.push(removeTicketPromise);
      });
      forOwn(this.flatItems.products, (cartProduct) => {
        if (cartProduct.childOf) {
          return;
        }
        const removeProductPromise = this._removeProduct(
          cartProduct.item.guid,
          cartProduct.id,
          false
        ).then(() => {
          removedProducts[cartProduct.item.guid] = removedProducts[cartProduct.item.guid] || [];
          removedProducts[cartProduct.item.guid].push(cartProduct);
          return true;
        }, (reason) => Promise.resolve(reason));
        removePromises.push(removeProductPromise);
      });
      const result2 = await Promise.all(removePromises).then((results) => {
        this._itemsUpdated();
        this._action(CartAction.End);
        forOwn(removedTickets, (removedTicketsToFind, ticketGuid) => {
          const removedTicketsEvent = this._cartEventItemResponse(
            removedTicketsToFind[0].item,
            // The actual item of the ticket that got removed
            removedTicketsToFind,
            CartItemChildType.Tickets
          );
          this.emit(["ticket", ticketGuid, "remove"], removedTicketsEvent);
        });
        forOwn(removedProducts, (removedProductsToFind, productGuid) => {
          const removedProductsEvent = this._cartEventItemResponse(
            removedProductsToFind[0].item,
            // The actual item of the product that got removed
            removedProductsToFind,
            CartItemChildType.Products
          );
          this.emit(["product", productGuid, "remove"], removedProductsEvent);
        });
        const failures = results.filter((resultFilter) => resultFilter !== true);
        if (failures.length) {
          console.error(failures);
          return Promise.reject(failures);
        }
        return true;
      });
      this.emit(["empty"], null);
      return result2;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "removeAllItems", "error", "failed"]);
    }
  }
  // noinspection JSMethodCanBeStatic
  /**
   * Sanitize a coupon code by removing all whitespace
   */
  _sanitizeCouponCode(code) {
    return code.replace(/\s/g, "");
  }
  /**
   *  Used to apply a coupon. It makes sure to get the data of the coupon
   *  based on his code and apply the corresponding discount(s), but only
   *  when the coupon, or any other coupon, is not already applied.
   */
  async addCoupon(code) {
    this._action(CartAction.Start);
    try {
      const addedCouponEvent = await this._addCoupon(code);
      if (addedCouponEvent.products.length > 0) {
        this._doneUpdatingItems();
      }
      this._action(CartAction.End);
      this.emit(["coupon", "add", addedCouponEvent.code], addedCouponEvent);
      const tickets2 = {};
      forEach$1(addedCouponEvent.tickets, (item) => {
        const cartTicket = this.flatItems.tickets[item.id];
        tickets2[cartTicket.item.guid] = tickets2[cartTicket.item.guid] || { ticket: cartTicket.item, items: [] };
        tickets2[cartTicket.item.guid].items.push(cartTicket);
      });
      forOwn(tickets2, (cartTickets) => {
        this.emit(["ticket", cartTickets.ticket.guid, "update"], this._cartEventItemResponse(
          cartTickets.ticket,
          cartTickets.items,
          CartItemChildType.Tickets
        ));
      });
      const products = {};
      const cartTicketProducts = {};
      forEach$1(addedCouponEvent.products, (item) => {
        const cartProduct = this.flatItems.products[item.id];
        products[cartProduct.item.guid] = products[cartProduct.item.guid] || { product: cartProduct.item, items: [] };
        products[cartProduct.item.guid].items.push(cartProduct);
        if (cartProduct.childOf && this.flatItems[CartItemChildType.Tickets][cartProduct.childOf]) {
          cartTicketProducts[cartProduct.childOf] = cartTicketProducts[cartProduct.childOf] || {};
          cartTicketProducts[cartProduct.childOf][cartProduct.item.guid] = cartTicketProducts[cartProduct.childOf][cartProduct.item.guid] || {
            cartTicket: this.flatItems[CartItemChildType.Tickets][cartProduct.childOf],
            product: cartProduct.item,
            items: []
          };
          cartTicketProducts[cartProduct.childOf][cartProduct.item.guid].items.push(cartProduct);
        }
      });
      forOwn(products, (cartProducts) => {
        this.emit(["product", cartProducts.product.guid, "update"], this._cartEventItemResponse(
          cartProducts.product,
          cartProducts.items,
          CartItemChildType.Products
        ));
      });
      forOwn(cartTicketProducts, (cartTicketCartProducts) => {
        forOwn(
          cartTicketCartProducts,
          (cartProduct) => {
            this.emit(
              ["ticket", cartProduct.cartTicket.id, "product", cartProduct.product.guid, "update"],
              this._cartEventItemResponse(
                cartProduct.product,
                cartProduct.items,
                CartItemChildType.Products,
                cartProduct.cartTicket
              )
            );
          }
        );
      });
      return addedCouponEvent;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "addCoupon", "error", "failed"], { code });
    }
  }
  /**
   *  Internally used to apply a coupon. It makes sure to get the data of the coupon
   *  based on his code and apply the corresponding discount(s), but only
   *  when the coupon, or any other coupon, is not already applied.
   */
  async _addCoupon(code) {
    if (typeof code !== "string" || !code.length) {
      throw new ShopError(`Cannot add coupon -> The provided code is invalid: ${code}`);
    }
    code = this._sanitizeCouponCode(code);
    const appliedCoupons = Object.keys(this._coupons);
    if (appliedCoupons.length) {
      const appliedCoupon2 = this.getAppliedCoupon(code);
      if (appliedCoupon2) {
        return this._cartEventCouponResponse(appliedCoupon2);
      }
      throw this.log._create(LogLevel.Error, ["cart", "addCoupon", "error", "multiple"], {
        code,
        existing_code: this._coupons[appliedCoupons[0]].item.code
      });
    }
    let res;
    try {
      const url = this._config.getNoCacheUrl(`${this._config.guid}/coupon/${code}`);
      res = await this._config.httpClient.get(url);
    } catch (error) {
      if (errorHasResponseStatus(error)) {
        if (error.response.status === 404) {
          throw this.log._create(LogLevel.Warning, ["cart", "addCoupon", "error", "notfound"], { code }, null, error, false);
        } else if (error.response.status === 406) {
          throw this.log._create(LogLevel.Warning, ["cart", "addCoupon", "error", "notacceptable"], { code }, null, error, false);
        }
      }
      throw this.log._create(LogLevel.Warning, ["cart", "addCoupon", "error", "failed"], { code }, null, error);
    }
    const coupon = res.data;
    coupon.coupon.guid = coupon.guid;
    const appliedCoupon = {
      guid: coupon.guid,
      item: coupon,
      appliedCount: 0,
      appliedCounts: {},
      appliesTo: {
        cart: this._getCouponApplicableItems(coupon),
        shop: []
      },
      spend: 0
    };
    const affectedItems = this._couponDiscounts(CouponAction.Add, appliedCoupon);
    this._shop._updateCouponDiscounts(CouponAction.Add, appliedCoupon);
    this._coupons[coupon.guid] = appliedCoupon;
    return this._cartEventCouponResponse(appliedCoupon, affectedItems);
  }
  /**
   *  Used to add multiple coupons, based on an Array of coupon codes.
   */
  async addCoupons(codes) {
    this._action(CartAction.Start);
    try {
      const addCouponEvents = await this._addCoupons(codes);
      this._action(CartAction.End);
      return addCouponEvents;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "addCoupons", "error", "failed"], { codes });
    }
  }
  /**
   *  Used to add multiple coupons, based on an Array of coupon codes.
   */
  async _addCoupons(codes) {
    if (!Array.isArray(codes)) {
      throw new ShopError(`Cannot add coupons -> The provided codes is not an Array: ${typeof codes}`);
    }
    if (!codes.length) {
      throw new ShopError("Cannot add coupons -> The provided codes Array is empty");
    }
    codes = codes.map((code) => this._sanitizeCouponCode(code));
    const addCouponEvents = [];
    let affectedItems = false;
    for (const code of codes) {
      const addedCouponEvent = await this._addCoupon(code);
      this.emit(["coupon", "add", code], addedCouponEvent);
      if (addedCouponEvent.products.length > 0) {
        affectedItems = true;
      }
      addCouponEvents.push(addedCouponEvent);
    }
    if (affectedItems) {
      this._itemsUpdated();
    }
    return addCouponEvents;
  }
  /**
   *
   *  Used to remove the coupon that belongs to the forwarded code.
   *
   *  @return remove coupon events that holds the data of the coupon
   *  that got removed or null if no coupon was applied for the code
   *
   */
  async removeCoupon(code) {
    this._action(CartAction.Start);
    try {
      const removeCouponEvent = await this._removeCoupon(code);
      if (removeCouponEvent.products.length > 0) {
        this._doneUpdatingItems();
      }
      this._action(CartAction.End);
      this.emit(["coupon", "remove", removeCouponEvent.code], removeCouponEvent);
      const tickets2 = {};
      forEach$1(removeCouponEvent.tickets, (item) => {
        const cartTicket = this.flatItems.tickets[item.id];
        tickets2[cartTicket.item.guid] = tickets2[cartTicket.item.guid] || { ticket: cartTicket.item, items: [] };
        tickets2[cartTicket.item.guid].items.push(cartTicket);
      });
      forOwn(tickets2, (cartTickets) => {
        this.emit(["ticket", cartTickets.ticket.guid, "update"], this._cartEventItemResponse(
          cartTickets.ticket,
          cartTickets.items,
          CartItemChildType.Tickets
        ));
      });
      const products = {};
      const cartTicketProducts = {};
      forEach$1(removeCouponEvent.products, (item) => {
        const cartProduct = this.flatItems.products[item.id];
        products[cartProduct.item.guid] = products[cartProduct.item.guid] || { product: cartProduct.item, items: [] };
        products[cartProduct.item.guid].items.push(cartProduct);
        if (cartProduct.childOf && this.flatItems[CartItemChildType.Tickets][cartProduct.childOf]) {
          cartTicketProducts[cartProduct.childOf] = cartTicketProducts[cartProduct.childOf] || {};
          cartTicketProducts[cartProduct.childOf][cartProduct.item.guid] = cartTicketProducts[cartProduct.childOf][cartProduct.item.guid] || {
            cartTicket: this.flatItems[CartItemChildType.Tickets][cartProduct.childOf],
            product: cartProduct.item,
            items: []
          };
          cartTicketProducts[cartProduct.childOf][cartProduct.item.guid].items.push(cartProduct);
        }
      });
      forOwn(products, (cartProducts) => {
        this.emit(["product", cartProducts.product.guid, "update"], this._cartEventItemResponse(
          cartProducts.product,
          cartProducts.items,
          CartItemChildType.Products
        ));
      });
      forOwn(cartTicketProducts, (cartTicketCartProducts) => {
        forOwn(
          cartTicketCartProducts,
          (cartProduct) => {
            this.emit(
              ["ticket", cartProduct.cartTicket.id, "product", cartProduct.product.guid, "update"],
              this._cartEventItemResponse(
                cartProduct.product,
                cartProduct.items,
                CartItemChildType.Products,
                cartProduct.cartTicket
              )
            );
          }
        );
      });
      return removeCouponEvent;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "removeCoupon", "error", "failed"], { code });
    }
  }
  /**
   *  Internally used to remove the coupon that belongs to the forwarded code.
   */
  // eslint-disable-next-line @typescript-eslint/require-await
  async _removeCoupon(code) {
    if (typeof code !== "string" || !code.length) {
      throw new ShopError(`Cannot remove coupon -> The provided code is invalid: ${code}`);
    }
    code = this._sanitizeCouponCode(code);
    const appliedCoupon = this.getAppliedCoupon(code);
    if (!appliedCoupon) {
      return this._cartEventCouponResponse(null);
    }
    const affectedItems = this._couponDiscounts(
      CouponAction.Remove,
      appliedCoupon
    );
    delete this._coupons[appliedCoupon.item.guid];
    this._shop._updateCouponDiscounts(CouponAction.Remove, appliedCoupon);
    return this._cartEventCouponResponse(appliedCoupon, affectedItems);
  }
  /**
   *  Used to remove multiple coupons, based on an Array of coupon codes.
   */
  async removeCoupons(codes) {
    this._action(CartAction.Start);
    try {
      const removeCouponEvents = await this._removeCoupons(codes);
      this._action(CartAction.End);
      return removeCouponEvents;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "removeCoupons", "error", "failed"], { codes });
    }
  }
  /**
   *  Used to remove multiple coupons, based on an Array of coupon codes.
   */
  async _removeCoupons(codes) {
    if (!Array.isArray(codes)) {
      throw new ShopError(`Cannot remove coupons -> The provided codes is not an Array: ${typeof codes}`);
    }
    if (!codes.length) {
      throw new ShopError("Cannot remove coupons -> The provided codes Array is empty");
    }
    codes = codes.map((code) => this._sanitizeCouponCode(code));
    const removeCouponEvents = [];
    let affectedItems = false;
    for (const code of codes) {
      const removeCouponEvent = await this._removeCoupon(code);
      this.emit(["coupon", "remove", code], removeCouponEvent);
      if (removeCouponEvent.products.length > 0) {
        affectedItems = true;
      }
      removeCouponEvents.push(removeCouponEvent);
    }
    if (affectedItems) {
      this._itemsUpdated();
    }
    return removeCouponEvents;
  }
  /**
   *  Used to get the data of an applied coupon, based on his code.
   */
  getAppliedCoupon(code) {
    let appliedCoupon;
    forOwn(this._coupons, (ac) => {
      if (ac.item.code === code) {
        appliedCoupon = ac;
      }
      return !appliedCoupon;
    });
    return appliedCoupon;
  }
  /**
   *  Used to get the data of all applied coupons.
   */
  getAppliedCoupons() {
    return this._coupons;
  }
  /**
   *  Set the payment method for this order.
   *
   *  Optionally an issuer id can be provided to immediately set an issuer.
   *
   *  If the payment method is already set and equals the provided guid,
   *  the item within the cart payment method is replaced,
   *  but the cart payment method object is NOT replaced.
   *  Because of this, this method can also be used to only update the issuer.
   *
   *  ```ts
   *  const cartPaymentMethod: CartPaymentMethod = cart.setPaymentMethod(paymentMethod.guid);
   *  const cartPaymentMethod: CartPaymentMethod = cart.setPaymentMethod(paymentMethod.guid, paymentMethod.issuers[0].id);
   *  ```
   *
   *  | Error                        | Reason                                                                                 |
   *  | :--------------------------- | :------------------------------------------------------------------------------------- |
   *  | [ShopError](shoperror.html)  | No or invalid payment method guid in shop data [ShopData](../interfaces/shopdata.html) |
   *  |                              | No or invalid issuer id in payment method [ShopData](../interfaces/shopdata.html)      |
   */
  async setPaymentMethod(paymentMethodGuid, issuerId) {
    this._action(CartAction.Start);
    try {
      const setPaymentMethodEvent = await this._setPaymentMethod(paymentMethodGuid, issuerId);
      this._action(CartAction.End);
      this.emit(["payment_method", "set", setPaymentMethodEvent.guid], setPaymentMethodEvent);
      return setPaymentMethodEvent;
    } catch (error) {
      this._action(CartAction.End);
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "setPaymentMethod", "error", "failed"], { paymentMethodGuid, issuerId });
    }
  }
  /**
   *
   *  Internally used for setting the payment method for this order.
   *
   *  @param paymentMethodGuid The guid of the payment method to set.
   *  @param issuerId When a payment method has issuers, this is where to set them.
   *
   */
  // eslint-disable-next-line @typescript-eslint/require-await
  async _setPaymentMethod(paymentMethodGuid, issuerId) {
    if (typeof paymentMethodGuid !== "string" || !Object.prototype.hasOwnProperty.call(this._data.payment_methods_map, paymentMethodGuid)) {
      throw new ShopError(`Cannot set payment method -> No valid payment method guid provided: ${paymentMethodGuid}`);
    }
    const paymentMethod = this._data.payment_methods_map[paymentMethodGuid];
    if (!paymentMethod.guid || paymentMethodGuid !== paymentMethod.guid) {
      throw new ShopError(`Cannot set payment method -> Payment method does not have valid guid: ${paymentMethod.guid}`);
    }
    let issuer;
    if (issuerId) {
      issuer = paymentMethod.issuers.find((issuerToFind) => issuerToFind.id === issuerId);
      if (!issuer) {
        throw new ShopError(`Cannot set payment method -> Issuer ${issuerId} not part of payment method ${paymentMethod.guid}`);
      }
    } else if (this.paymentMethod && this.paymentMethod.item.guid === paymentMethod.guid) {
      issuer = this.paymentMethod.issuer;
    }
    this.paymentMethod.item = paymentMethod;
    this.paymentMethod.issuer = issuer;
    this.paymentMethod.is_stripe = !!paymentMethod.stripe;
    this._computeCheckoutDetails();
    return {
      guid: paymentMethod.guid,
      name: paymentMethod.name,
      issuer,
      pricing: paymentMethod.pricing
    };
  }
  /**
   *  Mount the stripe payment method elements.
   *
   *  Optionally card options can be provided.
   *  These options are primarily used to style the input elements.
   *
   *  If the stripe card is already set,
   *  the card is mounted (again), but the card object is NOT replaced.
   *
   *  | Error                                    | Reason                          |
   *  | :--------------------------------------- | :------------------------------ |
   *  | [ShopError](shoperror.html)              | Invalid payment method selected |
   */
  async mountStripePaymentMethod(selector, options) {
    if (!this.paymentMethod.item.stripe || !this.paymentMethod.item.stripe.stripe) {
      throw this.log._create(LogLevel.Error, ["cart", "mountStripePaymentMethod", "error", "initialized"]);
    }
    const { paymentMethod } = this;
    const { stripe } = this.paymentMethod.item;
    if (!stripe.card) {
      const elements = stripe.stripe.elements();
      stripe.card = elements.create("card", options);
      stripe.card.on("change", (event2) => {
        stripe.errors.splice(0, stripe.errors.length);
        stripe.complete = false;
        if (event2.complete) {
          stripe.complete = true;
          this.emit(["payment_method", "change", paymentMethod.item.guid, "stripe", "complete"], true);
        } else if (event2.error) {
          stripe.errors.push(event2.error);
          this.emit(["payment_method", "change", paymentMethod.item.guid, "stripe", "error"], event2.error);
        }
      });
    }
    return new Promise((resolve, reject) => {
      const timeout = window.setTimeout(reject, 15e3);
      stripe.card.on("ready", () => {
        this.emit(["payment_method", "change", paymentMethod.item.guid, "stripe", "ready"], true);
        window.clearTimeout(timeout);
        resolve();
      });
      stripe.card.mount(selector);
    });
  }
  /**
   *  Finalize the payment method if applicable
   *
   *  | Error                                    | Reason                                      |
   *  | :--------------------------------------- | :------------------------------------------ |
   *  | [ShopError](shoperror.html)              | Invalid payment method. E.g.: Stripe failed |
   */
  async finalizePaymentMethod() {
    if (this.checkout_details.total_price === 0) {
      this.log._create(LogLevel.Debug, ["cart", "finalizePaymentMethod", "free"]);
      return;
    }
    try {
      await this._finalizePaymentMethodStripe();
    } catch (error) {
      throw this.log._passThroughOrCreate(error, LogLevel.Error, ["cart", "finalizePaymentMethod", "error", "stripe", "error"]);
    }
  }
  async _finalizePaymentMethodStripe() {
    if (this.paymentMethod.item.stripe && this.paymentMethod.item.stripe.stripe && this.paymentMethod.item.stripe.card) {
      delete this.paymentMethod.errors;
      const stripeTokenResponse = await this.paymentMethod.item.stripe.stripe.createToken(
        this.paymentMethod.item.stripe.card
      );
      if (stripeTokenResponse.error) {
        this.paymentMethod.errors = [stripeTokenResponse.error];
        throw this.log._create(LogLevel.Error, ["cart", "finalizePaymentMethod", "error", "stripe", "error"], stripeTokenResponse.error);
      } else if (!stripeTokenResponse.token) {
        throw this.log._create(LogLevel.Error, ["cart", "finalizePaymentMethod", "error", "stripe", "token"]);
      }
      this.paymentMethod.stripe_token = stripeTokenResponse.token;
    }
  }
  /**
   *  Agree to a specific or default terms.
   *
   *  Rejecting terms is only possible for named terms with the second argument
   *
   *  ```ts
   *  const terms: { [key: string]: boolean } = cart.agreeToTerms();
   *  const terms: { [key: string]: boolean } = cart.agreeToTerms('default');
   *  const terms: { [key: string]: boolean } = cart.agreeToTerms('default', true);
   *  const terms: { [key: string]: boolean } = cart.agreeToTerms('default', false);
   *  ```
   *
   *  | Error                                    | Reason                                                                  |
   *  | :--------------------------------------- | :---------------------------------------------------------------------- |
   *  | [ShopError](shoperror.html)              | No or invalid terms id provided [ShopData](../interfaces/shopdata.html) |
   */
  // eslint-disable-next-line @typescript-eslint/require-await
  async agreeToTerms(termId = "default", agree = true) {
    if (typeof termId !== "string" || !Object.prototype.hasOwnProperty.call(this.terms, termId)) {
      throw this.log._create(LogLevel.Error, ["cart", "agreeToTerms", "error", "terms"], { termId, agree });
    }
    this.terms[termId] = [true, 1, "1", "true"].indexOf(agree) > -1;
    const action = agree ? TermsActions.Accept : TermsActions.Reject;
    this.emit(["terms", action, termId], this.terms);
    return this.terms;
  }
  /**
   *  Set the locale for the order.
   *
   *  This value will be send to the API.
   *  E.g.: tickets can be rendered using the correct locale.
   *
   *  ```ts
   *  cart.setLocale('en_GB');
   *  ```
   */
  setLocale(locale) {
    this.locale = locale;
    setValidationLang(locale);
    this._resetPriceFormatter();
    this.emit(["locale"], locale);
  }
  /**
   *  Update the price formatter
   *
   *  This method can be called when i.e. the locale changes
   */
  _resetPriceFormatter() {
    const tryLocales = [
      this.locale,
      this.locale.replace("_", "-"),
      this.locale.substr(0, 2),
      "en-GB"
    ];
    const localeStructures = Intl.NumberFormat.supportedLocalesOf(tryLocales.filter((locale) => {
      try {
        Intl.NumberFormat.supportedLocalesOf(locale);
        return true;
      } catch (e) {
        return false;
      }
    }));
    return this._priceFormatter = new Intl.NumberFormat(localeStructures, { style: "currency", currency: this._data.currency || "EUR" });
  }
  /**
   *  Set extra arbitrary data to add to the place order call
   */
  setTechData(techData) {
    this.techData = {
      ...this.techData,
      ...techData
    };
  }
  /**
   *  Enable server side order tracking
   *  (Off by default)
   */
  setOrderTracking(enabled = true) {
    this._enableOrderTracking = enabled;
  }
  /**
   * Set the booker information and metadata from the outside
   * @param data - the booker information
   */
  setBookerInformation(data) {
    if (data.firstname) {
      this.booker.firstname.value = data.firstname;
    }
    if (data.lastname) {
      this.booker.lastname.value = data.lastname;
    }
    if (data.email) {
      this.booker.email.value = data.email;
    }
    forEach$1(this.metadataList, (cartMetadata) => {
      const value = data[cartMetadata.item.name] || data[cartMetadata.item.auto_fill_facebook];
      if (value !== void 0 && value !== null) {
        cartMetadata.value = value;
      }
    });
  }
  /**
   *  Send the order to the API.
   *
   *  Before the request will be attempted, the cart structure and values will be validated.
   *  If validation fails, a ShopError will be thrown.
   *
   *  The cart content will then be formatted to the data format the API expects,
   *  before sending the order to the API.
   *
   *  ```ts
   *  const orderResponse: PlaceOrderResponse = await cart.placeOrder();
   *  ```
   *
   *  | Error                                    | Reason                                                          |
   *  | :--------------------------------------- | :-------------------------------------------------------------- |
   *  | [ShopError](shoperror.html)              | A validation failure is encountered                             |
   *  | [OrderApiError](orderapierror.html)      | The API rejects the data, some precondition or validation fails |
   *  | [ApiError](apierror.html)                | The API encountered an unexpected error                         |
   */
  async placeOrder() {
    try {
      const response = await this._placeOrder();
      this.emit(["order", "placed"], response);
      return response;
    } catch (error) {
      throw this.log._passThroughOrCreate(error, LogLevel.Fatal, ["cart", "placeOrder", "error", "failed"]);
    }
  }
  async _placeOrder() {
    if (this.checkout_details.busy) {
      throw this.log._create(LogLevel.Debug, ["cart", "placeOrder", "error", "busy"]);
    }
    const validation = this.validator.all();
    if (!validation.valid) {
      throw this.log._create(LogLevel.Warning, ["cart", "placeOrder", "error", "validation"], { errors: validation.errors });
    }
    const seatsOptions = this.seatsioInstance && this.seatsioInstance.holdToken ? { holdToken: this.seatsioInstance.holdToken } : void 0;
    const ticketOptions = Object.values(this.flatItems[CartItemChildType.Tickets]);
    const productOptions = Object.values(this.flatItems[CartItemChildType.Products]).filter(
      (cartProduct) => !cartProduct.childOf
    );
    const couponOptions = Object.values(this._coupons);
    const trackingInfo = this._config.trackingInfo || {};
    if (this._data.google_tag) {
      trackingInfo.google_tag = this._data.google_tag;
    } else {
      trackingInfo.google_tag = this._config.gtmCode;
    }
    const orderbuilderOptions = {
      // Required, static booker info
      booker: {
        bookerInfo: this.booker,
        locale: this.locale
      },
      // The tickets and global products
      // Tickets have nested products
      // Tickets and (global) products have nested metadata
      tickets: ticketOptions,
      products: productOptions,
      // Dynamic booker info / shop level metadata
      metaData: this.metadataList,
      // Shop level seats info (like hold token, used to verify/book the seats from the API)
      seats: seatsOptions,
      // Chosen payment method and needed info
      paymentMethod: this.paymentMethod,
      // Applied coupon(s), note: currently only one coupon supported.
      coupons: couponOptions,
      cartInitAt: this._initAt,
      extraTechData: this.techData,
      trackingInfo: this._enableOrderTracking ? trackingInfo : void 0
      // TODO Add techdata
      // TODO Add seats hold token to techdata
    };
    return this._orderbuilder.handle(orderbuilderOptions, this.log);
  }
  // noinspection JSUnusedGlobalSymbols
  /**
   *  Listener for changes on the checkout details
   */
  onCheckoutDetails(cb) {
    this.on(["checkout"], cb);
  }
  /**
   *  Remove any metadata no longer used by the global products in the cart.
   */
  _checkRemovedProductMetadata(metadataCollection) {
    const metadataRemove = {};
    forEach$1(metadataCollection, (metadata2) => {
      if (metadata2.item.applies_to !== MetadataAppliesTo.Person) {
        return;
      }
      metadataRemove[metadata2.guid] = metadata2;
    });
    forEach$1(this._data.booker_metadata, (metadata2) => {
      delete metadataRemove[metadata2.guid];
    });
    forOwn(this.flatItems[CartItemChildType.Products], (cartProduct) => {
      if (cartProduct.childOf) {
        return;
      }
      forEach$1(cartProduct.item.metadata, (metadata2) => {
        if (metadata2.item.applies_to !== MetadataAppliesTo.Person) {
          return;
        }
        delete metadataRemove[metadata2.guid];
      });
    });
    forOwn(metadataRemove, (metadata2, metadataId) => {
      delete this.metadata[metadataId];
      const listIndex = this.metadataList.findIndex(
        (cartMetadata) => cartMetadata.item.guid === metadata2.guid
      );
      if (listIndex > -1) {
        this.metadataList.splice(listIndex, 1);
      }
    });
  }
  /**
   *  Update the reservation interval
   *
   *  This creates an interval if one does not exist yet and there are items in the cart.
   *  This clears the interval if one already exists and there are no items in the cart (anymore).
   *
   *  This method can be called with a cart item id that will be ignored (e.g. an item that will be removed).
   *  However note that right now this does not ignore it's child items.
   *
   *  When setting a new interval,
   *  the expiration date is set and the interval is started to update every 100ms.
   *  The interval updates depending on the current time,
   *  so it won't fluctuate depending on interval trigger rates of the client.
   *  The interval is therefore triggered every 100 milliseconds to ensure the reservation time is not jittery.
   */
  _updateReservationTimer(removingCartItemId) {
    const hasTickets = Object.keys(this.flatItems.tickets).filter(
      (cartItemId) => cartItemId !== removingCartItemId
    ).length > 0;
    const hasProducts = Object.keys(this.flatItems.products).filter(
      (cartItemId) => cartItemId !== removingCartItemId
    ).length > 0;
    const hasItems = hasTickets || hasProducts;
    const reservationTickerHandle = this._reservationTicker;
    const reservationTimeMs = this._reservationTime * 6e4;
    if (hasItems && this._reservationTime && !reservationTickerHandle) {
      this.reservationExpiration.date = new Date(Date.now() + reservationTimeMs);
      this._updateRelativeReservationExpirationValues();
      this._reservationTicker = window.setInterval(this._updateRelativeReservationExpirationValues.bind(this), 100);
      window.clearInterval(reservationTickerHandle);
      this.emit(["timer", "start"], this.reservationExpiration, true);
    } else if (reservationTickerHandle && !hasItems) {
      const isTimeout = typeof this.reservationExpiration.secondsRemaining === "number" && this.reservationExpiration.secondsRemaining <= 0;
      this.reservationExpiration.date = null;
      this.reservationExpiration.secondsRemaining = null;
      this._reservationTicker = void 0;
      window.clearInterval(reservationTickerHandle);
      this.emit(["timer", "clear"], {
        ...this.reservationExpiration,
        timeout: isTimeout
      }, true);
    }
  }
  /**
   *  Update the relative reservation expiration value
   *
   *  This is mostly called by the reservation interval (every 100 milliseconds)
   *
   *  The seconds remaining value is updates depending on the current time,
   *  so it won't fluctuate depending on interval trigger rates of the client.
   *  When the seconds remaining value hits zero, the interval (if it exists) is cleared,
   *  the values reset and all cart items removed (reservations released).
   */
  _updateRelativeReservationExpirationValues() {
    if (!this.reservationExpiration.date) {
      throw slugError("Invalid reservation expiration date value", ["cart", "_updateRelativeReservationExpirationValues", "error", "date"]);
    }
    this.reservationExpiration.secondsRemaining = Math.max(
      0,
      Math.floor((this.reservationExpiration.date.getTime() - Date.now()) / 1e3)
    );
    this.emit(["timer", "tick"], this.reservationExpiration, true);
    if (this.reservationExpiration.secondsRemaining < 1) {
      void this.removeAllItems();
      this._updateReservationTimer();
    }
  }
  /**
   *  Used to get the cart items to which a specific forwarded coupon
   *  applies, making use of the coupon logic.
   *
   *  @return a sorted Array of items on which the forwarded coupon
   *  applies, descending from the most expensive
   */
  _getCouponApplicableItems(coupon) {
    const getTicketOfCartProduct = (cartProduct) => cartProduct.childOf ? this.flatItems.tickets[cartProduct.childOf] : void 0;
    return Coupon.getApplicableItems(
      coupon,
      this.flatItems.products,
      getTicketOfCartProduct
    );
  }
  /**
   *
   *  Used for adding or removing the discount of a coupon on all applicable
   *  items, taking the applies_to_count and amount_override into account.
   *
   *  @return The affected coupon applicable items.
   *
   */
  _couponDiscounts(action, coupon) {
    const affectedApplicableItems = [];
    if (!coupon) {
      return [];
    }
    if (!enumIncludes(CouponType, coupon.item.coupon.type)) {
      throw new ShopError(`Cannot ${action} coupon -> Unknown coupon type: ${coupon.item.coupon.type}`);
    }
    if (!coupon.appliesTo.cart.length) {
      return [];
    }
    if (action === CouponAction.Add && coupon.appliedCount === coupon.item.applies_to_count || action === CouponAction.Update && coupon.appliedCount === coupon.item.applies_to_count || action === CouponAction.Remove && coupon.appliedCount === 0) {
      return [];
    }
    forEach$1(coupon.appliesTo.cart, (couponApplicable) => {
      Coupon.applyDiscount(
        coupon,
        action,
        couponApplicable
      );
      affectedApplicableItems.push(couponApplicable);
      return action === CouponAction.Remove ? !(coupon.appliedCount === 0) : !(coupon.appliedCount === coupon.item.applies_to_count);
    });
    return affectedApplicableItems;
  }
  /**
   *  Used to check if a coupon was applied on a product that got removed,
   *  making sure to lower the applied count and the spend amount of the
   *  coupon if so - keeping the stats of an applied coupon up to date.
   */
  _checkRemovedProductCoupons(cartProduct) {
    forOwn(cartProduct.pricing.coupons, (delta, guid) => {
      this._coupons[guid].appliedCount--;
      this._coupons[guid].appliedCounts[cartProduct.item.pricing.base_price] = this._coupons[guid].appliedCounts[cartProduct.item.pricing.base_price] || 0;
      this._coupons[guid].appliedCounts[cartProduct.item.pricing.base_price]--;
      this._coupons[guid].spend -= delta;
    });
  }
  /**
   *
   *  Used to make sure the discount of a coupon has been distributed correctly
   *  among the coupon applicable products, making sure it's still correct
   *  when a product got added or removed.
   *
   *  (!) The re-computation of the prices is invoked in the _itemsUpdated()
   *  method, because it should have invoked this method for every applied
   *  coupon before recomputing the prices.
   *
   *  It returns the updated models,
   *  so the _itemsUpdated() method can emit events AFTER recomputing prices.
   *
   */
  _checkCouponDiscounts(coupon) {
    coupon.appliesTo.cart = this._getCouponApplicableItems(coupon.item);
    const cartItemsUpdated = {
      tickets: {},
      products: {}
    };
    const collectUpdatedItems = (couponApplicable) => {
      if (couponApplicable.ticket) {
        cartItemsUpdated.tickets[couponApplicable.ticket.item.guid] = couponApplicable.ticket.item;
      } else {
        cartItemsUpdated.products[couponApplicable.product.item.guid] = couponApplicable.product.item;
      }
    };
    const appliesToShouldBeRemoved = coupon.appliesTo.cart.slice(
      coupon.item.coupon.type === CouponType.Cheque ? 0 : coupon.item.applies_to_count
    );
    const appliesToShouldBeAdded = coupon.appliesTo.cart.slice(0, coupon.item.applies_to_count);
    forEach$1(appliesToShouldBeRemoved, (couponApplicable) => {
      const applied = typeof couponApplicable.product.pricing.coupons[coupon.item.guid] === "number";
      if (applied) {
        Coupon.applyDiscount(
          coupon,
          CouponAction.Remove,
          couponApplicable
        );
        collectUpdatedItems(couponApplicable);
      }
    });
    forEach$1(appliesToShouldBeAdded, (couponApplicable) => {
      const applied = typeof couponApplicable.product.pricing.coupons[coupon.item.guid] === "number";
      if (!applied) {
        Coupon.applyDiscount(
          coupon,
          CouponAction.Add,
          couponApplicable
        );
        collectUpdatedItems(couponApplicable);
      }
    });
    this._shop._updateCouponDiscounts(CouponAction.Update, coupon);
    this.emit(["coupon", CouponAction.Update, coupon.item.code], this._cartEventCouponResponse(coupon));
    return cartItemsUpdated;
  }
  /**
   *  Used to reset an applied coupon; resetting his applied count and
   *  amount spend and recomputing the applicable items for the cart.
   */
  _resetCoupon(coupon) {
    coupon.appliedCount = 0;
    coupon.appliedCounts = {};
    coupon.spend = 0;
    coupon.appliesTo.cart = this._getCouponApplicableItems(coupon.item);
  }
  /**
   *  Used to notify the cart if an action (adding a ticket, adding a product) started or ended,
   *  so the checkout details / cart can become pending while actions are pending and we
   *  can block the place order call if actions are pending.
   */
  _action(action) {
    this._pendingActions += action === CartAction.Start ? 1 : -1;
    this.checkout_details.busy = this._pendingActions > 0;
    this._emitCheckoutDetails();
  }
  /**
   *  Invoked every time the items in the cart updated. It
   *  updates the reservation timer accordingly, checks the
   *  coupons, recomputes the pricing of all items in the cart
   *  and builds and emits the checkout details.
   */
  _itemsUpdated() {
    this._updateReservationTimer();
    const updatedCartItems = {
      tickets: {},
      products: {}
    };
    forOwn(this._coupons, (coupon) => {
      const { tickets: tickets22, products: products2 } = this._checkCouponDiscounts(coupon);
      updatedCartItems.tickets = { ...updatedCartItems.tickets, ...tickets22 };
      updatedCartItems.products = { ...updatedCartItems.products, ...products2 };
    });
    const { tickets: tickets2, products } = this._doneUpdatingItems();
    updatedCartItems.tickets = { ...updatedCartItems.tickets, ...tickets2 };
    updatedCartItems.products = { ...updatedCartItems.products, ...products };
    forOwn(updatedCartItems.tickets, (ticket2, guid) => {
      if (!this.items[ticket2.event_id] || !this.items[ticket2.event_id][CartItemChildType.Tickets].map[guid]) {
        return;
      }
      this.emit(["ticket", guid, "update"], this._cartEventItemResponse(
        ticket2,
        Object.values(this.items[ticket2.event_id][CartItemChildType.Tickets].map[guid]),
        CartItemChildType.Tickets
      ));
    });
    forOwn(updatedCartItems.products, (product, guid) => {
      const collection = this.items[product.event_id] ? this.items[product.event_id][CartItemChildType.Products] : this.orphanedGlobalProducts;
      if (!collection.map[guid]) {
        return;
      }
      this.emit(["product", guid, "update"], this._cartEventItemResponse(
        product,
        Object.values(collection.map[guid]),
        CartItemChildType.Products
      ));
    });
  }
  /**
   *  Used to compute the actual (new) pricing of products and tickets in the cart when
   *  the updating of items is done taking any applied coupons into account, as discounts
   *  are applied to the pricing object of the item immediately.
   */
  _doneUpdatingItems() {
    const getProductsOfTicket = (cartTicket) => cartTicket.products.collection;
    const updated = Price.computeItemsPricing(
      this.flatItems.products,
      this.flatItems.tickets,
      getProductsOfTicket
    );
    this._computeCheckoutDetails();
    const cartItemsUpdated = {
      tickets: {},
      products: {}
    };
    forEach$1(updated.tickets, (ticket2) => {
      cartItemsUpdated.tickets[ticket2.item.guid] = ticket2.item;
    });
    forEach$1(updated.products, (product) => {
      cartItemsUpdated.products[product.item.guid] = product.item;
    });
    return cartItemsUpdated;
  }
  /**
   *  Used to compute the checkout details of the cart based
   *  on his current items, taking tickets and both regular
   *  as container products into account.
   */
  _computeCheckoutDetails() {
    const checkoutDetails = {
      vats: {
        percentages: {},
        total: 0
      },
      subtotal_price: 0,
      payment_method_fee: 0,
      order_fee: {
        fixed: 0,
        percentage: 0,
        total: 0
      },
      booking_fee: {
        fixed: 0,
        percentage: 0,
        total: 0
      },
      transaction_fee: {
        fixed: 0,
        percentage: 0,
        total: 0
      },
      total_price: 0,
      // Actual pending is being set below to prevent race conditions
      busy: true
    };
    const containerProducts = [];
    forOwn(this.flatItems.tickets, (cartTicket) => {
      checkoutDetails.total_price += cartTicket.pricing.total_price;
      checkoutDetails.subtotal_price += cartTicket.pricing.subtotal_price;
      forOwn(cartTicket.pricing.including_vats.percentages, (amount, percentage) => {
        Price.updateVATCollection(
          VATUpdateAction.Add,
          checkoutDetails.vats,
          percentage,
          amount
        );
      });
    });
    forOwn(this.flatItems.products, (cartProduct) => {
      if (cartProduct.childOf !== void 0) {
        return;
      }
      if (cartProduct.item.pricing_method === PricingMethod.Container) {
        containerProducts.push(cartProduct);
        return;
      }
      checkoutDetails.total_price += cartProduct.pricing.total_price;
      checkoutDetails.subtotal_price += cartProduct.pricing.subtotal_price;
      Price.updateVATCollection(
        VATUpdateAction.Add,
        checkoutDetails.vats,
        cartProduct.pricing.vat.percentage,
        cartProduct.pricing.vat.amount
      );
    });
    if (containerProducts.length) {
      const originalOrderPrice = checkoutDetails.total_price;
      forEach$1(containerProducts, (cartProduct) => {
        Price.computeProductPricing(cartProduct.pricing, originalOrderPrice);
        checkoutDetails.total_price += cartProduct.pricing.total_price;
        checkoutDetails.subtotal_price += cartProduct.pricing.subtotal_price;
        Price.updateVATCollection(
          VATUpdateAction.Add,
          checkoutDetails.vats,
          cartProduct.pricing.vat.percentage,
          cartProduct.pricing.vat.amount
        );
      });
    }
    this._computePaymentMethodFees(checkoutDetails);
    if (checkoutDetails.total_price > 0 && this.paymentMethod) {
      checkoutDetails.payment_method_fee = this.paymentMethod.item.pricing.total_fees;
      checkoutDetails.total_price += checkoutDetails.payment_method_fee;
      checkoutDetails.order_fee.fixed = this.paymentMethod.item.pricing.fees.fixed;
      checkoutDetails.order_fee.percentage = this.paymentMethod.item.pricing.fees.percentage;
      checkoutDetails.order_fee.total = checkoutDetails.payment_method_fee;
      checkoutDetails.booking_fee.fixed = (this.paymentMethod.item.pricing.fees.generic || {}).fixed || 0;
      checkoutDetails.booking_fee.percentage = (this.paymentMethod.item.pricing.fees.generic || {}).percentage || 0;
      checkoutDetails.booking_fee.total = this.paymentMethod.item.pricing.generic_total;
      if (this.paymentMethod.item.allSpecificFeesEqual) {
        checkoutDetails.booking_fee.fixed += (this.paymentMethod.item.pricing.fees.specific || {}).fixed || 0;
        checkoutDetails.booking_fee.percentage += (this.paymentMethod.item.pricing.fees.specific || {}).percentage || 0;
        checkoutDetails.booking_fee.total += this.paymentMethod.item.pricing.specific_total;
        checkoutDetails.transaction_fee.fixed = 0;
        checkoutDetails.transaction_fee.percentage = 0;
        checkoutDetails.transaction_fee.total = 0;
      } else {
        checkoutDetails.transaction_fee.fixed = (this.paymentMethod.item.pricing.fees.specific || {}).fixed || 0;
        checkoutDetails.transaction_fee.percentage = (this.paymentMethod.item.pricing.fees.specific || {}).percentage || 0;
        checkoutDetails.transaction_fee.total = this.paymentMethod.item.pricing.specific_total;
      }
    }
    this.checkout_details.vats.percentages = checkoutDetails.vats.percentages;
    this.checkout_details.vats.total = checkoutDetails.vats.total;
    this.checkout_details.payment_method_fee = checkoutDetails.payment_method_fee;
    this.checkout_details.order_fee.fixed = checkoutDetails.order_fee.fixed;
    this.checkout_details.order_fee.percentage = checkoutDetails.order_fee.percentage;
    this.checkout_details.order_fee.total = checkoutDetails.order_fee.total;
    this.checkout_details.booking_fee.fixed = checkoutDetails.booking_fee.fixed;
    this.checkout_details.booking_fee.percentage = checkoutDetails.booking_fee.percentage;
    this.checkout_details.booking_fee.total = checkoutDetails.booking_fee.total;
    this.checkout_details.transaction_fee.fixed = checkoutDetails.transaction_fee.fixed;
    this.checkout_details.transaction_fee.percentage = checkoutDetails.transaction_fee.percentage;
    this.checkout_details.transaction_fee.total = checkoutDetails.transaction_fee.total;
    this.checkout_details.subtotal_price = checkoutDetails.subtotal_price;
    this.checkout_details.total_price = checkoutDetails.total_price;
    this.checkout_details.busy = this._pendingActions > 0;
  }
  /**
   *  Computes the total fees, based on the current total price
   *  of the order, for every available payment method fee.
   */
  _computePaymentMethodFees(checkoutDetails) {
    for (const paymentMethod of this._data.payment_methods) {
      paymentMethod.pricing.total_fees = 0;
      paymentMethod.pricing.generic_total = 0;
      paymentMethod.pricing.specific_total = 0;
      if (checkoutDetails.total_price === 0) {
        continue;
      }
      paymentMethod.pricing.total_fees += paymentMethod.pricing.fees.fixed;
      paymentMethod.pricing.total_fees += round(
        checkoutDetails.total_price * paymentMethod.pricing.fees.percentage / 100
      );
      if (paymentMethod.pricing.fees.generic) {
        paymentMethod.pricing.generic_total += paymentMethod.pricing.fees.generic.fixed;
        paymentMethod.pricing.generic_total += round(
          checkoutDetails.total_price * paymentMethod.pricing.fees.generic.percentage / 100
        );
      }
      if (paymentMethod.pricing.fees.specific) {
        if (paymentMethod.allSpecificFeesEqual) {
          paymentMethod.pricing.generic_total += paymentMethod.pricing.fees.specific.fixed;
          paymentMethod.pricing.generic_total += round(
            checkoutDetails.total_price * paymentMethod.pricing.fees.specific.percentage / 100
          );
        } else {
          paymentMethod.pricing.specific_total += paymentMethod.pricing.fees.specific.fixed;
          paymentMethod.pricing.specific_total += round(
            checkoutDetails.total_price * paymentMethod.pricing.fees.specific.percentage / 100
          );
        }
      }
    }
  }
  /**
   *  Emit the checkout details
   *  (i) Emit the value instead of the ref to prevent race conditions
   */
  _emitCheckoutDetails() {
    this.emit("checkout", JSON.parse(JSON.stringify(this.checkout_details)));
  }
  /**
   *  Format a price in cents to the correct currency format
   */
  _formatPrice(cents) {
    if (typeof cents !== "number") {
      cents = Number.parseFloat(cents);
    }
    if (Number.isNaN(cents)) {
      return "???";
    }
    return this._priceFormatter.format(cents / 100);
  }
  /**
   *  Register the on unload event handlers, so reservations CAN be released on window close.
   */
  _registerOnUnload() {
    window.addEventListener("unload", this._unloadHandler.bind(this));
  }
  /**
   *  Handler method factory for onunload event. The returned handler will try to release any reservations when
   *  closing the window.
   *
   *  Note: There is no fail-proof way to do this, as browser implementations
   *  do not always allow processes to finish after DOM unload.
   *  However, the this method uses the FETCH API with keepalive,
   *  which SHOULD in theory allow the request to exist without its parent
   *  or anything waiting for its response.
   */
  _unloadHandler() {
    if (!window.fetch) {
      return;
    }
    const releaseCbFactory = (type) => (cartItem) => {
      if (cartItem.childOf) {
        return;
      }
      void this._reservator.releaseOnUnload(type, cartItem.item.guid, cartItem.reservation.reservation);
    };
    forOwn(this.flatItems.tickets, releaseCbFactory(ReservationType.Ticket));
    forOwn(this.flatItems.products, releaseCbFactory(ReservationType.Product));
  }
}
function factoryBookerCartMetadata(emailValidationRule) {
  const emailValidationRules = ["required", "email"];
  if (emailValidationRule) {
    emailValidationRules.push(emailValidationRule);
  }
  return {
    firstname: {
      item: {
        name: "first_name",
        extra: ["required"],
        type: MetadataType.String,
        auto_fill_facebook: "first_name",
        translateName: "shop.common.metaData.first_name",
        translatable: true
      },
      value: null,
      errors: [],
      index: -3
    },
    lastname: {
      item: {
        name: "last_name",
        extra: ["required"],
        type: MetadataType.String,
        auto_fill_facebook: "last_name",
        translateName: "shop.common.metaData.last_name",
        translatable: true
      },
      value: null,
      errors: [],
      index: -2
    },
    email: {
      item: {
        name: "email",
        extra: emailValidationRules,
        type: MetadataType.String,
        auto_fill_facebook: "email",
        translateName: "shop.common.metaData.email",
        translatable: true
      },
      value: null,
      errors: [],
      index: -1
    }
  };
}
function calculateTicketDiff(currentTicketCount, min, increment, direction = 1) {
  let diffToNext;
  if (direction > 0) {
    const quotient = Math.floor(currentTicketCount / increment);
    const next = (quotient + 1) * increment;
    diffToNext = next - currentTicketCount;
    if (next < min) {
      const tooLow = min - next;
      const tooLowQuotient = Math.ceil(tooLow / increment);
      diffToNext += tooLowQuotient * increment;
    }
  } else {
    const quotient = Math.ceil(currentTicketCount / increment);
    diffToNext = currentTicketCount - (quotient - 1) * increment;
    if (currentTicketCount - diffToNext < min) {
      diffToNext = currentTicketCount;
    }
  }
  return diffToNext;
}
function filterPartialTypeList(inArray, propertiesToCheck, onFilteredOut) {
  if (!Array.isArray(inArray)) {
    return [];
  }
  const filteredOutItems = [];
  const filteredArray = inArray.filter(
    (objectToGuard) => {
      const isMatch = Object.entries(propertiesToCheck).every(
        // eslint-disable-next-line valid-typeof
        ([key, value]) => hasAttribute(objectToGuard, key) && typeof objectToGuard[key] === value
      );
      if (!isMatch) {
        filteredOutItems.push(objectToGuard);
      }
      return isMatch;
    }
  );
  if (onFilteredOut && filteredOutItems.length > 0) {
    onFilteredOut(filteredOutItems);
  }
  return filteredArray;
}
function filterPartialTypeMap(inMap, propertiesToCheck, onFilteredOut) {
  if (!isRecord(inMap)) {
    return {};
  }
  const filteredOutItems = {};
  const filteredMap = Object.fromEntries(Object.entries(inMap).filter(
    (entry) => {
      const [key, objectToGuard] = entry;
      const isMatch = !isRecord(objectToGuard) || hasExpectedProperties(objectToGuard, propertiesToCheck);
      if (!isMatch) {
        filteredOutItems[key] = objectToGuard;
      }
      return isMatch;
    }
  ));
  if (onFilteredOut && Object.keys(filteredOutItems).length > 0) {
    onFilteredOut(filteredOutItems);
  }
  return filteredMap;
}
class OpenTicketShop extends libExports.EventScope {
  /**
   *  Constructing a new instance creates an uninitialized *(empty)* instance
   */
  constructor(config) {
    super(new EventBus());
    /**
     * Used by EventScope to determine event bus prefix
     */
    __publicField(this, "_eventScope", "shop");
    /**
     *
     *  Promise that reflects the initialized state of the shop. It allows you
     *  to let multiple scripts await the initialization of a single shop.
     *
     *  ```ts
     *  const shop: OpenTicketShop = new OpenTicketShop();
     *
     *  const config: ShopConfig = {
     *      guid: '36a8e380-d09b-11e9-be79-49649df1d206',
     *  };
     *
     *  // Await the initialization of the shop
     *  shop.initialized.then(() => {
     *
     *      console.info('Shop initialized');
     *
     *  }).catch((error) => {
     *
     *      console.warn('Error while initializing:', error);
     *
     *  });
     *
     *  // Initialize the shop
     *  shop.init(config);
     *  ```
     *
     *  | Settle   | Resolve value                                            |
     *  | :------- | :------------------------------------------------------- |
     *  | Resolve  | `Boolean`                                                |
     *  | Reject   | [ShopError](shoperror.html) or [ApiError](apierror.html) |
     *
     *  @category State
     *
     */
    __publicField(this, "initialized");
    /**
     *  Boolean that reflects the initialized state of the class.
     *  @category State
     */
    __publicField(this, "is_initialized", false);
    /**
     *  Boolean that refrects the initializing state of the class
     *  @category State
     */
    __publicField(this, "state", State.Start);
    /**
     *  Boolean that reflects the loading state of the class. It
     *  is loading while setting data, both on initialization as
     *  on overwriting or updating data
     *  @category State
     */
    __publicField(this, "loading", true);
    // Used to resolve or reject the exposed initialized promise
    __publicField(this, "_resolveInit");
    __publicField(this, "_rejectInit");
    /**
     * The notification manager, translates events into notifications
     */
    __publicField(this, "notifications");
    /**
     *  Takes care of all logging functionality
     */
    __publicField(this, "log");
    /**
     *  Contains the errors or missing data after initialization
     */
    __publicField(this, "initErrors", []);
    /**
     *  Containing all the data of the shop, based on the [ShopData](../interfaces/shopdata.html) interface.
     *  @category Data
     */
    // The object below should be sorted but it has some grouped logic with comments, this should be refactored out
    /* eslint-disable sort-keys */
    __publicField(this, "data", {
      guid: "",
      name: "",
      description: null,
      event_selection: null,
      google_tag: null,
      email_validation_rule: null,
      email_must_be_unique: null,
      company_terms: null,
      css: null,
      facebook_auto_attend: null,
      facebook_page_url: null,
      seats_allow_orphan: null,
      greedy_date_selection: null,
      seats_public_key: null,
      reservation_time: null,
      currency: null,
      global_terms: null,
      shop_options: {
        validate: null,
        report: null,
        pdf: null,
        reservations: null,
        payment: null,
        callback: null,
        insert: null,
        return: null,
        receipt: null,
        allow_user_return: null,
        arbitrary: null,
        allow_order_return: null,
        to_zero: null,
        skip_metadata_validation: null,
        send_email: null,
        late_personalization: null
      },
      // Transformed model maps
      collapses_map: {},
      events_map: {},
      event_dates_map: {},
      groups_map: {},
      metadata_map: {},
      payment_methods_map: {},
      products_map: {},
      tickets_map: {},
      // Sorted model representation collections, holding
      // sorted refs to their maps collection
      collapses: [],
      events: [],
      event_dates: [],
      groups: [],
      payment_methods: [],
      tickets: [],
      // Global data
      booker_metadata: [],
      global_products: [],
      // Branding
      branding: {
        dashboard_terms: null,
        guid: null,
        locale: null,
        name: null,
        shop_privacy_policy: null,
        shop_terms: null,
        website: null
      },
      // Company
      company: {
        country: null,
        guid: null,
        locale: null,
        name: null,
        coc_name: null,
        seats_allow_orphan: null,
        seats_public_key: null,
        timezone: null,
        website: null
      },
      // The applied filter for the data
      filters: {},
      // Dates
      available_future_dates: [],
      available_future_dates_nested: {}
    });
    /* eslint-enable sort-keys */
    /**
     *
     *  Containing the state and logic for the cart, see [Cart](../interfaces/cart.html).
     *
     *  @category Cart
     *
     */
    __publicField(this, "cart");
    /**
     * For managing connections between frames
     */
    __publicField(this, "messaging");
    /**
     *  The shop can be put in debug mode.
     *
     *  This will result in less human friendly error messages.
     */
    __publicField(this, "_debugMode", false);
    /**
     *  The config that is created for the shop based on the provided config.
     */
    __publicField(this, "_config");
    /**
     *  Pivots from the shop data
     */
    __publicField(this, "_pivots");
    /**
     *  Holding the original shop data that should be loaded while setting data.
     */
    __publicField(this, "_shopDataToLoad", {});
    /**
     *  All model collections, used to build model collection Arrays when loading data.
     */
    __publicField(this, "_modelCollections", [
      "collapses",
      "events",
      "event_dates",
      "groups",
      "payment_methods",
      "tickets"
    ]);
    /**
     *  Contains the errors or missing data after initialization
     */
    __publicField(this, "_initErrors", {
      payment_methods: false,
      items: false
    });
    this.log = new Logger(this._eventBus, config);
    this._pivots = new Pivot(this.log);
    this.notifications = new OpenTicketBaseNotifications(this);
    this.initialized = new Promise((resolve, reject) => {
      this._resolveInit = resolve;
      this._rejectInit = reject;
    });
  }
  get events() {
    return this._eventBus;
  }
  /**
   *
   *  Async method to initialize an OpenTicketShop instance.
   *  It gets the data of the shop based on the provided shop guid,
   *  transforms it and exposes the data by binding the result to his public properties.
   *
   *  ```ts
   *  const shop: OpenTicketShop = new OpenTicketShop();
   *
   *  const config: ShopConfig = {
   *      baseUrl: 'https://api.myticketshop.nl',
   *      guid: '36a8e380-d09b-11e9-be79-49649df1d206',
   *  };
   *
   *  try {
   *
   *      await shop.init(config);
   *
   *      console.info('Initialized shop:', shop);
   *
   *  } catch (error) {
   *
   *      console.warn('An error occured:', error);
   *
   *  }
   *  ```
   *
   *  A filter can be added to limit the amount of shop data.
   *  E.g. for timeslot shops.
   *
   *  Alternatively the shopdata can be forwarded.
   *
   *  Note: filters and forwarded shopdata can not be used consecutively!
   *
   *  #### Possible errors
   *  Two different types of errors could be thrown while initializing a shop.
   *
   *  | Error                         | Reason                                                      |
   *  | :------------------------ --- | :---------------------------------------------------------- |
   *  | [ShopError](shoperror.html)   | No or invalid [ShopConfig](../interfaces/shopconfig.html)   |
   *  |                               | provided or the API returned invalid data                   |
   *  | [ApiError](apierror.html)     | The used API threw an error                                 |
   *
   *  @param config The [config](../interfaces/shopconfig.html) to use for the shop
   *  @param filter The [filter](../globals.html#shopfilter) to use for getting the shop data at
   *  initialisation (not the filter that got applied for retrieving the provided shop data)
   *  @param shopData The original shop data. Initializes the shop with this data instead
   *  of retrieving it out of the API.
   *
   */
  async init(config, filter2, shopData) {
    if (this.state === State.Ready) {
      throw this.log._create(LogLevel.Error, ["shop", "init", "error", "initialized"], {
        state: this.state,
        errors: this.initErrors
      });
    } else if (this.state !== State.Start) {
      throw this.log._create(LogLevel.Error, ["shop", "init", "error", "loading"], {
        state: this.state,
        errors: this.initErrors
      });
    }
    this.state = State.Initializing;
    this.log.setEntityId(config ? config.guid : "");
    if (config && config.guid) {
      this.log.addStaticValue("shop_id", config.guid);
    }
    try {
      if (ShopConfig.isInitializedShopConfig(config)) {
        this._config = config;
      } else {
        this._config = new ShopConfig(config);
      }
      if (this._config.logLevels) {
        this.log.setLoggingLevels(this._config.logLevels);
      }
      if (this._config.loggerUrl) {
        this.log.setLoggingUrl(this._config.loggerUrl);
      } else {
        this.log._create(LogLevel.Info, ["shop", "init", "logging", "no-external"]);
      }
      this.log.addStaticValue("shop_id", this._config.guid);
      this.log.addStaticValue("base_url", this._config.baseUrl);
      this._ensureFilterOrShopData(filter2, shopData);
      if (!shopData) {
        shopData = await this._getShopData();
      }
      await this._setData(shopData);
      if (window.self !== window.top) {
        this.messaging = new CrossWindowShop(window.parent, this);
      }
      const state = this._determineDataIntegrity();
      if (state === State.Ready) {
        await this._finishInit();
      } else {
        this.state = State.Waiting;
      }
    } catch (error) {
      this.state = State.Error;
      const initError = this.log._create(
        LogLevel.Fatal,
        ["shop", "init", "error", "fatal"],
        {
          state: this.state,
          errors: this.initErrors
        },
        null,
        error
      );
      this._rejectInit(initError);
      this.loading = false;
      return this.initialized;
    }
    if (this.state === State.Waiting) {
      const initError = this.log._create(
        LogLevel.Warning,
        ["shop", "init", "error", "waiting"],
        {
          state: this.state,
          errors: this.initErrors
        }
      );
      return Promise.reject(initError);
    }
    this.log._create(LogLevel.Info, ["shop", "init", "done"], {
      state: this.state,
      errors: this.initErrors
    });
    return this.initialized;
  }
  /**
   *  Listen to log events by providing a path and a callback to the `on` function
   *
   *  @param path - Path to listen to
   *  @param cb - Will be called when an error event occurs
   */
  onLog(path, cb) {
    if (typeof path === "string") {
      path = [path];
    }
    return this.on(["log", ...path], cb, true);
  }
  /**
   * Returns true if the library is loaded within an iframe and is connected to an OpenTicket CrossWindowClient
   */
  get isFramed() {
    return window.top !== window.self && this.messaging.isConnected;
  }
  /**
   * Send a notification to cross window client
   * @param notification
   */
  sendClientNotification(notification) {
    this.emit(["client-notification"], {
      _isOpenticket: true,
      action: "client-notification",
      ...notification
    }, true);
  }
  /**
   *  Used to overwrite the exposed shop data. Makes sure to cast the data in
   *  the models as it should be exposed, that the cart is being re-created
   *  and to set the original shop data to undefined.
   */
  async overwriteData(shopData) {
    if (!shopData) {
      throw this.log._create(LogLevel.Error, ["shop", "overwriteData", "error", "data"], {
        state: this.state,
        errors: this.initErrors
      });
    }
    if (this.state === State.Start) {
      throw this.log._create(LogLevel.Error, ["shop", "overwriteData", "error", "initialized"], {
        state: this.state,
        errors: this.initErrors
      });
    }
    if (this.state !== State.Waiting) {
      if (this.loading) {
        throw this.log._create(LogLevel.Error, ["shop", "overwriteData", "error", "loading"], {
          state: this.state,
          errors: this.initErrors
        });
      }
      if (this.state !== State.Ready) {
        throw this.log._create(LogLevel.Error, ["shop", "overwriteData", "error", "state"], {
          state: this.state,
          errors: this.initErrors
        });
      }
    }
    try {
      this.loading = true;
      this.state = this.state === State.Waiting ? State.Initializing : State.Loading;
      this.data = OpenTicketShop._castData(shopData);
      await this.cart.removeAllItems();
      this.cart = new Cart(this, this._config, this.log, this._eventBus);
      forEach$1(this._modelCollections, (name) => {
        this._setRepresentationCollection(name);
      });
      const state = this._determineDataIntegrity();
      if (this.state === State.Initializing && state === State.Ready) {
        await this._finishInit();
      } else {
        this.state = state;
      }
    } catch (error) {
      this.state = State.Error;
      const overwriteDataError = this.log._create(
        LogLevel.Fatal,
        ["shop", "overwriteData", "error", "fatal"],
        {
          state: this.state,
          errors: this.initErrors
        },
        null,
        error
      );
      this.loading = false;
      throw overwriteDataError;
    }
    if (this.state === State.Waiting) {
      this.log._create(LogLevel.Warning, ["shop", "overwriteData", "error", "waiting"], {
        state: this.state,
        errors: this.initErrors
      });
      return;
    }
    this.log._create(LogLevel.Info, ["shop", "overwriteData", "done"], {
      state: this.state,
      errors: this.initErrors
    });
    this.loading = this.state !== State.Ready;
  }
  /**
   *  Used to update the data based on a provided filter.
   */
  async updateData(filters) {
    if (!this.is_initialized) {
      throw this.log._create(LogLevel.Error, ["shop", "updateData", "error", "initialized"], {
        state: this.state,
        errors: this.initErrors
      });
    }
    if (!filters) {
      throw this.log._create(LogLevel.Error, ["shop", "updateData", "error", "filters"], {
        state: this.state,
        errors: this.initErrors
      });
    }
    if (this.loading) {
      throw this.log._create(LogLevel.Error, ["shop", "updateData", "error", "loading"], {
        state: this.state,
        errors: this.initErrors
      });
    }
    let data;
    try {
      this.loading = true;
      this.data.filters = { ...filters };
      data = await this._getShopData();
    } catch (error) {
      const updateDataError = this.log._create(
        LogLevel.Fatal,
        ["shop", "updateData", "error", "api"],
        {
          state: this.state,
          errors: this.initErrors
        },
        null,
        error
      );
      this.loading = false;
      throw updateDataError;
    }
    try {
      await this._setData(data);
      this.cart._shopDataUpdated();
      forOwn(this.cart.getAppliedCoupons(), (coupon) => {
        this._updateCouponDiscounts(CouponAction.Update, coupon);
      });
      await this._initPaymentMethods();
    } catch (error) {
      this.state = State.Error;
      const overwriteDataError = this.log._create(
        LogLevel.Fatal,
        ["shop", "overwriteData", "error", "fatal"],
        {
          state: this.state,
          errors: this.initErrors
        },
        null,
        error
      );
      this.loading = false;
      throw overwriteDataError;
    }
    this.emit(["update"], {
      name: this.data.name,
      filters: filters || null
    });
    this.log._create(LogLevel.Info, ["shop", "updateData", "done"], {
      state: this.state,
      errors: this.initErrors
    });
    this.loading = false;
    return true;
  }
  /**
   *  Used to invoke a refresh of the data: getting the newest data out of the API.
   */
  async refreshData() {
    return this.updateData(this.data.filters);
  }
  /**
   * Check the queue (gatekeeper) endpoint to validate if the users' setup is valid, not blacklisted and able to do api calls
   * returns true if so, false if not.
   */
  async isQueuedProperly() {
    try {
      const response = await this._config.httpClient.get(this._config.getNoCacheUrl(`gatekeeper/${this.data.guid}`));
      if (response && (response.status === 200 || response.status === 204)) {
        return Promise.resolve(true);
      }
      this.log._create(
        LogLevel.Warning,
        ["shop", "check-queue", "failed"],
        { status: response.status }
      );
      return Promise.resolve(false);
    } catch (error) {
      if (errorHasResponseStatus(error)) {
        if (error.response.status === 403) {
          this.log._create(
            LogLevel.Info,
            ["shop", "check-queue", "blocked"],
            { status: error.response.status },
            null,
            error
          );
          return Promise.resolve(false);
        }
        this.log._create(
          LogLevel.Warning,
          ["shop", "check-queue", "unknown-response"],
          { status: error.response.status },
          null,
          error
        );
      } else {
        this.log._create(
          LogLevel.Warning,
          ["shop", "check-queue", "unknown-error"],
          {},
          null,
          error
        );
      }
    }
    return Promise.resolve(true);
  }
  /**
   *  Used to update the coupon discounts when the coupons change in
   *  the cart. Invoked by the cart event listener that got initialised
   *  in the init method.
   *
   *  @internal: Is and should only be used by the cart to update
   *  the discounts of applied coupons AND on update of the data of the shop.
   */
  _updateCouponDiscounts(action, coupon) {
    coupon.appliesTo.shop = this._calculateCouponApplicableItems(coupon);
    const eventsToCheckForHidden = {};
    forEach$1(coupon.appliesTo.shop, (couponApplicable) => {
      if (!couponApplicable.ticket) {
        if (coupon.appliedCount >= coupon.item.applies_to_count) {
          return;
        }
        const delta = Coupon.applyDiscount(coupon, action, couponApplicable);
        if (delta !== 0) {
          this.emit(["product", couponApplicable.product.guid, "update"], {});
        }
        return;
      }
      if (couponApplicable.ticket.hide_without_coupon) {
        couponApplicable.ticket.hidden = this._determineTicketHidden(couponApplicable.ticket, action === CouponAction.Remove ? void 0 : couponApplicable);
        eventsToCheckForHidden[couponApplicable.ticket.event_id] = null;
      }
      const ticketPricing = couponApplicable.ticket.pricing;
      if (!couponApplicable.product.is_optional) {
        ticketPricing.coupons[coupon.item.guid] = ticketPricing.coupons[coupon.item.guid] || 0;
        ticketPricing.coupons_count[coupon.item.guid] = ticketPricing.coupons_count[coupon.item.guid] || 0;
      }
      const actions = action === CouponAction.Update ? [CouponAction.Remove, CouponAction.Add] : [action];
      const beforeBasePrice = couponApplicable.product.pricing.base_price;
      for (const couponAction of actions) {
        const appliedInTicketCount = ticketPricing.coupons_count[coupon.item.guid] || 0;
        let openSlotsCount = coupon.item.applies_to_count;
        for (const cents in coupon.appliedCounts) {
          try {
            if (Number.parseInt(cents, 10) >= couponApplicable.product_original_pricing.base_price) {
              openSlotsCount -= coupon.appliedCounts[cents] || 0;
            }
          } catch (e) {
          }
        }
        if (couponAction === CouponAction.Add && appliedInTicketCount >= openSlotsCount || couponAction === CouponAction.Remove && !appliedInTicketCount && !couponApplicable.product.is_optional) {
          continue;
        }
        const delta = Coupon.applyDiscount(
          coupon,
          couponAction,
          couponApplicable
        );
        if (!couponApplicable.product.is_optional) {
          ticketPricing.coupons[coupon.item.guid] += delta;
          if (delta !== 0) {
            ticketPricing.coupons_count[coupon.item.guid] += couponAction === CouponAction.Remove ? -1 : 1;
          }
        }
      }
      if (beforeBasePrice !== couponApplicable.product.pricing.base_price) {
        this.emit(["ticket", couponApplicable.ticket.guid, "update"], {});
      }
      if (action === CouponAction.Remove) {
        if (ticketPricing.coupons[coupon.item.guid] === 0) {
          delete ticketPricing.coupons[coupon.item.guid];
        }
        if (ticketPricing.coupons_count[coupon.item.guid] === 0) {
          delete ticketPricing.coupons_count[coupon.item.guid];
        }
      }
    });
    forEach$1(Object.getOwnPropertyNames(eventsToCheckForHidden), (eventId) => {
      const event2 = this.data.events_map[eventId];
      event2.hidden = this._determineEventHidden(event2, true);
    });
    const getProductsOfTicket = (ticket2) => ticket2.products.all;
    Price.computeItemsPricing(
      this.data.products_map,
      this.data.tickets_map,
      getProductsOfTicket,
      IGNORE_OPTIONAL
    );
  }
  /**
   *  Set the shop to debug mode.
   *
   *  Errors will now be more clear and less user friendly!
   *
   *  @param value Whether or not to set the shop to debug mode
   */
  setDebugMode(value) {
    this._debugMode = value;
  }
  /**
   * Set the tracking info to be sent with an order
   * @param trackingInfo
   */
  setOrderTrackingInfo(trackingInfo) {
    this._config.setTrackingInfo(trackingInfo);
  }
  /**
   *  Filters and forwarded shopdata can not be used together.
   *  The filter is used for retrieving filtered shop data,
   *  When shop data is forwarded in the init call,
   *  this should already contain the filter used.
   *
   *  @param filters The [filter](../globals.html#shopfilter) to use for getting the shop data at
   *  initialisation (not the filter that got applied for retrieving the provided shop data)
   *  @param shopData The original shop data. Initializes the shop with this data instead
   *  of retrieving it out of the API.
   */
  _ensureFilterOrShopData(filters, shopData) {
    if (filters && shopData) {
      throw this.log._create(LogLevel.Fatal, ["shop", "data", "error", "exclusive", "filterdata"]);
    }
    if (filters) {
      this.data.filters = { ...filters };
    } else {
      this.data.filters = shopData && hasAttribute(shopData, "filters") && typeof shopData.filters === "object" ? { ...shopData.filters } : {};
    }
  }
  /**
   *  The init process' final steps.
   *
   *  This method is separated from the init call,
   *  because the init process can be suspended,
   *  if data is incomplete.
   */
  async _finishInit() {
    await this._initPaymentMethods();
    this.cart = new Cart(this, this._config, this.log, this._eventBus);
    this.is_initialized = true;
    this.state = State.Ready;
    this._resolveInit(true);
    this.loading = false;
    this.emit(["init"], {
      name: this.data.name,
      filters: this.data.filters || null
    });
  }
  /**
   *  Used to cast the needed data of the models in the forwarded data.
   */
  static _castData(shopData) {
    Model.castData.ofEvents(shopData.events_map);
    Model.castData.ofEventDates(shopData.event_dates_map);
    Model.castData.ofTickets(shopData.tickets_map);
    return shopData;
  }
  /**
   *  Used for getting the data of the shop via the configured HTTP client.
   */
  async _getShopData() {
    const url = this._config.getNoCacheUrl(`${this._config.guid}/data`, this.data.filters);
    try {
      const shop = await this._config.httpClient.get(url);
      if (hasAttribute(shop, "data") && (!hasAttribute(shop.data, "filters") || hasAttribute(shop.data, "filters") && !shop.data.filters)) {
        shop.data.filters = { ...this.data.filters || {} };
      }
      return shop.data;
    } catch (error) {
      if (errorHasResponseStatus(error) && error.response.status === 404) {
        throw this.log._create(LogLevel.Fatal, ["shop", "data", "error", "notfound"], {}, null, error);
      }
      throw this.log._create(LogLevel.Fatal, ["shop", "data", "error", "retrieval", "failed"], {}, null, error);
    }
  }
  /**
   *
   *  Used for setting original data and transforming that
   *  data to something we want to expose to the client.
   *
   *  (i) Which is exposed by binding it to this instance
   *
   */
  async _setData(shopData) {
    if (!shopData || !Object.keys(shopData).filter((key) => key !== "filters").length || !isRecord(shopData)) {
      throw this.log._create(LogLevel.Fatal, ["shop", "data", "error", "missing", "data"]);
    }
    if (!hasAttribute(shopData, "shops") || !Array.isArray(shopData.shops) || !shopData.shops.length) {
      throw this.log._create(LogLevel.Fatal, ["shop", "data", "error", "missing", "shop"]);
    }
    if (!shopData.shops[0] || !hasAttribute(shopData.shops[0], "currency")) {
      throw this.log._create(LogLevel.Fatal, ["shop", "data", "error", "missing", "currency"]);
    }
    this._shopDataToLoad = shopData;
    this.data.filters = hasAttribute(shopData, "filters") && typeof shopData.filters === "object" ? shopData.filters : {};
    this._pivots.setPivots(hasAttribute(shopData, "pivots") && isRecord(shopData.pivots) ? shopData.pivots : {});
    this._setEventDatesMap();
    this._setMetadataMap();
    this._setProductsMap();
    this._setGroupsMap();
    this._setTicketsMap();
    this._setCollapsesMap();
    this._setEventsMap();
    this._setPaymentMethodsMap();
    forEach$1(this._modelCollections, (name) => {
      this._setRepresentationCollection(name);
    });
    const shop = shopData.shops[0];
    const branding = hasAttribute(shopData, "brandings") && Array.isArray(shopData.brandings) && shopData.brandings.length ? shopData.brandings[0] : {};
    const company = hasAttribute(shopData, "companies") && Array.isArray(shopData.companies) && shopData.companies.length ? shopData.companies[0] : {};
    this._setGlobalData(shop, branding, company);
    if (this.data.greedy_date_selection) {
      this.data.available_future_dates = Array.from(
        hasAttribute(shopData, "available_future_dates") ? shopData.available_future_dates : []
      );
      this.data.available_future_dates_nested = hasAttribute(shopData, "available_future_dates_nested") ? shopData.available_future_dates_nested : {};
    }
    this._shopDataToLoad = {};
    return Promise.resolve(true);
  }
  /**
   *  Determine if the shop data is ready for full initialization of the shop.
   */
  _determineDataIntegrity() {
    this._initErrors.payment_methods = !this.data.payment_methods.length;
    this._initErrors.items = !this.data.tickets.length && !this.data.global_products.filter((globalProduct) => !globalProduct.item.class || !["CoverGenius", "RefundProtect", "Co2Compensate", "Giro555"].includes(globalProduct.item.class)).length;
    this.initErrors = [];
    if (this._initErrors.payment_methods) {
      this.initErrors.push({
        type: "payment_methods",
        message: "Missing payment methods"
      });
    }
    if (this._initErrors.items) {
      this.initErrors.push({
        type: "items",
        message: "Missing tickets or products"
      });
    }
    if (this.initErrors.length) {
      return State.Waiting;
    }
    return State.Ready;
  }
  /**
   *  Used to (re-)initialize any payment method 3rd party scripts.
   */
  async _initPaymentMethods() {
    if (!this.data || !this.data.payment_methods) {
      throw this.log._create(LogLevel.Error, ["shop", "data", "error", "loading", "paymentmethods"]);
    }
    const promises2 = [];
    forEach$1(this.data.payment_methods, (paymentMethod) => {
      if (paymentMethod.stripe && !paymentMethod.stripe.stripe) {
        const promise = pure.loadStripe(paymentMethod.stripe.stripe_public_key).then((stripe) => {
          if (!stripe || !paymentMethod.stripe) {
            throw this.log._create(LogLevel.Error, ["shop", "data", "error", "loading", "stripe"]);
          }
          paymentMethod.stripe.stripe = stripe;
        });
        promises2.push(promise);
      }
    });
    await Promise.all(promises2);
  }
  /**
   *  Used to set and expose all the event dates of the shop
   *  as guid map, making sure they are being transformed
   *  before doing so.
   */
  _setEventDatesMap() {
    if (!hasAttribute(this._shopDataToLoad, "eventDates") || !Array.isArray(this._shopDataToLoad.eventDates)) {
      throw this.log._create(LogLevel.Warning, ["shop", "data", "error", "missing", "eventdates"]);
    }
    forEach$1(filterPartialTypeList(
      this._shopDataToLoad.eventDates,
      {
        guid: "string",
        event_id: "string",
        start: "string",
        end: "string"
      },
      (filteredOutList) => {
        this.log._create(LogLevel.Warning, ["shop", "data", "error", "set", "failed", "eventdates"], { count: filteredOutList.length });
      }
    ), (eventDate2) => {
      Model.addTo(
        this.data.event_dates_map,
        this._getTransformedEventDate(eventDate2.guid)
      );
    });
  }
  /**
   *  Used to set and expose all the metadata of the shop, making
   *  sure they are being transformed before doing so.
   */
  _setMetadataMap() {
    if (!hasAttribute(this._shopDataToLoad, "metaData") || !Array.isArray(this._shopDataToLoad.metaData)) {
      throw this.log._create(LogLevel.Warning, ["shop", "data", "error", "missing", "metadata"]);
    }
    forEach$1(filterPartialTypeList(
      this._shopDataToLoad.metaData,
      {
        guid: "string",
        company_id: "string",
        applies_to: "string",
        type: "string"
      },
      (filteredOutList) => {
        this.log._create(LogLevel.Warning, ["shop", "data", "error", "set", "failed", "metadata"], { count: filteredOutList.length });
      }
    ), (metadata2) => {
      Model.addTo(
        this.data.metadata_map,
        this._getTransformedMetadata(metadata2.guid)
      );
    });
  }
  /**
   *  Used to set and expose all the events of the shop as
   *  guid map, making sure they are being transformed
   *  before doing so.
   */
  _setEventsMap() {
    if (!hasAttribute(this._shopDataToLoad, "events") || !Array.isArray(this._shopDataToLoad.events)) {
      throw this.log._create(LogLevel.Warning, ["shop", "data", "error", "missing", "events"]);
    }
    const addedEvents = {};
    forEach$1(filterPartialTypeList(
      this._shopDataToLoad.events,
      {
        guid: "string",
        company_id: "string",
        name: "string"
      },
      (filteredOutList) => {
        this.log._create(LogLevel.Warning, ["shop", "data", "error", "set", "failed", "events"], { count: filteredOutList.length });
      }
    ), (event2) => {
      addedEvents[event2.guid] = event2.guid;
      Model.addTo(
        this.data.events_map,
        this._getTransformedEvent(event2.guid)
      );
    });
    forEach$1(Object.keys(this.data.events_map), (guid) => {
      if (!addedEvents[guid]) {
        this._enrichEvent(this.data.events_map[guid]);
      }
    });
  }
  /**
   *  Used to set and expose all the collapses of the shop as
   *  guid map, making sure they are being transformed
   *  before doing so.
   */
  _setCollapsesMap() {
    if (!hasAttribute(this._shopDataToLoad, "collapses") || !Array.isArray(this._shopDataToLoad.collapses)) {
      throw this.log._create(LogLevel.Warning, ["shop", "data", "error", "missing", "collapses"]);
    }
    if (!this._shopDataToLoad.collapses.length) {
      return;
    }
    forEach$1(filterPartialTypeList(
      this._shopDataToLoad.collapses,
      {
        guid: "string",
        company_id: "string",
        title: "string"
      },
      (filteredOutList) => {
        this.log._create(LogLevel.Warning, ["shop", "data", "error", "set", "failed", "collapse"], { count: filteredOutList.length });
      }
    ), (collapse) => {
      Model.addTo(
        this.data.collapses_map,
        this._getTransformedCollapse(collapse.guid)
      );
    });
    const pivotSettings = {
      key: PIVOTS_KEY_SHOPS_COLLAPSES,
      item: {
        guid: "",
        guid_key: "collapse_guid"
      }
    };
    this._pivots.computeIndexes(
      this.data.collapses_map,
      pivotSettings
    );
    const numberOfTickets = Object.keys(this.data.tickets_map).length;
    forOwn(this.data.collapses_map, (collapse) => {
      collapse.index += numberOfTickets;
      collapse.index = collapse.tickets[0] && typeof collapse.tickets[0].index === "number" ? collapse.tickets[0].index : collapse.index;
    });
  }
  /**
   *  Used to transform and expose the general data of the shop, including
   *  the general shop data, booker metadata and payment methods.
   */
  _setGlobalData(shop, branding, company) {
    Object.keys(shop).forEach((key) => {
      if (shop[key] === null || typeof shop[key] !== "object" && typeof shop[key] !== "undefined") {
        this.data[key] = shop[key];
      }
    });
    this.data.shop_options = shop.shop_options;
    this._setBookerInformation(shop.guid);
    this._setGlobalProducts(shop.guid);
    for (const [key, value] of Object.entries(branding)) {
      if (!Object.prototype.hasOwnProperty.call(branding, key)) {
        continue;
      }
      if (value !== Object(value)) {
        this.data.branding[key] = value;
      }
    }
    for (const [key, value] of Object.entries(company)) {
      if (!Object.prototype.hasOwnProperty.call(company, key)) {
        continue;
      }
      if (value !== Object(value)) {
        this.data.company[key] = value;
      }
    }
  }
  /**
   *  Used to collect and expose the booker metadata, which basically is
   *  the metadata that applies for the whole shop.
   */
  _setBookerInformation(shopGuid) {
    const metadataPivots = this._pivots.get({
      key: PIVOTS_KEY_SHOPS_METADATA,
      item: {
        guid: shopGuid,
        guid_key: "shop_guid"
      }
    });
    forEach$1(metadataPivots, (pivot) => {
      const metadata2 = Model.getFrom(this.data, "metadata_map", pivot.metadata_guid);
      const shopMetadata = {
        index: 0,
        // Proper indexes will be added after all metadata has been added.
        guid: metadata2.guid,
        item: metadata2
      };
      Model.addTo(this.data.booker_metadata, shopMetadata);
    });
    const pivotSettings = {
      key: PIVOTS_KEY_SHOPS_METADATA,
      item: {
        guid: "",
        guid_key: "metadata_guid"
      }
    };
    this._pivots.computeIndexes(
      this.data.booker_metadata,
      pivotSettings
    );
    this.data.booker_metadata.sort(modelSort);
  }
  /**
   *
   *  Used to expose the global products, which basically are products
   *  that could be purchased on shop level. Exposing them out
   *  of both the global_products as pivots data.
   *
   *  (!) They are first added to the general products collection in the
   *  _setProductsMap() method, before their references are added to the
   *  event's global products or global global_products collection.
   *
   */
  _setGlobalProducts(shopGuid) {
    const setGlobalProduct = (productGuid, index) => {
      const product = Model.getFrom(this.data, "products_map", productGuid);
      const collection = !product.event_id || !this.data.events_map[product.event_id] ? this.data.global_products : this.data.events_map[product.event_id].global_products;
      const shopProduct = {
        index,
        guid: product.guid,
        item: product,
        pricing: cloneObject(product.pricing)
      };
      shopProduct.pricing.coupons = {};
      Model.addTo(collection, shopProduct);
    };
    if (hasAttribute(this._shopDataToLoad, "global_products") && this._shopDataToLoad.global_products && this._shopDataToLoad.global_products.constructor === Object) {
      forEach$1(Object.keys(
        filterPartialTypeMap(
          this._shopDataToLoad.global_products,
          {
            guid: "string",
            name: "string",
            class: "string"
          },
          (filteredOutList) => {
            this.log._create(LogLevel.Warning, ["shop", "data", "error", "set", "failed", "globalproducts"], { count: Object.keys(filteredOutList).length });
          }
        )
      ), setGlobalProduct);
    }
    const shopProductPivots = hasAttribute(this._shopDataToLoad, "pivots") && hasAttribute(this._shopDataToLoad.pivots, PIVOTS_KEY_SHOPS_PRODUCTS) ? this._shopDataToLoad.pivots[PIVOTS_KEY_SHOPS_PRODUCTS] : [];
    if (Array.isArray(shopProductPivots) && shopProductPivots.length) {
      const globalProductPivots = this._pivots.get({
        key: PIVOTS_KEY_SHOPS_PRODUCTS,
        item: {
          guid: shopGuid,
          guid_key: "shop_guid"
        }
      });
      forEach$1(globalProductPivots, (pivot, index) => {
        setGlobalProduct(pivot.product_guid, index);
      });
    }
    if (Array.isArray(this.data.global_products)) {
      this.data.global_products.sort(modelSort);
    }
    forEach$1(this.data.events, (event2) => {
      event2.global_products.sort(modelSort);
    });
  }
  /**
   *  Used to set and expose all the payment methods of the shop,
   *  making sure they are being transformed before doing so.
   */
  _setPaymentMethodsMap() {
    if (!hasAttribute(this._shopDataToLoad, "paymentmethods") || !Array.isArray(this._shopDataToLoad.paymentmethods)) {
      throw this.log._create(LogLevel.Warning, ["shop", "data", "error", "missing", "paymentmethods"]);
    }
    let allEqual = true;
    let fixed = null;
    let percentage = null;
    const paymentMethods = filterPartialTypeList(
      this._shopDataToLoad.paymentmethods,
      {
        guid: "string",
        name: "string"
      },
      (filteredOutList) => {
        this.log._create(LogLevel.Warning, ["shop", "data", "error", "set", "failed", "paymentmethods"], { count: filteredOutList.length });
      }
    );
    forEach$1(paymentMethods, (paymentMethod) => {
      const transformedPaymentMethod = this._getTransformedPaymentMethod(paymentMethod.guid);
      Model.addTo(this.data.payment_methods_map, transformedPaymentMethod);
      if (transformedPaymentMethod.pricing.fees.specific) {
        if (fixed === null) {
          fixed = transformedPaymentMethod.pricing.fees.specific.fixed;
        } else if (transformedPaymentMethod.pricing.fees.specific.fixed !== fixed) {
          allEqual = false;
        }
        if (percentage === null) {
          percentage = transformedPaymentMethod.pricing.fees.specific.percentage;
        } else if (transformedPaymentMethod.pricing.fees.specific.percentage !== percentage) {
          allEqual = false;
        }
      }
    });
    if (allEqual) {
      forEach$1(paymentMethods, ({ guid }) => {
        const paymentMethod = Model.getFrom(this.data, "payment_methods_map", guid);
        paymentMethod.allSpecificFeesEqual = true;
      });
    }
    const pivotSettings = {
      key: PIVOTS_KEY_SHOPS_PAYMENT_METHODS,
      item: {
        guid: "",
        guid_key: "payment_method_id"
      }
    };
    this._pivots.computeIndexes(
      this.data.payment_methods_map,
      pivotSettings
    );
  }
  /**
   *  Used to set and expose all the products of the shop, both the regular products
   *  as global products; making sure they are being transformed before doing so.
   */
  _setProductsMap() {
    if (!hasAttribute(this._shopDataToLoad, "products") || !this._shopDataToLoad.products) {
      throw this.log._create(LogLevel.Warning, ["shop", "data", "error", "missing", "products"]);
    }
    const addedProducts = {};
    if (isRecord(this._shopDataToLoad.products)) {
      forEach$1(Object.keys(this._shopDataToLoad.products), (guid) => {
        addedProducts[guid] = guid;
        Model.addTo(
          this.data.products_map,
          this._getTransformedProduct(guid)
        );
      });
    } else if (!this._shopDataToLoad.products || typeof this._shopDataToLoad.products !== "object" || Object.keys(this._shopDataToLoad.products).length > 0) {
      this.log._create(LogLevel.Warning, ["shop", "data", "error", "set", "failed", "products"]);
    }
    if (hasAttribute(this._shopDataToLoad, "global_products") && this._shopDataToLoad.global_products && isRecord(this._shopDataToLoad.global_products)) {
      forEach$1(Object.keys(this._shopDataToLoad.global_products), (guid) => {
        addedProducts[guid] = guid;
        Model.addTo(
          this.data.products_map,
          this._getTransformedProduct(guid)
        );
      });
    }
    forEach$1(Object.keys(this.data.products_map), (guid) => {
      if (!addedProducts[guid]) {
        this._enrichProduct(this.data.products_map[guid]);
      }
    });
  }
  /**
   *  Used to set and expose all the groups of the shop as
   *  guid map, making sure they are being transformed
   *  before doing so.
   */
  _setGroupsMap() {
    if (!hasAttribute(this._shopDataToLoad, "groups") || !Array.isArray(this._shopDataToLoad.groups)) {
      throw this.log._create(LogLevel.Warning, ["shop", "data", "error", "missing", "groups"]);
    }
    const addedGroups = {};
    forEach$1(filterPartialTypeList(
      this._shopDataToLoad.groups,
      {
        guid: "string",
        ticket_id: "string",
        min_bound: "number",
        max_bound: "number",
        uniqueness: "number"
      },
      (filteredOutList) => {
        this.log._create(LogLevel.Warning, ["shop", "data", "error", "set", "failed", "productgroups"], { count: filteredOutList.length });
      }
    ), (group) => {
      addedGroups[group.guid] = group.guid;
      Model.addTo(
        this.data.groups_map,
        this._getTransformedProductGroup(group.guid)
      );
    });
    forOwn(this.data.groups_map, (group, guid) => {
      if (!addedGroups[guid]) {
        this._enrichGroup(group);
      }
    });
    const pivotSettings = {
      key: PIVOTS_KEY_TICKETS_GROUPS,
      item: {
        guid: "",
        guid_key: "group_guid"
      }
    };
    this._pivots.computeIndexes(
      this.data.groups_map,
      pivotSettings
    );
  }
  /**
   *  Used to set and expose all the tickets of the shop as
   *  guid map, making sure they are being transformed
   *  before doing so.
   */
  _setTicketsMap() {
    if (!hasAttribute(this._shopDataToLoad, "tickets") || !this._shopDataToLoad.tickets) {
      throw this.log._create(LogLevel.Warning, ["shop", "data", "error", "missing", "tickets"]);
    }
    const addedTickets = {};
    forOwn(filterPartialTypeMap(
      this._shopDataToLoad.tickets,
      {
        guid: "string",
        company_id: "string",
        event_id: "string",
        name: "string"
      },
      (filteredOutList) => {
        this.log._create(LogLevel.Warning, ["shop", "data", "error", "set", "failed", "ticket"], { count: Object.keys(filteredOutList).length });
      }
    ), (ticket2) => {
      addedTickets[ticket2.guid] = ticket2.guid;
      Model.addTo(
        this.data.tickets_map,
        this._getTransformedTicket(ticket2.guid)
      );
    });
    forOwn(this.data.tickets_map, (ticket2, guid) => {
      if (!addedTickets[guid]) {
        this._enrichTicket(ticket2);
      }
    });
    const pivotSettings = {
      key: PIVOTS_KEY_SHOPS_TICKETS,
      item: {
        guid: "",
        guid_key: "ticket_guid"
      }
    };
    this._pivots.computeIndexes(
      this.data.tickets_map,
      pivotSettings
    );
  }
  /**
   *
   *  Used to expose all the models as a representation Array,
   *  containing sorted refs to the original model objects in
   *  the model's guid map.
   *
   *  @param name The name of the collection to set the representation collection of
   *
   */
  _setRepresentationCollection(name) {
    const collection = this.data[name];
    const map = this.data[`${name}_map`];
    if (!collection || !map) {
      throw slugError(`The ${!collection ? "collection" : "map"} of ${name} is undefined`, ["shop", "data", "error", "representation"], { name });
    }
    collection.splice(0, collection.length);
    if (!isRecord(this._shopDataToLoad) || !Object.keys(this._shopDataToLoad).length || !Object.keys(this.data.filters).length) {
      forOwn(map, (model) => {
        Model.addTo(collection, model);
      });
    } else {
      const dataKeyMap = {
        event_dates: "eventDates",
        payment_methods: "paymentmethods"
      };
      const dataKey = dataKeyMap[name] || name;
      const loadedData = hasAttribute(this._shopDataToLoad, dataKey) ? this._shopDataToLoad[dataKey] : [];
      const addModelToCollection = (model) => {
        if (!!model && typeof model === "object" && "guid" in model && typeof model.guid === "string" && model.guid) {
          Model.addTo(collection, map[model.guid]);
        }
      };
      if (Array.isArray(loadedData)) {
        forEach$1(loadedData, addModelToCollection);
      } else {
        forOwn(loadedData, addModelToCollection);
      }
    }
    collection.sort(modelSort);
  }
  /**
   *  Used to get a transformed copy of an event date
   *  out of the original data; casting the dates.
   */
  _getTransformedEventDate(guid) {
    const eventDate2 = Model.getFrom(this._shopDataToLoad, "eventDates", guid, GET_BY_VALUE);
    Model.castData.ofEventDate(eventDate2);
    return eventDate2;
  }
  /**
   *  Used to get a transformed copy of a metadata
   *  out of the original data; casting the dates.
   */
  _getTransformedMetadata(guid) {
    const metadataWithUnknownExtra = Model.getFrom(this._shopDataToLoad, "metaData", guid, GET_BY_VALUE);
    let extra;
    if (typeof metadataWithUnknownExtra.extra === "string") {
      extra = metadataWithUnknownExtra.extra.split("|");
    } else {
      extra = metadataWithUnknownExtra.extra || [];
    }
    const metadata2 = {
      ...metadataWithUnknownExtra,
      extra,
      options: []
      // Used for enum values
    };
    if (!metadata2.extra) {
      return metadata2;
    }
    metadata2.extra = metadata2.extra.filter((rule) => {
      if (!rule.length) {
        return false;
      }
      if (/^in:/.test(rule)) {
        const values = rule.split(":")[1].split(",");
        forEach$1(values, (value) => {
          if (!value.length) {
            return;
          }
          metadata2.options.push(value);
        });
      }
      return true;
    });
    return metadata2;
  }
  /**
   *  Used to get a transformed copy of an event out of the original
   *  data; adding a holder for his global products, his tickets, event
   *  dates, computing his start and end based on the corresponding
   *  event dates and adding his sorted items list.
   */
  _getTransformedEvent(guid) {
    const event2 = Model.getFrom(this._shopDataToLoad, "events", guid, GET_BY_VALUE);
    Model.castData.ofEvent(event2);
    this._enrichEvent(event2);
    return event2;
  }
  /**
   *  Used to get a transformed copy of an event out of the original data;
   *  adding the corresponding tickets based on his ticket_guid prop
   *  and casting the dates.
   */
  _getTransformedCollapse(guid) {
    const collapse = Model.getFrom(this._shopDataToLoad, "collapses", guid, GET_BY_VALUE);
    collapse.tickets = [];
    forEach$1(collapse.ticket_guids, (ticketGuid) => {
      const ticket2 = Model.getOrUndefinedFrom(this.data, "tickets_map", ticketGuid, GET_BY_REF);
      if (ticket2) {
        Model.addTo(collapse.tickets, ticket2);
      }
    });
    collapse.tickets.sort(modelSort);
    return collapse;
  }
  /**
   *  Used to get a transformed copy of a payment method out of the original
   *  data; adding a pricing object and moving the fees to that object.
   */
  _getTransformedPaymentMethod(guid) {
    const {
      fees: extractedFees,
      stripe_public_key: extractedStripePublicKey,
      ...paymentMethod
    } = Model.getFrom(this._shopDataToLoad, "paymentmethods", guid, GET_BY_VALUE);
    const fees = this._transformFees(extractedFees);
    const stripePublicKey = extractedStripePublicKey;
    const pricing = {
      fees,
      vat: {
        percentage: 0,
        amount: 0
      },
      generic_total: 0,
      specific_total: 0,
      total_fees: 0
    };
    const stripe = stripePublicKey ? {
      stripe_public_key: stripePublicKey,
      complete: false,
      errors: []
    } : void 0;
    return {
      ...paymentMethod,
      pricing,
      stripe,
      surchargeReason: null
    };
  }
  /**
   *  Used to get a transformed copy of a product group out of the original data;
   *  adding the corresponding products based on his members prop.
   */
  _getTransformedProductGroup(guid) {
    const productGroup = Model.getFrom(this._shopDataToLoad, "groups", guid, GET_BY_VALUE);
    delete productGroup.members;
    productGroup.products = [];
    this._enrichGroup(productGroup);
    if (productGroup.min_bound === productGroup.max_bound && productGroup.max_bound === productGroup.products.length && productGroup.uniqueness === 1) {
      productGroup.type = ProductGroupType.Required;
    } else if (productGroup.uniqueness === 1) {
      if (productGroup.max_bound === 1 && productGroup.min_bound === 0 && productGroup.products.length === 1) {
        productGroup.type = ProductGroupType.Checkbox;
      } else if (productGroup.max_bound === 1) {
        productGroup.type = productGroup.products.length > 3 ? ProductGroupType.Select : ProductGroupType.Radio;
      } else {
        productGroup.type = productGroup.products.length > 3 ? ProductGroupType.Multiselect : ProductGroupType.Checkbox;
      }
    } else {
      productGroup.type = ProductGroupType.Optional;
    }
    return productGroup;
  }
  /**
   *  Used to get a transformed copy of a product out of the original data;
   *  adding the corresponding metadata and event dates and adding
   *  original and regular pricing object.
   */
  _getTransformedProduct(guid) {
    if (!hasAttribute(this._shopDataToLoad, "products") || !this._shopDataToLoad.products) {
      throw new ShopError("The loaded shop data does not contain products");
    }
    let product = null;
    let error = null;
    try {
      product = Model.getFrom(this._shopDataToLoad, "products", guid, GET_BY_VALUE);
    } catch (originalError) {
      error = originalError;
    }
    if (!product) {
      try {
        product = Model.getFrom(this._shopDataToLoad, "global_products", guid, GET_BY_VALUE);
      } catch (e) {
        throw error;
      }
    }
    const pricing = Price.createPricing(product.price, this._transformFees(product.fees), product.vat_percentage);
    delete product.price;
    delete product.fees;
    product = {
      ...product,
      pricing
    };
    this._enrichProduct(product);
    Price.computeProductPricing(product.pricing);
    delete product.price;
    delete product.fees;
    return product;
  }
  /**
   *  Used to get a transformed copy of a ticket out of the original data;
   *  adding the corresponding groups and products, original and regular
   *  pricing objects and casting the dates.
   */
  _getTransformedTicket(guid) {
    if (!hasAttribute(this._shopDataToLoad, "tickets") || !this._shopDataToLoad.tickets) {
      throw new ShopError("The loaded shop data does not contain tickets");
    }
    let ticket2 = Model.getFrom(this._shopDataToLoad, "tickets", guid, GET_BY_VALUE);
    Model.castData.ofTicket(ticket2);
    const pricing = Price.createTicketPricing(0, this._transformFees(ticket2.fees), ticket2.vat_percentage);
    delete ticket2.fees;
    this._enrichTicket(ticket2);
    Price.computeTicketPricing(
      pricing,
      ticket2.min_price,
      ticket2.products.all,
      IGNORE_OPTIONAL
    );
    ticket2 = {
      ...ticket2,
      pricing,
      available_from_margin: ticket2.availability_margin && ticket2.available_from ? new Date(ticket2.available_from.getTime() - ticket2.availability_margin * 6e4) : null,
      available_until_margin: ticket2.availability_margin && ticket2.available_until ? new Date(ticket2.available_until.getTime() + ticket2.availability_margin * 6e4) : null
    };
    ticket2.hidden = this._determineTicketHidden(ticket2);
    this._setTicketHiddenTimeout(ticket2);
    ticket2.original_pricing = cloneObject(ticket2.pricing);
    return ticket2;
  }
  /**
   *  Used to enrich the productGroup with his products models, based on the pivots.
   */
  _enrichGroup(group) {
    const groupProducts = [];
    const productPivots = this._pivots.get({
      key: PIVOTS_KEY_GROUPS_PRODUCTS,
      item: {
        guid: group.guid,
        guid_key: "group_id"
      }
    });
    forEach$1(productPivots, (pivot) => {
      const product = Model.getFrom(this.data, "products_map", pivot.product_id);
      Model.addTo(
        groupProducts,
        {
          guid: product.guid,
          group_guid: group.guid,
          item: product,
          index: -1,
          // Actual index is computed below
          uniqueness: pivot.uniqueness || null
        }
      );
    });
    const pivotSettings = {
      key: PIVOTS_KEY_GROUPS_PRODUCTS,
      item: {
        guid: "",
        guid_key: "product_id"
      },
      belongs_to: {
        guid: group.guid,
        // Ticket guid for which the products get collected
        guid_key: "group_id"
      }
    };
    this._pivots.computeIndexes(
      groupProducts,
      pivotSettings
    );
    groupProducts.sort(modelSort);
    group.products = groupProducts;
  }
  /**
   *  Used to enrich the product with his event dates
   *  and metadata models, based on the pivots.
   */
  _enrichProduct(product) {
    product.event_dates = [];
    product.metadata = [];
    const pivotSettings = {
      key: PIVOTS_KEY_PRODUCTS_EVENT_DATES,
      item: {
        guid: product.guid,
        guid_key: "product_guid"
      }
    };
    const eventDatePivots = this._pivots.get({
      ...pivotSettings,
      key: PIVOTS_KEY_PRODUCTS_EVENT_DATES
    });
    forEach$1(eventDatePivots, (pivot) => {
      Model.addTo(
        product.event_dates,
        Model.getFrom(this.data, "event_dates_map", pivot.event_date_guid)
      );
    });
    const metadataPivots = this._pivots.get({
      ...pivotSettings,
      key: PIVOTS_KEY_PRODUCTS_METADATA
    });
    forEach$1(metadataPivots, (pivot) => {
      const metadata2 = Model.getFrom(this.data, "metadata_map", pivot.metadata_guid);
      const shopMetadata = {
        index: 0,
        // Proper indexes will be added after all metadata has been added.
        guid: metadata2.guid,
        item: metadata2,
        productId: product.guid
      };
      Model.addTo(product.metadata, shopMetadata);
    });
    this._pivots.computeIndexes(
      product.metadata,
      {
        key: PIVOTS_KEY_PRODUCTS_METADATA,
        item: {
          guid: "",
          guid_key: "metadata_guid"
        },
        belongs_to: {
          guid: product.guid,
          guid_key: "product_guid"
        }
      }
    );
    product.metadata.sort(modelSort);
  }
  /**
   *  Used to enrich the forwarded ticket with his product
   *  group and product models, based on the pivots.
   */
  _enrichTicket(ticket2) {
    ticket2.groups = [];
    const pivotSettings = {
      key: PIVOTS_KEY_TICKETS_GROUPS,
      item: {
        guid: ticket2.guid,
        guid_key: "ticket_guid"
      }
    };
    const groupPivots = this._pivots.get(pivotSettings);
    forEach$1(groupPivots, (pivot) => {
      Model.addTo(
        ticket2.groups,
        Model.getFrom(this.data, "groups_map", pivot.group_guid)
      );
    });
    pivotSettings.key = PIVOTS_KEY_TICKETS_GROUPS;
    pivotSettings.item = {
      guid: "",
      guid_key: "group_guid"
    };
    this._pivots.computeIndexes(
      ticket2.groups,
      pivotSettings
    );
    ticket2.groups.sort(modelSort);
    ticket2.products = this._getTicketProducts(ticket2.guid, ticket2.groups);
  }
  /**
   *  Used to enrich the forwarded event with a holder
   *  for his global products (which are set in the
   *  _setGlobalProducts method), his ticket and event
   *  date models, his start and end date based on his
   *  attached event dates and the sorted items list.
   */
  _enrichEvent(event2) {
    event2.global_products = [];
    event2.tickets = [];
    const eventTicketPivots = this._pivots.get({
      key: PIVOTS_KEY_EVENTS_TICKETS,
      item: {
        guid: event2.guid,
        guid_key: "event_guid"
      }
    });
    forEach$1(eventTicketPivots, (pivot) => {
      Model.addTo(
        event2.tickets,
        Model.getFrom(this.data, "tickets_map", pivot.ticket_guid)
      );
    });
    event2.tickets.sort(modelSort);
    const eventDates2 = [];
    forOwn(this.data.event_dates_map, (eventDate2) => {
      if (eventDate2.event_id === event2.guid) {
        eventDates2.push(eventDate2);
      }
    });
    event2.start = event2.start || null;
    event2.end = event2.end || null;
    if ((!event2.start || !event2.end) && eventDates2.length) {
      if (eventDates2.length === 1) {
        event2.start = eventDates2[0].start;
        event2.end = eventDates2[0].end;
      } else if (eventDates2.length > 1) {
        const [nearest] = eventDates2.slice().sort(modelSort);
        const [furthest] = eventDates2.slice().sort(({ end: endA }, { end: endB }) => {
          const timeA = endA.getTime();
          const timeB = endB.getTime();
          if (timeA === timeB) {
            return 0;
          }
          return timeA > timeB ? -1 : 1;
        });
        event2.start = nearest.start;
        event2.end = furthest.end;
      }
    }
    this._addEventSortedItems(event2);
    event2.hidden = this._determineEventHidden(event2, true);
  }
  /**
   *  A ticket can be hidden by coupons or by availability
   *
   *  If the ticket is not yet / no longer available,
   *  the ticket should be hidden if it is outside the availability margin.
   *
   *  If the ticket should be hidden without coupon,
   *  All coupons should be checked for the ticket to be visible.
   *
   *  @param ticket Ticket to determine hidden property for
   *  @param addedCouponItem When a coupon is added, the CouponApplicable item can be given to save looping over all coupon items.
   */
  _determineTicketHidden(ticket2, addedCouponItem) {
    if (ticket2.available_from_margin && Date.now() < ticket2.available_from_margin.getTime()) {
      return true;
    }
    if (ticket2.available_until_margin && Date.now() > ticket2.available_until_margin.getTime()) {
      return true;
    }
    if (!ticket2.hide_without_coupon) {
      return false;
    }
    if (addedCouponItem && addedCouponItem.ticket && addedCouponItem.ticket.guid === ticket2.guid) {
      return false;
    }
    if (!this.cart) {
      return true;
    }
    let hideTicket = true;
    forOwn(this.cart.getAppliedCoupons(), (appliedCoupon) => {
      forEach$1(appliedCoupon.appliesTo.shop, (applicableCoupon) => {
        if (applicableCoupon.ticket && applicableCoupon.ticket.guid === ticket2.guid) {
          hideTicket = false;
        }
      });
    });
    return hideTicket;
  }
  // noinspection JSMethodCanBeStatic
  /**
   *  An event item can be hidden when none of its tickets are visible
   */
  _determineEventItemHidden(item) {
    if (!item.tickets.length) {
      return true;
    }
    return !item.tickets.some((ticket2) => !ticket2.hidden);
  }
  /**
   *  Determine if an event has no visible items.
   *
   *  @param event The event to check the hidden value for
   *  @param checkAndUpdateItems Update the event items with their hidden values
   */
  _determineEventHidden(event2, checkAndUpdateItems = false) {
    if (!event2.items.length) {
      return true;
    }
    if (checkAndUpdateItems) {
      forEach$1(event2.items, (item) => {
        item.hidden = this._determineEventItemHidden(item);
      });
    }
    return !event2.items.some((item) => !item.hidden);
  }
  /**
   *  Register the timeouts for ticket availability.
   *
   *  E.g.: Show and hide depending on the availability window.
   */
  _setTicketHiddenTimeout(ticket2) {
    const margin = 1;
    if (ticket2.available_from_margin && (!ticket2.available_until_margin || ticket2.available_from_margin < ticket2.available_until_margin)) {
      const msToVisible = ticket2.available_from_margin.getTime() - Date.now();
      if (msToVisible > 0) {
        setLargeTimeout(() => {
          ticket2.hidden = this._determineTicketHidden(ticket2);
          const event2 = this.data.events_map[ticket2.event_id];
          event2.hidden = this._determineEventHidden(event2, true);
        }, Math.max(0, msToVisible) + margin);
      }
    }
    if (ticket2.available_until_margin) {
      const msToHidden = ticket2.available_until_margin.getTime() - Date.now();
      if (msToHidden > 0) {
        setLargeTimeout(() => {
          ticket2.hidden = this._determineTicketHidden(ticket2);
          const event2 = this.data.events_map[ticket2.event_id];
          event2.hidden = this._determineEventHidden(event2, true);
        }, Math.max(0, msToHidden) + margin);
      }
    }
    if (ticket2.available_from && (!ticket2.available_until || ticket2.available_from < ticket2.available_until)) {
      const msToAvailable = ticket2.available_from.getTime() - Date.now();
      if (msToAvailable > 0) {
        setLargeTimeout(() => {
          if (ticket2.available_from && ticket2.available_from.getTime() - Date.now() < 0 && ticket2.status === "not_sold_right_now") {
            ticket2.status = "available";
          }
        }, Math.max(0, msToAvailable) + margin);
      }
    }
    if (ticket2.available_until) {
      const msToNotAvailable = ticket2.available_until.getTime() - Date.now();
      if (msToNotAvailable > 0) {
        setLargeTimeout(() => {
          if (ticket2.available_until && ticket2.available_until.getTime() - Date.now() < 0 && ticket2.status === "available") {
            ticket2.status = "not_sold_right_now";
          }
        }, Math.max(0, msToNotAvailable) + margin);
      }
    }
  }
  /**
   *  Used to compute and add the sorted items Array of
   *  an event. It includes a mixed up sorted collection
   *  of collapses and tickets that belong to the event.
   */
  _addEventSortedItems(event2) {
    event2.items = [];
    const addedItemGuids = {};
    const correspondingCollapse = (ticketGuid) => {
      let ticketCollapse;
      forOwn(this.data.collapses_map, (collapse) => {
        if (collapse.ticket_guids.indexOf(ticketGuid) > -1) {
          ticketCollapse = collapse;
        }
        return !ticketCollapse;
      });
      return ticketCollapse;
    };
    forEach$1(event2.tickets, (ticketToAdd) => {
      const collapse = correspondingCollapse(ticketToAdd.guid);
      const item = collapse || ticketToAdd;
      const eventItem = {
        index: item.index,
        type: collapse ? "collapse" : "ticket",
        item,
        tickets: [],
        hidden: false
      };
      if (!addedItemGuids[item.guid]) {
        if (collapse) {
          forEach$1(collapse.tickets, (ticket2) => {
            if (ticket2.event_id === event2.guid) {
              eventItem.tickets.push(ticket2);
            }
          });
          if (!eventItem.tickets.length) {
            return;
          }
          eventItem.index = eventItem.tickets[0].index;
        } else {
          eventItem.tickets = [ticketToAdd];
        }
        eventItem.hidden = this._determineEventItemHidden(eventItem);
        event2.items.push(eventItem);
        addedItemGuids[item.guid] = item.guid;
      }
    });
    event2.items.sort(modelSort);
  }
  /**
   *  Used to get a sorted product collection of a ticket, which includes a
   *  collection of; all products (including optional and required),
   *  optional products and required products - all sorted.
   */
  _getTicketProducts(guid, groups) {
    const products = [];
    const ticketProducts = {
      all: [],
      optional: [],
      required: []
    };
    const productPivots = this._pivots.get({
      key: PIVOTS_KEY_PRODUCTS_TICKETS,
      item: {
        guid,
        guid_key: "ticket_guid"
      }
    });
    forEach$1(productPivots, (pivot) => {
      Model.addTo(
        products,
        Model.getFrom(this.data, "products_map", pivot.product_guid)
      );
    });
    const isRequired = (productToCheck) => {
      let unGrouped = true;
      forEach$1(groups, (group) => {
        forEach$1(group.products, (groupProduct) => {
          if (groupProduct.guid === productToCheck.guid) {
            return unGrouped = false;
          }
          return true;
        });
        return unGrouped;
      });
      if (unGrouped) {
        return true;
      }
      let required = false;
      forEach$1(groups, (group) => {
        if (group.type === ProductGroupType.Required) {
          forEach$1(group.products, (groupProduct) => {
            if (groupProduct.guid === productToCheck.guid) {
              required = true;
            }
            return !required;
          });
          return !required;
        }
        return false;
      });
      return required;
    };
    forEach$1(products, (product) => {
      const shopProduct = {
        index: -1,
        // Actual index is computed below
        guid: product.guid,
        ticket_guid: guid,
        item: product,
        is_optional: !isRequired(product),
        pricing: cloneObject(product.pricing),
        skip_late_personalization: product.skip_late_personalization
      };
      shopProduct.pricing.coupons = {};
      ticketProducts.all.push(shopProduct);
    });
    const pivotSettings = {
      key: PIVOTS_KEY_PRODUCTS_TICKETS,
      item: {
        guid: "",
        guid_key: "product_guid"
      },
      belongs_to: {
        guid,
        // Ticket guid for which the products get collected
        guid_key: "ticket_guid"
      }
    };
    this._pivots.computeIndexes(
      ticketProducts.all,
      pivotSettings
    );
    ticketProducts.all.sort(modelSort);
    if (!groups.length) {
      ticketProducts.required = ticketProducts.all;
    } else {
      forEach$1(ticketProducts.all, (ticketProduct) => {
        ticketProducts[ticketProduct.is_optional ? "optional" : "required"].push(ticketProduct);
      });
      ticketProducts.optional.sort(modelSort);
      ticketProducts.required.sort(modelSort);
    }
    return ticketProducts;
  }
  // noinspection JSMethodCanBeStatic
  /**
   *  Used to transform a fees object; summing up the fixed and percentage
   *  fees (removing the distinction of the self and other) and removing
   *  the returned total.
   */
  _transformFees(fees) {
    const result2 = {
      fixed: fees.self.fixed + fees.other.fixed,
      percentage: fees.self.percentages + fees.other.percentages
    };
    if (fees.generic) {
      result2.generic = {
        percentage: fees.generic.percentages,
        fixed: fees.generic.fixed
      };
    }
    if (fees.specific) {
      result2.specific = {
        percentage: fees.specific.percentages,
        fixed: fees.specific.fixed
      };
    }
    return result2;
  }
  _calculateCouponApplicableItems(coupon) {
    const allGlobalProducts = {};
    forEach$1(this.data.events, (event2) => {
      forEach$1(event2.global_products, (globalProduct) => {
        allGlobalProducts[globalProduct.guid] = globalProduct;
      });
    });
    forEach$1(this.data.global_products, (globalProduct) => {
      allGlobalProducts[globalProduct.guid] = globalProduct;
    });
    const allRequiredTicketProducts = {};
    const productTicket = {};
    const constructTicketProductId = (ticketProduct) => `${ticketProduct.ticket_guid}-${ticketProduct.guid}`;
    forEach$1(this.data.tickets, (ticket2) => {
      forEach$1(ticket2.products.all, (ticketProduct) => {
        const ticketProductGuid = constructTicketProductId(ticketProduct);
        allRequiredTicketProducts[ticketProductGuid] = ticketProduct;
        productTicket[ticketProductGuid] = ticket2;
      });
    });
    const getTicketOfProduct = (ticketProduct) => {
      if (!ticketProduct.ticket_guid) {
        return void 0;
      }
      return productTicket[constructTicketProductId(ticketProduct)];
    };
    return Coupon.getApplicableItems(
      coupon.item,
      {
        ...allGlobalProducts,
        ...allRequiredTicketProducts
      },
      getTicketOfProduct
    );
  }
}
window.OpenTicket = Object.assign(window.OpenTicket || {}, {
  createShop() {
    return new OpenTicketShop();
  }
});
export {
  ApiError,
  BaseValidator,
  Cart,
  CartAction,
  CartItem,
  CartItemChildType,
  CartItemType,
  CartProduct,
  CartTicket,
  CartValidator,
  Coupon,
  CouponAction,
  CouponType,
  CrossWindowBase,
  CrossWindowClient,
  CrossWindowShop,
  DistinctValidator,
  EventSelection,
  EventStatus,
  EventType,
  GET_BY_REF,
  GET_BY_VALUE,
  IGNORE_OPTIONAL,
  IGNORE_UNDEFINED,
  LogLevel,
  LogLevelNumber,
  Logger,
  MetadataAppliesTo,
  MetadataType,
  Model,
  OpenTicketBaseNotifications,
  OpenTicketShop,
  OrderApiError,
  OrderType,
  Orderbuilder,
  PIVOTS_KEY_EVENTS_TICKETS,
  PIVOTS_KEY_GROUPS_PRODUCTS,
  PIVOTS_KEY_PRODUCTS_EVENT_DATES,
  PIVOTS_KEY_PRODUCTS_METADATA,
  PIVOTS_KEY_PRODUCTS_TICKETS,
  PIVOTS_KEY_SHOPS_COLLAPSES,
  PIVOTS_KEY_SHOPS_METADATA,
  PIVOTS_KEY_SHOPS_PAYMENT_METHODS,
  PIVOTS_KEY_SHOPS_PRODUCTS,
  PIVOTS_KEY_SHOPS_TICKETS,
  PIVOTS_KEY_TICKETS_GROUPS,
  Pivot,
  Price,
  PricingMethod,
  ProductGroupType,
  ProductMethod,
  ProductType,
  ReservationRequest,
  ReservationRequestAction,
  ReservationType,
  Reservator,
  SeatsioService,
  ShopConfig,
  ShopError,
  State,
  TermsActions,
  VATUpdateAction,
  addMetadataFromProduct,
  addMetadataToCollection,
  adsBlocked,
  arraysMatch,
  calculateTicketDiff,
  cartRemoveOnId,
  castDate,
  castDateAsIs,
  clearLargeTimeout,
  distinctErrorSlug,
  easyToSpeakId,
  enumIncludes,
  errorHasResponseStatus,
  errorToSlugError,
  event,
  eventDate,
  eventDates,
  events,
  factoryBookerCartMetadata,
  flattenObject,
  forEach$1 as forEach,
  forOwn,
  guessTimezone,
  hasLocalStorage$1 as hasLocalStorage,
  isComparable,
  isHttpClient,
  isMetadataWithDistinctRule,
  isModel,
  isModelArray,
  isModelObject,
  isSluggedError,
  loadScript$1 as loadScript,
  logLevelNumberToString,
  logLevelStringToNumber,
  metadataGen,
  metadataGenForTicketOrProduct,
  modelSort,
  parseQuery,
  round,
  setLargeTimeout,
  setValidationLang,
  slugError,
  sumBy,
  ticket,
  tickets,
  toSeatsioLanguage,
  validateMetadata
};
//# sourceMappingURL=ot-shop.mjs.map
